export type Product = {
  id: string;
  name: string;
  description: string;
  price: string;
  categories: string[];
  images: string[];
  featured?: boolean;
  updatedAt?: string;
};

export type Category = {
  id: string;
  name: string;
};

export const categories: Category[] = [
  { id: "shoes", name: "Shoes" },
  { id: "bags", name: "Bags" },
  { id: "clothing", name: "Clothing" },
  { id: "beauty", name: "Beauty" },
  { id: "watch", name: "Watch" },
  { id: "jewelry", name: "Jewelry" },
  { id: "belt", name: "Belt" },
  { id: "cosmetics", name: "Cosmetics" },
  { id: "electronic", name: "Electronic" },
  { id: "adidas", name: "Yupoo_Adidas" },
  { id: "af", name: "Yupoo_AirForce" },
  { id: "aj", name: "Yupoo_Aj" },
  { id: "balenciaga", name: "Yupoo_Balenciaga" },
  { id: "burberry", name: "Yupoo_Burberry" },
  { id: "bulgari", name: "Yupoo_Bulgari" },
  { id: "foge", name: "Yupoo_FOG_Essentials" },
  { id: "gucci", name: "Yupoo_Gucci" },
  { id: "hermes", name: "Yupoo_Hermes" },
  { id: "hublot", name: "Yupoo_Hublot" },
  { id: "lv", name: "Yupoo_Lv" },
  { id: "nb", name: "Yupoo_Nb" },
  { id: "nike", name: "Yupoo_Nike" },
  { id: "prada", name: "Yupoo_Prada" },
  { id: "rolex", name: "Yupoo_Rolex" },
  { id: "yeezy", name: "Yupoo_Yeezy" },
  { id: "ysl", name: "Yupoo_YSL" },
  { id: "home", name: "Others" },
];

const productImagesBasePath = "/productimgs/";
function generateImagePaths(category: string, brand: string, which: string, imageCount: number): string[] {
    return Array.from({  length: imageCount }, (_, index) => `${productImagesBasePath}${category}/${brand}/${which}/${brand}_${which}_pic_${index + 1}.jpg`);
}

function generateAjImagePaths(category: string, brand: string, which: string, imageCount: number): string[] {
    return Array.from({  length: imageCount }, (_, index) => {
        const paddedIndex = String(index + 1).padStart(2, '0'); // 将索引值格式化为两位数，不足两位时前面补零 
        return `${productImagesBasePath}${category}/${brand}/${which}/Yupoo-NIKE_Air_Jordan_Shoes_Sneaker10${paddedIndex}.jpg`;
    });
}

export const getProductBySlug = (slug: string): Product | undefined => {
  return products.find(product  => product.id  === slug);
};

export const getAllProducts = (): Product[] => {
  // 如果产品数据需要动态处理可以在这里添加逻辑 
  return products.map(product  => ({
    ...product,
    // 自动填充缺失的 updatedAt 字段 
    updatedAt: product.updatedAt  || new Date().toISOString()
  }));
};

const PriceInfo = "Contact for Details";

export const products: Product[] = [
  {
    id: "1",
    name: "Contact Us for Yupoo Products",
    description: "We are a source factory agent from China, specializing in high-end Yupoo of top brands, including shoes, clothing, pants, watches, bags, belts, and more. With our own logistics company, we ensure fast global shipping. Feel free to contact us for purchasing!",
    price: PriceInfo,
    categories: ["home"],
    images:  generateImagePaths("main", "logo","1", 1),
    featured: true,
  },
  {
    id: "2",
    name: "Nike Dunk Low Retro Sneakers",
    description: "Step Bold. Own the Streets.Crafted with premium natural leather for enduring vintage appeal, this Dunk Low faithfully recreates the 1985 OG silhouette through its perforated toe box and classic tongue/heel profile. The full-length rubber outsole delivers legendary traction, while the padded low-top collar ensures all-day comfort. ",
    price: PriceInfo,
    categories: ["shoes", "nike"], 
    images:  generateImagePaths("shoes", "Nike","1", 10),
  },
  {
    id: "3",
    name: "Tom & Jerry x Converse CHUCK TAYLOR",
    description: "These officially licensed canvas high-tops blend retro cartoon charm with streetwear versatility. The white unisex design (EU 35-44) features premium canvas, playful Tom & Jerry graphics, and a durable rubber outsole for everyday wear. Perfect for summer 2025's nostalgia trend.",
    price: PriceInfo,
    categories: ["shoes"],
    images:  generateImagePaths("shoes", "Converse","1", 9),
  },
  {
    id: "4",
    name: "Jordan Air Jordan 1 low shadow",
    description: "The Air Jordan 1 Low Shadow combines synthetic leather with a sleek, retro design, offering a stylish and comfortable fit for both men and women. With its detailed craftsmanship, cushioning, and durable, slip-resistant outsole, it's the perfect choice for those seeking a classic basketball shoe with a modern twist.",
    price: PriceInfo,
    categories: ["shoes", "nike"], 
    images:  generateImagePaths("shoes", "Nike","2", 9),
  },
  {
    id: "5",
    name: "Burberry-🔥🔥1964ss Spring Fashion Collar T-shirt",
    description: "Casual and fashionable, perfect for both wearing out and layering. Comfortable and visually appealing, with a delicate and smooth touch, cozy against the skin without irritation. Stylish and well-shaped, featuring original quality and craftsmanship. Available in sizes M-3XL. Model is 176cm/140lbs wearing size L.",
    price: PriceInfo,
    categories: ["clothing"],
    images:  generateImagePaths("clothing", "Burberry","1", 9),
  },
  {
    id: "6",
    name: "Chanel Ring New Hexagram Starry Sky Ring",
    description: "Chanel Ring New Hexagram Starry Sky Ring Sizes: 6, 7, 8#.",
    price: PriceInfo,
    categories: ["beauty"],
    images:  generateImagePaths("beauty", "Chanel","1", 6),
  },
  {
    id: "7",
    name: "Hermes New Arrival: Giovanni Loafer Leather Shoes",
    description: "Featuring a decorative Paris shoe buckle and water-stained cowhide lining, these loafers boast a luxurious feel with their embossed logo and exquisite craftsmanship. Sizes available: 39-45#, with custom options for 38 and 46#. ",
    price: PriceInfo,
    categories: ["shoes", "hermes"],
    images:  generateImagePaths("shoes", "Hermes","1", 9),
  },
  {
    id: "8",
    name: "Lv M10145 Black Flower Etui Bijou Handbag",
    description: "This M10145 Black Flower Etui Bijou Handbag features exquisite leather trim on Monogram canvas. Its compact size boasts impressive storage with two snap pockets and two padded compartments, perfect for safely storing jewelry like necklaces, watches, rings, bracelets, and earrings. The golden S-lock clasp adds an elegant and feminine touch. ",
    price: PriceInfo,
    categories: ["bags"],
    images:  generateImagePaths("bags", "Lv","1", 9),
    featured: true,
  },
  {
    id: "9",
    name: "GUCCI 4.0cm Early Spring Leather Belt with GG Buckle",
    description: "Crafted from fine cowhide, this GUCCI belt showcases the brand's iconic double G buckle and features a grey leather front with a black reverse, offering style versatility.",
    price: PriceInfo,
    categories: ["beauty"],
    images:  generateImagePaths("clothing", "Gucci","1", 9),
  },
  {
    id: "10",
    name: "Prada Casual Rattan Tote Bag",
    description: "This Prada Rattan Tote Bag is perfect for a relaxed, summer vibe. Ideal for casual wear and travel, with dimensions 45*32*28 cm.",
    price: PriceInfo,
    categories: ["bags"],
    images:  generateImagePaths("bags", "Prada","1", 9),
  },
  { 
    id: "11", 
    name: "Hermès Chypre Sandals – H-Strap Flat Slides", 
    description: "Crafted with premium imported leather (silk calfskin/palm-grain calfskin/goatskin) and lined with hybrid lambskin for ultimate comfort. Features authentic H-strap design with Velcro closure and original-molded sole. The pinnacle of luxury footwear.", 
    price: PriceInfo, 
    categories: ["shoes", "hermes"],
    images: generateImagePaths("shoes", "Hermes","2", 9) 
  },
  { 
    id: "12", 
    name: "Jordan Legacy 312 Low Retro Basketball Shoes", 
    description: "The Jordan Legacy 312 Low combines classic basketball heritage with modern comfort. Featuring a durable outsole for slip resistance and a versatile black/white colorway, these low-top sneakers offer all-day wearability. Available in sizes 36-46 (including half sizes).", 
    price: PriceInfo, 
    categories: ["shoes", "nike"], 
    images: generateImagePaths("shoes", "Nike","3", 9) 
  },
  { 
    id: "13", 
    name: "Air Legacy 312 Low \"Red/White-Black Swoosh\"", 
    description: "This revolutionary hybrid sneaker combines the iconic elements of aj 3, aj 1, and Air Trainer 2 into one ultimate design. The bold red/white colorway with contrasting black Swoosh delivers striking visual impact, while the interlocking design pays homage to three legendary silhouettes.", 
    price: PriceInfo, 
    categories: ["shoes", "nike"], 
    images: generateImagePaths("shoes", "Nike","4", 9) 
  },
  { 
    id: "14", 
    name: "A Ma Manière x Air Jordan 5 Retro \"Burgundy Crush\"",
    description: "Crafted in collaboration with A Ma Manière, this Air Jordan 5 reissue combines premium white leather with burgundy crushed velvet accents for a refined retro look. Designed for comfort and durability, it features a high-top silhouette, slip-resistant outsole, and vintage cushioning.", 
    price: PriceInfo, 
    categories: ["shoes", "nike"], 
    images: generateImagePaths("shoes", "Nike","5", 9) 
  }, 
  { 
    id: "15", 
    name: "Air Jordan 4 Retro \"Rattan\" – Women's Mid-Top Basketball Sneakers", 
    description: "This Air Jordan 4 Retro \"Rattan\" combines timeless style with performance-driven features. The earthy brown colorway offers versatile wearability, while the mid-top design, cushioned sole, and slip-resistant outsole ensure comfort and durability for everyday use.", 
    price: PriceInfo, 
    categories: ["shoes", "nike"], 
    images: generateImagePaths("shoes", "Nike","6", 9) 
  },
  { 
    id: "16", 
    name: "Jordan Spizike Low Retro \"White\" – Men's Low-Top Lifestyle Sneakers", 
    description: "The Jordan Spizike Low blends iconic heritage with modern streetwear appeal. Featuring a crisp white colorway, durable slip-resistant outsole, and low-top silhouette, this retro-inspired shoe delivers both style and everyday comfort.", 
    price: PriceInfo, 
    categories: ["shoes", "nike"], 
    images: generateImagePaths("shoes", "Nike","7", 9) 
  },
  { 
    id: "17", 
    name: "Jordan Spizike Low \"Flax\" – Men's Retro Low-Top Sneakers", 
    description: "Crafted for comfort and durability, the Jordan Spizike Low \"Flax\" features a soft construction, slip-resistant outsole, and retro low-top design in a versatile wheat/grey colorway.", 
    price: PriceInfo, 
    categories: ["shoes", "nike"], 
    images: generateImagePaths("shoes", "Nike","8", 9) 
  },
  { 
    id: "18", 
    name: "PUMA Speedcat Suede - Women's Casual Sneakers", 
    description: "The PUMA Speedcat Suede combines timeless style with everyday comfort. These women's low-top sneakers feature a soft suede upper in a versatile black/white colorway, perfect for casual wear.", 
    price: PriceInfo, 
    categories: ["shoes"], 
    images: generateImagePaths("shoes", "Puma","1", 9) 
  },
  { 
    id: "19", 
    name: "PUMA Speedcat Suede - Women's Fashion Sneakers (Red/White)", 
    description: "These PUMA Speedcat Suede sneakers blend style and comfort with a soft suede upper in vibrant red/white. Perfect for casual outings, they offer lightweight flexibility for all-day wear.", 
    price: PriceInfo, 
    categories: ["shoes"], 
    images: generateImagePaths("shoes", "Puma","2", 9) 
  },
  { 
    id: "20", 
    name: "PUMA Speedcat Ballet - Women's Low-Top Lifestyle Shoes", 
    description: "The PUMA Speedcat Ballet combines ballet-inspired elegance with everyday comfort. Featuring a slim sole, slip-resistant outsole, and versatile white/pink colorway, these low-top shoes offer all-day wearability.", 
    price: PriceInfo, 
    categories: ["shoes"], 
    images: generateImagePaths("shoes", "Puma","3", 9) 
  },
  { 
    id: "22", 
    name: "adidas Originals GAZELLE INDOOR W - Women's Low-Top Sneakers (Pink)", 
    description: "Classic pink GAZELLE with soft suede upper and grippy rubber sole for all-day comfort. Timeless low-top design perfect for casual wear.", 
    price: PriceInfo, 
    categories: ["shoes"], 
    images: generateImagePaths("shoes", "Adidas","2", 9) 
  },
  { 
    id: "23", 
    name: "adidas Originals GAZELLE - Low-Top Lifestyle Sneakers (Grey/White)", 
    description: "Classic GAZELLE sneakers featuring a soft suede upper in blue/white colorway with durable rubber sole for all-day comfort. Perfect for casual wear.", 
    price: PriceInfo, 
    categories: ["shoes"], 
    images: generateImagePaths("shoes", "Adidas","3", 9) 
  },
  { 
    id: "24", 
    name: "Rolex Mechanical Watch GMT-Master II -3285 movement", 
    description: "Rolex GMT-Master II features the latest-generation Caliber 3285 automatic movement, housed in a sleek 40mm case with 100m water resistance. Precision-engineered for reliability, this iconic timepiece combines cutting-edge technology with timeless design for global explorers.", 
    price: PriceInfo, 
    categories: ["watch", "rolex"], 
    images: generateImagePaths("watch", "Rolex","1", 15),
    featured: true,
  },
  {
    id: "25",
    name: "Yupoo shoes: Asics EL-NIMBUS 10.1",
    description: "Millennium style is back in control! The GEL-NIMBUS 10.1 perfectly embodies millennial aesthetics with a fusion of retro technology and avant-garde design, redefining premium fashion. Whether you're a millennial hottie, into high-end couture, or rocking clean fits or streetwear, the GEL-NIMBUS 10.1 effortlessly nails it all.",
    price: PriceInfo,
    categories: ["shoes"],
    images:  generateImagePaths("shoes", "Asics","1", 9),
  },
  { 
    id: "26", 
    name: "Yupoo Shoes: New Balance 530 Retro Runners - Viral TikTok Sneaker", 
    description: "These classic NB 530 retro runners blend timeless design with modern upgrades—featuring streamlined layers, premium cushioning, and the iconic silhouette that sold out everywhere. Get the hype before it's gone again! 🏃‍♂️💨 #yupooshoes #shoes #yupoonb #NbShoes #NewBalance", 
    price: PriceInfo, 
    categories: ["shoes", "nb"], 
    images: generateImagePaths("shoes", "Nb","4", 9), 
    featured: true,
  },
  { 
    id: "27", 
    name: "Yupoo shoes: Louis Vuitton LV Trainer Sneakers - Virgil Abloh Inspired", 
    description: "Reinterpreting Virgil Abloh's iconic design, these LV Trainer sneakers feature premium perforated calf leather and grained leather upper with bold Monogram florals. The hook-and-loop strap system, cushioned collar, and signature TPU rubber sole with Monogram detailing deliver avant-garde streetwear elegance.", 
    price: PriceInfo, 
    categories: ["shoes", "lv"], 
    images: generateImagePaths("shoes", "Lv","1", 9),
    featured: true,
  },
  { 
    id: "28", 
    name: "AMG x Cartier Santos 100 \"Full Pavé\" - Limited Edition", 
    description: "This groundbreaking Santos 100 collaboration features AMG's signature with over 1,200 hand-set 5A zirconias, achieving seamless sparkle without compromising the original bracelet thickness. Swiss-made 9015 movement powers this horological masterpiece.", 
    price: PriceInfo, 
    categories: ["watch"], 
    images: generateImagePaths("watch", "Cartier","1", 9), 
    featured: true,
  },
  { 
    id: "29", 
    name: "Hermès Birkin 25 Himalaya - Niloticus Crocodile (Silver Hardware)", 
    description: "Exclusive handcrafted Birkin 25 in rare Himalaya gradient, made from French-sourced Niloticus crocodile leather originating from the Nile. Features hand-hammered silver hardware and 18k electroplated steel accents.", 
    price: PriceInfo, 
    categories: ["bags", "hermes"], 
    images: generateImagePaths("bags", "Hermes","1", 8) 
  },
  { 
    id: "30", 
    name: "Hermès Kelly 25 - Gold Epsom Leather (Gold Hardware)", 
    description: "Handcrafted Kelly 25 in 37 Gold Epsom leather from France, featuring contrast stitching and luxurious gold hardware. A timeless investment piece with meticulous saddle stitching.", 
    price: PriceInfo, 
    categories: ["bags","hermes"], 
    images: generateImagePaths("bags", "Hermes","2", 7),
    featured: true,
  },
  { 
    id: "31", 
    name: "Nike PSG Fourth Jersey 24/25 - Men's Football Shirt (Jordan Edition/Blue)", 
    description: "Celebrate Parisian football style with this 2024/25 PSG fourth kit, co-branded with Jordan. The breathable Dri-FIT fabric and minimalist design ensure comfort for both matches and casual wear.", 
    price: PriceInfo, 
    categories: ["clothing", "nike"], 
    images: generateImagePaths("clothing", "Nike","1", 3) 
  },
  { 
    id: "32", 
    name: "Rolex Air-King 126900 (40mm, Stainless Steel, Automatic)", 
    description: "The newly upgraded Rolex Air-King (Ref.126900) features a precision 40mm 316L stainless steel case with polished bezel and scratch-resistant sapphire crystal. Equipped with a high-performance automatic movement and iconic Oyster bracelet with folding clasp, this timepiece combines aviation heritage with modern robustness.", 
    price: PriceInfo, 
    categories: ["watch", "rolex"], 
    images: generateImagePaths("watch", "Rolex","2", 9) 
  },
  { 
    id: "33", 
    name: "Rolex Datejust 36mm EA1 Edition - 904L Steel, Swiss C1+C3 Lume", 
    description: "The latest Clean Factory Rolex Datejust 36mm EA1 Edition features a yupoo super clone 3235 movement with adjustable date, housed in a 904L steel case paired with an AR factory bracelet. Its IP-plated platinum bezel matches genuine dimensions (with free replacement if faded), complemented by a sunburst dial in authentic mint green. The watch boasts correct date font, Swiss C1+C3 lume for uniform glow, white gold-plated hour markers/crown, and unique identifiers", 
    price: PriceInfo, 
    categories: ["watch", "rolex"], 
    images: generateImagePaths("watch", "Rolex","3", 9) 
  },
  { 
    id: "34", 
    name: "Rolex Datejust 36mm EA1 Edition - Premium Yupoo", 
    description: "Premium Yupoo Yupoo with: Super Clone 3235 movement, 904L steel & platinum bezel.Mint green sunburst dial (99% accuracy).Limited 500 units (Serial: 6R87Y755)", 
    price: PriceInfo, 
    categories: ["watch", "rolex"], 
    images: generateImagePaths("watch", "Rolex","4", 9) 
  },
  { 
    id: "35", 
    name: "Yupoo Omega De Ville Prestige 3rd Gen - Yupoo Master Chronometer Yupoo", 
    description: "This 3rd-gen Omega De Ville Prestige Yupoo features: ✅ Yupoo Clone 8810 Co-Axial Movement with black octopus rotor (55h power reserve) ✅ 41mm 316L Steel Case + arched anti-reflective sapphire crystal  ✅ Gen-spec dial: Vertical textured pattern, small seconds at 9H, date at 6H  ✅ Dual Straps: Original steel bracelet + Italian leather strap (50m waterproof) ✅ Five-Code Sync: Caseback, movement, dial, clasp, and serial match genuine specs", 
    price: PriceInfo, 
    categories: ["watch"], 
    images: generateImagePaths("watch", "Omega","1", 9) 
  },
  { 
    id: "36", 
    name: "Yupoo shoes: Custom Nike SB Dunk Low × LV Grey Embroidered-Yupoo Rep", 
    description: "This premium custom SB Dunk Low features LV-inspired grey embroidered motifs, premium suede construction, and signature low-top silhouette. Includes special edition packaging and dust bags.", 
    price: PriceInfo, 
    categories: ["shoes", "nike"], 
    images: generateImagePaths("shoes", "Nike","10", 9) 
  },
  { 
    id: "37", 
    name: "Yupoo shoes: Custom Travis Scott x LV x AJ1 Low Denim Mocha - Yupoo Yupoo", 
    description: "This exclusive custom collab combines Travis Scott's reverse Swoosh, LV monogram denim, and AJ1 Low silhouette. Features premium distressed black/denim fabric, double-branded tongue tags, and aged midsole. Includes 3 lace sets + special box.", 
    price: PriceInfo, 
    categories: ["shoes", "nike"], 
    images: generateImagePaths("shoes", "Nike","9", 9) 
  },
  { 
    id: "38", 
    name: "Yupoo clothing: BALENCIAGA 2025SS Summer Casual Shorts", 
    description: "These BALENCIAGA-inspired summer shorts feature ultra-comfortable fabric, oversized patch pockets, and an adjustable drawstring waist for a perfect fit. The straight-cut design suits all body types, offering effortless style with premium quality. All product images are 100% real shots - what you see is what you get.", 
    price: PriceInfo, 
    categories: ["clothing"], 
    images: generateImagePaths("clothing", "Nb","1", 9) 
  },
  { 
    id: "39", 
    name: "Yupoo clothing: BALENCIAGA Paris 2025SS Summer Shorts - Premium yupoo Yupoo", 
    description: "Experience luxury comfort with these yupoo BALENCIAGA-inspired shorts, crafted from authentic-grade fabric for unmatched softness. Features oversized patch pockets, an adjustable drawstring waist, and a relaxed straight-cut silhouette that flatters all body types. All images are real unedited shots - guaranteed quality.", 
    price: PriceInfo, 
    categories: ["clothing"], 
    images: generateImagePaths("clothing", "Nb","2", 9) 
  },
  { 
    id: "40", 
    name: "New Balance 530 - Men's Low-Top Casual Sneakers (White/Brown)", 
    description: "The New Balance 530 combines timeless style with everyday comfort. Featuring a cushioned midsole for all-day support, slip-resistant outsole for urban commutes, and breathable mesh upper. Perfect for casual wear or light running. Classic white/brown colorway matches any outfit.", 
    price: PriceInfo, 
    categories: ["shoes", "nb"], 
    images: generateImagePaths("shoes", "Nb","1", 9) 
  },
  { 
    id: "41", 
    name: "XLIM × New Balance 509 Unisex Lifestyle Sneakers (Black/Purple)", 
    description: "This XLIM collab with New Balance 509 delivers street-ready style and all-day comfort. The low-top design features anti-slip soles, cushioned support, and a versatile black/purple colorway. Perfect for urban adventures in unisex sizing.", 
    price: PriceInfo, 
    categories: ["shoes", "nb"], 
    images: generateImagePaths("shoes", "Nb","2", 9) 
  },
  { 
    id: "42", 
    name: "XLIM × New Balance 509 Unisex Lifestyle Sneakers (Black/Purple)", 
    description: "Designed for urban runners, the XLIM × New Balance 509 combines streetwear style with performance. Features:✅ Slip-resistant rubber outsole for wet surfaces✅ Lightweight cushioning with ABZORB shock absorption✅ Breathable mesh/suede upper in sleek black/silver✅ Versatile design transitions from running to casual wear", 
    price: PriceInfo, 
    categories: ["shoes", "nb"], 
    images: generateImagePaths("shoes", "Nb","3", 9) 
  },
  { 
    id: "43", 
    name: "Yupoo Shoes: Hermès-Inspired Giovanni Loafers - Luxury Men's Slip-On", 
    description: "Crafted with imported high-gloss calfskin and featuring a palladium-plated Paris buckle, these Hermès-inspired Giovanni loafers combine elegance with functionality. The water-stained leather lining, genuine leather sole with rubber traction pads, and embossed 3D logo deliver unparalleled comfort and sophistication for a timeless slip-on statement.", 
    price: PriceInfo, 
    categories: ["shoes", "hermes"], 
    images: generateImagePaths("shoes", "Hermes","3", 9) 
  },
  { 
    id: "44", 
    name: "Yupoo Shoes: Hermès-Style Giovanni Loafers - Luxury Slip-On Dress Shoes", 
    description: "These premium Hermès-inspired Giovanni loafers feature imported glossy calfskin, a signature palladium-plated Paris buckle, and water-stained leather lining. The genuine leather sole with anti-slip rubber pads ensures comfort and traction, while the embossed logo elevates your effortless elegance.", 
    price: PriceInfo, 
    categories: ["shoes"], 
    images: generateImagePaths("shoes", "Hermes","4", 9) 
  },
  { 
    id: "45", 
    name: "Yupoo Shoes: Luxury Hermès-Inspired Giovanni Loafers - Handcrafted Leather Slip-On Dress Shoes with Palladium Buckle", 
    description: "Elevate your style with these premium Hermès-inspired Giovanni loafers, meticulously crafted from imported high-gloss calfskin and featuring a distinctive palladium-plated Paris buckle. Designed for both comfort and sophistication, they boast a water-stained leather lining, genuine leather sole with anti-slip rubber pads, and an embossed logo for timeless elegance. Perfect for effortless, chic dressing.", 
    price: PriceInfo, 
    categories: ["shoes", "hermes"], 
    images: generateImagePaths("shoes", "Hermes","5", 9) 
  },
  { 
    id: "46", 
    name: "Yupoo Watch: Rolex Datejust 36mm Custom Edition - 3255 Movement", 
    description: "This 2025 ultimate Rolex Datejust 36mm Yupoo features a precision 3255 clone movement with date function, crafted in genuine 904L steel with AR factory bracelet and platinum-coated fluted bezel (fade-proof guaranteed). The sunburst mint green dial achieves 99% gen similarity with perfect date font alignment (1-31), Swiss C1/C3 lume on hands/indices, and exclusive authentication codes (Case:5L27K422, Clasp:F6U) - representing the highest standard in super clone watchmaking with all common flaws eliminated.", 
    price: PriceInfo, 
    categories: ["watch", "rolex"], 
    images: generateImagePaths("watch", "Rolex","5", 9) 
  },
  { 
    id: "47", 
    name: "Yupoo Watch: Rolex Cellini CM6 - 115g Weighted Edition", 
    description: "This premium Rolex Cellini CM6 Yupoo by SJ features a custom 3165 movement with date function, crafted in 316L steel with genuine-like platinum/rose gold plating. The 39mm case showcases deep engraved radial dial texture, paired with Italian full-grain leather strap and authentic folding clasp - delivering 115g perfect wrist balance for discerning collectors.", 
    price: PriceInfo, 
    categories: ["watch", "rolex"], 
    images: generateImagePaths("watch", "Rolex","6", 9) 
  },
  { 
    id: "48", 
    name: "Yupoo Watch: Rolex Full Diamond Watch-904L Steel Case", 
    description: "This exquisite Rolex-inspired full diamond watch features a dazzling 904L steel case and bracelet completely encrusted with premium Swarovski crystals, offering unmatched brilliance and luxury. Available with reliable 2824 or domestic movement options, this 42mm statement piece from ZY delivers ultimate sparkle and prestige for those who demand extraordinary elegance. ✨", 
    price: PriceInfo, 
    categories: ["watch", "rolex"], 
    images: generateImagePaths("watch", "Rolex","7", 9) 
  },
  { 
    id: "49", 
    name: "Yupoo Watch:🔥Rolex Homage Watch - 316L Steel Case", 
    description: "This stunning Rolex-inspired timepiece features a precision-crafted 316L steel case with perfect polygonal curves, scratch-resistant sapphire crystal, and genuine Italian waterproof leather strap with original buckle. Powered by a reliable 8215 automatic movement (zero-return rate), this 40mm watch delivers exceptional craftsmanship with vivid dial markers and master-level finishing for a truly luxurious wrist presence. 💎", 
    price: PriceInfo, 
    categories: ["watch", "rolex"], 
    images: generateImagePaths("watch", "Rolex","8", 8) 
  },
  { 
    id: "50", 
    name: "Yupoo Watch:🔥Rolex DIW Submariner Homage - Carbon Fiber Bezel", 
    description: "Crafted with premium 904L steel and featuring a custom carbon fiber bezel with gradient green dial, this DIW-inspired Submariner delivers unmatched style and precision. Powered by a reliable Japanese 8215 movement, it boasts ultra-luminous markers, gen-like engraving depth, and flawless finishing for a truly exceptional dive watch experience. 🌊✨", 
    price: PriceInfo, 
    categories: ["watch", "rolex"], 
    images: generateImagePaths("watch", "Rolex","9", 8) 
  },
  { 
    id: "51", 
    name: "Yupoo Watch:🔥Rolex DIW Submariner Homage - Carbon Fiber Bezel", 
    description: "Crafted with premium 904L steel and a custom carbon fiber bezel, this DIW-inspired Submariner features a mesmerizing gradient green dial and ultra-luminous markers for unmatched style. Powered by a Japanese 8215 movement, it combines precision engineering with DIW’s极致 craftsmanship, offering a bold, dark-toned aesthetic that mirrors genuine luxury. 🌊✨", 
    price: PriceInfo, 
    categories: ["watch", "rolex"], 
    images: generateImagePaths("watch", "Rolex","10", 8) 
  },
  { 
    id: "52", 
    name: "Yupoo Watch: Rolex DIW Submariner - Carbon Fiber Bezel & 904L Steel", 
    description: "This limited DIW Submariner homage features a custom carbon fiber bezel, gradient green dial & ultra-luminous markers on 904L steel. Powered by a Japanese 8215 movement, it delivers gen-like precision with bold dark aesthetics. 🌊✨", 
    price: PriceInfo, 
    categories: ["watch", "rolex"], 
    images: generateImagePaths("watch", "Rolex","11", 9) 
  },
  { 
    id: "53", 
    name: "Yupoo Watch: Rolex Datejust 31mm - Swiss SW200/2824", 
    description: "This A+ Factory 31mm Datejust features a flawless Yupoo cloned Oyster case with screw-down crown, sapphire crystal with blue AR coating, and interchangeable bezels (smooth/fluted/diamond). Choose between Jubilee/Oyster/President bracelets and ultra-precise Swiss SW200 or modified 2824 movements - all QC-tested for waterproof accuracy with zero date-jump issues. 🌟", 
    price: PriceInfo, 
    categories: ["watch", "rolex"], 
    images: generateImagePaths("watch", "Rolex","12", 9) 
  },
  { 
    id: "54", 
    name: "Yupoo Watch: Rolex Datejust 31mm Floral Dial - Swiss SW200/2824", 
    description: "This exquisite A+ Factory Datejust 31mm features a stunning floral dial with Yupoo cloned Oyster case, sapphire crystal with blue AR coating, and your choice of bezel (smooth/fluted/diamond). Customize with Jubilee/Oyster/President bracelets and ultra-precise Swiss SW200 or modified 2824 movements - all QC-tested for waterproof accuracy and zero date-jump issues. ✨", 
    price: PriceInfo, 
    categories: ["watch", "rolex"], 
    images: generateImagePaths("watch", "Rolex","13", 9) 
  },
{ 
    id: "55", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100401", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","11", 10) 
  },
  { 
    id: "56", 
    name: "Yupoo Shoes:Nike Jordan 1 1S Aj1 Cherry Blossom Powder Men's Casual Sports Sneakers", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","12", 11) 
  },
  { 
    id: "57", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100443", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","13", 11) 
  },
  { 
    id: "58", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100132", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","14", 11) 
  },
  { 
    id: "59", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100373", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","15", 10) 
  },
  { 
    id: "60", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100301", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","16", 11) 
  },
  { 
    id: "61", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100584", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","17", 10) 
  },
  { 
    id: "62", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100351", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","18", 12) 
  },
  { 
    id: "63", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100188", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","19", 10) 
  },
  { 
    id: "64", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100356", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","20", 11) 
  },
  { 
    id: "65", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100344", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","21", 11) 
  },
  { 
    id: "66", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100102", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","22", 11) 
  },
  { 
    id: "67", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100618", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","23", 15) 
  },
  { 
    id: "68", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100381", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","24", 10) 
  },
  { 
    id: "69", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100137", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","25", 10) 
  },
  { 
    id: "70", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100525", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","26", 10) 
  },
  { 
    id: "71", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100162", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","27", 9) 
  },
  { 
    id: "72", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100126", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","28", 10) 
  },
  { 
    id: "73", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100130", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","29", 11) 
  },
  { 
    id: "74", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100338", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","30", 11) 
  },
  { 
    id: "75", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100548", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","31", 10) 
  },
  { 
    id: "76", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100170", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","32", 11) 
  },
  { 
    id: "77", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100179", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","33", 14) 
  },
  { 
    id: "78", 
    name: "Yupoo Shoes:Nike Air Jordan 11 aj11  Low 'Snakeskin' Men's Basketball Shoes", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","34", 12) 
  },
  { 
    id: "79", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100430", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","35", 11) 
  },
  { 
    id: "80", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100492", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","36", 11) 
  },
  { 
    id: "81", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100452", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","37", 11) 
  },
  { 
    id: "82", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100614", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","38", 10) 
  },
  { 
    id: "83", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100161", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","39", 10) 
  },
  { 
    id: "84", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100316", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","40", 10) 
  },
  { 
    id: "85", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100172", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","41", 10) 
  },
  { 
    id: "86", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100283", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","42", 10) 
  },
  { 
    id: "87", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100205", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","43", 11) 
  },
  { 
    id: "88", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100570", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","44", 10) 
  },
  { 
    id: "89", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100163", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","45", 10) 
  },
  { 
    id: "90", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100500", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","46", 10) 
  },
  { 
    id: "91", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100585", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","47", 13) 
  },
  { 
    id: "92", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100333", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","48", 11) 
  },
  { 
    id: "93", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100483", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","49", 10) 
  },
  { 
    id: "94", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100643", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","50", 14) 
  },
  { 
    id: "95", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100148", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","51", 10) 
  },
  { 
    id: "96", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100150", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","52", 10) 
  },
  { 
    id: "97", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100462", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","53", 11) 
  },
  { 
    id: "98", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100554", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","54", 12) 
  },
  { 
    id: "99", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100477", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","55", 10) 
  },
  { 
    id: "100", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100638", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","56", 11) 
  },
  { 
    id: "101", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100208", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","57", 9) 
  },
  { 
    id: "102", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100380", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","58", 11) 
  },
  { 
    id: "103", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100311", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","59", 10) 
  },
  { 
    id: "104", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100357", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","60", 12) 
  },
  { 
    id: "105", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100105", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","61", 11) 
  },
  { 
    id: "106", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100581", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","62", 11) 
  },
  { 
    id: "107", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100391", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","63", 12) 
  },
  { 
    id: "108", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100578", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","64", 10) 
  },
  { 
    id: "109", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100426", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","65", 11) 
  },
  { 
    id: "110", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100360", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","66", 12) 
  },
  { 
    id: "111", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100233", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","67", 5) 
  },
  { 
    id: "112", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100370", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","68", 11) 
  },
  { 
    id: "113", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100135", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","69", 11) 
  },
  { 
    id: "114", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100216", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","70", 11) 
  },
  { 
    id: "115", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100254", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","71", 10) 
  },
  { 
    id: "116", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100640", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","72", 11) 
  },
  { 
    id: "117", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100253", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","73", 10) 
  },
  { 
    id: "118", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100386", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","74", 13) 
  },
  { 
    id: "119", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100371", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","75", 11) 
  },
  { 
    id: "120", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100243", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","76", 11) 
  },
  { 
    id: "121", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100290", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","77", 11) 
  },
  { 
    id: "122", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100293", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","78", 10) 
  },
  { 
    id: "123", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100382", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","79", 11) 
  },
  { 
    id: "124", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100613", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","80", 11) 
  },
  { 
    id: "125", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100230", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","81", 10) 
  },
  { 
    id: "126", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100103", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","82", 11) 
  },
  { 
    id: "127", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100158", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","83", 10) 
  },
  { 
    id: "128", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100507", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","84", 10) 
  },
  { 
    id: "129", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100611", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","85", 11) 
  },
  { 
    id: "130", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100471", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","86", 11) 
  },
  { 
    id: "131", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100217", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","87", 11) 
  },
  { 
    id: "132", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100390", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","88", 13) 
  },
  { 
    id: "133", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100285", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","89", 11) 
  },
  { 
    id: "134", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100238", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","90", 10) 
  },
  { 
    id: "135", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100256", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","91", 11) 
  },
  { 
    id: "136", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100544", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","92", 11) 
  },
  { 
    id: "137", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100313", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","93", 12) 
  },
  { 
    id: "138", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100294", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","94", 11) 
  },
  { 
    id: "139", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100550", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","95", 11) 
  },
  { 
    id: "140", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100160", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","96", 10) 
  },
  { 
    id: "141", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100127", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","97", 10) 
  },
  { 
    id: "142", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100454", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","98", 11) 
  },
  { 
    id: "143", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100307", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","99", 11) 
  },
  { 
    id: "144", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100224", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","100", 11) 
  },
  { 
    id: "145", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100129", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","101", 11) 
  },
  { 
    id: "146", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100229", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","102", 11) 
  },
  { 
    id: "147", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100345", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","103", 11) 
  },
  { 
    id: "148", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100235", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","104", 11) 
  },
  { 
    id: "149", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100110", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","105", 10) 
  },
  { 
    id: "150", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100511", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","106", 9) 
  },
  { 
    id: "151", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100583", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","107", 11) 
  },
  { 
    id: "152", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100476", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","108", 11) 
  },
  { 
    id: "153", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100417", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","109", 11) 
  },
  { 
    id: "154", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100203", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","110", 11) 
  },
  { 
    id: "155", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100251", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","111", 9) 
  },
  { 
    id: "156", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100438", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","112", 10) 
  },
  { 
    id: "157", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100286", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","113", 10) 
  },
  { 
    id: "158", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100627", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","114", 10) 
  },
  { 
    id: "159", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100214", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","115", 10) 
  },
  { 
    id: "160", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100145", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","116", 10) 
  },
  { 
    id: "161", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100151", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","117", 10) 
  },
  { 
    id: "162", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100320", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","118", 12) 
  },
  { 
    id: "163", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100101", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","119", 11) 
  },
  { 
    id: "164", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100406", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","120", 11) 
  },
  { 
    id: "165", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100125", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","121", 10) 
  },
  { 
    id: "166", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100250", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","122", 12) 
  },
  { 
    id: "167", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100569", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","123", 10) 
  },
  { 
    id: "168", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100121", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","124", 10) 
  },
  { 
    id: "169", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100354", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","125", 12) 
  },
  { 
    id: "170", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100498", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","126", 11) 
  },
  { 
    id: "171", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100453", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","127", 10) 
  },
  { 
    id: "172", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100529", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","128", 11) 
  },
  { 
    id: "173", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100560", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","129", 11) 
  },
  { 
    id: "174", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100364", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","130", 12) 
  },
  { 
    id: "175", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100494", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","131", 11) 
  },
  { 
    id: "176", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100562", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","132", 11) 
  },
  { 
    id: "177", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100527", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","133", 11) 
  },
  { 
    id: "178", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100510", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","134", 10) 
  },
  { 
    id: "179", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100580", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","135", 11) 
  },
  { 
    id: "180", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100431", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","136", 11) 
  },
  { 
    id: "181", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100328", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","137", 10) 
  },
  { 
    id: "182", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100197", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","138", 11) 
  },
  { 
    id: "183", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100119", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","139", 11) 
  },
  { 
    id: "184", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100322", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","140", 11) 
  },
  { 
    id: "185", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100136", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","141", 11) 
  },
  { 
    id: "186", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100138", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","142", 9) 
  },
  { 
    id: "187", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100488", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","143", 12) 
  },
  { 
    id: "188", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100234", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","144", 11) 
  },
  { 
    id: "189", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100302", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","145", 11) 
  },
  { 
    id: "190", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100196", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","146", 11) 
  },
  { 
    id: "191", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100187", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","147", 11) 
  },
  { 
    id: "192", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100303", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","148", 11) 
  },
  { 
    id: "193", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100593", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","149", 11) 
  },
  { 
    id: "194", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100228", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","150", 11) 
  },
  { 
    id: "195", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100600", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","151", 13) 
  },
  { 
    id: "196", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100479", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","152", 14) 
  },
  { 
    id: "197", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100185", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","153", 11) 
  },
  { 
    id: "198", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100104", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","154", 11) 
  },
  { 
    id: "199", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100516", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","155", 12) 
  },
  { 
    id: "200", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100433", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","156", 11) 
  },
  { 
    id: "201", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100385", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","157", 13) 
  },
  { 
    id: "202", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100387", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","158", 11) 
  },
  { 
    id: "203", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100457", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","159", 12) 
  },
  { 
    id: "204", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100523", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","160", 11) 
  },
  { 
    id: "205", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100398", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","161", 11) 
  },
  { 
    id: "206", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100271", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","162", 11) 
  },
  { 
    id: "207", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100210", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","163", 11) 
  },
  { 
    id: "208", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100153", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","164", 10) 
  },
  { 
    id: "209", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100418", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","165", 10) 
  },
  { 
    id: "210", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100141", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","166", 10) 
  },
  { 
    id: "211", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100346", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","167", 12) 
  },
  { 
    id: "212", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100506", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","168", 10) 
  },
  { 
    id: "213", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100624", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","169", 11) 
  },
  { 
    id: "214", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100389", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","170", 13) 
  },
  { 
    id: "215", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100340", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","171", 10) 
  },
  { 
    id: "216", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100227", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","172", 10) 
  },
  { 
    id: "217", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100194", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","173", 10) 
  },
  { 
    id: "218", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100122", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","174", 11) 
  },
  { 
    id: "219", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100595", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","175", 11) 
  },
  { 
    id: "220", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100531", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","176", 11) 
  },
  { 
    id: "221", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100232", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","177", 11) 
  },
  { 
    id: "222", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100181", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","178", 11) 
  },
  { 
    id: "223", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100157", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","179", 10) 
  },
  { 
    id: "224", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100167", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","180", 10) 
  },
  { 
    id: "225", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100384", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","181", 13) 
  },
  { 
    id: "226", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100297", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","182", 11) 
  },
  { 
    id: "227", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100200", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","183", 11) 
  },
  { 
    id: "228", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100372", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","184", 10) 
  },
  { 
    id: "229", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100449", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","185", 10) 
  },
  { 
    id: "230", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100368", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","186", 12) 
  },
  { 
    id: "231", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100540", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","187", 11) 
  },
  { 
    id: "232", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100133", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","188", 11) 
  },
  { 
    id: "233", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100156", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","189", 10) 
  },
  { 
    id: "234", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100586", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","190", 12) 
  },
  { 
    id: "235", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100379", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","191", 10) 
  },
  { 
    id: "236", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100175", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","192", 10) 
  },
  { 
    id: "237", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100491", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","193", 11) 
  },
  { 
    id: "238", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100215", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","194", 10) 
  },
  { 
    id: "239", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100383", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","195", 13) 
  },
  { 
    id: "240", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100278", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","196", 11) 
  },
  { 
    id: "241", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100402", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","197", 10) 
  },
  { 
    id: "242", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100480", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","198", 11) 
  },
  { 
    id: "243", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100537", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","199", 10) 
  },
  { 
    id: "244", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100549", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","200", 13) 
  },
  { 
    id: "245", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100159", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","201", 10) 
  },
  { 
    id: "246", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100642", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","202", 11) 
  },
  { 
    id: "247", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100440", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","203", 11) 
  },
  { 
    id: "248", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100526", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","204", 11) 
  },
  { 
    id: "249", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100319", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","205", 11) 
  },
  { 
    id: "250", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100425", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","206", 11) 
  },
  { 
    id: "251", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100358", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","207", 10) 
  },
  { 
    id: "252", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100308", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","208", 10) 
  },
  { 
    id: "253", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100124", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","209", 10) 
  },
  { 
    id: "254", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100332", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","210", 11) 
  },
  { 
    id: "255", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100329", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","211", 11) 
  },
  { 
    id: "256", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100450", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","212", 10) 
  },
  { 
    id: "257", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100437", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","213", 10) 
  },
  { 
    id: "258", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100273", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","214", 11) 
  },
  { 
    id: "259", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100317", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","215", 12) 
  },
  { 
    id: "260", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100206", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","216", 11) 
  },
  { 
    id: "261", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100325", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","217", 13) 
  },
  { 
    id: "262", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100405", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","218", 11) 
  },
  { 
    id: "263", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100209", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","219", 11) 
  },
  { 
    id: "264", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100436", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","220", 9) 
  },
  { 
    id: "265", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100192", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","221", 10) 
  },
  { 
    id: "266", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100279", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","222", 11) 
  },
  { 
    id: "267", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100469", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","223", 10) 
  },
  { 
    id: "268", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100534", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","224", 10) 
  },
  { 
    id: "269", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100482", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","225", 11) 
  },
  { 
    id: "270", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100535", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","226", 11) 
  },
  { 
    id: "271", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100249", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","227", 10) 
  },
  { 
    id: "272", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100305", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","228", 11) 
  },
  { 
    id: "273", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100410", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","229", 11) 
  },
  { 
    id: "274", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100522", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","230", 11) 
  },
  { 
    id: "275", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100374", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","231", 10) 
  },
  { 
    id: "276", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100460", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","232", 12) 
  },
  { 
    id: "277", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100497", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","233", 10) 
  },
  { 
    id: "278", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100574", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","234", 10) 
  },
  { 
    id: "279", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100335", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","235", 11) 
  },
  { 
    id: "280", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100155", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","236", 10) 
  },
  { 
    id: "281", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100177", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","237", 9) 
  },
  { 
    id: "282", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100588", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","238", 11) 
  },
  { 
    id: "283", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100274", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","239", 12) 
  },
  { 
    id: "284", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100171", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","240", 10) 
  },
  { 
    id: "285", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100164", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","241", 11) 
  },
  { 
    id: "286", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100409", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","242", 12) 
  },
  { 
    id: "287", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100267", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","243", 10) 
  },
  { 
    id: "288", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100300", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","244", 10) 
  },
  { 
    id: "289", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100140", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","245", 10) 
  },
  { 
    id: "290", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100342", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","246", 12) 
  },
  { 
    id: "291", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100625", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","247", 13) 
  },
  { 
    id: "292", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100552", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","248", 11) 
  },
  { 
    id: "293", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100348", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","249", 11) 
  },
  { 
    id: "294", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100609", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","250", 10) 
  },
  { 
    id: "295", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100429", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","251", 11) 
  },
  { 
    id: "296", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100174", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","252", 10) 
  },
  { 
    id: "297", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100255", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","253", 11) 
  },
  { 
    id: "298", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100421", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","254", 11) 
  },
  { 
    id: "299", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100128", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","255", 11) 
  },
  { 
    id: "300", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100324", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","256", 11) 
  },
  { 
    id: "301", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100199", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","257", 10) 
  },
  { 
    id: "302", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100287", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","258", 11) 
  },
  { 
    id: "303", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100289", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","259", 9) 
  },
  { 
    id: "304", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100252", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","260", 10) 
  },
  { 
    id: "305", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100142", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","261", 10) 
  },
  { 
    id: "306", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100334", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","262", 11) 
  },
  { 
    id: "307", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100152", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","263", 10) 
  },
  { 
    id: "308", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100444", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","264", 11) 
  },
  { 
    id: "309", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100359", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","265", 11) 
  },
  { 
    id: "310", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100485", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","266", 12) 
  },
  { 
    id: "311", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100509", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","267", 10) 
  },
  { 
    id: "312", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100579", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","268", 11) 
  },
  { 
    id: "313", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100484", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","269", 12) 
  },
  { 
    id: "314", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100393", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","270", 12) 
  },
  { 
    id: "315", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100242", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","271", 12) 
  },
  { 
    id: "316", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100598", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","272", 11) 
  },
  { 
    id: "317", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100612", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","273", 11) 
  },
  { 
    id: "318", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100495", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","274", 11) 
  },
  { 
    id: "319", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100365", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","275", 11) 
  },
  { 
    id: "320", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100367", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","276", 11) 
  },
  { 
    id: "321", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100524", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","277", 11) 
  },
  { 
    id: "322", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100536", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","278", 11) 
  },
  { 
    id: "323", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100515", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","279", 10) 
  },
  { 
    id: "324", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100219", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","280", 11) 
  },
  { 
    id: "325", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100556", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","281", 12) 
  },
  { 
    id: "326", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100451", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","282", 12) 
  },
  { 
    id: "327", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100173", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","283", 10) 
  },
  { 
    id: "328", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100411", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","284", 11) 
  },
  { 
    id: "329", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100458", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","285", 11) 
  },
  { 
    id: "330", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100375", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","286", 10) 
  },
  { 
    id: "331", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100366", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","287", 13) 
  },
  { 
    id: "332", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100304", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","288", 10) 
  },
  { 
    id: "333", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100149", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","289", 10) 
  },
  { 
    id: "334", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100472", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","290", 11) 
  },
  { 
    id: "335", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100231", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","291", 10) 
  },
  { 
    id: "336", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100213", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","292", 11) 
  },
  { 
    id: "337", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100218", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","293", 11) 
  },
  { 
    id: "338", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100284", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","294", 11) 
  },
  { 
    id: "339", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100567", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","295", 11) 
  },
  { 
    id: "340", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100414", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","296", 11) 
  },
  { 
    id: "341", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100636", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","297", 11) 
  },
  { 
    id: "342", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100513", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","298", 12) 
  },
  { 
    id: "343", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100347", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","299", 11) 
  },
  { 
    id: "344", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100248", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","300", 10) 
  },
  { 
    id: "345", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100378", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","301", 11) 
  },
  { 
    id: "346", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100269", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","302", 11) 
  },
  { 
    id: "347", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100432", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","303", 11) 
  },
  { 
    id: "348", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100517", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","304", 10) 
  },
  { 
    id: "349", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100245", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","305", 11) 
  },
  { 
    id: "350", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100596", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","306", 11) 
  },
  { 
    id: "351", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100343", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","307", 12) 
  },
  { 
    id: "352", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100131", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","308", 11) 
  },
  { 
    id: "353", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100143", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","309", 10) 
  },
  { 
    id: "354", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100403", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","310", 11) 
  },
  { 
    id: "355", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100323", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","311", 11) 
  },
  { 
    id: "356", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100521", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","312", 10) 
  },
  { 
    id: "357", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100504", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","313", 11) 
  },
  { 
    id: "358", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100459", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","314", 12) 
  },
  { 
    id: "359", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100505", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","315", 10) 
  },
  { 
    id: "360", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100239", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","316", 11) 
  },
  { 
    id: "361", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100532", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","317", 12) 
  },
  { 
    id: "362", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100558", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","318", 10) 
  },
  { 
    id: "363", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100182", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","319", 11) 
  },
  { 
    id: "364", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100288", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","320", 11) 
  },
  { 
    id: "365", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100445", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","321", 11) 
  },
  { 
    id: "366", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100247", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","322", 11) 
  },
  { 
    id: "367", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100607", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","323", 11) 
  },
  { 
    id: "368", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100481", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","324", 11) 
  },
  { 
    id: "369", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100394", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","325", 12) 
  },
  { 
    id: "370", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100559", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","326", 12) 
  },
  { 
    id: "371", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100606", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","327", 11) 
  },
  { 
    id: "372", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100619", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","328", 14) 
  },
  { 
    id: "373", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100577", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","329", 10) 
  },
  { 
    id: "374", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100419", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","330", 12) 
  },
  { 
    id: "375", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100280", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","331", 11) 
  },
  { 
    id: "376", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100193", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","332", 11) 
  },
  { 
    id: "377", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100186", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","333", 10) 
  },
  { 
    id: "378", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100601", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","334", 14) 
  },
  { 
    id: "379", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100508", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","335", 11) 
  },
  { 
    id: "380", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100147", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","336", 10) 
  },
  { 
    id: "381", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100571", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","337", 11) 
  },
  { 
    id: "382", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100435", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","338", 9) 
  },
  { 
    id: "383", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100361", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","339", 12) 
  },
  { 
    id: "384", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100422", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","340", 11) 
  },
  { 
    id: "385", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100331", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","341", 11) 
  },
  { 
    id: "386", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100376", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","342", 11) 
  },
  { 
    id: "387", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100604", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","343", 12) 
  },
  { 
    id: "388", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100493", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","344", 11) 
  },
  { 
    id: "389", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100575", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","345", 12) 
  },
  { 
    id: "390", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100123", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","346", 11) 
  },
  { 
    id: "391", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100257", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","347", 11) 
  },
  { 
    id: "392", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100599", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","348", 14) 
  },
  { 
    id: "393", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100632", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","349", 10) 
  },
  { 
    id: "394", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100117", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","350", 11) 
  },
  { 
    id: "395", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100538", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","351", 11) 
  },
  { 
    id: "396", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100272", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","352", 10) 
  },
  { 
    id: "397", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100266", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","353", 10) 
  },
  { 
    id: "398", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100582", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","354", 11) 
  },
  { 
    id: "399", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100631", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","355", 11) 
  },
  { 
    id: "400", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100573", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","356", 10) 
  },
  { 
    id: "401", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100478", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","357", 11) 
  },
  { 
    id: "402", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100475", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","358", 11) 
  },
  { 
    id: "403", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100641", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","359", 12) 
  },
  { 
    id: "404", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100519", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","360", 11) 
  },
  { 
    id: "405", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100198", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","361", 11) 
  },
  { 
    id: "406", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100108", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","362", 10) 
  },
  { 
    id: "407", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100520", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","363", 11) 
  },
  { 
    id: "408", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100190", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","364", 11) 
  },
  { 
    id: "409", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100592", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","365", 11) 
  },
  { 
    id: "410", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100637", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","366", 11) 
  },
  { 
    id: "411", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100113", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","367", 11) 
  },
  { 
    id: "412", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100539", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","368", 11) 
  },
  { 
    id: "413", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100463", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","369", 14) 
  },
  { 
    id: "414", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100400", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","370", 9) 
  },
  { 
    id: "415", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100553", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","371", 11) 
  },
  { 
    id: "416", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100589", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","372", 11) 
  },
  { 
    id: "417", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100299", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","373", 11) 
  },
  { 
    id: "418", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100501", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","374", 9) 
  },
  { 
    id: "419", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100388", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","375", 11) 
  },
  { 
    id: "420", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100545", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","376", 15) 
  },
  { 
    id: "421", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100220", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","377", 5) 
  },
  { 
    id: "422", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100263", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","378", 10) 
  },
  { 
    id: "423", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100336", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","379", 11) 
  },
  { 
    id: "424", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100337", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","380", 11) 
  },
  { 
    id: "425", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100281", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","381", 11) 
  },
  { 
    id: "426", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100547", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","382", 11) 
  },
  { 
    id: "427", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100566", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","383", 11) 
  },
  { 
    id: "428", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100415", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","384", 11) 
  },
  { 
    id: "429", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100461", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","385", 11) 
  },
  { 
    id: "430", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100496", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","386", 10) 
  },
  { 
    id: "431", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100191", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","387", 11) 
  },
  { 
    id: "432", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100223", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","388", 14) 
  },
  { 
    id: "433", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100225", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","389", 9) 
  },
  { 
    id: "434", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100212", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","390", 10) 
  },
  { 
    id: "435", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100423", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","391", 11) 
  },
  { 
    id: "436", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100448", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","392", 11) 
  },
  { 
    id: "437", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100201", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","393", 10) 
  },
  { 
    id: "438", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100473", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","394", 11) 
  },
  { 
    id: "439", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100646", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","395", 10) 
  },
  { 
    id: "440", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100590", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","396", 10) 
  },
  { 
    id: "441", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100512", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","397", 10) 
  },
  { 
    id: "442", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100591", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","398", 10) 
  },
  { 
    id: "443", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100605", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","399", 11) 
  },
  { 
    id: "444", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100165", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","400", 10) 
  },
  { 
    id: "445", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100107", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","401", 10) 
  },
  { 
    id: "446", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100146", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","402", 10) 
  },
  { 
    id: "447", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100207", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","403", 10) 
  },
  { 
    id: "448", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100134", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","404", 11) 
  },
  { 
    id: "449", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100428", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","405", 11) 
  },
  { 
    id: "450", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100635", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","406", 13) 
  },
  { 
    id: "451", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100262", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","407", 11) 
  },
  { 
    id: "452", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100258", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","408", 11) 
  },
  { 
    id: "453", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100326", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","409", 10) 
  },
  { 
    id: "454", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100176", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","410", 10) 
  },
  { 
    id: "455", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100533", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","411", 12) 
  },
  { 
    id: "456", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100474", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","412", 11) 
  },
  { 
    id: "457", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100563", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","413", 12) 
  },
  { 
    id: "458", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100399", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","414", 11) 
  },
  { 
    id: "459", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100236", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","415", 10) 
  },
  { 
    id: "460", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100261", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","416", 11) 
  },
  { 
    id: "461", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100615", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","417", 12) 
  },
  { 
    id: "462", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100644", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","418", 12) 
  },
  { 
    id: "463", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100314", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","419", 11) 
  },
  { 
    id: "464", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100465", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","420", 10) 
  },
  { 
    id: "465", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100244", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","421", 10) 
  },
  { 
    id: "466", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100541", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","422", 11) 
  },
  { 
    id: "467", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100392", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","423", 10) 
  },
  { 
    id: "468", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100424", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","424", 11) 
  },
  { 
    id: "469", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100572", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","425", 12) 
  },
  { 
    id: "470", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100542", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","426", 12) 
  },
  { 
    id: "471", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100561", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","427", 14) 
  },
  { 
    id: "472", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100362", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","428", 11) 
  },
  { 
    id: "473", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100434", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","429", 10) 
  },
  { 
    id: "474", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100350", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","430", 11) 
  },
  { 
    id: "475", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100204", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","431", 11) 
  },
  { 
    id: "476", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100622", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","432", 11) 
  },
  { 
    id: "477", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100268", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","433", 9) 
  },
  { 
    id: "478", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100557", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","434", 12) 
  },
  { 
    id: "479", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100195", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","435", 11) 
  },
  { 
    id: "480", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100270", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","436", 10) 
  },
  { 
    id: "481", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100154", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","437", 10) 
  },
  { 
    id: "482", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100282", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","438", 11) 
  },
  { 
    id: "483", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100183", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","439", 10) 
  },
  { 
    id: "484", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100363", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","440", 11) 
  },
  { 
    id: "485", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100466", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","441", 11) 
  },
  { 
    id: "486", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100240", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","442", 10) 
  },
  { 
    id: "487", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100377", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","443", 11) 
  },
  { 
    id: "488", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100446", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","444", 11) 
  },
  { 
    id: "489", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100576", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","445", 11) 
  },
  { 
    id: "490", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100330", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","446", 11) 
  },
  { 
    id: "491", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100168", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","447", 10) 
  },
  { 
    id: "492", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100339", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","448", 10) 
  },
  { 
    id: "493", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100184", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","449", 11) 
  },
  { 
    id: "494", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100264", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","450", 10) 
  },
  { 
    id: "495", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100341", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","451", 11) 
  },
  { 
    id: "496", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100139", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","452", 10) 
  },
  { 
    id: "497", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100296", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","453", 11) 
  },
  { 
    id: "498", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100318", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","454", 10) 
  },
  { 
    id: "499", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100106", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","455", 11) 
  },
  { 
    id: "500", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100617", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","456", 10) 
  },
  { 
    id: "501", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100621", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","457", 11) 
  },
  { 
    id: "502", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100610", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","458", 10) 
  },
  { 
    id: "503", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100630", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","459", 12) 
  },
  { 
    id: "504", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100241", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","460", 11) 
  },
  { 
    id: "505", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100166", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","461", 10) 
  },
  { 
    id: "506", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100202", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","462", 11) 
  },
  { 
    id: "507", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100115", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","463", 11) 
  },
  { 
    id: "508", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100277", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","464", 13) 
  },
  { 
    id: "509", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100608", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","465", 10) 
  },
  { 
    id: "510", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100295", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","466", 11) 
  },
  { 
    id: "511", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100355", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","467", 12) 
  },
  { 
    id: "512", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100259", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","468", 11) 
  },
  { 
    id: "513", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100211", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","469", 11) 
  },
  { 
    id: "514", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100353", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","470", 11) 
  },
  { 
    id: "515", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100222", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","471", 11) 
  },
  { 
    id: "516", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100237", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","472", 11) 
  },
  { 
    id: "517", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100470", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","473", 12) 
  },
  { 
    id: "518", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100447", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","474", 11) 
  },
  { 
    id: "519", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100490", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","475", 10) 
  },
  { 
    id: "520", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100594", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","476", 11) 
  },
  { 
    id: "521", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100265", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","477", 10) 
  },
  { 
    id: "522", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100603", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","478", 11) 
  },
  { 
    id: "523", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100312", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","479", 11) 
  },
  { 
    id: "524", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100144", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","480", 10) 
  },
  { 
    id: "525", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100555", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","481", 11) 
  },
  { 
    id: "526", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100275", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","482", 11) 
  },
  { 
    id: "527", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100112", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","483", 11) 
  },
  { 
    id: "528", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100408", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","484", 11) 
  },
  { 
    id: "529", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100587", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","485", 11) 
  },
  { 
    id: "530", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100528", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","486", 11) 
  },
  { 
    id: "531", 
    name: "Yupoo Shoes:Nike Air Jordan(aj) Sneakers CXS100416", 
    description: "Celebrate basketball heritage with Nike Air Jordan(aj) Sneakers, the legendary footwear that blends court-ready performance with streetwear prestige. Designed for athletes and sneakerheads alike, each pair delivers responsive cushioning, premium materials, and the timeless Jumpman logo that defines excellence.", 
    price: PriceInfo, 
    categories: ["shoes", "aj"], 
    images: generateAjImagePaths("shoes", "Nike","487", 11) 
  },
  { 
    id: "532", 
    name: "Yupoo Shoes: Converse 1970s Patchwork Low Top-Unisex Canvas Sneakers", 
    description: "These classic Converse 1970s low tops feature a stylish patchwork design on durable canvas, with a comfortable cushioned sole for all-day wear. The non-slip rubber outsole provides excellent traction, making these unisex sneakers perfect for both casual outings and everyday style. 🌟", 
    price: PriceInfo, 
    categories: ["shoes"], 
    images: generateImagePaths("shoes", "Converse","2", 9) 
  },
  { 
    id: "533", 
    name: "Yupoo Shoes: LV Trainer Sneakers - Monogram Patchwork Leather (Virgil Abloh Inspired)", 
    description: "These iconic LV Trainer sneakers reimagine Virgil Abloh's classic with premium perforated leather, grained calfskin, and bold Monogram floral accents. Featuring a cushioned collar, contrast LV tongue branding, and signature TPU rubber soles, they blend retro basketball vibes with high-fashion streetwear. 🔥 #yupooshoes #yupoolv #yupoo", 
    price: PriceInfo, 
    categories: ["shoes", "lv"], 
    images: generateImagePaths("shoes", "Lv","2", 9) 
  },
  { 
    id: "534", 
    name: "Yupoo Shoes: LV x Nike Dunk Low Carhartt - Custom Streetwear Sneakers (Made by Ideas) ", 
    description: "Breaking traditional design limits, this LV x Nike Dunk Low collab unites top designers to create bold, personalized streetwear. With \"Made by Ideas\" creativity, it empowers you to define your own—where luxury meets urban edge in every stitch. 🔥 #yupooshoes #yupoolv #yupoonike #shoes #Carhartt", 
    price: PriceInfo, 
    categories: ["shoes", "nike", "lv", "nike"], 
    images: generateImagePaths("shoes", "Nike","488", 9) 
  },
  { 
    id: "535", 
    name: "Yupoo Watch: Hublot Spirit of Big Bang 42mm - Ceramic Chrono Limited Edition 🐝", 
    description: "This top-tier Hublot Yupoo features a bold 42mm ceramic/titanium case with sapphire crystal, HUB4700 automatic movement (45h power reserve), and quick-release rubber strap. A \"Toxic Yellow\" stunner for collectors who demand precision. 🔥#yupoowath #watch #yupoo #Hublot #yupoohublot", 
    price: PriceInfo, 
    categories: ["watch", "hublot"], 
    images: generateImagePaths("watch", "Hublot","1", 9) 
  },
  { 
    id: "536", 
    name: "Yupoo Shoes: New Balance M1906R - Retro Dad Shoes w/ T-Beam Support", 
    description: "These unisex NB M1906R retro runners feature premium leather/mesh uppers with distressed color-blocking, T-Beam arch support for stability, and exposed heel cushioning. The yellowed soles add vintage charm while delivering all-day comfort. Perfect for streetwear lovers! #yupooshoes #shoes #yupoonb #NbShoes #NewBalance", 
    price: PriceInfo, 
    categories: ["shoes", "nb"], 
    images: generateImagePaths("shoes", "Nb","5", 9),
    featured: true,
  },
  { 
    id: "537", 
    name: "Yupoo Shoes: New Balance M1906R \"Silver\" - Retro Dad Shoes w/ T-Beam Tech 👟", 
    description: "Upgraded with eco-leather/mesh uppers and precise sizing, these NB M1906R retro runners feature T-Beam arch support, exposed heel cushioning, and Y2K metallic flair—blending vintage aesthetics with modern stability for street-ready comfort. #yupooshoes #shoes #yupoonb #NbShoes #NewBalance", 
    price: PriceInfo, 
    categories: ["shoes", "nb"], 
    images: generateImagePaths("shoes", "Nb","6", 9) 
  },
  { 
    id: "538", 
    name: "Yupoo Shoes: New Balance M1906R Silver - Eco Leather Retro Runners 👟", 
    description: "These unisex NB M1906R sneakers blend Y2K nostalgia with modern tech, featuring eco-leather/mesh uppers, T-Beam arch support, and exposed heel cushioning for all-day comfort in a metallic silver vintage revival. #yupooshoes #shoes #yupoonb #NbShoes #NewBalance", 
    price: PriceInfo, 
    categories: ["shoes", "nb"], 
    images: generateImagePaths("shoes", "Nb","7", 9) 
  },
  { 
    id: "539", 
    name: "Yupoo Shoes: New Balance  990v4 - NB Premium Suede President Runners 👟", 
    description: "Crafted with imported pigskin suede and advanced cushioning, these NB 990v4 \"President Run\" sneakers deliver elite comfort and durability for all-day wear, blending luxury materials with iconic American craftsmanship. #yupooshoes #shoes #yupoonb #NbShoes #NewBalance", 
    price: PriceInfo, 
    categories: ["shoes", "nb"], 
    images: generateImagePaths("shoes", "Nb","8", 4) 
  },
  { 
    id: "540", 
    name: "Yupoo Shoes: New Balance 2010 - NB ENCAP/N-ERGY Retro Yupoo Sneakers 👟", 
    description: "These pure-origin NB 2010 retro runners blend premium suede with classic nylon mesh, featuring upgraded ENCAP/N-ERGY cushioning for legendary comfort while keeping the authentic running heritage alive for the new gen. #yupooshoes #shoes #yupoonb #NbShoes #NewBalance #YupooSneakers", 
    price: PriceInfo, 
    categories: ["shoes", "nb"], 
    images: generateImagePaths("shoes", "Nb","9", 9) 
  },
  {
    id: "541",
    name: "Yupoo Shoes:Adidas Yeezy500",
    description: "Get the Adidas Yeezy500 shoes from productalbum.cn. They offer a balance of style and comfort, making them a versatile addition to your shoe collection. #yupooshoes #yupooyeezy #yeezy #yupooadidas",
    price: PriceInfo,
    categories: [
      "shoes",
      "yeezy",
      "adidas"
    ],
    images: [
      "/productimgs/shoes/Adidas/4/yeezy yupoo 001-Adida Yeezy500  1.jpg",
      "/productimgs/shoes/Adidas/4/yeezy yupoo 001-Adida Yeezy500  2.jpg",
      "/productimgs/shoes/Adidas/4/yeezy yupoo 001-Adida Yeezy500  3.jpg",
      "/productimgs/shoes/Adidas/4/yeezy yupoo 001-Adida Yeezy500  4.jpg",
      "/productimgs/shoes/Adidas/4/yeezy yupoo 001-Adida Yeezy500  5.jpg",
      "/productimgs/shoes/Adidas/4/yeezy yupoo 001-Adida Yeezy500  6.jpg",
      "/productimgs/shoes/Adidas/4/yeezy yupoo 001-Adida Yeezy500  7.jpg"
    ]
  },
  {
    id: "542",
    name: "Yupoo Shoes: Premium Yeezy Yupoo Sneakers",
    description: "Premium quality Yeezy Yupoo Sneakers from productalbum.cn. These high-end Yupoos perfectly capture the design and comfort of the authentic version at an affordable price. #yupooshoes #yupooyeezy #yeezy #yupooadidas",
    price: PriceInfo,
    categories: [
      "shoes",
      "yeezy",
      "adidas"
    ],
    images: [
      "/productimgs/shoes/Adidas/73/yupoo yeezy 350 V2 yupoo shoes 1.jpg",
      "/productimgs/shoes/Adidas/73/yupoo yeezy 350 V2 yupoo shoes 2.jpg",
      "/productimgs/shoes/Adidas/73/yupoo yeezy 350 V2 yupoo shoes 3.jpg",
      "/productimgs/shoes/Adidas/73/yupoo yeezy 350 V2 yupoo shoes 4.jpg",
      "/productimgs/shoes/Adidas/73/yupoo yeezy 350 V2 yupoo shoes 5.jpg",
      "/productimgs/shoes/Adidas/73/yupoo yeezy 350 V2 yupoo shoes 6.jpg",
      "/productimgs/shoes/Adidas/73/yupoo yeezy 350 V2 yupoo shoes 7.jpg",
      "/productimgs/shoes/Adidas/73/yupoo yeezy 350 V2 yupoo shoes 8.jpg",
      "/productimgs/shoes/Adidas/73/yupoo yeezy 350 V2 yupoo shoes 9.jpg",
      "/productimgs/shoes/Adidas/73/yupoo yeezy 350 V2 yupoo shoes 10.jpg",
      "/productimgs/shoes/Adidas/73/yupoo yeezy 350 V2 yupoo shoes 11.jpg",
      "/productimgs/shoes/Adidas/73/yupoo yeezy 350 V2 yupoo shoes 12.jpg",
      "/productimgs/shoes/Adidas/73/yupoo yeezy 350 V2 yupoo shoes 13.jpg",
      "/productimgs/shoes/Adidas/73/yupoo yeezy 350 V2 yupoo shoes 14.jpg",
      "/productimgs/shoes/Adidas/73/yupoo yeezy 350 V2 yupoo shoes 15.jpg",
      "/productimgs/shoes/Adidas/73/yupoo yeezy 350 V2 yupoo shoes 16.jpg",
      "/productimgs/shoes/Adidas/73/yupoo yeezy 350 V2 yupoo shoes 17.jpg",
      "/productimgs/shoes/Adidas/73/yupoo yeezy 350 V2 yupoo shoes 18.jpg",
      "/productimgs/shoes/Adidas/73/yupoo yeezy 350 V2 yupoo shoes 19.jpg"
    ]
  },
  {
    id: "543",
    name: "Yupoo Shoes: Premium Yeezy Yupoo Sneakers",
    description: "Premium quality Yeezy Yupoo Sneakers from productalbum.cn. These high-end Yupoos perfectly capture the design and comfort of the authentic version at an affordable price. #yupooshoes #yupooyeezy #yeezy #yupooadidas",
    price: PriceInfo,
    categories: [
      "shoes",
      "yeezy",
      "adidas"
    ],
    images: [
      "/productimgs/shoes/Adidas/66/yupoo yeezy 350 V2 yupoo shoes 1.jpg",
      "/productimgs/shoes/Adidas/66/yupoo yeezy 350 V2 yupoo shoes 2.jpg",
      "/productimgs/shoes/Adidas/66/yupoo yeezy 350 V2 yupoo shoes 3.jpg",
      "/productimgs/shoes/Adidas/66/yupoo yeezy 350 V2 yupoo shoes 4.jpg",
      "/productimgs/shoes/Adidas/66/yupoo yeezy 350 V2 yupoo shoes 5.jpg",
      "/productimgs/shoes/Adidas/66/yupoo yeezy 350 V2 yupoo shoes 6.jpg",
      "/productimgs/shoes/Adidas/66/yupoo yeezy 350 V2 yupoo shoes 7.jpg",
      "/productimgs/shoes/Adidas/66/yupoo yeezy 350 V2 yupoo shoes 8.jpg",
      "/productimgs/shoes/Adidas/66/yupoo yeezy 350 V2 yupoo shoes 9.jpg",
      "/productimgs/shoes/Adidas/66/yupoo yeezy 350 V2 yupoo shoes 10.jpg",
      "/productimgs/shoes/Adidas/66/yupoo yeezy 350 V2 yupoo shoes 11.jpg",
      "/productimgs/shoes/Adidas/66/yupoo yeezy 350 V2 yupoo shoes 12.jpg",
      "/productimgs/shoes/Adidas/66/yupoo yeezy 350 V2 yupoo shoes 13.jpg",
      "/productimgs/shoes/Adidas/66/yupoo yeezy 350 V2 yupoo shoes 14.jpg",
      "/productimgs/shoes/Adidas/66/yupoo yeezy 350 V2 yupoo shoes 15.jpg",
      "/productimgs/shoes/Adidas/66/yupoo yeezy 350 V2 yupoo shoes 16.jpg",
      "/productimgs/shoes/Adidas/66/yupoo yeezy 350 V2 yupoo shoes 17.jpg",
      "/productimgs/shoes/Adidas/66/yupoo yeezy 350 V2 yupoo shoes 18.jpg",
      "/productimgs/shoes/Adidas/66/yupoo yeezy 350 V2 yupoo shoes 19.jpg",
      "/productimgs/shoes/Adidas/66/yupoo yeezy 350 V2 yupoo shoes 20.jpg",
      "/productimgs/shoes/Adidas/66/yupoo yeezy 350 V2 yupoo shoes 21.jpg",
      "/productimgs/shoes/Adidas/66/yupoo yeezy 350 V2 yupoo shoes 22.jpg",
      "/productimgs/shoes/Adidas/66/yupoo yeezy 350 V2 yupoo shoes 23.jpg",
      "/productimgs/shoes/Adidas/66/yupoo yeezy 350 V2 yupoo shoes 24.jpg",
      "/productimgs/shoes/Adidas/66/yupoo yeezy 350 V2 yupoo shoes 25.jpg",
      "/productimgs/shoes/Adidas/66/yupoo yeezy 350 V2 yupoo shoes 26.jpg",
      "/productimgs/shoes/Adidas/66/yupoo yeezy 350 V2 yupoo shoes 27.jpg",
      "/productimgs/shoes/Adidas/66/yupoo yeezy 350 V2 yupoo shoes 28.jpg",
      "/productimgs/shoes/Adidas/66/yupoo yeezy 350 V2 yupoo shoes 29.jpg",
      "/productimgs/shoes/Adidas/66/yupoo yeezy 350 V2 yupoo shoes 30.jpg"
    ]
  },
  {
    id: "544",
    name: "Yupoo Shoes: Adidas Yeezy 700",
    description: "Shop the Adidas Yeezy 700 shoes on Yupoo. These shoes are known for their bold design and excellent performance, adding a touch of style to your outfit. #yupooshoes #yupooyeezy #yeezy #yupooadidas",
    price: PriceInfo,
    categories: [
      "shoes",
      "yeezy",
      "adidas"
    ],
    images: [
      "/productimgs/shoes/Adidas/10/yeezy yupoo Adida Yeezy 700  1.jpg",
      "/productimgs/shoes/Adidas/10/yeezy yupoo Adida Yeezy 700  2.jpg",
      "/productimgs/shoes/Adidas/10/yeezy yupoo Adida Yeezy 700  3.jpg",
      "/productimgs/shoes/Adidas/10/yeezy yupoo Adida Yeezy 700  4.jpg",
      "/productimgs/shoes/Adidas/10/yeezy yupoo Adida Yeezy 700  5.jpg",
      "/productimgs/shoes/Adidas/10/yeezy yupoo Adida Yeezy 700  6.jpg",
      "/productimgs/shoes/Adidas/10/yeezy yupoo Adida Yeezy 700  7.jpg",
      "/productimgs/shoes/Adidas/10/yeezy yupoo Adida Yeezy 700  8.jpg"
    ]
  },
  {
    id: "545",
    name: "Yupoo Shoes: Premium Yeezy Yupoo Sneakers",
    description: "Premium quality Yeezy Yupoo Sneakers from productalbum.cn. These high-end Yupoos perfectly capture the design and comfort of the authentic version at an affordable price. #yupooshoes #yupooyeezy #yeezy #yupooadidas",
    price: PriceInfo,
    categories: [
      "shoes",
      "yeezy",
      "adidas"
    ],
    images: [
      "/productimgs/shoes/Adidas/95/yupoo yeezy 750 Boost yupoo shoes 3.jpg",
      "/productimgs/shoes/Adidas/95/yupoo yeezy 750 Boost yupoo shoes 2.jpg",
      "/productimgs/shoes/Adidas/95/yupoo yeezy 750 Boost yupoo shoes 4.jpg",
      "/productimgs/shoes/Adidas/95/yupoo yeezy 750 Boost yupoo shoes 5.jpg",
      "/productimgs/shoes/Adidas/95/yupoo yeezy 750 Boost yupoo shoes 6.jpg",
      "/productimgs/shoes/Adidas/95/yupoo yeezy 750 Boost yupoo shoes 7.jpg",
      "/productimgs/shoes/Adidas/95/yupoo yeezy 750 Boost yupoo shoes 9.jpg",
      "/productimgs/shoes/Adidas/95/yupoo yeezy 750 Boost yupoo shoes 10.jpg",
      "/productimgs/shoes/Adidas/95/yupoo yeezy 750 Boost yupoo shoes 11.jpg",
      "/productimgs/shoes/Adidas/95/yupoo yeezy 750 Boost yupoo shoes 12.jpg",
      "/productimgs/shoes/Adidas/95/yupoo yeezy 750 Boost yupoo shoes 13.jpg",
      "/productimgs/shoes/Adidas/95/yupoo yeezy 750 Boost yupoo shoes 14.jpg"
    ]
  },
  {
    id: "546",
    name: "Yupoo Shoes: Premium Yeezy Yupoo Sneakers",
    description: "Premium quality Yeezy Yupoo Sneakers from productalbum.cn. These high-end Yupoos perfectly capture the design and comfort of the authentic version at an affordable price. #yupooshoes #yupooyeezy #yeezy #yupooadidas",
    price: PriceInfo,
    categories: [
      "shoes",
      "yeezy",
      "adidas"
    ],
    images: [
      "/productimgs/shoes/Adidas/52/yupoo yeezy 350 V2 yupoo shoes 1.jpg",
      "/productimgs/shoes/Adidas/52/yupoo yeezy 350 V2 yupoo shoes 2.jpg",
      "/productimgs/shoes/Adidas/52/yupoo yeezy 350 V2 yupoo shoes 3.jpg",
      "/productimgs/shoes/Adidas/52/yupoo yeezy 350 V2 yupoo shoes 4.jpg",
      "/productimgs/shoes/Adidas/52/yupoo yeezy 350 V2 yupoo shoes 5.jpg",
      "/productimgs/shoes/Adidas/52/yupoo yeezy 350 V2 yupoo shoes 6.jpg",
      "/productimgs/shoes/Adidas/52/yupoo yeezy 350 V2 yupoo shoes 7.jpg",
      "/productimgs/shoes/Adidas/52/yupoo yeezy 350 V2 yupoo shoes 8.jpg",
      "/productimgs/shoes/Adidas/52/yupoo yeezy 350 V2 yupoo shoes 9.jpg",
      "/productimgs/shoes/Adidas/52/yupoo yeezy 350 V2 yupoo shoes 10.jpg",
      "/productimgs/shoes/Adidas/52/yupoo yeezy 350 V2 yupoo shoes 11.jpg",
      "/productimgs/shoes/Adidas/52/yupoo yeezy 350 V2 yupoo shoes 12.jpg",
      "/productimgs/shoes/Adidas/52/yupoo yeezy 350 V2 yupoo shoes 13.jpg",
      "/productimgs/shoes/Adidas/52/yupoo yeezy 350 V2 yupoo shoes 14.jpg",
      "/productimgs/shoes/Adidas/52/yupoo yeezy 350 V2 yupoo shoes 15.jpg",
      "/productimgs/shoes/Adidas/52/yupoo yeezy 350 V2 yupoo shoes 16.jpg"
    ]
  },
  {
    id: "547",
    name: "Yupoo Shoes: Premium Yeezy Yupoo Sneakers",
    description: "Premium quality Yeezy Yupoo Sneakers from productalbum.cn. These high-end Yupoos perfectly capture the design and comfort of the authentic version at an affordable price. #yupooshoes #yupooyeezy #yeezy #yupooadidas",
    price: PriceInfo,
    categories: [
      "shoes",
      "yeezy",
      "adidas"
    ],
    images: [
      "/productimgs/shoes/Adidas/28/yupoo yeezy 350 Boost V2 yupoo shoes 1.jpg",
      "/productimgs/shoes/Adidas/28/yupoo yeezy 350 Boost V2 yupoo shoes 2.jpg",
      "/productimgs/shoes/Adidas/28/yupoo yeezy 350 Boost V2 yupoo shoes 3.jpg",
      "/productimgs/shoes/Adidas/28/yupoo yeezy 350 Boost V2 yupoo shoes 4.jpg",
      "/productimgs/shoes/Adidas/28/yupoo yeezy 350 Boost V2 yupoo shoes 5.jpg",
      "/productimgs/shoes/Adidas/28/yupoo yeezy 350 Boost V2 yupoo shoes 6.jpg",
      "/productimgs/shoes/Adidas/28/yupoo yeezy 350 Boost V2 yupoo shoes 7.jpg",
      "/productimgs/shoes/Adidas/28/yupoo yeezy 350 Boost V2 yupoo shoes 8.jpg",
      "/productimgs/shoes/Adidas/28/yupoo yeezy 350 Boost V2 yupoo shoes 9.jpg",
      "/productimgs/shoes/Adidas/28/yupoo yeezy 350 Boost V2 yupoo shoes 10.jpg",
      "/productimgs/shoes/Adidas/28/yupoo yeezy 350 Boost V2 yupoo shoes 11.jpg",
      "/productimgs/shoes/Adidas/28/yupoo yeezy 350 Boost V2 yupoo shoes 12.jpg",
      "/productimgs/shoes/Adidas/28/yupoo yeezy 350 Boost V2 yupoo shoes 13.jpg",
      "/productimgs/shoes/Adidas/28/yupoo yeezy 350 Boost V2 yupoo shoes 14.jpg",
      "/productimgs/shoes/Adidas/28/yupoo yeezy 350 Boost V2 yupoo shoes 15.jpg",
      "/productimgs/shoes/Adidas/28/yupoo yeezy 350 Boost V2 yupoo shoes 16.jpg"
    ]
  },
  {
    id: "548",
    name: "Yupoo Shoes: Premium Yeezy Yupoo Sneakers",
    description: "Premium quality Yeezy Yupoo Sneakers from productalbum.cn. These high-end Yupoos perfectly capture the design and comfort of the authentic version at an affordable price. #yupooshoes #yupooyeezy #yeezy #yupooadidas",
    price: PriceInfo,
    categories: [
      "shoes",
      "yeezy",
      "adidas"
    ],
    images: [
      "/productimgs/shoes/Adidas/71/yupoo yeezy 350 V2 yupoo shoes 1.jpg",
      "/productimgs/shoes/Adidas/71/yupoo yeezy 350 V2 yupoo shoes 2.jpg",
      "/productimgs/shoes/Adidas/71/yupoo yeezy 350 V2 yupoo shoes 3.jpg",
      "/productimgs/shoes/Adidas/71/yupoo yeezy 350 V2 yupoo shoes 4.jpg",
      "/productimgs/shoes/Adidas/71/yupoo yeezy 350 V2 yupoo shoes 5.jpg",
      "/productimgs/shoes/Adidas/71/yupoo yeezy 350 V2 yupoo shoes 6.jpg",
      "/productimgs/shoes/Adidas/71/yupoo yeezy 350 V2 yupoo shoes 7.jpg",
      "/productimgs/shoes/Adidas/71/yupoo yeezy 350 V2 yupoo shoes 8.jpg",
      "/productimgs/shoes/Adidas/71/yupoo yeezy 350 V2 yupoo shoes 9.jpg",
      "/productimgs/shoes/Adidas/71/yupoo yeezy 350 V2 yupoo shoes 10.jpg",
      "/productimgs/shoes/Adidas/71/yupoo yeezy 350 V2 yupoo shoes 11.jpg",
      "/productimgs/shoes/Adidas/71/yupoo yeezy 350 V2 yupoo shoes 12.jpg",
      "/productimgs/shoes/Adidas/71/yupoo yeezy 350 V2 yupoo shoes 13.jpg",
      "/productimgs/shoes/Adidas/71/yupoo yeezy 350 V2 yupoo shoes 14.jpg",
      "/productimgs/shoes/Adidas/71/yupoo yeezy 350 V2 yupoo shoes 15.jpg",
      "/productimgs/shoes/Adidas/71/yupoo yeezy 350 V2 yupoo shoes 16.jpg"
    ]
  },
  {
    id: "549",
    name: "Yupoo Shoes: Adidas Yeezy 700",
    description: "Shop the Adidas Yeezy 700 shoes on Yupoo. These shoes are known for their bold design and excellent performance, adding a touch of style to your outfit. #yupooshoes #yupooyeezy #yeezy #yupooadidas",
    price: PriceInfo,
    categories: [
      "shoes",
      "yeezy",
      "adidas"
    ],
    images: [
      "/productimgs/shoes/Adidas/8/yeezy yupoo Adida Yeezy 700   1.jpeg",
      "/productimgs/shoes/Adidas/8/yeezy yupoo Adida Yeezy 700   1.jpg",
      "/productimgs/shoes/Adidas/8/yeezy yupoo Adida Yeezy 700   2.jpg",
      "/productimgs/shoes/Adidas/8/yeezy yupoo Adida Yeezy 700   3.jpg",
      "/productimgs/shoes/Adidas/8/yeezy yupoo Adida Yeezy 700   4.jpg",
      "/productimgs/shoes/Adidas/8/yeezy yupoo Adida Yeezy 700   5.jpg",
      "/productimgs/shoes/Adidas/8/yeezy yupoo Adida Yeezy 700   6.jpg"
    ]
  },
  {
    id: "550",
    name: "Yupoo Shoes: Premium Yeezy Yupoo Sneakers",
    description: "Premium quality Yeezy Yupoo Sneakers from productalbum.cn. These high-end Yupoos perfectly capture the design and comfort of the authentic version at an affordable price. #yupooshoes #yupooyeezy #yeezy #yupooadidas",
    price: PriceInfo,
    categories: [
      "shoes",
      "yeezy",
      "adidas"
    ],
    images: [
      "/productimgs/shoes/Adidas/27/yupoo yeezy 350 Boost V2 yupoo shoes 1.jpg",
      "/productimgs/shoes/Adidas/27/yupoo yeezy 350 Boost V2 yupoo shoes 2.jpg",
      "/productimgs/shoes/Adidas/27/yupoo yeezy 350 Boost V2 yupoo shoes 3.jpg",
      "/productimgs/shoes/Adidas/27/yupoo yeezy 350 Boost V2 yupoo shoes 4.jpg",
      "/productimgs/shoes/Adidas/27/yupoo yeezy 350 Boost V2 yupoo shoes 5.jpg",
      "/productimgs/shoes/Adidas/27/yupoo yeezy 350 Boost V2 yupoo shoes 6.jpg",
      "/productimgs/shoes/Adidas/27/yupoo yeezy 350 Boost V2 yupoo shoes 7.jpg",
      "/productimgs/shoes/Adidas/27/yupoo yeezy 350 Boost V2 yupoo shoes 8.jpg",
      "/productimgs/shoes/Adidas/27/yupoo yeezy 350 Boost V2 yupoo shoes 9.jpg",
      "/productimgs/shoes/Adidas/27/yupoo yeezy 350 Boost V2 yupoo shoes 10.jpg",
      "/productimgs/shoes/Adidas/27/yupoo yeezy 350 Boost V2 yupoo shoes 11.jpg",
      "/productimgs/shoes/Adidas/27/yupoo yeezy 350 Boost V2 yupoo shoes 12.jpg",
      "/productimgs/shoes/Adidas/27/yupoo yeezy 350 Boost V2 yupoo shoes 13.jpg",
      "/productimgs/shoes/Adidas/27/yupoo yeezy 350 Boost V2 yupoo shoes 14.jpg",
      "/productimgs/shoes/Adidas/27/yupoo yeezy 350 Boost V2 yupoo shoes 15.jpg",
      "/productimgs/shoes/Adidas/27/yupoo yeezy 350 Boost V2 yupoo shoes 16.jpg",
      "/productimgs/shoes/Adidas/27/yupoo yeezy 350 Boost V2 yupoo shoes 17.jpg"
    ]
  },
  {
    id: "551",
    name: "Yupoo Shoes: Premium Yeezy Yupoo Sneakers",
    description: "Premium quality Yeezy Yupoo Sneakers from productalbum.cn. These high-end Yupoos perfectly capture the design and comfort of the authentic version at an affordable price. #yupooshoes #yupooyeezy #yeezy #yupooadidas",
    price: PriceInfo,
    categories: [
      "shoes",
      "yeezy",
      "adidas"
    ],
    images: [
      "/productimgs/shoes/Adidas/31/yupoo yeezy 350 Boost V2 yupoo shoes 1.jpg",
      "/productimgs/shoes/Adidas/31/yupoo yeezy 350 Boost V2 yupoo shoes 2.jpg",
      "/productimgs/shoes/Adidas/31/yupoo yeezy 350 Boost V2 yupoo shoes 3.jpg",
      "/productimgs/shoes/Adidas/31/yupoo yeezy 350 Boost V2 yupoo shoes 4.jpg",
      "/productimgs/shoes/Adidas/31/yupoo yeezy 350 Boost V2 yupoo shoes 5.jpg",
      "/productimgs/shoes/Adidas/31/yupoo yeezy 350 Boost V2 yupoo shoes 6.jpg",
      "/productimgs/shoes/Adidas/31/yupoo yeezy 350 Boost V2 yupoo shoes 7.jpg",
      "/productimgs/shoes/Adidas/31/yupoo yeezy 350 Boost V2 yupoo shoes 8.jpg",
      "/productimgs/shoes/Adidas/31/yupoo yeezy 350 Boost V2 yupoo shoes 9.jpg",
      "/productimgs/shoes/Adidas/31/yupoo yeezy 350 Boost V2 yupoo shoes 10.jpg",
      "/productimgs/shoes/Adidas/31/yupoo yeezy 350 Boost V2 yupoo shoes 11.jpg",
      "/productimgs/shoes/Adidas/31/yupoo yeezy 350 Boost V2 yupoo shoes 12.jpg",
      "/productimgs/shoes/Adidas/31/yupoo yeezy 350 Boost V2 yupoo shoes 13.jpg",
      "/productimgs/shoes/Adidas/31/yupoo yeezy 350 Boost V2 yupoo shoes 14.jpg",
      "/productimgs/shoes/Adidas/31/yupoo yeezy 350 Boost V2 yupoo shoes 15.jpg",
      "/productimgs/shoes/Adidas/31/yupoo yeezy 350 Boost V2 yupoo shoes 16.jpg",
      "/productimgs/shoes/Adidas/31/yupoo yeezy 350 Boost V2 yupoo shoes 17.jpg"
    ]
  },
  {
    id: "552",
    name: "Yupoo Shoes: Premium Yeezy Yupoo Sneakers",
    description: "Premium quality Yeezy Yupoo Sneakers from productalbum.cn. These high-end Yupoos perfectly capture the design and comfort of the authentic version at an affordable price. #yupooshoes #yupooyeezy #yeezy #yupooadidas",
    price: PriceInfo,
    categories: [
      "shoes",
      "yeezy",
      "adidas"
    ],
    images: [
      "/productimgs/shoes/Adidas/18/yupoo yeezy 350 Boost V2 yupoo shoes 1.jpg",
      "/productimgs/shoes/Adidas/18/yupoo yeezy 350 Boost V2 yupoo shoes 2.jpg",
      "/productimgs/shoes/Adidas/18/yupoo yeezy 350 Boost V2 yupoo shoes 3.jpg",
      "/productimgs/shoes/Adidas/18/yupoo yeezy 350 Boost V2 yupoo shoes 4.jpg",
      "/productimgs/shoes/Adidas/18/yupoo yeezy 350 Boost V2 yupoo shoes 5.jpg",
      "/productimgs/shoes/Adidas/18/yupoo yeezy 350 Boost V2 yupoo shoes 6.jpg",
      "/productimgs/shoes/Adidas/18/yupoo yeezy 350 Boost V2 yupoo shoes 7.jpg",
      "/productimgs/shoes/Adidas/18/yupoo yeezy 350 Boost V2 yupoo shoes 8.jpg",
      "/productimgs/shoes/Adidas/18/yupoo yeezy 350 Boost V2 yupoo shoes 9.jpg",
      "/productimgs/shoes/Adidas/18/yupoo yeezy 350 Boost V2 yupoo shoes 10.jpg",
      "/productimgs/shoes/Adidas/18/yupoo yeezy 350 Boost V2 yupoo shoes 11.jpg",
      "/productimgs/shoes/Adidas/18/yupoo yeezy 350 Boost V2 yupoo shoes 12.jpg",
      "/productimgs/shoes/Adidas/18/yupoo yeezy 350 Boost V2 yupoo shoes 13.jpg",
      "/productimgs/shoes/Adidas/18/yupoo yeezy 350 Boost V2 yupoo shoes 14.jpg",
      "/productimgs/shoes/Adidas/18/yupoo yeezy 350 Boost V2 yupoo shoes 15.jpg",
      "/productimgs/shoes/Adidas/18/yupoo yeezy 350 Boost V2 yupoo shoes 16.jpg",
      "/productimgs/shoes/Adidas/18/yupoo yeezy 350 Boost V2 yupoo shoes 17.jpg"
    ]
  },
  {
    id: "553",
    name: "Yupoo Shoes: Premium Yeezy Yupoo Sneakers",
    description: "Premium quality Yeezy Yupoo Sneakers from productalbum.cn. These high-end Yupoos perfectly capture the design and comfort of the authentic version at an affordable price. #yupooshoes #yupooyeezy #yeezy #yupooadidas",
    price: PriceInfo,
    categories: [
      "shoes",
      "yeezy",
      "adidas"
    ],
    images: [
      "/productimgs/shoes/Adidas/42/yupoo yeezy 350 V2 yupoo shoes 1.jpg",
      "/productimgs/shoes/Adidas/42/yupoo yeezy 350 V2 yupoo shoes 2.jpg",
      "/productimgs/shoes/Adidas/42/yupoo yeezy 350 V2 yupoo shoes 3.jpg",
      "/productimgs/shoes/Adidas/42/yupoo yeezy 350 V2 yupoo shoes 4.jpg",
      "/productimgs/shoes/Adidas/42/yupoo yeezy 350 V2 yupoo shoes 5.jpg",
      "/productimgs/shoes/Adidas/42/yupoo yeezy 350 V2 yupoo shoes 6.jpg",
      "/productimgs/shoes/Adidas/42/yupoo yeezy 350 V2 yupoo shoes 7.jpg",
      "/productimgs/shoes/Adidas/42/yupoo yeezy 350 V2 yupoo shoes 8.jpg",
      "/productimgs/shoes/Adidas/42/yupoo yeezy 350 V2 yupoo shoes 9.jpg",
      "/productimgs/shoes/Adidas/42/yupoo yeezy 350 V2 yupoo shoes 10.jpg",
      "/productimgs/shoes/Adidas/42/yupoo yeezy 350 V2 yupoo shoes 11.jpg",
      "/productimgs/shoes/Adidas/42/yupoo yeezy 350 V2 yupoo shoes 12.jpg",
      "/productimgs/shoes/Adidas/42/yupoo yeezy 350 V2 yupoo shoes 13.jpg",
      "/productimgs/shoes/Adidas/42/yupoo yeezy 350 V2 yupoo shoes 14.jpg",
      "/productimgs/shoes/Adidas/42/yupoo yeezy 350 V2 yupoo shoes 15.jpg",
      "/productimgs/shoes/Adidas/42/yupoo yeezy 350 V2 yupoo shoes 16.jpg",
      "/productimgs/shoes/Adidas/42/yupoo yeezy 350 V2 yupoo shoes 17.jpg",
      "/productimgs/shoes/Adidas/42/yupoo yeezy 350 V2 yupoo shoes 18.jpg",
      "/productimgs/shoes/Adidas/42/yupoo yeezy 350 V2 yupoo shoes 19.jpg",
      "/productimgs/shoes/Adidas/42/yupoo yeezy 350 V2 yupoo shoes 20.jpg"
    ]
  },
  {
    id: "554",
    name: "Yupoo Shoes: Premium Yeezy Yupoo Sneakers",
    description: "Premium quality Yeezy Yupoo Sneakers from productalbum.cn. These high-end Yupoos perfectly capture the design and comfort of the authentic version at an affordable price. #yupooshoes #yupooyeezy #yeezy #yupooadidas",
    price: PriceInfo,
    categories: [
      "shoes",
      "yeezy",
      "adidas"
    ],
    images: [
      "/productimgs/shoes/Adidas/24/yupoo yeezy 350 Boost V2 yupoo shoes 1.jpg",
      "/productimgs/shoes/Adidas/24/yupoo yeezy 350 Boost V2 yupoo shoes 2.jpg",
      "/productimgs/shoes/Adidas/24/yupoo yeezy 350 Boost V2 yupoo shoes 3.jpg",
      "/productimgs/shoes/Adidas/24/yupoo yeezy 350 Boost V2 yupoo shoes 4.jpg",
      "/productimgs/shoes/Adidas/24/yupoo yeezy 350 Boost V2 yupoo shoes 5.jpg",
      "/productimgs/shoes/Adidas/24/yupoo yeezy 350 Boost V2 yupoo shoes 6.jpg",
      "/productimgs/shoes/Adidas/24/yupoo yeezy 350 Boost V2 yupoo shoes 7.jpg",
      "/productimgs/shoes/Adidas/24/yupoo yeezy 350 Boost V2 yupoo shoes 8.jpg",
      "/productimgs/shoes/Adidas/24/yupoo yeezy 350 Boost V2 yupoo shoes 9.jpg",
      "/productimgs/shoes/Adidas/24/yupoo yeezy 350 Boost V2 yupoo shoes 10.jpg",
      "/productimgs/shoes/Adidas/24/yupoo yeezy 350 Boost V2 yupoo shoes 11.jpg",
      "/productimgs/shoes/Adidas/24/yupoo yeezy 350 Boost V2 yupoo shoes 12.jpg",
      "/productimgs/shoes/Adidas/24/yupoo yeezy 350 Boost V2 yupoo shoes 13.jpg",
      "/productimgs/shoes/Adidas/24/yupoo yeezy 350 Boost V2 yupoo shoes 14.jpg"
    ]
  },
  {
    id: "555",
    name: "Yupoo Shoes: Premium Yeezy Yupoo Sneakers",
    description: "Premium quality Yeezy Yupoo Sneakers from productalbum.cn. These high-end Yupoos perfectly capture the design and comfort of the authentic version at an affordable price. #yupooshoes #yupooyeezy #yeezy #yupooadidas",
    price: PriceInfo,
    categories: [
      "shoes",
      "yeezy",
      "adidas"
    ],
    images: [
      "/productimgs/shoes/Adidas/44/yupoo yeezy 350 V2 yupoo shoes 1.jpg",
      "/productimgs/shoes/Adidas/44/yupoo yeezy 350 V2 yupoo shoes 2.jpg",
      "/productimgs/shoes/Adidas/44/yupoo yeezy 350 V2 yupoo shoes 3.jpg",
      "/productimgs/shoes/Adidas/44/yupoo yeezy 350 V2 yupoo shoes 4.jpg",
      "/productimgs/shoes/Adidas/44/yupoo yeezy 350 V2 yupoo shoes 5.jpg",
      "/productimgs/shoes/Adidas/44/yupoo yeezy 350 V2 yupoo shoes 6.jpg",
      "/productimgs/shoes/Adidas/44/yupoo yeezy 350 V2 yupoo shoes 7.jpg",
      "/productimgs/shoes/Adidas/44/yupoo yeezy 350 V2 yupoo shoes 8.jpg",
      "/productimgs/shoes/Adidas/44/yupoo yeezy 350 V2 yupoo shoes 9.jpg",
      "/productimgs/shoes/Adidas/44/yupoo yeezy 350 V2 yupoo shoes 10.jpg",
      "/productimgs/shoes/Adidas/44/yupoo yeezy 350 V2 yupoo shoes 11.jpg",
      "/productimgs/shoes/Adidas/44/yupoo yeezy 350 V2 yupoo shoes 12.jpg",
      "/productimgs/shoes/Adidas/44/yupoo yeezy 350 V2 yupoo shoes 13.jpg",
      "/productimgs/shoes/Adidas/44/yupoo yeezy 350 V2 yupoo shoes 14.jpg",
      "/productimgs/shoes/Adidas/44/yupoo yeezy 350 V2 yupoo shoes 15.jpg"
    ]
  },
  {
    id: "556",
    name: "Yupoo Shoes: Premium Yeezy Yupoo Sneakers",
    description: "Premium quality Yeezy Yupoo Sneakers from productalbum.cn. These high-end Yupoos perfectly capture the design and comfort of the authentic version at an affordable price. #yupooshoes #yupooyeezy #yeezy #yupooadidas",
    price: PriceInfo,
    categories: [
      "shoes",
      "yeezy",
      "adidas"
    ],
    images: [
      "/productimgs/shoes/Adidas/54/yupoo yeezy 350 V2 yupoo shoes 1.jpg",
      "/productimgs/shoes/Adidas/54/yupoo yeezy 350 V2 yupoo shoes 2.jpg",
      "/productimgs/shoes/Adidas/54/yupoo yeezy 350 V2 yupoo shoes 3.jpg",
      "/productimgs/shoes/Adidas/54/yupoo yeezy 350 V2 yupoo shoes 4.jpg",
      "/productimgs/shoes/Adidas/54/yupoo yeezy 350 V2 yupoo shoes 5.jpg",
      "/productimgs/shoes/Adidas/54/yupoo yeezy 350 V2 yupoo shoes 6.jpg",
      "/productimgs/shoes/Adidas/54/yupoo yeezy 350 V2 yupoo shoes 7.jpg",
      "/productimgs/shoes/Adidas/54/yupoo yeezy 350 V2 yupoo shoes 8.jpg",
      "/productimgs/shoes/Adidas/54/yupoo yeezy 350 V2 yupoo shoes 9.jpg",
      "/productimgs/shoes/Adidas/54/yupoo yeezy 350 V2 yupoo shoes 10.jpg",
      "/productimgs/shoes/Adidas/54/yupoo yeezy 350 V2 yupoo shoes 11.jpg",
      "/productimgs/shoes/Adidas/54/yupoo yeezy 350 V2 yupoo shoes 12.jpg",
      "/productimgs/shoes/Adidas/54/yupoo yeezy 350 V2 yupoo shoes 13.jpg"
    ]
  },
  {
    id: "557",
    name: "Yupoo Shoes: Premium Yeezy Yupoo Sneakers",
    description: "Premium quality Yeezy Yupoo Sneakers from productalbum.cn. These high-end Yupoos perfectly capture the design and comfort of the authentic version at an affordable price. #yupooshoes #yupooyeezy #yeezy #yupooadidas",
    price: PriceInfo,
    categories: [
      "shoes",
      "yeezy",
      "adidas"
    ],
    images: [
      "/productimgs/shoes/Adidas/32/yupoo yeezy 350 Boost V2 yupoo shoes 1.jpg",
      "/productimgs/shoes/Adidas/32/yupoo yeezy 350 Boost V2 yupoo shoes 2.jpg",
      "/productimgs/shoes/Adidas/32/yupoo yeezy 350 Boost V2 yupoo shoes 3.jpg",
      "/productimgs/shoes/Adidas/32/yupoo yeezy 350 Boost V2 yupoo shoes 4.jpg",
      "/productimgs/shoes/Adidas/32/yupoo yeezy 350 Boost V2 yupoo shoes 5.jpg",
      "/productimgs/shoes/Adidas/32/yupoo yeezy 350 Boost V2 yupoo shoes 6.jpg",
      "/productimgs/shoes/Adidas/32/yupoo yeezy 350 Boost V2 yupoo shoes 7.jpg",
      "/productimgs/shoes/Adidas/32/yupoo yeezy 350 Boost V2 yupoo shoes 8.jpg",
      "/productimgs/shoes/Adidas/32/yupoo yeezy 350 Boost V2 yupoo shoes 9.jpg",
      "/productimgs/shoes/Adidas/32/yupoo yeezy 350 Boost V2 yupoo shoes 11.jpg",
      "/productimgs/shoes/Adidas/32/yupoo yeezy 350 Boost V2 yupoo shoes 17.jpg",
      "/productimgs/shoes/Adidas/32/yupoo yeezy 350 Boost V2 yupoo shoes 25.jpg",
      "/productimgs/shoes/Adidas/32/yupoo yeezy 350 Boost V2 yupoo shoes 27.jpg"
    ]
  },
  {
    id: "558",
    name: "Yupoo Shoes: Premium Yeezy Yupoo Sneakers",
    description: "Premium quality Yeezy Yupoo Sneakers from productalbum.cn. These high-end Yupoos perfectly capture the design and comfort of the authentic version at an affordable price. #yupooshoes #yupooyeezy #yeezy #yupooadidas",
    price: PriceInfo,
    categories: [
      "shoes",
      "yeezy",
      "adidas"
    ],
    images: [
      "/productimgs/shoes/Adidas/67/yupoo yeezy 350 V2 yupoo shoes 1.jpg",
      "/productimgs/shoes/Adidas/67/yupoo yeezy 350 V2 yupoo shoes 2.jpg",
      "/productimgs/shoes/Adidas/67/yupoo yeezy 350 V2 yupoo shoes 3.jpg",
      "/productimgs/shoes/Adidas/67/yupoo yeezy 350 V2 yupoo shoes 4.jpg",
      "/productimgs/shoes/Adidas/67/yupoo yeezy 350 V2 yupoo shoes 5.jpg",
      "/productimgs/shoes/Adidas/67/yupoo yeezy 350 V2 yupoo shoes 6.jpg",
      "/productimgs/shoes/Adidas/67/yupoo yeezy 350 V2 yupoo shoes 7.jpg",
      "/productimgs/shoes/Adidas/67/yupoo yeezy 350 V2 yupoo shoes 8.jpg",
      "/productimgs/shoes/Adidas/67/yupoo yeezy 350 V2 yupoo shoes 9.jpg",
      "/productimgs/shoes/Adidas/67/yupoo yeezy 350 V2 yupoo shoes 10.jpg",
      "/productimgs/shoes/Adidas/67/yupoo yeezy 350 V2 yupoo shoes 11.jpg",
      "/productimgs/shoes/Adidas/67/yupoo yeezy 350 V2 yupoo shoes 12.jpg",
      "/productimgs/shoes/Adidas/67/yupoo yeezy 350 V2 yupoo shoes 13.jpg"
    ]
  },
  {
    id: "559",
    name: "Yupoo Shoes: Premium Yeezy Yupoo Sneakers",
    description: "Premium quality Yeezy Yupoo Sneakers from productalbum.cn. These high-end Yupoos perfectly capture the design and comfort of the authentic version at an affordable price. #yupooshoes #yupooyeezy #yeezy #yupooadidas",
    price: PriceInfo,
    categories: [
      "shoes",
      "yeezy",
      "adidas"
    ],
    images: [
      "/productimgs/shoes/Adidas/70/yupoo yeezy 350 V2 yupoo shoes 1.jpg",
      "/productimgs/shoes/Adidas/70/yupoo yeezy 350 V2 yupoo shoes 2.jpg",
      "/productimgs/shoes/Adidas/70/yupoo yeezy 350 V2 yupoo shoes 3.jpg",
      "/productimgs/shoes/Adidas/70/yupoo yeezy 350 V2 yupoo shoes 4.jpg",
      "/productimgs/shoes/Adidas/70/yupoo yeezy 350 V2 yupoo shoes 5.jpg",
      "/productimgs/shoes/Adidas/70/yupoo yeezy 350 V2 yupoo shoes 6.jpg",
      "/productimgs/shoes/Adidas/70/yupoo yeezy 350 V2 yupoo shoes 7.jpg",
      "/productimgs/shoes/Adidas/70/yupoo yeezy 350 V2 yupoo shoes 8.jpg",
      "/productimgs/shoes/Adidas/70/yupoo yeezy 350 V2 yupoo shoes 9.jpg",
      "/productimgs/shoes/Adidas/70/yupoo yeezy 350 V2 yupoo shoes 10.jpg",
      "/productimgs/shoes/Adidas/70/yupoo yeezy 350 V2 yupoo shoes 11.jpg"
    ]
  },
  {
    id: "560",
    name: "Yupoo Shoes: Premium Yeezy Yupoo Sneakers",
    description: "Premium quality Yeezy Yupoo Sneakers from productalbum.cn. These high-end Yupoos perfectly capture the design and comfort of the authentic version at an affordable price. #yupooshoes #yupooyeezy #yeezy #yupooadidas",
    price: PriceInfo,
    categories: [
      "shoes",
      "yeezy",
      "adidas"
    ],
    images: [
      "/productimgs/shoes/Adidas/47/yupoo yeezy 350 V2 yupoo shoes 1.jpg",
      "/productimgs/shoes/Adidas/47/yupoo yeezy 350 V2 yupoo shoes 2.jpg",
      "/productimgs/shoes/Adidas/47/yupoo yeezy 350 V2 yupoo shoes 3.jpg",
      "/productimgs/shoes/Adidas/47/yupoo yeezy 350 V2 yupoo shoes 4.jpg",
      "/productimgs/shoes/Adidas/47/yupoo yeezy 350 V2 yupoo shoes 5.jpg",
      "/productimgs/shoes/Adidas/47/yupoo yeezy 350 V2 yupoo shoes 6.jpg",
      "/productimgs/shoes/Adidas/47/yupoo yeezy 350 V2 yupoo shoes 7.jpg",
      "/productimgs/shoes/Adidas/47/yupoo yeezy 350 V2 yupoo shoes 8.jpg",
      "/productimgs/shoes/Adidas/47/yupoo yeezy 350 V2 yupoo shoes 9.jpg",
      "/productimgs/shoes/Adidas/47/yupoo yeezy 350 V2 yupoo shoes 10.jpg",
      "/productimgs/shoes/Adidas/47/yupoo yeezy 350 V2 yupoo shoes 11.jpg",
      "/productimgs/shoes/Adidas/47/yupoo yeezy 350 V2 yupoo shoes 12.jpg",
      "/productimgs/shoes/Adidas/47/yupoo yeezy 350 V2 yupoo shoes 13.jpg",
      "/productimgs/shoes/Adidas/47/yupoo yeezy 350 V2 yupoo shoes 14.jpg",
      "/productimgs/shoes/Adidas/47/yupoo yeezy 350 V2 yupoo shoes 15.jpg",
      "/productimgs/shoes/Adidas/47/yupoo yeezy 350 V2 yupoo shoes 16.jpg",
      "/productimgs/shoes/Adidas/47/yupoo yeezy 350 V2 yupoo shoes 17.jpg",
      "/productimgs/shoes/Adidas/47/yupoo yeezy 350 V2 yupoo shoes 18.jpg"
    ]
  },
  {
    id: "561",
    name: "Yupoo Shoes: Adidas Yeezy 700",
    description: "Shop the Adidas Yeezy 700 shoes on Yupoo. These shoes are known for their bold design and excellent performance, adding a touch of style to your outfit. #yupooshoes #yupooyeezy #yeezy #yupooadidas",
    price: PriceInfo,
    categories: [
      "shoes",
      "yeezy",
      "adidas"
    ],
    images: [
      "/productimgs/shoes/Adidas/9/yeezy yupoo Adida Yeezy 700  1.jpg",
      "/productimgs/shoes/Adidas/9/yeezy yupoo Adida Yeezy 700  2.jpg",
      "/productimgs/shoes/Adidas/9/yeezy yupoo Adida Yeezy 700  3.jpg",
      "/productimgs/shoes/Adidas/9/yeezy yupoo Adida Yeezy 700  4.jpg",
      "/productimgs/shoes/Adidas/9/yeezy yupoo Adida Yeezy 700  5.jpg",
      "/productimgs/shoes/Adidas/9/yeezy yupoo Adida Yeezy 700  6.jpg"
    ]
  },
  {
    id: "562",
    name: "Yupoo Shoes: Premium Yeezy Yupoo Sneakers",
    description: "Premium quality Yeezy Yupoo Sneakers from productalbum.cn. These high-end Yupoos perfectly capture the design and comfort of the authentic version at an affordable price. #yupooshoes #yupooyeezy #yeezy #yupooadidas",
    price: PriceInfo,
    categories: [
      "shoes",
      "yeezy",
      "adidas"
    ],
    images: [
      "/productimgs/shoes/Adidas/85/yupoo yeezy 500 yupoo shoes 1.jpg",
      "/productimgs/shoes/Adidas/85/yupoo yeezy 500 yupoo shoes 2.jpg",
      "/productimgs/shoes/Adidas/85/yupoo yeezy 500 yupoo shoes 3.jpg",
      "/productimgs/shoes/Adidas/85/yupoo yeezy 500 yupoo shoes 4.jpg",
      "/productimgs/shoes/Adidas/85/yupoo yeezy 500 yupoo shoes 5.jpg",
      "/productimgs/shoes/Adidas/85/yupoo yeezy 500 yupoo shoes 6.jpg",
      "/productimgs/shoes/Adidas/85/yupoo yeezy 500 yupoo shoes 7.jpg",
      "/productimgs/shoes/Adidas/85/yupoo yeezy 500 yupoo shoes 8.jpg",
      "/productimgs/shoes/Adidas/85/yupoo yeezy 500 yupoo shoes 9.jpg",
      "/productimgs/shoes/Adidas/85/yupoo yeezy 500 yupoo shoes 10.jpg",
      "/productimgs/shoes/Adidas/85/yupoo yeezy 500 yupoo shoes 11.jpg",
      "/productimgs/shoes/Adidas/85/yupoo yeezy 500 yupoo shoes 12.jpg"
    ]
  },
  {
    id: "563",
    name: "Yupoo Shoes:Adidas Yeezy 700V2",
    description: "Explore the trendy Adidas Yeezy 700V2 shoes on Yupoo. These shoes offer a unique blend of style and comfort, perfect for fashion - forward individuals. #yupooshoes #yupooyeezy #yeezy #yupooadidas",
    price: PriceInfo,
    categories: [
      "shoes",
      "yeezy",
      "adidas"
    ],
    images: [
      "/productimgs/shoes/Adidas/14/yeezy yupoo 001-Adida Yeezy 700V2  1.jpeg",
      "/productimgs/shoes/Adidas/14/yeezy yupoo 001-Adida Yeezy 700V2  2.jpeg",
      "/productimgs/shoes/Adidas/14/yeezy yupoo 001-Adida Yeezy 700V2  3.jpeg",
      "/productimgs/shoes/Adidas/14/yeezy yupoo 001-Adida Yeezy 700V2  4.jpeg",
      "/productimgs/shoes/Adidas/14/yeezy yupoo 001-Adida Yeezy 700V2  5.jpeg",
      "/productimgs/shoes/Adidas/14/yeezy yupoo 001-Adida Yeezy 700V2  6.jpeg",
      "/productimgs/shoes/Adidas/14/yeezy yupoo 001-Adida Yeezy 700V2  7.jpeg"
    ]
  },
  {
    id: "564",
    name: "Yupoo Shoes: Premium Yeezy Yupoo Sneakers",
    description: "Premium quality Yeezy Yupoo Sneakers from productalbum.cn. These high-end Yupoos perfectly capture the design and comfort of the authentic version at an affordable price. #yupooshoes #yupooyeezy #yeezy #yupooadidas",
    price: PriceInfo,
    categories: [
      "shoes",
      "yeezy",
      "adidas"
    ],
    images: [
      "/productimgs/shoes/Adidas/22/yupoo yeezy 350 Boost V2 yupoo shoes 1.jpg",
      "/productimgs/shoes/Adidas/22/yupoo yeezy 350 Boost V2 yupoo shoes 2.jpg",
      "/productimgs/shoes/Adidas/22/yupoo yeezy 350 Boost V2 yupoo shoes 3.jpg",
      "/productimgs/shoes/Adidas/22/yupoo yeezy 350 Boost V2 yupoo shoes 4.jpg",
      "/productimgs/shoes/Adidas/22/yupoo yeezy 350 Boost V2 yupoo shoes 5.jpg",
      "/productimgs/shoes/Adidas/22/yupoo yeezy 350 Boost V2 yupoo shoes 6.jpg",
      "/productimgs/shoes/Adidas/22/yupoo yeezy 350 Boost V2 yupoo shoes 7.jpg",
      "/productimgs/shoes/Adidas/22/yupoo yeezy 350 Boost V2 yupoo shoes 8.jpg",
      "/productimgs/shoes/Adidas/22/yupoo yeezy 350 Boost V2 yupoo shoes 9.jpg",
      "/productimgs/shoes/Adidas/22/yupoo yeezy 350 Boost V2 yupoo shoes 10.jpg",
      "/productimgs/shoes/Adidas/22/yupoo yeezy 350 Boost V2 yupoo shoes 11.jpg",
      "/productimgs/shoes/Adidas/22/yupoo yeezy 350 Boost V2 yupoo shoes 12.jpg",
      "/productimgs/shoes/Adidas/22/yupoo yeezy 350 Boost V2 yupoo shoes 13.jpg",
      "/productimgs/shoes/Adidas/22/yupoo yeezy 350 Boost V2 yupoo shoes 14.jpg"
    ]
  },
  {
    id: "565",
    name: "Yupoo Shoes: Premium Yeezy Yupoo Sneakers",
    description: "Premium quality Yeezy Yupoo Sneakers from productalbum.cn. These high-end Yupoos perfectly capture the design and comfort of the authentic version at an affordable price. #yupooshoes #yupooyeezy #yeezy #yupooadidas",
    price: PriceInfo,
    categories: [
      "shoes",
      "yeezy",
      "adidas"
    ],
    images: [
      "/productimgs/shoes/Adidas/17/yupoo yeezy 350 Boost Basf V2 1.jpg",
      "/productimgs/shoes/Adidas/17/yupoo yeezy 350 Boost Basf V2 2.jpg",
      "/productimgs/shoes/Adidas/17/yupoo yeezy 350 Boost Basf V2 3.jpg",
      "/productimgs/shoes/Adidas/17/yupoo yeezy 350 Boost Basf V2 4.jpg",
      "/productimgs/shoes/Adidas/17/yupoo yeezy 350 Boost Basf V2 5.jpg",
      "/productimgs/shoes/Adidas/17/yupoo yeezy 350 Boost Basf V2 6.jpg",
      "/productimgs/shoes/Adidas/17/yupoo yeezy 350 Boost Basf V2 7.jpg",
      "/productimgs/shoes/Adidas/17/yupoo yeezy 350 Boost Basf V2 8.jpg",
      "/productimgs/shoes/Adidas/17/yupoo yeezy 350 Boost Basf V2 9.jpg",
      "/productimgs/shoes/Adidas/17/yupoo yeezy 350 Boost Basf V2 10.jpg",
      "/productimgs/shoes/Adidas/17/yupoo yeezy 350 Boost Basf V2 11.jpg",
      "/productimgs/shoes/Adidas/17/yupoo yeezy 350 Boost Basf V2 12.jpg",
      "/productimgs/shoes/Adidas/17/yupoo yeezy 350 Boost Basf V2 13.jpg",
      "/productimgs/shoes/Adidas/17/yupoo yeezy 350 Boost Basf V2 14.jpg",
      "/productimgs/shoes/Adidas/17/yupoo yeezy 350 Boost Basf V2 15.jpg",
      "/productimgs/shoes/Adidas/17/yupoo yeezy 350 Boost Basf V2 16.jpg"
    ]
  },
  {
    id: "566",
    name: "Yupoo Shoes:Adidas Yeezy 700V2",
    description: "Explore the trendy Adidas Yeezy 700V2 shoes on Yupoo. These shoes offer a unique blend of style and comfort, perfect for fashion - forward individuals. #yupooshoes #yupooyeezy #yeezy #yupooadidas",
    price: PriceInfo,
    categories: [
      "shoes",
      "yeezy",
      "adidas"
    ],
    images: [
      "/productimgs/shoes/Adidas/13/yeezy yupoo 001-Adida Yeezy 700V2  1.jpg",
      "/productimgs/shoes/Adidas/13/yeezy yupoo 001-Adida Yeezy 700V2  1.jpeg",
      "/productimgs/shoes/Adidas/13/yeezy yupoo 001-Adida Yeezy 700V2  2.jpeg",
      "/productimgs/shoes/Adidas/13/yeezy yupoo 001-Adida Yeezy 700V2  2.jpg",
      "/productimgs/shoes/Adidas/13/yeezy yupoo 001-Adida Yeezy 700V2  3.jpg",
      "/productimgs/shoes/Adidas/13/yeezy yupoo 001-Adida Yeezy 700V2  3.jpeg",
      "/productimgs/shoes/Adidas/13/yeezy yupoo 001-Adida Yeezy 700V2  4.jpeg",
      "/productimgs/shoes/Adidas/13/yeezy yupoo 001-Adida Yeezy 700V2  5.jpeg",
      "/productimgs/shoes/Adidas/13/yeezy yupoo 001-Adida Yeezy 700V2  6.jpeg",
      "/productimgs/shoes/Adidas/13/yeezy yupoo 001-Adida Yeezy 700V2  7.jpeg"
    ]
  },
  {
    id: "567",
    name: "Yupoo Shoes: Premium Yeezy Yupoo Sneakers",
    description: "Premium quality Yeezy Yupoo Sneakers from productalbum.cn. These high-end Yupoos perfectly capture the design and comfort of the authentic version at an affordable price. #yupooshoes #yupooyeezy #yeezy #yupooadidas",
    price: PriceInfo,
    categories: [
      "shoes",
      "yeezy",
      "adidas"
    ],
    images: [
      "/productimgs/shoes/Adidas/49/yupoo yeezy 350 V2 yupoo shoes 1.jpg",
      "/productimgs/shoes/Adidas/49/yupoo yeezy 350 V2 yupoo shoes 2.jpg",
      "/productimgs/shoes/Adidas/49/yupoo yeezy 350 V2 yupoo shoes 3.jpg",
      "/productimgs/shoes/Adidas/49/yupoo yeezy 350 V2 yupoo shoes 4.jpg",
      "/productimgs/shoes/Adidas/49/yupoo yeezy 350 V2 yupoo shoes 5.jpg",
      "/productimgs/shoes/Adidas/49/yupoo yeezy 350 V2 yupoo shoes 6.jpg",
      "/productimgs/shoes/Adidas/49/yupoo yeezy 350 V2 yupoo shoes 7.jpg",
      "/productimgs/shoes/Adidas/49/yupoo yeezy 350 V2 yupoo shoes 8.jpg",
      "/productimgs/shoes/Adidas/49/yupoo yeezy 350 V2 yupoo shoes 9.jpg",
      "/productimgs/shoes/Adidas/49/yupoo yeezy 350 V2 yupoo shoes 10.jpg",
      "/productimgs/shoes/Adidas/49/yupoo yeezy 350 V2 yupoo shoes 11.jpg",
      "/productimgs/shoes/Adidas/49/yupoo yeezy 350 V2 yupoo shoes 12.jpg",
      "/productimgs/shoes/Adidas/49/yupoo yeezy 350 V2 yupoo shoes 13.jpg",
      "/productimgs/shoes/Adidas/49/yupoo yeezy 350 V2 yupoo shoes 14.jpg",
      "/productimgs/shoes/Adidas/49/yupoo yeezy 350 V2 yupoo shoes 15.jpg",
      "/productimgs/shoes/Adidas/49/yupoo yeezy 350 V2 yupoo shoes 16.jpg"
    ]
  },
  {
    id: "568",
    name: "adidas Originals GAZELLE INDOOR W - Women's Low-Top Sneakers (Pink)",
    description: "Classic pink GAZELLE with soft suede upper and grippy rubber sole for all-day comfort. Timeless low-top design perfect for casual wear.",
    price: PriceInfo,
    categories: [
      "shoes",
      "yeezy",
      "adidas"
    ],
    images: [
      "/productimgs/shoes/Adidas/2/Adidas_2_pic_3.jpg",
      "/productimgs/shoes/Adidas/2/Adidas_2_pic_7.jpg",
      "/productimgs/shoes/Adidas/2/Adidas_2_pic_4.jpg",
      "/productimgs/shoes/Adidas/2/Adidas_2_pic_6.jpg",
      "/productimgs/shoes/Adidas/2/Adidas_2_pic_5.jpg",
      "/productimgs/shoes/Adidas/2/Adidas_2_pic_8.jpg",
      "/productimgs/shoes/Adidas/2/Adidas_2_pic_9.jpg",
      "/productimgs/shoes/Adidas/2/Adidas_2_pic_1.jpg",
      "/productimgs/shoes/Adidas/2/Adidas_2_pic_2.jpg"
    ]
  },
  {
    id: "569",
    name: "Yupoo Shoes: Premium Yeezy Yupoo Sneakers",
    description: "Premium quality Yeezy Yupoo Sneakers from productalbum.cn. These high-end Yupoos perfectly capture the design and comfort of the authentic version at an affordable price. #yupooshoes #yupooyeezy #yeezy #yupooadidas",
    price: PriceInfo,
    categories: [
      "shoes",
      "yeezy",
      "adidas"
    ],
    images: [
      "/productimgs/shoes/Adidas/41/yupoo yeezy 350 V2 yupoo shoes 1.jpg",
      "/productimgs/shoes/Adidas/41/yupoo yeezy 350 V2 yupoo shoes 2.jpg",
      "/productimgs/shoes/Adidas/41/yupoo yeezy 350 V2 yupoo shoes 3.jpg",
      "/productimgs/shoes/Adidas/41/yupoo yeezy 350 V2 yupoo shoes 4.jpg",
      "/productimgs/shoes/Adidas/41/yupoo yeezy 350 V2 yupoo shoes 5.jpg",
      "/productimgs/shoes/Adidas/41/yupoo yeezy 350 V2 yupoo shoes 6.jpg",
      "/productimgs/shoes/Adidas/41/yupoo yeezy 350 V2 yupoo shoes 7.jpg",
      "/productimgs/shoes/Adidas/41/yupoo yeezy 350 V2 yupoo shoes 8.jpg",
      "/productimgs/shoes/Adidas/41/yupoo yeezy 350 V2 yupoo shoes 9.jpg",
      "/productimgs/shoes/Adidas/41/yupoo yeezy 350 V2 yupoo shoes 10.jpg",
      "/productimgs/shoes/Adidas/41/yupoo yeezy 350 V2 yupoo shoes 11.jpg",
      "/productimgs/shoes/Adidas/41/yupoo yeezy 350 V2 yupoo shoes 12.jpg",
      "/productimgs/shoes/Adidas/41/yupoo yeezy 350 V2 yupoo shoes 13.jpg",
      "/productimgs/shoes/Adidas/41/yupoo yeezy 350 V2 yupoo shoes 14.jpg"
    ]
  },
  {
    id: "570",
    name: "Yupoo Shoes: Premium Yeezy Yupoo Sneakers",
    description: "Premium quality Yeezy Yupoo Sneakers from productalbum.cn. These high-end Yupoos perfectly capture the design and comfort of the authentic version at an affordable price. #yupooshoes #yupooyeezy #yeezy #yupooadidas",
    price: PriceInfo,
    categories: [
      "shoes",
      "yeezy",
      "adidas"
    ],
    images: [
      "/productimgs/shoes/Adidas/51/yupoo yeezy 350 V2 yupoo shoes 1.jpg",
      "/productimgs/shoes/Adidas/51/yupoo yeezy 350 V2 yupoo shoes 2.jpg",
      "/productimgs/shoes/Adidas/51/yupoo yeezy 350 V2 yupoo shoes 3.jpg",
      "/productimgs/shoes/Adidas/51/yupoo yeezy 350 V2 yupoo shoes 4.jpg",
      "/productimgs/shoes/Adidas/51/yupoo yeezy 350 V2 yupoo shoes 5.jpg",
      "/productimgs/shoes/Adidas/51/yupoo yeezy 350 V2 yupoo shoes 6.jpg",
      "/productimgs/shoes/Adidas/51/yupoo yeezy 350 V2 yupoo shoes 7.jpg",
      "/productimgs/shoes/Adidas/51/yupoo yeezy 350 V2 yupoo shoes 8.jpg",
      "/productimgs/shoes/Adidas/51/yupoo yeezy 350 V2 yupoo shoes 9.jpg",
      "/productimgs/shoes/Adidas/51/yupoo yeezy 350 V2 yupoo shoes 10.jpg"
    ]
  },
  {
    id: "571",
    name: "Yupoo Shoes: Premium Yeezy Yupoo Sneakers",
    description: "Premium quality Yeezy Yupoo Sneakers from productalbum.cn. These high-end Yupoos perfectly capture the design and comfort of the authentic version at an affordable price. #yupooshoes #yupooyeezy #yeezy #yupooadidas",
    price: PriceInfo,
    categories: [
      "shoes",
      "yeezy",
      "adidas"
    ],
    images: [
      "/productimgs/shoes/Adidas/92/yupoo yeezy 700 V2 1.jpg",
      "/productimgs/shoes/Adidas/92/yupoo yeezy 700 V2 2.jpg",
      "/productimgs/shoes/Adidas/92/yupoo yeezy 700 V2 3.jpg",
      "/productimgs/shoes/Adidas/92/yupoo yeezy 700 V2 4.jpg",
      "/productimgs/shoes/Adidas/92/yupoo yeezy 700 V2 5.jpg",
      "/productimgs/shoes/Adidas/92/yupoo yeezy 700 V2 6.jpg",
      "/productimgs/shoes/Adidas/92/yupoo yeezy 700 V2 7.jpg",
      "/productimgs/shoes/Adidas/92/yupoo yeezy 700 V2 8.jpg",
      "/productimgs/shoes/Adidas/92/yupoo yeezy 700 V2 9.jpg",
      "/productimgs/shoes/Adidas/92/yupoo yeezy 700 V2 10.jpg",
      "/productimgs/shoes/Adidas/92/yupoo yeezy 700 V2 11.jpg"
    ]
  },
  {
    id: "572",
    name: "Yupoo Shoes: Premium Yeezy Yupoo Sneakers",
    description: "Premium quality Yeezy Yupoo Sneakers from productalbum.cn. These high-end Yupoos perfectly capture the design and comfort of the authentic version at an affordable price. #yupooshoes #yupooyeezy #yeezy #yupooadidas",
    price: PriceInfo,
    categories: [
      "shoes",
      "yeezy",
      "adidas"
    ],
    images: [
      "/productimgs/shoes/Adidas/72/yupoo yeezy 350 V2 yupoo shoes 1.jpg",
      "/productimgs/shoes/Adidas/72/yupoo yeezy 350 V2 yupoo shoes 2.jpg",
      "/productimgs/shoes/Adidas/72/yupoo yeezy 350 V2 yupoo shoes 3.jpg",
      "/productimgs/shoes/Adidas/72/yupoo yeezy 350 V2 yupoo shoes 4.jpg",
      "/productimgs/shoes/Adidas/72/yupoo yeezy 350 V2 yupoo shoes 5.jpg",
      "/productimgs/shoes/Adidas/72/yupoo yeezy 350 V2 yupoo shoes 6.jpg",
      "/productimgs/shoes/Adidas/72/yupoo yeezy 350 V2 yupoo shoes 7.jpg",
      "/productimgs/shoes/Adidas/72/yupoo yeezy 350 V2 yupoo shoes 8.jpg",
      "/productimgs/shoes/Adidas/72/yupoo yeezy 350 V2 yupoo shoes 9.jpg",
      "/productimgs/shoes/Adidas/72/yupoo yeezy 350 V2 yupoo shoes 10.jpg",
      "/productimgs/shoes/Adidas/72/yupoo yeezy 350 V2 yupoo shoes 11.jpg",
      "/productimgs/shoes/Adidas/72/yupoo yeezy 350 V2 yupoo shoes 12.jpg",
      "/productimgs/shoes/Adidas/72/yupoo yeezy 350 V2 yupoo shoes 13.jpg",
      "/productimgs/shoes/Adidas/72/yupoo yeezy 350 V2 yupoo shoes 14.jpg",
      "/productimgs/shoes/Adidas/72/yupoo yeezy 350 V2 yupoo shoes 15.jpg",
      "/productimgs/shoes/Adidas/72/yupoo yeezy 350 V2 yupoo shoes 16.jpg"
    ]
  },
  {
    id: "573",
    name: "Yupoo Shoes: Premium Yeezy Yupoo Sneakers",
    description: "Premium quality Yeezy Yupoo Sneakers from productalbum.cn. These high-end Yupoos perfectly capture the design and comfort of the authentic version at an affordable price. #yupooshoes #yupooyeezy #yeezy #yupooadidas",
    price: PriceInfo,
    categories: [
      "shoes",
      "yeezy",
      "adidas"
    ],
    images: [
      "/productimgs/shoes/Adidas/23/yupoo yeezy 350 Boost V2 yupoo shoes 1.jpg",
      "/productimgs/shoes/Adidas/23/yupoo yeezy 350 Boost V2 yupoo shoes 2.jpg",
      "/productimgs/shoes/Adidas/23/yupoo yeezy 350 Boost V2 yupoo shoes 3.jpg",
      "/productimgs/shoes/Adidas/23/yupoo yeezy 350 Boost V2 yupoo shoes 4.jpg",
      "/productimgs/shoes/Adidas/23/yupoo yeezy 350 Boost V2 yupoo shoes 5.jpg",
      "/productimgs/shoes/Adidas/23/yupoo yeezy 350 Boost V2 yupoo shoes 6.jpg",
      "/productimgs/shoes/Adidas/23/yupoo yeezy 350 Boost V2 yupoo shoes 7.jpg",
      "/productimgs/shoes/Adidas/23/yupoo yeezy 350 Boost V2 yupoo shoes 8.jpg",
      "/productimgs/shoes/Adidas/23/yupoo yeezy 350 Boost V2 yupoo shoes 9.jpg",
      "/productimgs/shoes/Adidas/23/yupoo yeezy 350 Boost V2 yupoo shoes 10.jpg",
      "/productimgs/shoes/Adidas/23/yupoo yeezy 350 Boost V2 yupoo shoes 11.jpg",
      "/productimgs/shoes/Adidas/23/yupoo yeezy 350 Boost V2 yupoo shoes 12.jpg",
      "/productimgs/shoes/Adidas/23/yupoo yeezy 350 Boost V2 yupoo shoes 13.jpg",
      "/productimgs/shoes/Adidas/23/yupoo yeezy 350 Boost V2 yupoo shoes 14.jpg"
    ]
  },
  {
    id: "574",
    name: "Yupoo Shoes: Premium Yeezy Yupoo Sneakers",
    description: "Premium quality Yeezy Yupoo Sneakers from productalbum.cn. These high-end Yupoos perfectly capture the design and comfort of the authentic version at an affordable price. #yupooshoes #yupooyeezy #yeezy #yupooadidas",
    price: PriceInfo,
    categories: [
      "shoes",
      "yeezy",
      "adidas"
    ],
    images: [
      "/productimgs/shoes/Adidas/87/yupoo yeezy 700 V2 1.jpg",
      "/productimgs/shoes/Adidas/87/yupoo yeezy 700 V2 2.jpg",
      "/productimgs/shoes/Adidas/87/yupoo yeezy 700 V2 3.jpg",
      "/productimgs/shoes/Adidas/87/yupoo yeezy 700 V2 4.jpg",
      "/productimgs/shoes/Adidas/87/yupoo yeezy 700 V2 5.jpg",
      "/productimgs/shoes/Adidas/87/yupoo yeezy 700 V2 6.jpg",
      "/productimgs/shoes/Adidas/87/yupoo yeezy 700 V2 7.jpg",
      "/productimgs/shoes/Adidas/87/yupoo yeezy 700 V2 8.jpg",
      "/productimgs/shoes/Adidas/87/yupoo yeezy 700 V2 9.jpg"
    ]
  },
  {
    id: "575",
    name: "Yupoo Shoes: Premium Yeezy Yupoo Sneakers",
    description: "Premium quality Yeezy Yupoo Sneakers from productalbum.cn. These high-end Yupoos perfectly capture the design and comfort of the authentic version at an affordable price. #yupooshoes #yupooyeezy #yeezy #yupooadidas",
    price: PriceInfo,
    categories: [
      "shoes",
      "yeezy",
      "adidas"
    ],
    images: [
      "/productimgs/shoes/Adidas/36/yupoo yeezy 350 V2 yupoo shoes 1.jpg",
      "/productimgs/shoes/Adidas/36/yupoo yeezy 350 V2 yupoo shoes 2.jpg",
      "/productimgs/shoes/Adidas/36/yupoo yeezy 350 V2 yupoo shoes 3.jpg",
      "/productimgs/shoes/Adidas/36/yupoo yeezy 350 V2 yupoo shoes 4.jpg",
      "/productimgs/shoes/Adidas/36/yupoo yeezy 350 V2 yupoo shoes 5.jpg",
      "/productimgs/shoes/Adidas/36/yupoo yeezy 350 V2 yupoo shoes 6.jpg",
      "/productimgs/shoes/Adidas/36/yupoo yeezy 350 V2 yupoo shoes 7.jpg",
      "/productimgs/shoes/Adidas/36/yupoo yeezy 350 V2 yupoo shoes 8.jpg",
      "/productimgs/shoes/Adidas/36/yupoo yeezy 350 V2 yupoo shoes 9.jpg",
      "/productimgs/shoes/Adidas/36/yupoo yeezy 350 V2 yupoo shoes 10.jpg",
      "/productimgs/shoes/Adidas/36/yupoo yeezy 350 V2 yupoo shoes 11.jpg",
      "/productimgs/shoes/Adidas/36/yupoo yeezy 350 V2 yupoo shoes 12.jpg",
      "/productimgs/shoes/Adidas/36/yupoo yeezy 350 V2 yupoo shoes 13.jpg",
      "/productimgs/shoes/Adidas/36/yupoo yeezy 350 V2 yupoo shoes 14.jpg",
      "/productimgs/shoes/Adidas/36/yupoo yeezy 350 V2 yupoo shoes 15.jpg",
      "/productimgs/shoes/Adidas/36/yupoo yeezy 350 V2 yupoo shoes 16.jpg",
      "/productimgs/shoes/Adidas/36/yupoo yeezy 350 V2 yupoo shoes 17.jpg",
      "/productimgs/shoes/Adidas/36/yupoo yeezy 350 V2 yupoo shoes 18.jpg",
      "/productimgs/shoes/Adidas/36/yupoo yeezy 350 V2 yupoo shoes 19.jpg",
      "/productimgs/shoes/Adidas/36/yupoo yeezy 350 V2 yupoo shoes 20.jpg"
    ]
  },
  {
    id: "576",
    name: "Yupoo Shoes: Premium Yeezy Yupoo Sneakers",
    description: "Premium quality Yeezy Yupoo Sneakers from productalbum.cn. These high-end Yupoos perfectly capture the design and comfort of the authentic version at an affordable price. #yupooshoes #yupooyeezy #yeezy #yupooadidas",
    price: PriceInfo,
    categories: [
      "shoes",
      "yeezy",
      "adidas"
    ],
    images: [
      "/productimgs/shoes/Adidas/68/yupoo yeezy 350 V2 yupoo shoes 1.jpg",
      "/productimgs/shoes/Adidas/68/yupoo yeezy 350 V2 yupoo shoes 2.jpg",
      "/productimgs/shoes/Adidas/68/yupoo yeezy 350 V2 yupoo shoes 3.jpg",
      "/productimgs/shoes/Adidas/68/yupoo yeezy 350 V2 yupoo shoes 4.jpg",
      "/productimgs/shoes/Adidas/68/yupoo yeezy 350 V2 yupoo shoes 5.jpg",
      "/productimgs/shoes/Adidas/68/yupoo yeezy 350 V2 yupoo shoes 6.jpg",
      "/productimgs/shoes/Adidas/68/yupoo yeezy 350 V2 yupoo shoes 7.jpg",
      "/productimgs/shoes/Adidas/68/yupoo yeezy 350 V2 yupoo shoes 8.jpg",
      "/productimgs/shoes/Adidas/68/yupoo yeezy 350 V2 yupoo shoes 9.jpg",
      "/productimgs/shoes/Adidas/68/yupoo yeezy 350 V2 yupoo shoes 10.jpg",
      "/productimgs/shoes/Adidas/68/yupoo yeezy 350 V2 yupoo shoes 11.jpg",
      "/productimgs/shoes/Adidas/68/yupoo yeezy 350 V2 yupoo shoes 12.jpg",
      "/productimgs/shoes/Adidas/68/yupoo yeezy 350 V2 yupoo shoes 13.jpg",
      "/productimgs/shoes/Adidas/68/yupoo yeezy 350 V2 yupoo shoes 14.jpg"
    ]
  },
  {
    id: "577",
    name: "Yupoo Shoes: Premium Yeezy Yupoo Sneakers",
    description: "Premium quality Yeezy Yupoo Sneakers from productalbum.cn. These high-end Yupoos perfectly capture the design and comfort of the authentic version at an affordable price. #yupooshoes #yupooyeezy #yeezy #yupooadidas",
    price: PriceInfo,
    categories: [
      "shoes",
      "yeezy",
      "adidas"
    ],
    images: [
      "/productimgs/shoes/Adidas/93/yupoo yeezy 750 Boost yupoo shoes 1.jpg",
      "/productimgs/shoes/Adidas/93/yupoo yeezy 750 Boost yupoo shoes 2.jpg",
      "/productimgs/shoes/Adidas/93/yupoo yeezy 750 Boost yupoo shoes 3.jpg",
      "/productimgs/shoes/Adidas/93/yupoo yeezy 750 Boost yupoo shoes 4.jpg",
      "/productimgs/shoes/Adidas/93/yupoo yeezy 750 Boost yupoo shoes 5.jpg",
      "/productimgs/shoes/Adidas/93/yupoo yeezy 750 Boost yupoo shoes 6.jpg",
      "/productimgs/shoes/Adidas/93/yupoo yeezy 750 Boost yupoo shoes 7.jpg",
      "/productimgs/shoes/Adidas/93/yupoo yeezy 750 Boost yupoo shoes 8.jpg",
      "/productimgs/shoes/Adidas/93/yupoo yeezy 750 Boost yupoo shoes 9.jpg",
      "/productimgs/shoes/Adidas/93/yupoo yeezy 750 Boost yupoo shoes 10.jpg",
      "/productimgs/shoes/Adidas/93/yupoo yeezy 750 Boost yupoo shoes 11.jpg",
      "/productimgs/shoes/Adidas/93/yupoo yeezy 750 Boost yupoo shoes 12.jpg",
      "/productimgs/shoes/Adidas/93/yupoo yeezy 750 Boost yupoo shoes 13.jpg"
    ]
  },
  {
    id: "578",
    name: "Yupoo Shoes: Premium Yeezy Yupoo Sneakers",
    description: "Premium quality Yeezy Yupoo Sneakers from productalbum.cn. These high-end Yupoos perfectly capture the design and comfort of the authentic version at an affordable price. #yupooshoes #yupooyeezy #yeezy #yupooadidas",
    price: PriceInfo,
    categories: [
      "shoes",
      "yeezy",
      "adidas"
    ],
    images: [
      "/productimgs/shoes/Adidas/30/yupoo yeezy 350 Boost V2 yupoo shoes 1.jpg",
      "/productimgs/shoes/Adidas/30/yupoo yeezy 350 Boost V2 yupoo shoes 2.jpg",
      "/productimgs/shoes/Adidas/30/yupoo yeezy 350 Boost V2 yupoo shoes 3.jpg",
      "/productimgs/shoes/Adidas/30/yupoo yeezy 350 Boost V2 yupoo shoes 4.jpg",
      "/productimgs/shoes/Adidas/30/yupoo yeezy 350 Boost V2 yupoo shoes 5.jpg",
      "/productimgs/shoes/Adidas/30/yupoo yeezy 350 Boost V2 yupoo shoes 6.jpg",
      "/productimgs/shoes/Adidas/30/yupoo yeezy 350 Boost V2 yupoo shoes 7.jpg",
      "/productimgs/shoes/Adidas/30/yupoo yeezy 350 Boost V2 yupoo shoes 8.jpg",
      "/productimgs/shoes/Adidas/30/yupoo yeezy 350 Boost V2 yupoo shoes 9.jpg",
      "/productimgs/shoes/Adidas/30/yupoo yeezy 350 Boost V2 yupoo shoes 10.jpg",
      "/productimgs/shoes/Adidas/30/yupoo yeezy 350 Boost V2 yupoo shoes 11.jpg",
      "/productimgs/shoes/Adidas/30/yupoo yeezy 350 Boost V2 yupoo shoes 12.jpg",
      "/productimgs/shoes/Adidas/30/yupoo yeezy 350 Boost V2 yupoo shoes 13.jpg",
      "/productimgs/shoes/Adidas/30/yupoo yeezy 350 Boost V2 yupoo shoes 14.jpg"
    ]
  },
  {
    id: "579",
    name: "Yupoo Shoes: Premium Yeezy Yupoo Sneakers",
    description: "Premium quality Yeezy Yupoo Sneakers from productalbum.cn. These high-end Yupoos perfectly capture the design and comfort of the authentic version at an affordable price. #yupooshoes #yupooyeezy #yeezy #yupooadidas",
    price: PriceInfo,
    categories: [
      "shoes",
      "yeezy",
      "adidas"
    ],
    images: [
      "/productimgs/shoes/Adidas/45/yupoo yeezy 350 V2 yupoo shoes 1.jpg",
      "/productimgs/shoes/Adidas/45/yupoo yeezy 350 V2 yupoo shoes 2.jpg",
      "/productimgs/shoes/Adidas/45/yupoo yeezy 350 V2 yupoo shoes 3.jpg",
      "/productimgs/shoes/Adidas/45/yupoo yeezy 350 V2 yupoo shoes 4.jpg",
      "/productimgs/shoes/Adidas/45/yupoo yeezy 350 V2 yupoo shoes 5.jpg",
      "/productimgs/shoes/Adidas/45/yupoo yeezy 350 V2 yupoo shoes 6.jpg",
      "/productimgs/shoes/Adidas/45/yupoo yeezy 350 V2 yupoo shoes 7.jpg",
      "/productimgs/shoes/Adidas/45/yupoo yeezy 350 V2 yupoo shoes 8.jpg",
      "/productimgs/shoes/Adidas/45/yupoo yeezy 350 V2 yupoo shoes 9.jpg"
    ]
  },
  {
    id: "580",
    name: "Yupoo Shoes: Premium Yeezy Yupoo Sneakers",
    description: "Premium quality Yeezy Yupoo Sneakers from productalbum.cn. These high-end Yupoos perfectly capture the design and comfort of the authentic version at an affordable price. #yupooshoes #yupooyeezy #yeezy #yupooadidas",
    price: PriceInfo,
    categories: [
      "shoes",
      "yeezy",
      "adidas"
    ],
    images: [
      "/productimgs/shoes/Adidas/57/yupoo yeezy 350 V2 yupoo shoes 1.jpg",
      "/productimgs/shoes/Adidas/57/yupoo yeezy 350 V2 yupoo shoes 2.jpg",
      "/productimgs/shoes/Adidas/57/yupoo yeezy 350 V2 yupoo shoes 3.jpg",
      "/productimgs/shoes/Adidas/57/yupoo yeezy 350 V2 yupoo shoes 4.jpg",
      "/productimgs/shoes/Adidas/57/yupoo yeezy 350 V2 yupoo shoes 5.jpg",
      "/productimgs/shoes/Adidas/57/yupoo yeezy 350 V2 yupoo shoes 6.jpg",
      "/productimgs/shoes/Adidas/57/yupoo yeezy 350 V2 yupoo shoes 7.jpg",
      "/productimgs/shoes/Adidas/57/yupoo yeezy 350 V2 yupoo shoes 8.jpg",
      "/productimgs/shoes/Adidas/57/yupoo yeezy 350 V2 yupoo shoes 9.jpg",
      "/productimgs/shoes/Adidas/57/yupoo yeezy 350 V2 yupoo shoes 10.jpg",
      "/productimgs/shoes/Adidas/57/yupoo yeezy 350 V2 yupoo shoes 11.jpg",
      "/productimgs/shoes/Adidas/57/yupoo yeezy 350 V2 yupoo shoes 12.jpg",
      "/productimgs/shoes/Adidas/57/yupoo yeezy 350 V2 yupoo shoes 13.jpg"
    ]
  },
  {
    id: "581",
    name: "Yupoo Shoes: Premium Yeezy Yupoo Sneakers",
    description: "Premium quality Yeezy Yupoo Sneakers from productalbum.cn. These high-end Yupoos perfectly capture the design and comfort of the authentic version at an affordable price. #yupooshoes #yupooyeezy #yeezy #yupooadidas",
    price: PriceInfo,
    categories: [
      "shoes",
      "yeezy",
      "adidas"
    ],
    images: [
      "/productimgs/shoes/Adidas/35/yupoo yeezy 350 V2 yupoo shoes 1.jpg",
      "/productimgs/shoes/Adidas/35/yupoo yeezy 350 V2 yupoo shoes 2.jpg",
      "/productimgs/shoes/Adidas/35/yupoo yeezy 350 V2 yupoo shoes 3.jpg",
      "/productimgs/shoes/Adidas/35/yupoo yeezy 350 V2 yupoo shoes 4.jpg",
      "/productimgs/shoes/Adidas/35/yupoo yeezy 350 V2 yupoo shoes 5.jpg",
      "/productimgs/shoes/Adidas/35/yupoo yeezy 350 V2 yupoo shoes 6.jpg",
      "/productimgs/shoes/Adidas/35/yupoo yeezy 350 V2 yupoo shoes 7.jpg",
      "/productimgs/shoes/Adidas/35/yupoo yeezy 350 V2 yupoo shoes 8.jpg",
      "/productimgs/shoes/Adidas/35/yupoo yeezy 350 V2 yupoo shoes 9.jpg",
      "/productimgs/shoes/Adidas/35/yupoo yeezy 350 V2 yupoo shoes 10.jpg",
      "/productimgs/shoes/Adidas/35/yupoo yeezy 350 V2 yupoo shoes 11.jpg",
      "/productimgs/shoes/Adidas/35/yupoo yeezy 350 V2 yupoo shoes 12.jpg",
      "/productimgs/shoes/Adidas/35/yupoo yeezy 350 V2 yupoo shoes 13.jpg"
    ]
  },
  {
    id: "582",
    name: "Yupoo Shoes: Premium Yeezy Yupoo Sneakers",
    description: "Premium quality Yeezy Yupoo Sneakers from productalbum.cn. These high-end Yupoos perfectly capture the design and comfort of the authentic version at an affordable price. #yupooshoes #yupooyeezy #yeezy #yupooadidas",
    price: PriceInfo,
    categories: [
      "shoes",
      "yeezy",
      "adidas"
    ],
    images: [
      "/productimgs/shoes/Adidas/29/yupoo yeezy 350 Boost V2 yupoo shoes 1.jpg",
      "/productimgs/shoes/Adidas/29/yupoo yeezy 350 Boost V2 yupoo shoes 2.jpg",
      "/productimgs/shoes/Adidas/29/yupoo yeezy 350 Boost V2 yupoo shoes 3.jpg",
      "/productimgs/shoes/Adidas/29/yupoo yeezy 350 Boost V2 yupoo shoes 4.jpg",
      "/productimgs/shoes/Adidas/29/yupoo yeezy 350 Boost V2 yupoo shoes 5.jpg",
      "/productimgs/shoes/Adidas/29/yupoo yeezy 350 Boost V2 yupoo shoes 6.jpg",
      "/productimgs/shoes/Adidas/29/yupoo yeezy 350 Boost V2 yupoo shoes 7.jpg",
      "/productimgs/shoes/Adidas/29/yupoo yeezy 350 Boost V2 yupoo shoes 8.jpg",
      "/productimgs/shoes/Adidas/29/yupoo yeezy 350 Boost V2 yupoo shoes 9.jpg",
      "/productimgs/shoes/Adidas/29/yupoo yeezy 350 Boost V2 yupoo shoes 10.jpg",
      "/productimgs/shoes/Adidas/29/yupoo yeezy 350 Boost V2 yupoo shoes 11.jpg",
      "/productimgs/shoes/Adidas/29/yupoo yeezy 350 Boost V2 yupoo shoes 12.jpg",
      "/productimgs/shoes/Adidas/29/yupoo yeezy 350 Boost V2 yupoo shoes 13.jpg",
      "/productimgs/shoes/Adidas/29/yupoo yeezy 350 Boost V2 yupoo shoes 14.jpg",
      "/productimgs/shoes/Adidas/29/yupoo yeezy 350 Boost V2 yupoo shoes 15.jpg",
      "/productimgs/shoes/Adidas/29/yupoo yeezy 350 Boost V2 yupoo shoes 16.jpg",
      "/productimgs/shoes/Adidas/29/yupoo yeezy 350 Boost V2 yupoo shoes 17.jpg"
    ]
  },
  {
    id: "583",
    name: "Yupoo Shoes: Premium Yeezy Yupoo Sneakers",
    description: "Premium quality Yeezy Yupoo Sneakers from productalbum.cn. These high-end Yupoos perfectly capture the design and comfort of the authentic version at an affordable price. #yupooshoes #yupooyeezy #yeezy #yupooadidas",
    price: PriceInfo,
    categories: [
      "shoes",
      "yeezy",
      "adidas"
    ],
    images: [
      "/productimgs/shoes/Adidas/89/yupoo yeezy 700 V2 1.jpg",
      "/productimgs/shoes/Adidas/89/yupoo yeezy 700 V2 2.jpg",
      "/productimgs/shoes/Adidas/89/yupoo yeezy 700 V2 3.jpg",
      "/productimgs/shoes/Adidas/89/yupoo yeezy 700 V2 4.jpg",
      "/productimgs/shoes/Adidas/89/yupoo yeezy 700 V2 5.jpg",
      "/productimgs/shoes/Adidas/89/yupoo yeezy 700 V2 6.jpg",
      "/productimgs/shoes/Adidas/89/yupoo yeezy 700 V2 7.jpg",
      "/productimgs/shoes/Adidas/89/yupoo yeezy 700 V2 8.jpg",
      "/productimgs/shoes/Adidas/89/yupoo yeezy 700 V2 9.jpg",
      "/productimgs/shoes/Adidas/89/yupoo yeezy 700 V2 10.jpg",
      "/productimgs/shoes/Adidas/89/yupoo yeezy 700 V2 11.jpg",
      "/productimgs/shoes/Adidas/89/yupoo yeezy 700 V2 12.jpg",
      "/productimgs/shoes/Adidas/89/yupoo yeezy 700 V2 13.jpg",
      "/productimgs/shoes/Adidas/89/yupoo yeezy 700 V2 14.jpg",
      "/productimgs/shoes/Adidas/89/yupoo yeezy 700 V2 15.jpg",
      "/productimgs/shoes/Adidas/89/yupoo yeezy 700 V2 16.jpg"
    ]
  },
  {
    id: "584",
    name: "Yupoo Shoes: Premium Yeezy Yupoo Sneakers",
    description: "Premium quality Yeezy Yupoo Sneakers from productalbum.cn. These high-end Yupoos perfectly capture the design and comfort of the authentic version at an affordable price. #yupooshoes #yupooyeezy #yeezy #yupooadidas",
    price: PriceInfo,
    categories: [
      "shoes",
      "yeezy",
      "adidas"
    ],
    images: [
      "/productimgs/shoes/Adidas/82/yupoo yeezy 500 yupoo shoes 1.jpg",
      "/productimgs/shoes/Adidas/82/yupoo yeezy 500 yupoo shoes 2.jpg",
      "/productimgs/shoes/Adidas/82/yupoo yeezy 500 yupoo shoes 3.jpg",
      "/productimgs/shoes/Adidas/82/yupoo yeezy 500 yupoo shoes 4.jpg",
      "/productimgs/shoes/Adidas/82/yupoo yeezy 500 yupoo shoes 5.jpg",
      "/productimgs/shoes/Adidas/82/yupoo yeezy 500 yupoo shoes 6.jpg",
      "/productimgs/shoes/Adidas/82/yupoo yeezy 500 yupoo shoes 7.jpg",
      "/productimgs/shoes/Adidas/82/yupoo yeezy 500 yupoo shoes 8.jpg",
      "/productimgs/shoes/Adidas/82/yupoo yeezy 500 yupoo shoes 9.jpg",
      "/productimgs/shoes/Adidas/82/yupoo yeezy 500 yupoo shoes 10.jpg"
    ]
  },
  {
    id: "585",
    name: "Yupoo Shoes: Premium Yeezy Yupoo Sneakers",
    description: "Premium quality Yeezy Yupoo Sneakers from productalbum.cn. These high-end Yupoos perfectly capture the design and comfort of the authentic version at an affordable price. #yupooshoes #yupooyeezy #yeezy #yupooadidas",
    price: PriceInfo,
    categories: [
      "shoes",
      "yeezy",
      "adidas"
    ],
    images: [
      "/productimgs/shoes/Adidas/60/yupoo yeezy 350 V2 yupoo shoes 1.jpg",
      "/productimgs/shoes/Adidas/60/yupoo yeezy 350 V2 yupoo shoes 2.jpg",
      "/productimgs/shoes/Adidas/60/yupoo yeezy 350 V2 yupoo shoes 3.jpg",
      "/productimgs/shoes/Adidas/60/yupoo yeezy 350 V2 yupoo shoes 4.jpg",
      "/productimgs/shoes/Adidas/60/yupoo yeezy 350 V2 yupoo shoes 5.jpg",
      "/productimgs/shoes/Adidas/60/yupoo yeezy 350 V2 yupoo shoes 6.jpg",
      "/productimgs/shoes/Adidas/60/yupoo yeezy 350 V2 yupoo shoes 7.jpg",
      "/productimgs/shoes/Adidas/60/yupoo yeezy 350 V2 yupoo shoes 8.jpg",
      "/productimgs/shoes/Adidas/60/yupoo yeezy 350 V2 yupoo shoes 9.jpg",
      "/productimgs/shoes/Adidas/60/yupoo yeezy 350 V2 yupoo shoes 10.jpg",
      "/productimgs/shoes/Adidas/60/yupoo yeezy 350 V2 yupoo shoes 11.jpg",
      "/productimgs/shoes/Adidas/60/yupoo yeezy 350 V2 yupoo shoes 12.jpg",
      "/productimgs/shoes/Adidas/60/yupoo yeezy 350 V2 yupoo shoes 13.jpg",
      "/productimgs/shoes/Adidas/60/yupoo yeezy 350 V2 yupoo shoes 14.jpg"
    ]
  },
  {
    id: "586",
    name: "Yupoo Shoes: Premium Yeezy Yupoo Sneakers",
    description: "Premium quality Yeezy Yupoo Sneakers from productalbum.cn. These high-end Yupoos perfectly capture the design and comfort of the authentic version at an affordable price. #yupooshoes #yupooyeezy #yeezy #yupooadidas",
    price: PriceInfo,
    categories: [
      "shoes",
      "yeezy",
      "adidas"
    ],
    images: [
      "/productimgs/shoes/Adidas/78/yupoo yeezy 450 1.jpg",
      "/productimgs/shoes/Adidas/78/yupoo yeezy 450 2.jpg",
      "/productimgs/shoes/Adidas/78/yupoo yeezy 450 3.jpg",
      "/productimgs/shoes/Adidas/78/yupoo yeezy 450 4.jpg",
      "/productimgs/shoes/Adidas/78/yupoo yeezy 450 5.jpg",
      "/productimgs/shoes/Adidas/78/yupoo yeezy 450 6.jpg",
      "/productimgs/shoes/Adidas/78/yupoo yeezy 450 7.jpg",
      "/productimgs/shoes/Adidas/78/yupoo yeezy 450 8.jpg",
      "/productimgs/shoes/Adidas/78/yupoo yeezy 450 9.jpg",
      "/productimgs/shoes/Adidas/78/yupoo yeezy 450 10.jpg",
      "/productimgs/shoes/Adidas/78/yupoo yeezy 450 11.jpg"
    ]
  },
  {
    id: "587",
    name: "Yupoo Shoes: Premium Yeezy Yupoo Sneakers",
    description: "Premium quality Yeezy Yupoo Sneakers from productalbum.cn. These high-end Yupoos perfectly capture the design and comfort of the authentic version at an affordable price. #yupooshoes #yupooyeezy #yeezy #yupooadidas",
    price: PriceInfo,
    categories: [
      "shoes",
      "yeezy",
      "adidas"
    ],
    images: [
      "/productimgs/shoes/Adidas/34/yupoo yeezy 350 V2 yupoo shoes 1.jpg",
      "/productimgs/shoes/Adidas/34/yupoo yeezy 350 V2 yupoo shoes 2.jpg",
      "/productimgs/shoes/Adidas/34/yupoo yeezy 350 V2 yupoo shoes 3.jpg",
      "/productimgs/shoes/Adidas/34/yupoo yeezy 350 V2 yupoo shoes 4.jpg",
      "/productimgs/shoes/Adidas/34/yupoo yeezy 350 V2 yupoo shoes 5.jpg",
      "/productimgs/shoes/Adidas/34/yupoo yeezy 350 V2 yupoo shoes 6.jpg",
      "/productimgs/shoes/Adidas/34/yupoo yeezy 350 V2 yupoo shoes 7.jpg",
      "/productimgs/shoes/Adidas/34/yupoo yeezy 350 V2 yupoo shoes 8.jpg",
      "/productimgs/shoes/Adidas/34/yupoo yeezy 350 V2 yupoo shoes 9.jpg"
    ]
  },
  {
    id: "588",
    name: "Yupoo Shoes: Premium Yeezy Yupoo Sneakers",
    description: "Premium quality Yeezy Yupoo Sneakers from productalbum.cn. These high-end Yupoos perfectly capture the design and comfort of the authentic version at an affordable price. #yupooshoes #yupooyeezy #yeezy #yupooadidas",
    price: PriceInfo,
    categories: [
      "shoes",
      "yeezy",
      "adidas"
    ],
    images: [
      "/productimgs/shoes/Adidas/80/yupoo yeezy 500 yupoo shoes 1.jpg",
      "/productimgs/shoes/Adidas/80/yupoo yeezy 500 yupoo shoes 2.jpg",
      "/productimgs/shoes/Adidas/80/yupoo yeezy 500 yupoo shoes 3.jpg",
      "/productimgs/shoes/Adidas/80/yupoo yeezy 500 yupoo shoes 4.jpg",
      "/productimgs/shoes/Adidas/80/yupoo yeezy 500 yupoo shoes 5.jpg",
      "/productimgs/shoes/Adidas/80/yupoo yeezy 500 yupoo shoes 6.jpg",
      "/productimgs/shoes/Adidas/80/yupoo yeezy 500 yupoo shoes 7.jpg",
      "/productimgs/shoes/Adidas/80/yupoo yeezy 500 yupoo shoes 8.jpg",
      "/productimgs/shoes/Adidas/80/yupoo yeezy 500 yupoo shoes 9.jpg",
      "/productimgs/shoes/Adidas/80/yupoo yeezy 500 yupoo shoes 10.jpg"
    ]
  },
  {
    id: "589",
    name: "Yupoo Shoes: Premium Yeezy Yupoo Sneakers",
    description: "Premium quality Yeezy Yupoo Sneakers from productalbum.cn. These high-end Yupoos perfectly capture the design and comfort of the authentic version at an affordable price. #yupooshoes #yupooyeezy #yeezy #yupooadidas",
    price: PriceInfo,
    categories: [
      "shoes",
      "yeezy",
      "adidas"
    ],
    images: [
      "/productimgs/shoes/Adidas/61/yupoo yeezy 350 V2 yupoo shoes 1.jpg",
      "/productimgs/shoes/Adidas/61/yupoo yeezy 350 V2 yupoo shoes 2.jpg",
      "/productimgs/shoes/Adidas/61/yupoo yeezy 350 V2 yupoo shoes 3.jpg",
      "/productimgs/shoes/Adidas/61/yupoo yeezy 350 V2 yupoo shoes 4.jpg",
      "/productimgs/shoes/Adidas/61/yupoo yeezy 350 V2 yupoo shoes 5.jpg",
      "/productimgs/shoes/Adidas/61/yupoo yeezy 350 V2 yupoo shoes 6.jpg",
      "/productimgs/shoes/Adidas/61/yupoo yeezy 350 V2 yupoo shoes 7.jpg",
      "/productimgs/shoes/Adidas/61/yupoo yeezy 350 V2 yupoo shoes 8.jpg",
      "/productimgs/shoes/Adidas/61/yupoo yeezy 350 V2 yupoo shoes 9.jpg",
      "/productimgs/shoes/Adidas/61/yupoo yeezy 350 V2 yupoo shoes 10.jpg",
      "/productimgs/shoes/Adidas/61/yupoo yeezy 350 V2 yupoo shoes 11.jpg",
      "/productimgs/shoes/Adidas/61/yupoo yeezy 350 V2 yupoo shoes 12.jpg",
      "/productimgs/shoes/Adidas/61/yupoo yeezy 350 V2 yupoo shoes 13.jpg",
      "/productimgs/shoes/Adidas/61/yupoo yeezy 350 V2 yupoo shoes 14.jpg",
      "/productimgs/shoes/Adidas/61/yupoo yeezy 350 V2 yupoo shoes 15.jpg",
      "/productimgs/shoes/Adidas/61/yupoo yeezy 350 V2 yupoo shoes 16.jpg",
      "/productimgs/shoes/Adidas/61/yupoo yeezy 350 V2 yupoo shoes 17.jpg",
      "/productimgs/shoes/Adidas/61/yupoo yeezy 350 V2 yupoo shoes 18.jpg",
      "/productimgs/shoes/Adidas/61/yupoo yeezy 350 V2 yupoo shoes 19.jpg",
      "/productimgs/shoes/Adidas/61/yupoo yeezy 350 V2 yupoo shoes 20.jpg"
    ]
  },
  {
    id: "590",
    name: "Yupoo Shoes: Premium Yeezy Yupoo Sneakers",
    description: "Premium quality Yeezy Yupoo Sneakers from productalbum.cn. These high-end Yupoos perfectly capture the design and comfort of the authentic version at an affordable price. #yupooshoes #yupooyeezy #yeezy #yupooadidas",
    price: PriceInfo,
    categories: [
      "shoes",
      "yeezy",
      "adidas"
    ],
    images: [
      "/productimgs/shoes/Adidas/81/yupoo yeezy 500 yupoo shoes 1.jpg",
      "/productimgs/shoes/Adidas/81/yupoo yeezy 500 yupoo shoes 2.jpg",
      "/productimgs/shoes/Adidas/81/yupoo yeezy 500 yupoo shoes 3.jpg",
      "/productimgs/shoes/Adidas/81/yupoo yeezy 500 yupoo shoes 4.jpg",
      "/productimgs/shoes/Adidas/81/yupoo yeezy 500 yupoo shoes 5.jpg",
      "/productimgs/shoes/Adidas/81/yupoo yeezy 500 yupoo shoes 6.jpg",
      "/productimgs/shoes/Adidas/81/yupoo yeezy 500 yupoo shoes 7.jpg",
      "/productimgs/shoes/Adidas/81/yupoo yeezy 500 yupoo shoes 8.jpg",
      "/productimgs/shoes/Adidas/81/yupoo yeezy 500 yupoo shoes 9.jpg",
      "/productimgs/shoes/Adidas/81/yupoo yeezy 500 yupoo shoes 10.jpg",
      "/productimgs/shoes/Adidas/81/yupoo yeezy 500 yupoo shoes 11.jpg",
      "/productimgs/shoes/Adidas/81/yupoo yeezy 500 yupoo shoes 12.jpg",
      "/productimgs/shoes/Adidas/81/yupoo yeezy 500 yupoo shoes 13.jpg"
    ]
  },
  {
    id: "591",
    name: "Yupoo Shoes: Premium Yeezy Yupoo Sneakers",
    description: "Premium quality Yeezy Yupoo Sneakers from productalbum.cn. These high-end Yupoos perfectly capture the design and comfort of the authentic version at an affordable price. #yupooshoes #yupooyeezy #yeezy #yupooadidas",
    price: PriceInfo,
    categories: [
      "shoes",
      "yeezy",
      "adidas"
    ],
    images: [
      "/productimgs/shoes/Adidas/63/yupoo yeezy 350 V2 yupoo shoes 1.jpg",
      "/productimgs/shoes/Adidas/63/yupoo yeezy 350 V2 yupoo shoes 2.jpg",
      "/productimgs/shoes/Adidas/63/yupoo yeezy 350 V2 yupoo shoes 3.jpg",
      "/productimgs/shoes/Adidas/63/yupoo yeezy 350 V2 yupoo shoes 4.jpg",
      "/productimgs/shoes/Adidas/63/yupoo yeezy 350 V2 yupoo shoes 5.jpg",
      "/productimgs/shoes/Adidas/63/yupoo yeezy 350 V2 yupoo shoes 6.jpg",
      "/productimgs/shoes/Adidas/63/yupoo yeezy 350 V2 yupoo shoes 7.jpg",
      "/productimgs/shoes/Adidas/63/yupoo yeezy 350 V2 yupoo shoes 8.jpg",
      "/productimgs/shoes/Adidas/63/yupoo yeezy 350 V2 yupoo shoes 9.jpg",
      "/productimgs/shoes/Adidas/63/yupoo yeezy 350 V2 yupoo shoes 10.jpg",
      "/productimgs/shoes/Adidas/63/yupoo yeezy 350 V2 yupoo shoes 11.jpg",
      "/productimgs/shoes/Adidas/63/yupoo yeezy 350 V2 yupoo shoes 12.jpg"
    ]
  },
  {
    id: "592",
    name: "Yupoo Shoes: Premium Yeezy Yupoo Sneakers",
    description: "Premium quality Yeezy Yupoo Sneakers from productalbum.cn. These high-end Yupoos perfectly capture the design and comfort of the authentic version at an affordable price. #yupooshoes #yupooyeezy #yeezy #yupooadidas",
    price: PriceInfo,
    categories: [
      "shoes",
      "yeezy",
      "adidas"
    ],
    images: [
      "/productimgs/shoes/Adidas/84/yupoo yeezy 500 yupoo shoes 1.jpg",
      "/productimgs/shoes/Adidas/84/yupoo yeezy 500 yupoo shoes 2.jpg",
      "/productimgs/shoes/Adidas/84/yupoo yeezy 500 yupoo shoes 3.jpg",
      "/productimgs/shoes/Adidas/84/yupoo yeezy 500 yupoo shoes 4.jpg",
      "/productimgs/shoes/Adidas/84/yupoo yeezy 500 yupoo shoes 5.jpg",
      "/productimgs/shoes/Adidas/84/yupoo yeezy 500 yupoo shoes 6.jpg",
      "/productimgs/shoes/Adidas/84/yupoo yeezy 500 yupoo shoes 7.jpg",
      "/productimgs/shoes/Adidas/84/yupoo yeezy 500 yupoo shoes 8.jpg",
      "/productimgs/shoes/Adidas/84/yupoo yeezy 500 yupoo shoes 9.jpg",
      "/productimgs/shoes/Adidas/84/yupoo yeezy 500 yupoo shoes 10.jpg",
      "/productimgs/shoes/Adidas/84/yupoo yeezy 500 yupoo shoes 11.jpg",
      "/productimgs/shoes/Adidas/84/yupoo yeezy 500 yupoo shoes 12.jpg",
      "/productimgs/shoes/Adidas/84/yupoo yeezy 500 yupoo shoes 13.jpg",
      "/productimgs/shoes/Adidas/84/yupoo yeezy 500 yupoo shoes 14.jpg",
      "/productimgs/shoes/Adidas/84/yupoo yeezy 500 yupoo shoes 15.jpg",
      "/productimgs/shoes/Adidas/84/yupoo yeezy 500 yupoo shoes 16.jpg",
      "/productimgs/shoes/Adidas/84/yupoo yeezy 500 yupoo shoes 17.jpg",
      "/productimgs/shoes/Adidas/84/yupoo yeezy 500 yupoo shoes 18.jpg",
      "/productimgs/shoes/Adidas/84/yupoo yeezy 500 yupoo shoes 19.jpg",
      "/productimgs/shoes/Adidas/84/yupoo yeezy 500 yupoo shoes 20.jpg"
    ]
  },
  {
    id: "593",
    name: "Yupoo Shoes: Premium Yeezy Yupoo Sneakers",
    description: "Premium quality Yeezy Yupoo Sneakers from productalbum.cn. These high-end Yupoos perfectly capture the design and comfort of the authentic version at an affordable price. #yupooshoes #yupooyeezy #yeezy #yupooadidas",
    price: PriceInfo,
    categories: [
      "shoes",
      "yeezy",
      "adidas"
    ],
    images: [
      "/productimgs/shoes/Adidas/88/yupoo yeezy 700 V2 1.jpg",
      "/productimgs/shoes/Adidas/88/yupoo yeezy 700 V2 2.jpg",
      "/productimgs/shoes/Adidas/88/yupoo yeezy 700 V2 3.jpg",
      "/productimgs/shoes/Adidas/88/yupoo yeezy 700 V2 4.jpg",
      "/productimgs/shoes/Adidas/88/yupoo yeezy 700 V2 5.jpg",
      "/productimgs/shoes/Adidas/88/yupoo yeezy 700 V2 6.jpg",
      "/productimgs/shoes/Adidas/88/yupoo yeezy 700 V2 7.jpg",
      "/productimgs/shoes/Adidas/88/yupoo yeezy 700 V2 8.jpg",
      "/productimgs/shoes/Adidas/88/yupoo yeezy 700 V2 9.jpg",
      "/productimgs/shoes/Adidas/88/yupoo yeezy 700 V2 10.jpg",
      "/productimgs/shoes/Adidas/88/yupoo yeezy 700 V2 11.jpg",
      "/productimgs/shoes/Adidas/88/yupoo yeezy 700 V2 12.jpg"
    ]
  },
  {
    id: "594",
    name: "Yupoo Shoes:ADIDAX YEEZY Desert Rat 500",
    description: "Get the ADIDAX YEEZY Desert Rat 500 shoes from productalbum.cn. With their rugged design and comfortable fit, they are suitable for both casual and outdoor activities. #yupooshoes #yupooyeezy #yeezy #yupooadidas",
    price: PriceInfo,
    categories: [
      "shoes",
      "yeezy",
      "adidas"
    ],
    images: [
      "/productimgs/shoes/Adidas/5/yeezy yupoo 001-ADIDA YEEZY Desert Rat 500    1.jpg",
      "/productimgs/shoes/Adidas/5/yeezy yupoo 001-ADIDA YEEZY Desert Rat 500    2.jpg",
      "/productimgs/shoes/Adidas/5/yeezy yupoo 001-ADIDA YEEZY Desert Rat 500    3.jpg",
      "/productimgs/shoes/Adidas/5/yeezy yupoo 001-ADIDA YEEZY Desert Rat 500    4.jpg",
      "/productimgs/shoes/Adidas/5/yeezy yupoo 001-ADIDA YEEZY Desert Rat 500    5.jpg",
      "/productimgs/shoes/Adidas/5/yeezy yupoo 001-ADIDA YEEZY Desert Rat 500    6.jpg",
      "/productimgs/shoes/Adidas/5/yeezy yupoo 001-ADIDA YEEZY Desert Rat 500    7.jpg"
    ]
  },
  {
    id: "595",
    name: "Yupoo Shoes: Premium Yeezy Yupoo Sneakers",
    description: "Premium quality Yeezy Yupoo Sneakers from productalbum.cn. These high-end Yupoos perfectly capture the design and comfort of the authentic version at an affordable price. #yupooshoes #yupooyeezy #yeezy #yupooadidas",
    price: PriceInfo,
    categories: [
      "shoes",
      "yeezy",
      "adidas"
    ],
    images: [
      "/productimgs/shoes/Adidas/99/yupoo yeezy Boost 350 yupoo shoes 1.jpg",
      "/productimgs/shoes/Adidas/99/yupoo yeezy Boost 350 yupoo shoes 2.jpg",
      "/productimgs/shoes/Adidas/99/yupoo yeezy Boost 350 yupoo shoes 3.jpg",
      "/productimgs/shoes/Adidas/99/yupoo yeezy Boost 350 yupoo shoes 4.jpg",
      "/productimgs/shoes/Adidas/99/yupoo yeezy Boost 350 yupoo shoes 5.jpg",
      "/productimgs/shoes/Adidas/99/yupoo yeezy Boost 350 yupoo shoes 6.jpg",
      "/productimgs/shoes/Adidas/99/yupoo yeezy Boost 350 yupoo shoes 7.jpg",
      "/productimgs/shoes/Adidas/99/yupoo yeezy Boost 350 yupoo shoes 8.jpg",
      "/productimgs/shoes/Adidas/99/yupoo yeezy Boost 350 yupoo shoes 9.jpg",
      "/productimgs/shoes/Adidas/99/yupoo yeezy Boost 350 yupoo shoes 10.jpg",
      "/productimgs/shoes/Adidas/99/yupoo yeezy Boost 350 yupoo shoes 11.jpg",
      "/productimgs/shoes/Adidas/99/yupoo yeezy Boost 350 yupoo shoes 12.jpg",
      "/productimgs/shoes/Adidas/99/yupoo yeezy Boost 350 yupoo shoes 13.jpg",
      "/productimgs/shoes/Adidas/99/yupoo yeezy Boost 350 yupoo shoes 14.jpg",
      "/productimgs/shoes/Adidas/99/yupoo yeezy Boost 350 yupoo shoes 15.jpg",
      "/productimgs/shoes/Adidas/99/yupoo yeezy Boost 350 yupoo shoes 16.jpg",
      "/productimgs/shoes/Adidas/99/yupoo yeezy Boost 350 yupoo shoes 17.jpg",
      "/productimgs/shoes/Adidas/99/yupoo yeezy Boost 350 yupoo shoes 18.jpg",
      "/productimgs/shoes/Adidas/99/yupoo yeezy Boost 350 yupoo shoes 19.jpg",
      "/productimgs/shoes/Adidas/99/yupoo yeezy Boost 350 yupoo shoes 20.jpg",
      "/productimgs/shoes/Adidas/99/yupoo yeezy Boost 350 yupoo shoes 21.jpg",
      "/productimgs/shoes/Adidas/99/yupoo yeezy Boost 350 yupoo shoes 22.jpg"
    ]
  },
  {
    id: "596",
    name: "Yupoo Shoes: Premium Yeezy Yupoo Sneakers",
    description: "Premium quality Yeezy Yupoo Sneakers from productalbum.cn. These high-end Yupoos perfectly capture the design and comfort of the authentic version at an affordable price. #yupooshoes #yupooyeezy #yeezy #yupooadidas",
    price: PriceInfo,
    categories: [
      "shoes",
      "yeezy",
      "adidas"
    ],
    images: [
      "/productimgs/shoes/Adidas/55/yupoo yeezy 350 V2 yupoo shoes 1.jpg",
      "/productimgs/shoes/Adidas/55/yupoo yeezy 350 V2 yupoo shoes 2.jpg",
      "/productimgs/shoes/Adidas/55/yupoo yeezy 350 V2 yupoo shoes 3.jpg",
      "/productimgs/shoes/Adidas/55/yupoo yeezy 350 V2 yupoo shoes 4.jpg",
      "/productimgs/shoes/Adidas/55/yupoo yeezy 350 V2 yupoo shoes 5.jpg",
      "/productimgs/shoes/Adidas/55/yupoo yeezy 350 V2 yupoo shoes 6.jpg",
      "/productimgs/shoes/Adidas/55/yupoo yeezy 350 V2 yupoo shoes 7.jpg",
      "/productimgs/shoes/Adidas/55/yupoo yeezy 350 V2 yupoo shoes 8.jpg",
      "/productimgs/shoes/Adidas/55/yupoo yeezy 350 V2 yupoo shoes 9.jpg",
      "/productimgs/shoes/Adidas/55/yupoo yeezy 350 V2 yupoo shoes 10.jpg",
      "/productimgs/shoes/Adidas/55/yupoo yeezy 350 V2 yupoo shoes 11.jpg",
      "/productimgs/shoes/Adidas/55/yupoo yeezy 350 V2 yupoo shoes 12.jpg"
    ]
  },
  {
    id: "597",
    name: "Yupoo Shoes: Premium Yeezy Yupoo Sneakers",
    description: "Premium quality Yeezy Yupoo Sneakers from productalbum.cn. These high-end Yupoos perfectly capture the design and comfort of the authentic version at an affordable price. #yupooshoes #yupooyeezy #yeezy #yupooadidas",
    price: PriceInfo,
    categories: [
      "shoes",
      "yeezy",
      "adidas"
    ],
    images: [
      "/productimgs/shoes/Adidas/76/yupoo yeezy 350 V2 yupoo shoes 1.jpg",
      "/productimgs/shoes/Adidas/76/yupoo yeezy 350 V2 yupoo shoes 2.jpg",
      "/productimgs/shoes/Adidas/76/yupoo yeezy 350 V2 yupoo shoes 3.jpg",
      "/productimgs/shoes/Adidas/76/yupoo yeezy 350 V2 yupoo shoes 4.jpg",
      "/productimgs/shoes/Adidas/76/yupoo yeezy 350 V2 yupoo shoes 5.jpg",
      "/productimgs/shoes/Adidas/76/yupoo yeezy 350 V2 yupoo shoes 6.jpg",
      "/productimgs/shoes/Adidas/76/yupoo yeezy 350 V2 yupoo shoes 7.jpg",
      "/productimgs/shoes/Adidas/76/yupoo yeezy 350 V2 yupoo shoes 8.jpg",
      "/productimgs/shoes/Adidas/76/yupoo yeezy 350 V2 yupoo shoes 9.jpg",
      "/productimgs/shoes/Adidas/76/yupoo yeezy 350 V2 yupoo shoes 10.jpg"
    ]
  },
  {
    id: "598",
    name: "Yupoo Shoes: Premium Yeezy Yupoo Sneakers",
    description: "Premium quality Yeezy Yupoo Sneakers from productalbum.cn. These high-end Yupoos perfectly capture the design and comfort of the authentic version at an affordable price. #yupooshoes #yupooyeezy #yeezy #yupooadidas",
    price: PriceInfo,
    categories: [
      "shoes",
      "yeezy",
      "adidas"
    ],
    images: [
      "/productimgs/shoes/Adidas/64/yupoo yeezy 350 V2 yupoo shoes 1.jpg",
      "/productimgs/shoes/Adidas/64/yupoo yeezy 350 V2 yupoo shoes 2.jpg",
      "/productimgs/shoes/Adidas/64/yupoo yeezy 350 V2 yupoo shoes 3.jpg",
      "/productimgs/shoes/Adidas/64/yupoo yeezy 350 V2 yupoo shoes 4.jpg",
      "/productimgs/shoes/Adidas/64/yupoo yeezy 350 V2 yupoo shoes 5.jpg",
      "/productimgs/shoes/Adidas/64/yupoo yeezy 350 V2 yupoo shoes 6.jpg",
      "/productimgs/shoes/Adidas/64/yupoo yeezy 350 V2 yupoo shoes 7.jpg",
      "/productimgs/shoes/Adidas/64/yupoo yeezy 350 V2 yupoo shoes 8.jpg",
      "/productimgs/shoes/Adidas/64/yupoo yeezy 350 V2 yupoo shoes 9.jpg",
      "/productimgs/shoes/Adidas/64/yupoo yeezy 350 V2 yupoo shoes 10.jpg",
      "/productimgs/shoes/Adidas/64/yupoo yeezy 350 V2 yupoo shoes 11.jpg",
      "/productimgs/shoes/Adidas/64/yupoo yeezy 350 V2 yupoo shoes 12.jpg",
      "/productimgs/shoes/Adidas/64/yupoo yeezy 350 V2 yupoo shoes 13.jpg"
    ]
  },
  {
    id: "599",
    name: "Yupoo Shoes: Premium Yeezy Yupoo Sneakers",
    description: "Premium quality Yeezy Yupoo Sneakers from productalbum.cn. These high-end Yupoos perfectly capture the design and comfort of the authentic version at an affordable price. #yupooshoes #yupooyeezy #yeezy #yupooadidas",
    price: PriceInfo,
    categories: [
      "shoes",
      "yeezy",
      "adidas"
    ],
    images: [
      "/productimgs/shoes/Adidas/69/yupoo yeezy 350 V2 yupoo shoes 1.jpg",
      "/productimgs/shoes/Adidas/69/yupoo yeezy 350 V2 yupoo shoes 2.jpg",
      "/productimgs/shoes/Adidas/69/yupoo yeezy 350 V2 yupoo shoes 3.jpg",
      "/productimgs/shoes/Adidas/69/yupoo yeezy 350 V2 yupoo shoes 4.jpg",
      "/productimgs/shoes/Adidas/69/yupoo yeezy 350 V2 yupoo shoes 5.jpg",
      "/productimgs/shoes/Adidas/69/yupoo yeezy 350 V2 yupoo shoes 6.jpg",
      "/productimgs/shoes/Adidas/69/yupoo yeezy 350 V2 yupoo shoes 7.jpg",
      "/productimgs/shoes/Adidas/69/yupoo yeezy 350 V2 yupoo shoes 8.jpg",
      "/productimgs/shoes/Adidas/69/yupoo yeezy 350 V2 yupoo shoes 9.jpg",
      "/productimgs/shoes/Adidas/69/yupoo yeezy 350 V2 yupoo shoes 10.jpg",
      "/productimgs/shoes/Adidas/69/yupoo yeezy 350 V2 yupoo shoes 11.jpg",
      "/productimgs/shoes/Adidas/69/yupoo yeezy 350 V2 yupoo shoes 12.jpg"
    ]
  },
  {
    id: "600",
    name: "Liberty London x adidas Originals SAMBA OG - Low-Top Lifestyle Sneakers",
    description: "This exclusive Liberty London collaboration reimagines the iconic Samba with premium suede in a sophisticated dusty pink/grey colorway. Featuring the classic gum sole for traction and low-profile silhouette for versatile styling.",
    price: PriceInfo,
    categories: [
      "shoes",
      "yeezy",
      "adidas"
    ],
    images: [
      "/productimgs/shoes/Adidas/1/Adidas_1_pic_4.jpg",
      "/productimgs/shoes/Adidas/1/Adidas_1_pic_1.jpg",
      "/productimgs/shoes/Adidas/1/Adidas_1_pic_6.jpg",
      "/productimgs/shoes/Adidas/1/Adidas_1_pic_9.jpg",
      "/productimgs/shoes/Adidas/1/Adidas_1_pic_3.jpg",
      "/productimgs/shoes/Adidas/1/Adidas_1_pic_5.jpg",
      "/productimgs/shoes/Adidas/1/Adidas_1_pic_8.jpg",
      "/productimgs/shoes/Adidas/1/Adidas_1_pic_2.jpg",
      "/productimgs/shoes/Adidas/1/Adidas_1_pic_7.jpg"
    ]
  },
  {
    id: "601",
    name: "Yupoo Shoes: Premium Yeezy Yupoo Sneakers",
    description: "Premium quality Yeezy Yupoo Sneakers from productalbum.cn. These high-end Yupoos perfectly capture the design and comfort of the authentic version at an affordable price. #yupooshoes #yupooyeezy #yeezy #yupooadidas",
    price: PriceInfo,
    categories: [
      "shoes",
      "yeezy",
      "adidas"
    ],
    images: [
      "/productimgs/shoes/Adidas/25/yupoo yeezy 350 Boost V2 yupoo shoes 1.jpg",
      "/productimgs/shoes/Adidas/25/yupoo yeezy 350 Boost V2 yupoo shoes 2.jpg",
      "/productimgs/shoes/Adidas/25/yupoo yeezy 350 Boost V2 yupoo shoes 3.jpg",
      "/productimgs/shoes/Adidas/25/yupoo yeezy 350 Boost V2 yupoo shoes 4.jpg",
      "/productimgs/shoes/Adidas/25/yupoo yeezy 350 Boost V2 yupoo shoes 5.jpg",
      "/productimgs/shoes/Adidas/25/yupoo yeezy 350 Boost V2 yupoo shoes 6.jpg",
      "/productimgs/shoes/Adidas/25/yupoo yeezy 350 Boost V2 yupoo shoes 7.jpg",
      "/productimgs/shoes/Adidas/25/yupoo yeezy 350 Boost V2 yupoo shoes 8.jpg",
      "/productimgs/shoes/Adidas/25/yupoo yeezy 350 Boost V2 yupoo shoes 9.jpg",
      "/productimgs/shoes/Adidas/25/yupoo yeezy 350 Boost V2 yupoo shoes 10.jpg",
      "/productimgs/shoes/Adidas/25/yupoo yeezy 350 Boost V2 yupoo shoes 11.jpg",
      "/productimgs/shoes/Adidas/25/yupoo yeezy 350 Boost V2 yupoo shoes 12.jpg",
      "/productimgs/shoes/Adidas/25/yupoo yeezy 350 Boost V2 yupoo shoes 13.jpg",
      "/productimgs/shoes/Adidas/25/yupoo yeezy 350 Boost V2 yupoo shoes 14.jpg",
      "/productimgs/shoes/Adidas/25/yupoo yeezy 350 Boost V2 yupoo shoes 15.jpg"
    ]
  },
  {
    id: "602",
    name: "Yupoo Shoes: Premium Yeezy Yupoo Sneakers",
    description: "Premium quality Yeezy Yupoo Sneakers from productalbum.cn. These high-end Yupoos perfectly capture the design and comfort of the authentic version at an affordable price. #yupooshoes #yupooyeezy #yeezy #yupooadidas",
    price: PriceInfo,
    categories: [
      "shoes",
      "yeezy",
      "adidas"
    ],
    images: [
      "/productimgs/shoes/Adidas/86/yupoo yeezy 700 V2 adidas 1.jpg",
      "/productimgs/shoes/Adidas/86/yupoo yeezy 700 V2 adidas 2.jpg",
      "/productimgs/shoes/Adidas/86/yupoo yeezy 700 V2 adidas 3.jpg",
      "/productimgs/shoes/Adidas/86/yupoo yeezy 700 V2 adidas 4.jpg",
      "/productimgs/shoes/Adidas/86/yupoo yeezy 700 V2 adidas 5.jpg",
      "/productimgs/shoes/Adidas/86/yupoo yeezy 700 V2 adidas 6.jpg",
      "/productimgs/shoes/Adidas/86/yupoo yeezy 700 V2 adidas 7.jpg",
      "/productimgs/shoes/Adidas/86/yupoo yeezy 700 V2 adidas 8.jpg",
      "/productimgs/shoes/Adidas/86/yupoo yeezy 700 V2 adidas 9.jpg",
      "/productimgs/shoes/Adidas/86/yupoo yeezy 700 V2 adidas 10.jpg",
      "/productimgs/shoes/Adidas/86/yupoo yeezy 700 V2 adidas 11.jpg",
      "/productimgs/shoes/Adidas/86/yupoo yeezy 700 V2 adidas 12.jpg",
      "/productimgs/shoes/Adidas/86/yupoo yeezy 700 V2 adidas 13.jpg",
      "/productimgs/shoes/Adidas/86/yupoo yeezy 700 V2 adidas 14.jpg",
      "/productimgs/shoes/Adidas/86/yupoo yeezy 700 V2 adidas 15.jpg",
      "/productimgs/shoes/Adidas/86/yupoo yeezy 700 V2 adidas 16.jpg"
    ]
  },
  {
    id: "603",
    name: "Yupoo Shoes:Kanye West x Adidas Yeezy Boost Foam Runner 700 V3Az",
    description: "Discover the Kanye West x Adidas Yeezy Boost Foam Runner 700 V3Az shoes on Yupoo. A collaboration that combines creativity and functionality, these shoes are a must - have for sneaker enthusiasts. #yupooshoes #yupooyeezy #yeezy #yupooadidas",
    price: PriceInfo,
    categories: [
      "shoes",
      "yeezy",
      "adidas"
    ],
    images: [
      "/productimgs/shoes/Adidas/15/yeezy yupoo 001-Kanye West x Adida Yeezy Boost Foam Runner 700 V3Aza.jpeg"
    ]
  },
  {
    id: "605",
    name: "Yupoo Shoes: Adidas Yeezy 350V2 static reflective",
    description: "Find the Adidas Yeezy 350V2 static reflective shoes on Yupoo. The reflective feature not only adds a cool look but also enhances visibility in low - light conditions. #yupooshoes #yupooyeezy #yeezy #yupooadidas",
    price: PriceInfo,
    categories: [
      "shoes",
      "yeezy",
      "adidas"
    ],
    images: [
      "/productimgs/shoes/Adidas/11/yeezy yupoo Adida Yeezy 350V2 static reflective  1.jpeg",
      "/productimgs/shoes/Adidas/11/yeezy yupoo Adida Yeezy 350V2 static reflective  1.jpg",
      "/productimgs/shoes/Adidas/11/yeezy yupoo Adida Yeezy 350V2 static reflective  2.jpeg",
      "/productimgs/shoes/Adidas/11/yeezy yupoo Adida Yeezy 350V2 static reflective  3.jpeg",
      "/productimgs/shoes/Adidas/11/yeezy yupoo Adida Yeezy 350V2 static reflective  4.jpeg",
      "/productimgs/shoes/Adidas/11/yeezy yupoo Adida Yeezy 350V2 static reflective  5.jpeg",
      "/productimgs/shoes/Adidas/11/yeezy yupoo Adida Yeezy 350V2 static reflective  6.jpeg"
    ]
  },
  {
    id: "606",
    name: "Yupoo Shoes: Premium Yeezy Yupoo Sneakers",
    description: "Premium quality Yeezy Yupoo Sneakers from productalbum.cn. These high-end Yupoos perfectly capture the design and comfort of the authentic version at an affordable price. #yupooshoes #yupooyeezy #yeezy #yupooadidas",
    price: PriceInfo,
    categories: [
      "shoes",
      "yeezy",
      "adidas"
    ],
    images: [
      "/productimgs/shoes/Adidas/53/yupoo yeezy 350 V2 yupoo shoes 1.jpg",
      "/productimgs/shoes/Adidas/53/yupoo yeezy 350 V2 yupoo shoes 2.jpg",
      "/productimgs/shoes/Adidas/53/yupoo yeezy 350 V2 yupoo shoes 3.jpg",
      "/productimgs/shoes/Adidas/53/yupoo yeezy 350 V2 yupoo shoes 4.jpg",
      "/productimgs/shoes/Adidas/53/yupoo yeezy 350 V2 yupoo shoes 5.jpg",
      "/productimgs/shoes/Adidas/53/yupoo yeezy 350 V2 yupoo shoes 6.jpg",
      "/productimgs/shoes/Adidas/53/yupoo yeezy 350 V2 yupoo shoes 7.jpg",
      "/productimgs/shoes/Adidas/53/yupoo yeezy 350 V2 yupoo shoes 8.jpg",
      "/productimgs/shoes/Adidas/53/yupoo yeezy 350 V2 yupoo shoes 9.jpg",
      "/productimgs/shoes/Adidas/53/yupoo yeezy 350 V2 yupoo shoes 10.jpg",
      "/productimgs/shoes/Adidas/53/yupoo yeezy 350 V2 yupoo shoes 11.jpg"
    ]
  },
  {
    id: "607",
    name: "adidas Originals GAZELLE - Low-Top Lifestyle Sneakers (Blue/White)",
    description: "Classic GAZELLE sneakers featuring a soft suede upper in blue/white colorway with durable rubber sole for all-day comfort. Perfect for casual wear.",
    price: PriceInfo,
    categories: [
      "shoes",
      "yeezy",
      "adidas"
    ],
    images: [
      "/productimgs/shoes/Adidas/3/Adidas_3_pic_4.jpg",
      "/productimgs/shoes/Adidas/3/Adidas_3_pic_9.jpg",
      "/productimgs/shoes/Adidas/3/Adidas_3_pic_1.jpg",
      "/productimgs/shoes/Adidas/3/Adidas_3_pic_3.jpg",
      "/productimgs/shoes/Adidas/3/Adidas_3_pic_6.jpg",
      "/productimgs/shoes/Adidas/3/Adidas_3_pic_8.jpg",
      "/productimgs/shoes/Adidas/3/Adidas_3_pic_7.jpg",
      "/productimgs/shoes/Adidas/3/Adidas_3_pic_5.jpg",
      "/productimgs/shoes/Adidas/3/Adidas_3_pic_2.jpg"
    ]
  },
  {
    id: "608",
    name: "Yupoo Shoes: Premium Yeezy Yupoo Sneakers",
    description: "Premium quality Yeezy Yupoo Sneakers from productalbum.cn. These high-end Yupoos perfectly capture the design and comfort of the authentic version at an affordable price. #yupooshoes #yupooyeezy #yeezy #yupooadidas",
    price: PriceInfo,
    categories: [
      "shoes",
      "yeezy",
      "adidas"
    ],
    images: [
      "/productimgs/shoes/Adidas/50/yupoo yeezy 350 V2 yupoo shoes 1.jpg",
      "/productimgs/shoes/Adidas/50/yupoo yeezy 350 V2 yupoo shoes 2.jpg",
      "/productimgs/shoes/Adidas/50/yupoo yeezy 350 V2 yupoo shoes 3.jpg",
      "/productimgs/shoes/Adidas/50/yupoo yeezy 350 V2 yupoo shoes 4.jpg",
      "/productimgs/shoes/Adidas/50/yupoo yeezy 350 V2 yupoo shoes 5.jpg",
      "/productimgs/shoes/Adidas/50/yupoo yeezy 350 V2 yupoo shoes 6.jpg",
      "/productimgs/shoes/Adidas/50/yupoo yeezy 350 V2 yupoo shoes 7.jpg",
      "/productimgs/shoes/Adidas/50/yupoo yeezy 350 V2 yupoo shoes 8.jpg",
      "/productimgs/shoes/Adidas/50/yupoo yeezy 350 V2 yupoo shoes 9.jpg",
      "/productimgs/shoes/Adidas/50/yupoo yeezy 350 V2 yupoo shoes 10.jpg",
      "/productimgs/shoes/Adidas/50/yupoo yeezy 350 V2 yupoo shoes 11.jpg",
      "/productimgs/shoes/Adidas/50/yupoo yeezy 350 V2 yupoo shoes 12.jpg"
    ]
  },
  {
    id: "609",
    name: "Yupoo Shoes: Premium Yeezy Yupoo Sneakers",
    description: "Premium quality Yeezy Yupoo Sneakers from productalbum.cn. These high-end Yupoos perfectly capture the design and comfort of the authentic version at an affordable price. #yupooshoes #yupooyeezy #yeezy #yupooadidas",
    price: PriceInfo,
    categories: [
      "shoes",
      "yeezy",
      "adidas"
    ],
    images: [
      "/productimgs/shoes/Adidas/91/yupoo yeezy 700 V2 1.jpg",
      "/productimgs/shoes/Adidas/91/yupoo yeezy 700 V2 2.jpg",
      "/productimgs/shoes/Adidas/91/yupoo yeezy 700 V2 3.jpg",
      "/productimgs/shoes/Adidas/91/yupoo yeezy 700 V2 4.jpg",
      "/productimgs/shoes/Adidas/91/yupoo yeezy 700 V2 5.jpg",
      "/productimgs/shoes/Adidas/91/yupoo yeezy 700 V2 6.jpg",
      "/productimgs/shoes/Adidas/91/yupoo yeezy 700 V2 7.jpg",
      "/productimgs/shoes/Adidas/91/yupoo yeezy 700 V2 8.jpg",
      "/productimgs/shoes/Adidas/91/yupoo yeezy 700 V2 9.jpg",
      "/productimgs/shoes/Adidas/91/yupoo yeezy 700 V2 10.jpg",
      "/productimgs/shoes/Adidas/91/yupoo yeezy 700 V2 11.jpg",
      "/productimgs/shoes/Adidas/91/yupoo yeezy 700 V2 12.jpg"
    ]
  },
  {
    id: "610",
    name: "Yupoo Shoes: Premium Yeezy Yupoo Sneakers",
    description: "Premium quality Yeezy Yupoo Sneakers from productalbum.cn. These high-end Yupoos perfectly capture the design and comfort of the authentic version at an affordable price. #yupooshoes #yupooyeezy #yeezy #yupooadidas",
    price: PriceInfo,
    categories: [
      "shoes",
      "yeezy",
      "adidas"
    ],
    images: [
      "/productimgs/shoes/Adidas/20/yupoo yeezy 350 Boost V2 yupoo shoes 1.jpg",
      "/productimgs/shoes/Adidas/20/yupoo yeezy 350 Boost V2 yupoo shoes 2.jpg",
      "/productimgs/shoes/Adidas/20/yupoo yeezy 350 Boost V2 yupoo shoes 3.jpg",
      "/productimgs/shoes/Adidas/20/yupoo yeezy 350 Boost V2 yupoo shoes 4.jpg",
      "/productimgs/shoes/Adidas/20/yupoo yeezy 350 Boost V2 yupoo shoes 5.jpg",
      "/productimgs/shoes/Adidas/20/yupoo yeezy 350 Boost V2 yupoo shoes 6.jpg",
      "/productimgs/shoes/Adidas/20/yupoo yeezy 350 Boost V2 yupoo shoes 7.jpg",
      "/productimgs/shoes/Adidas/20/yupoo yeezy 350 Boost V2 yupoo shoes 8.jpg",
      "/productimgs/shoes/Adidas/20/yupoo yeezy 350 Boost V2 yupoo shoes 9.jpg",
      "/productimgs/shoes/Adidas/20/yupoo yeezy 350 Boost V2 yupoo shoes 10.jpg",
      "/productimgs/shoes/Adidas/20/yupoo yeezy 350 Boost V2 yupoo shoes 11.jpg",
      "/productimgs/shoes/Adidas/20/yupoo yeezy 350 Boost V2 yupoo shoes 12.jpg",
      "/productimgs/shoes/Adidas/20/yupoo yeezy 350 Boost V2 yupoo shoes 13.jpg",
      "/productimgs/shoes/Adidas/20/yupoo yeezy 350 Boost V2 yupoo shoes 14.jpg",
      "/productimgs/shoes/Adidas/20/yupoo yeezy 350 Boost V2 yupoo shoes 15.jpg"
    ]
  },
  {
    id: "611",
    name: "Yupoo Shoes: Premium Yeezy Yupoo Sneakers",
    description: "Premium quality Yeezy Yupoo Sneakers from productalbum.cn. These high-end Yupoos perfectly capture the design and comfort of the authentic version at an affordable price. #yupooshoes #yupooyeezy #yeezy #yupooadidas",
    price: PriceInfo,
    categories: [
      "shoes",
      "yeezy",
      "adidas"
    ],
    images: [
      "/productimgs/shoes/Adidas/21/yupoo yeezy 350 Boost V2 yupoo shoes 1.jpg",
      "/productimgs/shoes/Adidas/21/yupoo yeezy 350 Boost V2 yupoo shoes 2.jpg",
      "/productimgs/shoes/Adidas/21/yupoo yeezy 350 Boost V2 yupoo shoes 3.jpg",
      "/productimgs/shoes/Adidas/21/yupoo yeezy 350 Boost V2 yupoo shoes 4.jpg",
      "/productimgs/shoes/Adidas/21/yupoo yeezy 350 Boost V2 yupoo shoes 5.jpg",
      "/productimgs/shoes/Adidas/21/yupoo yeezy 350 Boost V2 yupoo shoes 6.jpg",
      "/productimgs/shoes/Adidas/21/yupoo yeezy 350 Boost V2 yupoo shoes 7.jpg",
      "/productimgs/shoes/Adidas/21/yupoo yeezy 350 Boost V2 yupoo shoes 8.jpg",
      "/productimgs/shoes/Adidas/21/yupoo yeezy 350 Boost V2 yupoo shoes 9.jpg",
      "/productimgs/shoes/Adidas/21/yupoo yeezy 350 Boost V2 yupoo shoes 10.jpg",
      "/productimgs/shoes/Adidas/21/yupoo yeezy 350 Boost V2 yupoo shoes 11.jpg",
      "/productimgs/shoes/Adidas/21/yupoo yeezy 350 Boost V2 yupoo shoes 12.jpg",
      "/productimgs/shoes/Adidas/21/yupoo yeezy 350 Boost V2 yupoo shoes 13.jpg",
      "/productimgs/shoes/Adidas/21/yupoo yeezy 350 Boost V2 yupoo shoes 14.jpg"
    ]
  },
  {
    id: "612",
    name: "Yupoo Shoes: Premium Yeezy Yupoo Sneakers",
    description: "Premium quality Yeezy Yupoo Sneakers from productalbum.cn. These high-end Yupoos perfectly capture the design and comfort of the authentic version at an affordable price. #yupooshoes #yupooyeezy #yeezy #yupooadidas",
    price: PriceInfo,
    categories: [
      "shoes",
      "yeezy",
      "adidas"
    ],
    images: [
      "/productimgs/shoes/Adidas/37/yupoo yeezy 350 V2 yupoo shoes 1.jpg",
      "/productimgs/shoes/Adidas/37/yupoo yeezy 350 V2 yupoo shoes 2.jpg",
      "/productimgs/shoes/Adidas/37/yupoo yeezy 350 V2 yupoo shoes 3.jpg",
      "/productimgs/shoes/Adidas/37/yupoo yeezy 350 V2 yupoo shoes 4.jpg",
      "/productimgs/shoes/Adidas/37/yupoo yeezy 350 V2 yupoo shoes 5.jpg",
      "/productimgs/shoes/Adidas/37/yupoo yeezy 350 V2 yupoo shoes 6.jpg",
      "/productimgs/shoes/Adidas/37/yupoo yeezy 350 V2 yupoo shoes 7.jpg",
      "/productimgs/shoes/Adidas/37/yupoo yeezy 350 V2 yupoo shoes 8.jpg",
      "/productimgs/shoes/Adidas/37/yupoo yeezy 350 V2 yupoo shoes 9.jpg",
      "/productimgs/shoes/Adidas/37/yupoo yeezy 350 V2 yupoo shoes 10.jpg",
      "/productimgs/shoes/Adidas/37/yupoo yeezy 350 V2 yupoo shoes 11.jpg",
      "/productimgs/shoes/Adidas/37/yupoo yeezy 350 V2 yupoo shoes 12.jpg",
      "/productimgs/shoes/Adidas/37/yupoo yeezy 350 V2 yupoo shoes 13.jpg",
      "/productimgs/shoes/Adidas/37/yupoo yeezy 350 V2 yupoo shoes 14.jpg",
      "/productimgs/shoes/Adidas/37/yupoo yeezy 350 V2 yupoo shoes 15.jpg",
      "/productimgs/shoes/Adidas/37/yupoo yeezy 350 V2 yupoo shoes 16.jpg",
      "/productimgs/shoes/Adidas/37/yupoo yeezy 350 V2 yupoo shoes 17.jpg"
    ]
  },
  {
    id: "613",
    name: "Yupoo Shoes: Premium Yeezy Yupoo Sneakers",
    description: "Premium quality Yeezy Yupoo Sneakers from productalbum.cn. These high-end Yupoos perfectly capture the design and comfort of the authentic version at an affordable price. #yupooshoes #yupooyeezy #yeezy #yupooadidas",
    price: PriceInfo,
    categories: [
      "shoes",
      "yeezy",
      "adidas"
    ],
    images: [
      "/productimgs/shoes/Adidas/97/yupoo yeezy Adidas Yeezy 500 1.jpg",
      "/productimgs/shoes/Adidas/97/yupoo yeezy Adidas Yeezy 500 2.jpg",
      "/productimgs/shoes/Adidas/97/yupoo yeezy Adidas Yeezy 500 3.jpg",
      "/productimgs/shoes/Adidas/97/yupoo yeezy Adidas Yeezy 500 4.jpg",
      "/productimgs/shoes/Adidas/97/yupoo yeezy Adidas Yeezy 500 5.jpg",
      "/productimgs/shoes/Adidas/97/yupoo yeezy Adidas Yeezy 500 6.jpg",
      "/productimgs/shoes/Adidas/97/yupoo yeezy Adidas Yeezy 500 7.jpg",
      "/productimgs/shoes/Adidas/97/yupoo yeezy Adidas Yeezy 500 8.jpg",
      "/productimgs/shoes/Adidas/97/yupoo yeezy Adidas Yeezy 500 9.jpg",
      "/productimgs/shoes/Adidas/97/yupoo yeezy Adidas Yeezy 500 10.jpg",
      "/productimgs/shoes/Adidas/97/yupoo yeezy Adidas Yeezy 500 11.jpg",
      "/productimgs/shoes/Adidas/97/yupoo yeezy Adidas Yeezy 500 12.jpg",
      "/productimgs/shoes/Adidas/97/yupoo yeezy Adidas Yeezy 500 13.jpg",
      "/productimgs/shoes/Adidas/97/yupoo yeezy Adidas Yeezy 500 14.jpg",
      "/productimgs/shoes/Adidas/97/yupoo yeezy Adidas Yeezy 500 15.jpg"
    ]
  },
  {
    id: "614",
    name: "Yupoo Shoes: Adidas Yeezy Boost 350 V2 3M",
    description: "Explore the Adidas Yeezy Boost 350 V2 3M shoes on Yupoo. The 3M material gives these shoes a special shine and makes them a popular choice among sneaker lovers. #yupooshoes #yupooyeezy #yeezy #yupooadidas",
    price: PriceInfo,
    categories: [
      "shoes",
      "yeezy",
      "adidas"
    ],
    images: [
      "/productimgs/shoes/Adidas/12/yeezy yupoo Adida Yeezy Boost 350 V2 3M   1.jpg",
      "/productimgs/shoes/Adidas/12/yeezy yupoo Adida Yeezy Boost 350 V2 3M   2.jpg",
      "/productimgs/shoes/Adidas/12/yeezy yupoo Adida Yeezy Boost 350 V2 3M   3.jpg",
      "/productimgs/shoes/Adidas/12/yeezy yupoo Adida Yeezy Boost 350 V2 3M   4.jpg",
      "/productimgs/shoes/Adidas/12/yeezy yupoo Adida Yeezy Boost 350 V2 3M   5.jpg",
      "/productimgs/shoes/Adidas/12/yeezy yupoo Adida Yeezy Boost 350 V2 3M   6.jpg",
      "/productimgs/shoes/Adidas/12/yeezy yupoo Adida Yeezy Boost 350 V2 3M   7.jpg",
      "/productimgs/shoes/Adidas/12/yeezy yupoo Adida Yeezy Boost 350 V2 3M   8.jpg"
    ]
  },
  {
    id: "615",
    name: "Yupoo Shoes: Premium Yeezy Yupoo Sneakers",
    description: "Premium quality Yeezy Yupoo Sneakers from productalbum.cn. These high-end Yupoos perfectly capture the design and comfort of the authentic version at an affordable price. #yupooshoes #yupooyeezy #yeezy #yupooadidas",
    price: PriceInfo,
    categories: [
      "shoes",
      "yeezy",
      "adidas"
    ],
    images: [
      "/productimgs/shoes/Adidas/75/yupoo yeezy 350 V2 yupoo shoes 1.jpg",
      "/productimgs/shoes/Adidas/75/yupoo yeezy 350 V2 yupoo shoes 2.jpg",
      "/productimgs/shoes/Adidas/75/yupoo yeezy 350 V2 yupoo shoes 3.jpg",
      "/productimgs/shoes/Adidas/75/yupoo yeezy 350 V2 yupoo shoes 4.jpg",
      "/productimgs/shoes/Adidas/75/yupoo yeezy 350 V2 yupoo shoes 5.jpg",
      "/productimgs/shoes/Adidas/75/yupoo yeezy 350 V2 yupoo shoes 6.jpg",
      "/productimgs/shoes/Adidas/75/yupoo yeezy 350 V2 yupoo shoes 7.jpg",
      "/productimgs/shoes/Adidas/75/yupoo yeezy 350 V2 yupoo shoes 8.jpg",
      "/productimgs/shoes/Adidas/75/yupoo yeezy 350 V2 yupoo shoes 9.jpg",
      "/productimgs/shoes/Adidas/75/yupoo yeezy 350 V2 yupoo shoes 10.jpg"
    ]
  },
  {
    id: "617",
    name: "Yupoo Shoes: Premium Yeezy Yupoo Sneakers",
    description: "Premium quality Yeezy Yupoo Sneakers from productalbum.cn. These high-end Yupoos perfectly capture the design and comfort of the authentic version at an affordable price. #yupooshoes #yupooyeezy #yeezy #yupooadidas",
    price: PriceInfo,
    categories: [
      "shoes",
      "yeezy",
      "adidas"
    ],
    images: [
      "/productimgs/shoes/Adidas/83/yupoo yeezy 500 yupoo shoes 1.jpg",
      "/productimgs/shoes/Adidas/83/yupoo yeezy 500 yupoo shoes 2.jpg",
      "/productimgs/shoes/Adidas/83/yupoo yeezy 500 yupoo shoes 3.jpg",
      "/productimgs/shoes/Adidas/83/yupoo yeezy 500 yupoo shoes 4.jpg",
      "/productimgs/shoes/Adidas/83/yupoo yeezy 500 yupoo shoes 5.jpg",
      "/productimgs/shoes/Adidas/83/yupoo yeezy 500 yupoo shoes 6.jpg",
      "/productimgs/shoes/Adidas/83/yupoo yeezy 500 yupoo shoes 7.jpg",
      "/productimgs/shoes/Adidas/83/yupoo yeezy 500 yupoo shoes 8.jpg",
      "/productimgs/shoes/Adidas/83/yupoo yeezy 500 yupoo shoes 9.jpg",
      "/productimgs/shoes/Adidas/83/yupoo yeezy 500 yupoo shoes 10.jpg",
      "/productimgs/shoes/Adidas/83/yupoo yeezy 500 yupoo shoes 11.jpg",
      "/productimgs/shoes/Adidas/83/yupoo yeezy 500 yupoo shoes 12.jpg",
      "/productimgs/shoes/Adidas/83/yupoo yeezy 500 yupoo shoes 13.jpg",
      "/productimgs/shoes/Adidas/83/yupoo yeezy 500 yupoo shoes 14.jpg",
      "/productimgs/shoes/Adidas/83/yupoo yeezy 500 yupoo shoes 15.jpg",
      "/productimgs/shoes/Adidas/83/yupoo yeezy 500 yupoo shoes 16.jpg"
    ]
  },
  {
    id: "618",
    name: "Yupoo Shoes: Premium Yeezy Yupoo Sneakers",
    description: "Premium quality Yeezy Yupoo Sneakers from productalbum.cn. These high-end Yupoos perfectly capture the design and comfort of the authentic version at an affordable price. #yupooshoes #yupooyeezy #yeezy #yupooadidas",
    price: PriceInfo,
    categories: [
      "shoes",
      "yeezy",
      "adidas"
    ],
    images: [
      "/productimgs/shoes/Adidas/65/yupoo yeezy 350 V2 yupoo shoes 1.jpg",
      "/productimgs/shoes/Adidas/65/yupoo yeezy 350 V2 yupoo shoes 2.jpg",
      "/productimgs/shoes/Adidas/65/yupoo yeezy 350 V2 yupoo shoes 3.jpg",
      "/productimgs/shoes/Adidas/65/yupoo yeezy 350 V2 yupoo shoes 4.jpg",
      "/productimgs/shoes/Adidas/65/yupoo yeezy 350 V2 yupoo shoes 5.jpg",
      "/productimgs/shoes/Adidas/65/yupoo yeezy 350 V2 yupoo shoes 6.jpg",
      "/productimgs/shoes/Adidas/65/yupoo yeezy 350 V2 yupoo shoes 7.jpg",
      "/productimgs/shoes/Adidas/65/yupoo yeezy 350 V2 yupoo shoes 8.jpg",
      "/productimgs/shoes/Adidas/65/yupoo yeezy 350 V2 yupoo shoes 9.jpg",
      "/productimgs/shoes/Adidas/65/yupoo yeezy 350 V2 yupoo shoes 10.jpg",
      "/productimgs/shoes/Adidas/65/yupoo yeezy 350 V2 yupoo shoes 11.jpg",
      "/productimgs/shoes/Adidas/65/yupoo yeezy 350 V2 yupoo shoes 12.jpg",
      "/productimgs/shoes/Adidas/65/yupoo yeezy 350 V2 yupoo shoes 13.jpg"
    ]
  },
  {
    id: "619",
    name: "Yupoo Shoes: Premium Yeezy Yupoo Sneakers",
    description: "Premium quality Yeezy Yupoo Sneakers from productalbum.cn. These high-end Yupoos perfectly capture the design and comfort of the authentic version at an affordable price. #yupooshoes #yupooyeezy #yeezy #yupooadidas",
    price: PriceInfo,
    categories: [
      "shoes",
      "yeezy",
      "adidas"
    ],
    images: [
      "/productimgs/shoes/Adidas/33/yupoo yeezy 350 Boost V2 yupoo shoes 1.jpg",
      "/productimgs/shoes/Adidas/33/yupoo yeezy 350 Boost V2 yupoo shoes 2.jpg",
      "/productimgs/shoes/Adidas/33/yupoo yeezy 350 Boost V2 yupoo shoes 3.jpg",
      "/productimgs/shoes/Adidas/33/yupoo yeezy 350 Boost V2 yupoo shoes 4.jpg",
      "/productimgs/shoes/Adidas/33/yupoo yeezy 350 Boost V2 yupoo shoes 5.jpg",
      "/productimgs/shoes/Adidas/33/yupoo yeezy 350 Boost V2 yupoo shoes 6.jpg",
      "/productimgs/shoes/Adidas/33/yupoo yeezy 350 Boost V2 yupoo shoes 7.jpg",
      "/productimgs/shoes/Adidas/33/yupoo yeezy 350 Boost V2 yupoo shoes 8.jpg",
      "/productimgs/shoes/Adidas/33/yupoo yeezy 350 Boost V2 yupoo shoes 9.jpg",
      "/productimgs/shoes/Adidas/33/yupoo yeezy 350 Boost V2 yupoo shoes 10.jpg",
      "/productimgs/shoes/Adidas/33/yupoo yeezy 350 Boost V2 yupoo shoes 11.jpg",
      "/productimgs/shoes/Adidas/33/yupoo yeezy 350 Boost V2 yupoo shoes 12.jpg",
      "/productimgs/shoes/Adidas/33/yupoo yeezy 350 Boost V2 yupoo shoes 13.jpg",
      "/productimgs/shoes/Adidas/33/yupoo yeezy 350 Boost V2 yupoo shoes 14.jpg",
      "/productimgs/shoes/Adidas/33/yupoo yeezy 350 Boost V2 yupoo shoes 15.jpg",
      "/productimgs/shoes/Adidas/33/yupoo yeezy 350 Boost V2 yupoo shoes 16.jpg",
      "/productimgs/shoes/Adidas/33/yupoo yeezy 350 Boost V2 yupoo shoes 17.jpg",
      "/productimgs/shoes/Adidas/33/yupoo yeezy 350 Boost V2 yupoo shoes 18.jpg",
      "/productimgs/shoes/Adidas/33/yupoo yeezy 350 Boost V2 yupoo shoes 19.jpg",
      "/productimgs/shoes/Adidas/33/yupoo yeezy 350 Boost V2 yupoo shoes 20.jpg"
    ]
  },
  {
    id: "620",
    name: "Yupoo Shoes: Premium Yeezy Yupoo Sneakers",
    description: "Premium quality Yeezy Yupoo Sneakers from productalbum.cn. These high-end Yupoos perfectly capture the design and comfort of the authentic version at an affordable price. #yupooshoes #yupooyeezy #yeezy #yupooadidas",
    price: PriceInfo,
    categories: [
      "shoes",
      "yeezy",
      "adidas"
    ],
    images: [
      "/productimgs/shoes/Adidas/96/yupoo yeezy 750 Boost yupoo shoes 1.jpg",
      "/productimgs/shoes/Adidas/96/yupoo yeezy 750 Boost yupoo shoes 2.jpg",
      "/productimgs/shoes/Adidas/96/yupoo yeezy 750 Boost yupoo shoes 3.jpg",
      "/productimgs/shoes/Adidas/96/yupoo yeezy 750 Boost yupoo shoes 4.jpg",
      "/productimgs/shoes/Adidas/96/yupoo yeezy 750 Boost yupoo shoes 5.jpg",
      "/productimgs/shoes/Adidas/96/yupoo yeezy 750 Boost yupoo shoes 6.jpg",
      "/productimgs/shoes/Adidas/96/yupoo yeezy 750 Boost yupoo shoes 7.jpg",
      "/productimgs/shoes/Adidas/96/yupoo yeezy 750 Boost yupoo shoes 8.jpg",
      "/productimgs/shoes/Adidas/96/yupoo yeezy 750 Boost yupoo shoes 9.jpg",
      "/productimgs/shoes/Adidas/96/yupoo yeezy 750 Boost yupoo shoes 10.jpg",
      "/productimgs/shoes/Adidas/96/yupoo yeezy 750 Boost yupoo shoes 11.jpg",
      "/productimgs/shoes/Adidas/96/yupoo yeezy 750 Boost yupoo shoes 12.jpg"
    ]
  },
  {
    id: "621",
    name: "Yupoo Shoes: Premium Yeezy Yupoo Sneakers",
    description: "Premium quality Yeezy Yupoo Sneakers from productalbum.cn. These high-end Yupoos perfectly capture the design and comfort of the authentic version at an affordable price. #yupooshoes #yupooyeezy #yeezy #yupooadidas",
    price: PriceInfo,
    categories: [
      "shoes",
      "yeezy",
      "adidas"
    ],
    images: [
      "/productimgs/shoes/Adidas/19/yupoo yeezy 350 Boost V2 yupoo shoes 1.jpg",
      "/productimgs/shoes/Adidas/19/yupoo yeezy 350 Boost V2 yupoo shoes 2.jpg",
      "/productimgs/shoes/Adidas/19/yupoo yeezy 350 Boost V2 yupoo shoes 3.jpg",
      "/productimgs/shoes/Adidas/19/yupoo yeezy 350 Boost V2 yupoo shoes 4.jpg",
      "/productimgs/shoes/Adidas/19/yupoo yeezy 350 Boost V2 yupoo shoes 5.jpg",
      "/productimgs/shoes/Adidas/19/yupoo yeezy 350 Boost V2 yupoo shoes 6.jpg",
      "/productimgs/shoes/Adidas/19/yupoo yeezy 350 Boost V2 yupoo shoes 7.jpg",
      "/productimgs/shoes/Adidas/19/yupoo yeezy 350 Boost V2 yupoo shoes 8.jpg",
      "/productimgs/shoes/Adidas/19/yupoo yeezy 350 Boost V2 yupoo shoes 9.jpg",
      "/productimgs/shoes/Adidas/19/yupoo yeezy 350 Boost V2 yupoo shoes 10.jpg",
      "/productimgs/shoes/Adidas/19/yupoo yeezy 350 Boost V2 yupoo shoes 11.jpg",
      "/productimgs/shoes/Adidas/19/yupoo yeezy 350 Boost V2 yupoo shoes 12.jpg",
      "/productimgs/shoes/Adidas/19/yupoo yeezy 350 Boost V2 yupoo shoes 13.jpg",
      "/productimgs/shoes/Adidas/19/yupoo yeezy 350 Boost V2 yupoo shoes 14.jpg",
      "/productimgs/shoes/Adidas/19/yupoo yeezy 350 Boost V2 yupoo shoes 15.jpg"
    ]
  },
  {
    id: "622",
    name: "Yupoo Shoes: Premium Yeezy Yupoo Sneakers",
    description: "Premium quality Yeezy Yupoo Sneakers from productalbum.cn. These high-end Yupoos perfectly capture the design and comfort of the authentic version at an affordable price. #yupooshoes #yupooyeezy #yeezy #yupooadidas",
    price: PriceInfo,
    categories: [
      "shoes",
      "yeezy",
      "adidas"
    ],
    images: [
      "/productimgs/shoes/Adidas/98/yupoo yeezy Boost 350 yupoo shoes 1.jpg",
      "/productimgs/shoes/Adidas/98/yupoo yeezy Boost 350 yupoo shoes 2.jpg",
      "/productimgs/shoes/Adidas/98/yupoo yeezy Boost 350 yupoo shoes 3.jpg",
      "/productimgs/shoes/Adidas/98/yupoo yeezy Boost 350 yupoo shoes 4.jpg",
      "/productimgs/shoes/Adidas/98/yupoo yeezy Boost 350 yupoo shoes 5.jpg",
      "/productimgs/shoes/Adidas/98/yupoo yeezy Boost 350 yupoo shoes 6.jpg",
      "/productimgs/shoes/Adidas/98/yupoo yeezy Boost 350 yupoo shoes 7.jpg",
      "/productimgs/shoes/Adidas/98/yupoo yeezy Boost 350 yupoo shoes 8.jpg",
      "/productimgs/shoes/Adidas/98/yupoo yeezy Boost 350 yupoo shoes 9.jpg",
      "/productimgs/shoes/Adidas/98/yupoo yeezy Boost 350 yupoo shoes 10.jpg",
      "/productimgs/shoes/Adidas/98/yupoo yeezy Boost 350 yupoo shoes 11.jpg",
      "/productimgs/shoes/Adidas/98/yupoo yeezy Boost 350 yupoo shoes 12.jpg",
      "/productimgs/shoes/Adidas/98/yupoo yeezy Boost 350 yupoo shoes 13.jpg",
      "/productimgs/shoes/Adidas/98/yupoo yeezy Boost 350 yupoo shoes 14.jpg",
      "/productimgs/shoes/Adidas/98/yupoo yeezy Boost 350 yupoo shoes 15.jpg",
      "/productimgs/shoes/Adidas/98/yupoo yeezy Boost 350 yupoo shoes 16.jpg",
      "/productimgs/shoes/Adidas/98/yupoo yeezy Boost 350 yupoo shoes 17.jpg",
      "/productimgs/shoes/Adidas/98/yupoo yeezy Boost 350 yupoo shoes 18.jpg",
      "/productimgs/shoes/Adidas/98/yupoo yeezy Boost 350 yupoo shoes 19.jpg",
      "/productimgs/shoes/Adidas/98/yupoo yeezy Boost 350 yupoo shoes 20.jpg",
      "/productimgs/shoes/Adidas/98/yupoo yeezy Boost 350 yupoo shoes 21.jpg",
      "/productimgs/shoes/Adidas/98/yupoo yeezy Boost 350 yupoo shoes 22.jpg"
    ]
  },
  {
    id: "623",
    name: "Yupoo Shoes: Premium Yeezy Yupoo Sneakers",
    description: "Premium quality Yeezy Yupoo Sneakers from productalbum.cn. These high-end Yupoos perfectly capture the design and comfort of the authentic version at an affordable price. #yupooshoes #yupooyeezy #yeezy #yupooadidas",
    price: PriceInfo,
    categories: [
      "shoes",
      "yeezy",
      "adidas"
    ],
    images: [
      "/productimgs/shoes/Adidas/48/yupoo yeezy 350 V2 yupoo shoes 1.jpg",
      "/productimgs/shoes/Adidas/48/yupoo yeezy 350 V2 yupoo shoes 2.jpg",
      "/productimgs/shoes/Adidas/48/yupoo yeezy 350 V2 yupoo shoes 3.jpg",
      "/productimgs/shoes/Adidas/48/yupoo yeezy 350 V2 yupoo shoes 4.jpg",
      "/productimgs/shoes/Adidas/48/yupoo yeezy 350 V2 yupoo shoes 5.jpg",
      "/productimgs/shoes/Adidas/48/yupoo yeezy 350 V2 yupoo shoes 6.jpg",
      "/productimgs/shoes/Adidas/48/yupoo yeezy 350 V2 yupoo shoes 7.jpg",
      "/productimgs/shoes/Adidas/48/yupoo yeezy 350 V2 yupoo shoes 8.jpg",
      "/productimgs/shoes/Adidas/48/yupoo yeezy 350 V2 yupoo shoes 9.jpg",
      "/productimgs/shoes/Adidas/48/yupoo yeezy 350 V2 yupoo shoes 10.jpg",
      "/productimgs/shoes/Adidas/48/yupoo yeezy 350 V2 yupoo shoes 11.jpg",
      "/productimgs/shoes/Adidas/48/yupoo yeezy 350 V2 yupoo shoes 12.jpg",
      "/productimgs/shoes/Adidas/48/yupoo yeezy 350 V2 yupoo shoes 13.jpg",
      "/productimgs/shoes/Adidas/48/yupoo yeezy 350 V2 yupoo shoes 14.jpg",
      "/productimgs/shoes/Adidas/48/yupoo yeezy 350 V2 yupoo shoes 15.jpg",
      "/productimgs/shoes/Adidas/48/yupoo yeezy 350 V2 yupoo shoes 16.jpg"
    ]
  },
  {
    id: "624",
    name: "Yupoo Shoes: Premium Yeezy Yupoo Sneakers",
    description: "Premium quality Yeezy Yupoo Sneakers from productalbum.cn. These high-end Yupoos perfectly capture the design and comfort of the authentic version at an affordable price. #yupooshoes #yupooyeezy #yeezy #yupooadidas",
    price: PriceInfo,
    categories: [
      "shoes",
      "yeezy",
      "adidas"
    ],
    images: [
      "/productimgs/shoes/Adidas/90/yupoo yeezy 700 V2 1.jpg",
      "/productimgs/shoes/Adidas/90/yupoo yeezy 700 V2 2.jpg",
      "/productimgs/shoes/Adidas/90/yupoo yeezy 700 V2 3.jpg",
      "/productimgs/shoes/Adidas/90/yupoo yeezy 700 V2 4.jpg",
      "/productimgs/shoes/Adidas/90/yupoo yeezy 700 V2 5.jpg",
      "/productimgs/shoes/Adidas/90/yupoo yeezy 700 V2 6.jpg",
      "/productimgs/shoes/Adidas/90/yupoo yeezy 700 V2 7.jpg",
      "/productimgs/shoes/Adidas/90/yupoo yeezy 700 V2 8.jpg",
      "/productimgs/shoes/Adidas/90/yupoo yeezy 700 V2 9.jpg",
      "/productimgs/shoes/Adidas/90/yupoo yeezy 700 V2 10.jpg",
      "/productimgs/shoes/Adidas/90/yupoo yeezy 700 V2 11.jpg"
    ]
  },
  {
    id: "625",
    name: "Yupoo Shoes: Premium Yeezy Yupoo Sneakers",
    description: "Premium quality Yeezy Yupoo Sneakers from productalbum.cn. These high-end Yupoos perfectly capture the design and comfort of the authentic version at an affordable price. #yupooshoes #yupooyeezy #yeezy #yupooadidas",
    price: PriceInfo,
    categories: [
      "shoes",
      "yeezy",
      "adidas"
    ],
    images: [
      "/productimgs/shoes/Adidas/74/yupoo yeezy 350 V2 yupoo shoes 1.jpg",
      "/productimgs/shoes/Adidas/74/yupoo yeezy 350 V2 yupoo shoes 2.jpg",
      "/productimgs/shoes/Adidas/74/yupoo yeezy 350 V2 yupoo shoes 3.jpg",
      "/productimgs/shoes/Adidas/74/yupoo yeezy 350 V2 yupoo shoes 4.jpg",
      "/productimgs/shoes/Adidas/74/yupoo yeezy 350 V2 yupoo shoes 5.jpg",
      "/productimgs/shoes/Adidas/74/yupoo yeezy 350 V2 yupoo shoes 6.jpg",
      "/productimgs/shoes/Adidas/74/yupoo yeezy 350 V2 yupoo shoes 7.jpg",
      "/productimgs/shoes/Adidas/74/yupoo yeezy 350 V2 yupoo shoes 8.jpg",
      "/productimgs/shoes/Adidas/74/yupoo yeezy 350 V2 yupoo shoes 9.jpg",
      "/productimgs/shoes/Adidas/74/yupoo yeezy 350 V2 yupoo shoes 10.jpg",
      "/productimgs/shoes/Adidas/74/yupoo yeezy 350 V2 yupoo shoes 11.jpg",
      "/productimgs/shoes/Adidas/74/yupoo yeezy 350 V2 yupoo shoes 12.jpg",
      "/productimgs/shoes/Adidas/74/yupoo yeezy 350 V2 yupoo shoes 13.jpg",
      "/productimgs/shoes/Adidas/74/yupoo yeezy 350 V2 yupoo shoes 14.jpg"
    ]
  },
  {
    id: "626",
    name: "Yupoo Shoes: Premium Yeezy Yupoo Sneakers",
    description: "Premium quality Yeezy Yupoo Sneakers from productalbum.cn. These high-end Yupoos perfectly capture the design and comfort of the authentic version at an affordable price. #yupooshoes #yupooyeezy #yeezy #yupooadidas",
    price: PriceInfo,
    categories: [
      "shoes",
      "yeezy",
      "adidas"
    ],
    images: [
      "/productimgs/shoes/Adidas/59/yupoo yeezy 350 V2 yupoo shoes 1.jpg",
      "/productimgs/shoes/Adidas/59/yupoo yeezy 350 V2 yupoo shoes 2.jpg",
      "/productimgs/shoes/Adidas/59/yupoo yeezy 350 V2 yupoo shoes 3.jpg",
      "/productimgs/shoes/Adidas/59/yupoo yeezy 350 V2 yupoo shoes 4.jpg",
      "/productimgs/shoes/Adidas/59/yupoo yeezy 350 V2 yupoo shoes 5.jpg",
      "/productimgs/shoes/Adidas/59/yupoo yeezy 350 V2 yupoo shoes 6.jpg",
      "/productimgs/shoes/Adidas/59/yupoo yeezy 350 V2 yupoo shoes 7.jpg",
      "/productimgs/shoes/Adidas/59/yupoo yeezy 350 V2 yupoo shoes 8.jpg",
      "/productimgs/shoes/Adidas/59/yupoo yeezy 350 V2 yupoo shoes 9.jpg",
      "/productimgs/shoes/Adidas/59/yupoo yeezy 350 V2 yupoo shoes 10.jpg",
      "/productimgs/shoes/Adidas/59/yupoo yeezy 350 V2 yupoo shoes 11.jpg",
      "/productimgs/shoes/Adidas/59/yupoo yeezy 350 V2 yupoo shoes 12.jpg"
    ]
  },
  {
    id: "627",
    name: "Yupoo Shoes: Premium Yeezy Yupoo Sneakers",
    description: "Premium quality Yeezy Yupoo Sneakers from productalbum.cn. These high-end Yupoos perfectly capture the design and comfort of the authentic version at an affordable price. #yupooshoes #yupooyeezy #yeezy #yupooadidas",
    price: PriceInfo,
    categories: [
      "shoes",
      "yeezy",
      "adidas"
    ],
    images: [
      "/productimgs/shoes/Adidas/56/yupoo yeezy 350 V2 yupoo shoes 1.jpg",
      "/productimgs/shoes/Adidas/56/yupoo yeezy 350 V2 yupoo shoes 2.jpg",
      "/productimgs/shoes/Adidas/56/yupoo yeezy 350 V2 yupoo shoes 3.jpg",
      "/productimgs/shoes/Adidas/56/yupoo yeezy 350 V2 yupoo shoes 4.jpg",
      "/productimgs/shoes/Adidas/56/yupoo yeezy 350 V2 yupoo shoes 5.jpg",
      "/productimgs/shoes/Adidas/56/yupoo yeezy 350 V2 yupoo shoes 6.jpg",
      "/productimgs/shoes/Adidas/56/yupoo yeezy 350 V2 yupoo shoes 7.jpg",
      "/productimgs/shoes/Adidas/56/yupoo yeezy 350 V2 yupoo shoes 8.jpg",
      "/productimgs/shoes/Adidas/56/yupoo yeezy 350 V2 yupoo shoes 9.jpg",
      "/productimgs/shoes/Adidas/56/yupoo yeezy 350 V2 yupoo shoes 10.jpg",
      "/productimgs/shoes/Adidas/56/yupoo yeezy 350 V2 yupoo shoes 11.jpg",
      "/productimgs/shoes/Adidas/56/yupoo yeezy 350 V2 yupoo shoes 12.jpg",
      "/productimgs/shoes/Adidas/56/yupoo yeezy 350 V2 yupoo shoes 13.jpg",
      "/productimgs/shoes/Adidas/56/yupoo yeezy 350 V2 yupoo shoes 14.jpg",
      "/productimgs/shoes/Adidas/56/yupoo yeezy 350 V2 yupoo shoes 15.jpg"
    ]
  },
  {
    id: "628",
    name: "Yupoo Shoes: Premium Yeezy Yupoo Sneakers",
    description: "Premium quality Yeezy Yupoo Sneakers from productalbum.cn. These high-end Yupoos perfectly capture the design and comfort of the authentic version at an affordable price. #yupooshoes #yupooyeezy #yeezy #yupooadidas",
    price: PriceInfo,
    categories: [
      "shoes",
      "yeezy",
      "adidas"
    ],
    images: [
      "/productimgs/shoes/Adidas/39/yupoo yeezy 350 V2 yupoo shoes 1.jpg",
      "/productimgs/shoes/Adidas/39/yupoo yeezy 350 V2 yupoo shoes 2.jpg",
      "/productimgs/shoes/Adidas/39/yupoo yeezy 350 V2 yupoo shoes 3.jpg",
      "/productimgs/shoes/Adidas/39/yupoo yeezy 350 V2 yupoo shoes 4.jpg",
      "/productimgs/shoes/Adidas/39/yupoo yeezy 350 V2 yupoo shoes 5.jpg",
      "/productimgs/shoes/Adidas/39/yupoo yeezy 350 V2 yupoo shoes 6.jpg",
      "/productimgs/shoes/Adidas/39/yupoo yeezy 350 V2 yupoo shoes 7.jpg",
      "/productimgs/shoes/Adidas/39/yupoo yeezy 350 V2 yupoo shoes 8.jpg",
      "/productimgs/shoes/Adidas/39/yupoo yeezy 350 V2 yupoo shoes 9.jpg",
      "/productimgs/shoes/Adidas/39/yupoo yeezy 350 V2 yupoo shoes 10.jpg",
      "/productimgs/shoes/Adidas/39/yupoo yeezy 350 V2 yupoo shoes 11.jpg",
      "/productimgs/shoes/Adidas/39/yupoo yeezy 350 V2 yupoo shoes 12.jpg",
      "/productimgs/shoes/Adidas/39/yupoo yeezy 350 V2 yupoo shoes 13.jpg",
      "/productimgs/shoes/Adidas/39/yupoo yeezy 350 V2 yupoo shoes 14.jpg",
      "/productimgs/shoes/Adidas/39/yupoo yeezy 350 V2 yupoo shoes 15.jpg",
      "/productimgs/shoes/Adidas/39/yupoo yeezy 350 V2 yupoo shoes 16.jpg",
      "/productimgs/shoes/Adidas/39/yupoo yeezy 350 V2 yupoo shoes 17.jpg",
      "/productimgs/shoes/Adidas/39/yupoo yeezy 350 V2 yupoo shoes 18.jpg"
    ]
  },
  {
    id: "629",
    name: "Yupoo Shoes: Premium Yeezy Yupoo Sneakers",
    description: "Premium quality Yeezy Yupoo Sneakers from productalbum.cn. These high-end Yupoos perfectly capture the design and comfort of the authentic version at an affordable price. #yupooshoes #yupooyeezy #yeezy #yupooadidas",
    price: PriceInfo,
    categories: [
      "shoes",
      "yeezy",
      "adidas"
    ],
    images: [
      "/productimgs/shoes/Adidas/40/yupoo yeezy 350 V2 yupoo shoes 1.jpg",
      "/productimgs/shoes/Adidas/40/yupoo yeezy 350 V2 yupoo shoes 2.jpg",
      "/productimgs/shoes/Adidas/40/yupoo yeezy 350 V2 yupoo shoes 3.jpg",
      "/productimgs/shoes/Adidas/40/yupoo yeezy 350 V2 yupoo shoes 4.jpg",
      "/productimgs/shoes/Adidas/40/yupoo yeezy 350 V2 yupoo shoes 5.jpg",
      "/productimgs/shoes/Adidas/40/yupoo yeezy 350 V2 yupoo shoes 6.jpg",
      "/productimgs/shoes/Adidas/40/yupoo yeezy 350 V2 yupoo shoes 7.jpg",
      "/productimgs/shoes/Adidas/40/yupoo yeezy 350 V2 yupoo shoes 8.jpg",
      "/productimgs/shoes/Adidas/40/yupoo yeezy 350 V2 yupoo shoes 9.jpg",
      "/productimgs/shoes/Adidas/40/yupoo yeezy 350 V2 yupoo shoes 10.jpg",
      "/productimgs/shoes/Adidas/40/yupoo yeezy 350 V2 yupoo shoes 11.jpg",
      "/productimgs/shoes/Adidas/40/yupoo yeezy 350 V2 yupoo shoes 12.jpg",
      "/productimgs/shoes/Adidas/40/yupoo yeezy 350 V2 yupoo shoes 13.jpg",
      "/productimgs/shoes/Adidas/40/yupoo yeezy 350 V2 yupoo shoes 14.jpg",
      "/productimgs/shoes/Adidas/40/yupoo yeezy 350 V2 yupoo shoes 15.jpg",
      "/productimgs/shoes/Adidas/40/yupoo yeezy 350 V2 yupoo shoes 16.jpg",
      "/productimgs/shoes/Adidas/40/yupoo yeezy 350 V2 yupoo shoes 17.jpg"
    ]
  },
  {
    id: "630",
    name: "Yupoo Shoes: Premium Yeezy Yupoo Sneakers",
    description: "Premium quality Yeezy Yupoo Sneakers from productalbum.cn. These high-end Yupoos perfectly capture the design and comfort of the authentic version at an affordable price. #yupooshoes #yupooyeezy #yeezy #yupooadidas",
    price: PriceInfo,
    categories: [
      "shoes",
      "yeezy",
      "adidas"
    ],
    images: [
      "/productimgs/shoes/Adidas/46/yupoo yeezy 350 V2 yupoo shoes 1.jpg",
      "/productimgs/shoes/Adidas/46/yupoo yeezy 350 V2 yupoo shoes 2.jpg",
      "/productimgs/shoes/Adidas/46/yupoo yeezy 350 V2 yupoo shoes 3.jpg",
      "/productimgs/shoes/Adidas/46/yupoo yeezy 350 V2 yupoo shoes 4.jpg",
      "/productimgs/shoes/Adidas/46/yupoo yeezy 350 V2 yupoo shoes 5.jpg",
      "/productimgs/shoes/Adidas/46/yupoo yeezy 350 V2 yupoo shoes 6.jpg",
      "/productimgs/shoes/Adidas/46/yupoo yeezy 350 V2 yupoo shoes 7.jpg",
      "/productimgs/shoes/Adidas/46/yupoo yeezy 350 V2 yupoo shoes 8.jpg",
      "/productimgs/shoes/Adidas/46/yupoo yeezy 350 V2 yupoo shoes 9.jpg",
      "/productimgs/shoes/Adidas/46/yupoo yeezy 350 V2 yupoo shoes 10.jpg",
      "/productimgs/shoes/Adidas/46/yupoo yeezy 350 V2 yupoo shoes 11.jpg",
      "/productimgs/shoes/Adidas/46/yupoo yeezy 350 V2 yupoo shoes 12.jpg",
      "/productimgs/shoes/Adidas/46/yupoo yeezy 350 V2 yupoo shoes 13.jpg",
      "/productimgs/shoes/Adidas/46/yupoo yeezy 350 V2 yupoo shoes 14.jpg",
      "/productimgs/shoes/Adidas/46/yupoo yeezy 350 V2 yupoo shoes 15.jpg",
      "/productimgs/shoes/Adidas/46/yupoo yeezy 350 V2 yupoo shoes 16.jpg",
      "/productimgs/shoes/Adidas/46/yupoo yeezy 350 V2 yupoo shoes 17.jpg",
      "/productimgs/shoes/Adidas/46/yupoo yeezy 350 V2 yupoo shoes 18.jpg",
      "/productimgs/shoes/Adidas/46/yupoo yeezy 350 V2 yupoo shoes 19.jpg"
    ]
  },
  {
    id: "631",
    name: "Yupoo Shoes: Premium Yeezy Yupoo Sneakers",
    description: "Premium quality Yeezy Yupoo Sneakers from productalbum.cn. These high-end Yupoos perfectly capture the design and comfort of the authentic version at an affordable price. #yupooshoes #yupooyeezy #yeezy #yupooadidas",
    price: PriceInfo,
    categories: [
      "shoes",
      "yeezy",
      "adidas"
    ],
    images: [
      "/productimgs/shoes/Adidas/38/yupoo yeezy 350 V2 yupoo shoes 1.jpg",
      "/productimgs/shoes/Adidas/38/yupoo yeezy 350 V2 yupoo shoes 2.jpg",
      "/productimgs/shoes/Adidas/38/yupoo yeezy 350 V2 yupoo shoes 3.jpg",
      "/productimgs/shoes/Adidas/38/yupoo yeezy 350 V2 yupoo shoes 4.jpg",
      "/productimgs/shoes/Adidas/38/yupoo yeezy 350 V2 yupoo shoes 5.jpg",
      "/productimgs/shoes/Adidas/38/yupoo yeezy 350 V2 yupoo shoes 6.jpg",
      "/productimgs/shoes/Adidas/38/yupoo yeezy 350 V2 yupoo shoes 7.jpg",
      "/productimgs/shoes/Adidas/38/yupoo yeezy 350 V2 yupoo shoes 8.jpg",
      "/productimgs/shoes/Adidas/38/yupoo yeezy 350 V2 yupoo shoes 9.jpg",
      "/productimgs/shoes/Adidas/38/yupoo yeezy 350 V2 yupoo shoes 10.jpg",
      "/productimgs/shoes/Adidas/38/yupoo yeezy 350 V2 yupoo shoes 11.jpg",
      "/productimgs/shoes/Adidas/38/yupoo yeezy 350 V2 yupoo shoes 12.jpg",
      "/productimgs/shoes/Adidas/38/yupoo yeezy 350 V2 yupoo shoes 13.jpg",
      "/productimgs/shoes/Adidas/38/yupoo yeezy 350 V2 yupoo shoes 14.jpg",
      "/productimgs/shoes/Adidas/38/yupoo yeezy 350 V2 yupoo shoes 15.jpg",
      "/productimgs/shoes/Adidas/38/yupoo yeezy 350 V2 yupoo shoes 16.jpg",
      "/productimgs/shoes/Adidas/38/yupoo yeezy 350 V2 yupoo shoes 17.jpg",
      "/productimgs/shoes/Adidas/38/yupoo yeezy 350 V2 yupoo shoes 18.jpg",
      "/productimgs/shoes/Adidas/38/yupoo yeezy 350 V2 yupoo shoes 19.jpg",
      "/productimgs/shoes/Adidas/38/yupoo yeezy 350 V2 yupoo shoes 20.jpg",
      "/productimgs/shoes/Adidas/38/yupoo yeezy 350 V2 yupoo shoes 21.jpg"
    ]
  },
  {
    id: "632",
    name: "Yupoo Shoes: Premium Yeezy Yupoo Sneakers",
    description: "Premium quality Yeezy Yupoo Sneakers from productalbum.cn. These high-end Yupoos perfectly capture the design and comfort of the authentic version at an affordable price. #yupooshoes #yupooyeezy #yeezy #yupooadidas",
    price: PriceInfo,
    categories: [
      "shoes",
      "yeezy",
      "adidas"
    ],
    images: [
      "/productimgs/shoes/Adidas/58/yupoo yeezy 350 V2 yupoo shoes 1.jpg",
      "/productimgs/shoes/Adidas/58/yupoo yeezy 350 V2 yupoo shoes 2.jpg",
      "/productimgs/shoes/Adidas/58/yupoo yeezy 350 V2 yupoo shoes 3.jpg",
      "/productimgs/shoes/Adidas/58/yupoo yeezy 350 V2 yupoo shoes 4.jpg",
      "/productimgs/shoes/Adidas/58/yupoo yeezy 350 V2 yupoo shoes 5.jpg",
      "/productimgs/shoes/Adidas/58/yupoo yeezy 350 V2 yupoo shoes 6.jpg",
      "/productimgs/shoes/Adidas/58/yupoo yeezy 350 V2 yupoo shoes 7.jpg",
      "/productimgs/shoes/Adidas/58/yupoo yeezy 350 V2 yupoo shoes 8.jpg",
      "/productimgs/shoes/Adidas/58/yupoo yeezy 350 V2 yupoo shoes 9.jpg",
      "/productimgs/shoes/Adidas/58/yupoo yeezy 350 V2 yupoo shoes 10.jpg",
      "/productimgs/shoes/Adidas/58/yupoo yeezy 350 V2 yupoo shoes 11.jpg"
    ]
  },
  {
    id: "633",
    name: "Yupoo Shoes: Premium Yeezy Yupoo Sneakers",
    description: "Premium quality Yeezy Yupoo Sneakers from productalbum.cn. These high-end Yupoos perfectly capture the design and comfort of the authentic version at an affordable price. #yupooshoes #yupooyeezy #yeezy #yupooadidas",
    price: PriceInfo,
    categories: [
      "shoes",
      "yeezy",
      "adidas"
    ],
    images: [
      "/productimgs/shoes/Adidas/62/yupoo yeezy 350 V2 yupoo shoes 1.jpg",
      "/productimgs/shoes/Adidas/62/yupoo yeezy 350 V2 yupoo shoes 2.jpg",
      "/productimgs/shoes/Adidas/62/yupoo yeezy 350 V2 yupoo shoes 3.jpg",
      "/productimgs/shoes/Adidas/62/yupoo yeezy 350 V2 yupoo shoes 4.jpg",
      "/productimgs/shoes/Adidas/62/yupoo yeezy 350 V2 yupoo shoes 5.jpg",
      "/productimgs/shoes/Adidas/62/yupoo yeezy 350 V2 yupoo shoes 6.jpg",
      "/productimgs/shoes/Adidas/62/yupoo yeezy 350 V2 yupoo shoes 7.jpg",
      "/productimgs/shoes/Adidas/62/yupoo yeezy 350 V2 yupoo shoes 8.jpg",
      "/productimgs/shoes/Adidas/62/yupoo yeezy 350 V2 yupoo shoes 9.jpg",
      "/productimgs/shoes/Adidas/62/yupoo yeezy 350 V2 yupoo shoes 10.jpg",
      "/productimgs/shoes/Adidas/62/yupoo yeezy 350 V2 yupoo shoes 11.jpg",
      "/productimgs/shoes/Adidas/62/yupoo yeezy 350 V2 yupoo shoes 12.jpg",
      "/productimgs/shoes/Adidas/62/yupoo yeezy 350 V2 yupoo shoes 13.jpg",
      "/productimgs/shoes/Adidas/62/yupoo yeezy 350 V2 yupoo shoes 14.jpg"
    ]
  },
  {
    id: "634",
    name: "Yupoo Shoes: Premium Yeezy Yupoo Sneakers",
    description: "Premium quality Yeezy Yupoo Sneakers from productalbum.cn. These high-end Yupoos perfectly capture the design and comfort of the authentic version at an affordable price. #yupooshoes #yupooyeezy #yeezy #yupooadidas",
    price: PriceInfo,
    categories: [
      "shoes",
      "yeezy",
      "adidas"
    ],
    images: [
      "/productimgs/shoes/Adidas/77/yupoo yeezy 350 V2 yupoo shoes 1.jpg",
      "/productimgs/shoes/Adidas/77/yupoo yeezy 350 V2 yupoo shoes 2.jpg",
      "/productimgs/shoes/Adidas/77/yupoo yeezy 350 V2 yupoo shoes 3.jpg",
      "/productimgs/shoes/Adidas/77/yupoo yeezy 350 V2 yupoo shoes 4.jpg",
      "/productimgs/shoes/Adidas/77/yupoo yeezy 350 V2 yupoo shoes 5.jpg",
      "/productimgs/shoes/Adidas/77/yupoo yeezy 350 V2 yupoo shoes 6.jpg",
      "/productimgs/shoes/Adidas/77/yupoo yeezy 350 V2 yupoo shoes 7.jpg",
      "/productimgs/shoes/Adidas/77/yupoo yeezy 350 V2 yupoo shoes 8.jpg",
      "/productimgs/shoes/Adidas/77/yupoo yeezy 350 V2 yupoo shoes 9.jpg",
      "/productimgs/shoes/Adidas/77/yupoo yeezy 350 V2 yupoo shoes 10.jpg"
    ]
  },
  {
    id: "635",
    name: "Yupoo Shoes: Premium Yeezy Yupoo Sneakers",
    description: "Premium quality Yeezy Yupoo Sneakers from productalbum.cn. These high-end Yupoos perfectly capture the design and comfort of the authentic version at an affordable price. #yupooshoes #yupooyeezy #yeezy #yupooadidas",
    price: PriceInfo,
    categories: [
      "shoes",
      "yeezy",
      "adidas"
    ],
    images: [
      "/productimgs/shoes/Adidas/43/yupoo yeezy 350 V2 yupoo shoes 1.jpg",
      "/productimgs/shoes/Adidas/43/yupoo yeezy 350 V2 yupoo shoes 2.jpg",
      "/productimgs/shoes/Adidas/43/yupoo yeezy 350 V2 yupoo shoes 3.jpg",
      "/productimgs/shoes/Adidas/43/yupoo yeezy 350 V2 yupoo shoes 4.jpg",
      "/productimgs/shoes/Adidas/43/yupoo yeezy 350 V2 yupoo shoes 5.jpg",
      "/productimgs/shoes/Adidas/43/yupoo yeezy 350 V2 yupoo shoes 6.jpg",
      "/productimgs/shoes/Adidas/43/yupoo yeezy 350 V2 yupoo shoes 7.jpg",
      "/productimgs/shoes/Adidas/43/yupoo yeezy 350 V2 yupoo shoes 8.jpg",
      "/productimgs/shoes/Adidas/43/yupoo yeezy 350 V2 yupoo shoes 9.jpg",
      "/productimgs/shoes/Adidas/43/yupoo yeezy 350 V2 yupoo shoes 10.jpg",
      "/productimgs/shoes/Adidas/43/yupoo yeezy 350 V2 yupoo shoes 11.jpg",
      "/productimgs/shoes/Adidas/43/yupoo yeezy 350 V2 yupoo shoes 12.jpg",
      "/productimgs/shoes/Adidas/43/yupoo yeezy 350 V2 yupoo shoes 13.jpg",
      "/productimgs/shoes/Adidas/43/yupoo yeezy 350 V2 yupoo shoes 14.jpg",
      "/productimgs/shoes/Adidas/43/yupoo yeezy 350 V2 yupoo shoes 15.jpg",
      "/productimgs/shoes/Adidas/43/yupoo yeezy 350 V2 yupoo shoes 16.jpg",
      "/productimgs/shoes/Adidas/43/yupoo yeezy 350 V2 yupoo shoes 17.jpg",
      "/productimgs/shoes/Adidas/43/yupoo yeezy 350 V2 yupoo shoes 18.jpg",
      "/productimgs/shoes/Adidas/43/yupoo yeezy 350 V2 yupoo shoes 19.jpg"
    ]
  },
  {
    id: "636",
    name: "Yupoo Shoes: Premium Yeezy Yupoo Sneakers",
    description: "Premium quality Yeezy Yupoo Sneakers from productalbum.cn. These high-end Yupoos perfectly capture the design and comfort of the authentic version at an affordable price. #yupooshoes #yupooyeezy #yeezy #yupooadidas",
    price: PriceInfo,
    categories: [
      "shoes",
      "yeezy",
      "adidas"
    ],
    images: [
      "/productimgs/shoes/Adidas/26/yupoo yeezy 350 Boost V2 yupoo shoes 1.jpg",
      "/productimgs/shoes/Adidas/26/yupoo yeezy 350 Boost V2 yupoo shoes 2.jpg",
      "/productimgs/shoes/Adidas/26/yupoo yeezy 350 Boost V2 yupoo shoes 3.jpg",
      "/productimgs/shoes/Adidas/26/yupoo yeezy 350 Boost V2 yupoo shoes 4.jpg",
      "/productimgs/shoes/Adidas/26/yupoo yeezy 350 Boost V2 yupoo shoes 5.jpg",
      "/productimgs/shoes/Adidas/26/yupoo yeezy 350 Boost V2 yupoo shoes 6.jpg",
      "/productimgs/shoes/Adidas/26/yupoo yeezy 350 Boost V2 yupoo shoes 7.jpg",
      "/productimgs/shoes/Adidas/26/yupoo yeezy 350 Boost V2 yupoo shoes 8.jpg",
      "/productimgs/shoes/Adidas/26/yupoo yeezy 350 Boost V2 yupoo shoes 9.jpg",
      "/productimgs/shoes/Adidas/26/yupoo yeezy 350 Boost V2 yupoo shoes 10.jpg",
      "/productimgs/shoes/Adidas/26/yupoo yeezy 350 Boost V2 yupoo shoes 11.jpg",
      "/productimgs/shoes/Adidas/26/yupoo yeezy 350 Boost V2 yupoo shoes 12.jpg",
      "/productimgs/shoes/Adidas/26/yupoo yeezy 350 Boost V2 yupoo shoes 13.jpg",
      "/productimgs/shoes/Adidas/26/yupoo yeezy 350 Boost V2 yupoo shoes 14.jpg",
      "/productimgs/shoes/Adidas/26/yupoo yeezy 350 Boost V2 yupoo shoes 15.jpg",
      "/productimgs/shoes/Adidas/26/yupoo yeezy 350 Boost V2 yupoo shoes 16.jpg",
      "/productimgs/shoes/Adidas/26/yupoo yeezy 350 Boost V2 yupoo shoes 17.jpg"
    ]
  },
  {
    id: "637",
    name: "Yupoo Shoes: Premium Yeezy Yupoo Sneakers",
    description: "Premium quality Yeezy Yupoo Sneakers from productalbum.cn. These high-end Yupoos perfectly capture the design and comfort of the authentic version at an affordable price. #yupooshoes #yupooyeezy #yeezy #yupooadidas",
    price: PriceInfo,
    categories: [
      "shoes",
      "yeezy",
      "adidas"
    ],
    images: [
      "/productimgs/shoes/Adidas/94/yupoo yeezy 750 Boost yupoo shoes 1.jpg",
      "/productimgs/shoes/Adidas/94/yupoo yeezy 750 Boost yupoo shoes 2.jpg",
      "/productimgs/shoes/Adidas/94/yupoo yeezy 750 Boost yupoo shoes 3.jpg",
      "/productimgs/shoes/Adidas/94/yupoo yeezy 750 Boost yupoo shoes 4.jpg",
      "/productimgs/shoes/Adidas/94/yupoo yeezy 750 Boost yupoo shoes 5.jpg",
      "/productimgs/shoes/Adidas/94/yupoo yeezy 750 Boost yupoo shoes 6.jpg",
      "/productimgs/shoes/Adidas/94/yupoo yeezy 750 Boost yupoo shoes 7.jpg",
      "/productimgs/shoes/Adidas/94/yupoo yeezy 750 Boost yupoo shoes 8.jpg",
      "/productimgs/shoes/Adidas/94/yupoo yeezy 750 Boost yupoo shoes 9.jpg",
      "/productimgs/shoes/Adidas/94/yupoo yeezy 750 Boost yupoo shoes 10.jpg",
      "/productimgs/shoes/Adidas/94/yupoo yeezy 750 Boost yupoo shoes 11.jpg",
      "/productimgs/shoes/Adidas/94/yupoo yeezy 750 Boost yupoo shoes 12.jpg",
      "/productimgs/shoes/Adidas/94/yupoo yeezy 750 Boost yupoo shoes 13.jpg",
      "/productimgs/shoes/Adidas/94/yupoo yeezy 750 Boost yupoo shoes 14.jpg",
      "/productimgs/shoes/Adidas/94/yupoo yeezy 750 Boost yupoo shoes 15.jpg"
    ]
  },
  {
    id: "638",
    name: "Yupoo Shoes: Premium Yeezy Yupoo Sneakers",
    description: "Premium quality Yeezy Yupoo Sneakers from productalbum.cn. These high-end Yupoos perfectly capture the design and comfort of the authentic version at an affordable price. #yupooshoes #yupooyeezy #yeezy #yupooadidas",
    price: PriceInfo,
    categories: [
      "shoes",
      "yeezy",
      "adidas"
    ],
    images: [
      "/productimgs/shoes/Adidas/79/yupoo yeezy 450 1.jpg",
      "/productimgs/shoes/Adidas/79/yupoo yeezy 450 2.jpg",
      "/productimgs/shoes/Adidas/79/yupoo yeezy 450 3.jpg",
      "/productimgs/shoes/Adidas/79/yupoo yeezy 450 4.jpg",
      "/productimgs/shoes/Adidas/79/yupoo yeezy 450 5.jpg",
      "/productimgs/shoes/Adidas/79/yupoo yeezy 450 6.jpg",
      "/productimgs/shoes/Adidas/79/yupoo yeezy 450 7.jpg",
      "/productimgs/shoes/Adidas/79/yupoo yeezy 450 8.jpg",
      "/productimgs/shoes/Adidas/79/yupoo yeezy 450 9.jpg",
      "/productimgs/shoes/Adidas/79/yupoo yeezy 450 10.jpg",
      "/productimgs/shoes/Adidas/79/yupoo yeezy 450 11.jpg",
      "/productimgs/shoes/Adidas/79/yupoo yeezy 450 12.jpg",
      "/productimgs/shoes/Adidas/79/yupoo yeezy 450 13.jpg",
      "/productimgs/shoes/Adidas/79/yupoo yeezy 450 14.jpg",
      "/productimgs/shoes/Adidas/79/yupoo yeezy 450 15.jpg"
    ]
  },
  { 
    id: "639", 
    name: "Yupoo Shoes: Travis Scott × AJ1 Low x Xiaomi Su7 - Grey/Black Custom 👟", 
    description: "This ultra-limited AJ1 Low collab merges Travis Scott’s streetwear edge with Xiaomi Su7’s tech aesthetic, featuring premium grey/black leather, custom branding, and low-top versatility for hypebeasts who demand exclusivity. 🔥 #yupooshoes #shoes #yupoonb #NikeShoes #Nike #XiaomiSu7 #Xiaomi", 
    price: PriceInfo, 
    categories: ["shoes", "nike", "af"], 
    images: generateImagePaths("shoes", "Nike","489", 9), 
    featured: true,
  },
  { 
    id: "640", 
    name: "Yupoo Shoes: Nike AF1 × The North Face - White/Blue Triple Swoosh 👟", 
    description: "This premium custom Air Force 1 collab with The North Face features a crisp white/blue colorway with triple Swoosh detailing, blending street-ready style with outdoor-inspired durability in a low-top silhouette. #yupooshoes #shoes #yupoonike #NikeShoes #Nike #airforce1 #NikeAF1 ", 
    price: PriceInfo, 
    categories: ["shoes", "nike", "af"], 
    images: generateImagePaths("shoes", "Nike_af","1", 9) 
  },
  { 
    id: "641", 
    name: "Yupoo Shoes: Nike Air Force 1 Low - Classic White Retro Sneakers 👟", 
    description: "The iconic AF1 Low combines timeless style with cloud-like cushioning, featuring a versatile white leather upper and responsive midsole that's kept this silhouette fresh for over 30 years of streetwear dominance. #yupooshoes #shoes #yupoonike #NikeShoes #Nike #airforce1 #NikeAF1 ", 
    price: PriceInfo, 
    categories: ["shoes", "nike", "af"], 
    images: generateImagePaths("shoes", "Nike_af","2", 9) 
  },
  { 
    id: "642", 
    name: "Yupoo Shoes: Nike Air Force 1 Low + LV - Iconic White Retro Sneakers", 
    description: "The legendary AF1 Low blends timeless white leather with cloud-like cushioning, delivering 30+ years of streetwear dominance through its versatile design and responsive midsole that never goes out of style. #yupooshoes #shoes #yupoonike #NikeShoes #Nike #airforce1 #NikeAF1 ", 
    price: PriceInfo, 
    categories: ["shoes", "nike", "af"], 
    images: generateImagePaths("shoes", "Nike_af","3", 9) 
  },
  { 
    id: "643", 
    name: "Yupoo Shoes: Nike AF1 x The North Face - Premium Leather TNF Collab👟", 
    description: "This custom AF1 Low collab blends rugged TNF outdoor DNA with classic Nike style, featuring premium pebbled leather/suede uppers, full-length Air cushioning, and the iconic low-top silhouette that dominates streets worldwide. #yupooshoes #shoes #yupoonike #NikeShoes #Nike #airforce1 #NikeAF1 ", 
    price: PriceInfo, 
    categories: ["shoes", "nike", "af"], 
    images: generateImagePaths("shoes", "Nike_af","4", 9) 
  },
  { 
    id: "644", 
    name: "Yupoo Bags: Moon Bag Odeo - Vintage Monogram Canvas & Leather Crossbody", 
    description: "This retro-inspired moon bag features durable Monogram canvas with reinforced leather corners for timeless style. The adjustable strap allows shoulder or crossbody wear, while the iconic print + leather chain strap adds luxury. Easy zip access keeps essentials secure yet accessible. Perfect for day-to-night elegance. 🌙✨ #yupoobags #bags #yupoolv #LvBags #LouisVuitton", 
    price: PriceInfo, 
    categories: ["bags",  "lv"], 
    images: generateImagePaths("bags", "Lv","2", 9) 
  },
  { 
    id: "645", 
    name: "Discover the Yupoo Chic CROISSANT Mini Handbag in Lacquered Moon & Pea Pod Series!", 
    description: "The CROISSANT small handbag from the Lacquered Moon and Pea Pod series is a remarkable addition to your fashion collection. With its unique lacquered finish, it sparkles like a moon in the night, adding a touch of glamour to any outfit. The pea - pod inspired design gives it a cute and trendy look. Ideal for both daily use and special occasions, this handbag combines style and functionality. It's a must - have accessory for fashion - forward individuals. #yupoobags #bags #yupoolv #LvBags #LouisVuitton", 
    price: PriceInfo, 
    categories: ["bags",  "lv"], 
    images: generateImagePaths("bags", "Lv","3", 9) 
  },
  { 
    id: "646", 
    name: "Yupoo bags: LV Marel Moon Bag - Vintage Monogram & Yellow Accents 🌙", 
    description: "This iconic LV Marel moon bag features classic monogram canvas with vibrant yellow accents from the 2022 runway, offering a roomy 38×30×10cm size with ultra-comfy straps that blend vintage charm with everyday practicality.#yupoobags #bags #yupoolv #LvBags #LouisVuitton", 
    price: PriceInfo, 
    categories: ["bags",  "lv"], 
    images: generateImagePaths("bags", "Lv","4", 9) 
  },
  { 
    id: "647", 
    name: "Yupoo bags: NIGO × LV Backpack M43735 - Rugged Monogram Style 🎒", 
    description: "This 2020 FW collab backpack blends LV's iconic monogram with NIGO's streetwear edge, offering a versatile 41×48×13cm design perfect for work or adventures, crafted to embody rugged travel spirit with premium durability. #yupoobags #bags #yupoolv #LvBags #LouisVuitton", 
    price: PriceInfo, 
    categories: ["bags",  "lv"], 
    images: generateImagePaths("bags", "Lv","5", 9) 
  },
  { 
    id: "648", 
    name: "Yupoo bags: LV Keepall 25 - Monogram/Brown Crossbody Bag 👜", 
    description: "This vintage-inspired Keepall Bandoulière 25 combines grained leather with suede accents and distressed hardware, featuring Monogram canvas exterior with easy-access zip, adjustable straps for all-day comfort in a compact 25×15×11cm size. #yupoobags #bags #yupoolv #LvBags #LouisVuitton", 
    price: PriceInfo, 
    categories: ["bags",  "lv"], 
    images: generateImagePaths("bags", "Lv","6", 10) 
  },
  { 
    id: "649", 
    name: "Yupoo Watch: TISSOT PRX T137 Quartz Watch for Men ⌚ Retro & Sleek", 
    description: "Experience timeless style with the TISSOT PRX T137.410.11.041.00—a bold blend of 70s retro flair and modern sophistication featuring a sleek barrel-shaped 316L stainless steel case, integrated bracelet, Swiss quartz movement, sapphire crystal, 100m water resistance, and luminous 40mm dial, perfect for business or casual wear. #yupoowatch #watches #yupoo", 
    price: PriceInfo, 
    categories: ["watch"], 
    images: generateImagePaths("watch", "Tissot","1", 9) 
  },
  { 
    id: "650", 
    name: "Yupoo Watch: TISSOT PRX T137.410.11.031.00 Men's Quartz Watch 🕶️", 
    description: "Discover the original-quality TISSOT PRX T137.410.11.031.00 men’s quartz watch—retro meets modern with a sleek 40mm barrel-style case, integrated 316L steel bracelet, sapphire glass, Swiss quartz movement, and 100m water resistance; full real-shot details and purchase support available via productalbum.cn 📷. #yupoowatch #watches #yupoo", 
    price: PriceInfo, 
    categories: ["watch"], 
    images: generateImagePaths("watch", "Tissot","2", 9) 
  },
  { 
    id: "651", 
    name: "Yupoo Watch: TISSOT PRX T137.410.11.031.00 🕶️ Swiss Retro 40mm", 
    description: "Now in stock: the overseas edition TISSOT PRX T137.410.11.031.00 men’s watch, blending 70s disco flair with Swiss precision—featuring a 40mm barrel-shaped case, integrated 316L steel bracelet, Swiss quartz movement, sapphire crystal, 100m water resistance, and luminous display; full real-life photos and purchase info at productalbum.cn 📸. #yupoowatch #watches #yupoo", 
    price: PriceInfo, 
    categories: ["watch"], 
    images: generateImagePaths("watch", "Tissot","3", 8) 
  },
  { 
    id: "652", 
    name: "Yupoo Watch: Rolex Submariner 41mm - Clean Factory Ultimate Edition ⌚", 
    description: "This limited-edition C厂 Submariner boasts a true 41mm case with upgraded Clean Factory green ceramic bezel (platinum-filled markers), Swiss-made dial with crown logo, and cloned Cal.3235 movement with reverse time adjustment – indistinguishable from genuine at 95% accuracy, featuring improved lugs, wider bracelet, and sapphire crystal. #yupoowatch #watches #yupoo", 
    price: PriceInfo, 
    categories: ["watch", "rolex"], 
    images: generateImagePaths("watch", "Rolex","14", 9) 
  },
  { 
    id: "653", 
    name: "Yupoo Watch: C Factory Rolex Submariner 41mm - Ultimate NFC Edition ⌚", 
    description: "This limited 2023 C Factory Submariner features true 41mm sizing with Swiss-made crown logo dial, platinum-coated ceramic bezel, and cloned Cal.3235 movement (with reverse time adjustment), plus NFC authentication card - 95% identical to genuine with upgraded lugs, wider bracelet, and scratch-resistant sapphire crystal. #yupoowatch #watches #yupoo #Rolex", 
    price: PriceInfo, 
    categories: ["watch", "rolex"], 
    images: generateImagePaths("watch", "Rolex","15", 9) 
  },
  { 
    id: "654", 
    name: "Yupoo Shoes: New Balance 2002 - Retro Running Sneakers", 
    description: "The NB2002 reinvents classic retro style with streamlined design and modern tech, featuring a sleek layered upper that keeps the iconic 2002 silhouette while delivering fresh, minimalist vibes for everyday wear. #yupoonb #yupooshoes #yupoo #newbalance ", 
    price: PriceInfo, 
    categories: ["shoes", "nb"], 
    images: generateImagePaths("shoes", "Nb","10", 9) 
  },
  { 
    id: "655", 
    name: "Yupoo Shoes: New Balance 2002 - Military Green Retro Runners", 
    description: "The NB2002 revives a classic with its military green hue and streamlined silhouette, blending vintage 2002 DNA with modern minimalist design for a street-ready look that's trending on tk. #yupoonb #yupooshoes #yupoo #newbalance ", 
    price: PriceInfo, 
    categories: ["shoes", "nb"], 
    images: generateImagePaths("shoes", "Nb","11", 9) 
  },
  { 
    id: "656", 
    name: "Yupoo Shoes: New Balance 1906 - Retro Runners (U1906ROC)", 
    description: "The NB1906 reimagines classic retro style with a sleek, streamlined design, keeping the iconic 1906 silhouette while upgrading with modern tech for all-day comfort. Available in sizes 36-46.5. #yupoonb #yupooshoes #yupoo #newbalance ", 
    price: PriceInfo, 
    categories: ["shoes", "nb"], 
    images: generateImagePaths("shoes", "Nb","12", 9) 
  },
  { 
    id: "657", 
    name: "Yupoo Shoes: Jound × New Balance 992 - Premium Pigskin Retro Runners", 
    description: "This collab 992 blends pigskin leather with breathable mesh for superior comfort, featuring ABZORB cushioning and Ndurance outsoles in timeless retro colors that pair with any outfit. Available in sizes 36-45 (M992EB). #yupoonb #yupooshoes #yupoo #newbalance ", 
    price: PriceInfo, 
    categories: ["shoes", "nb"], 
    images: generateImagePaths("shoes", "Nb","13", 9) 
  },
  { 
    id: "658", 
    name: "Yupoo Shoes: New Balance 1906 - Retro Dad Shoes (U1906ANC)", 
    description: "The NB1906 dad sneaker combines lightweight cowhide with breathable mesh, featuring T-Beam arch support and exposed heel cushioning for stable, comfortable strides. Available in sizes 36-45. #yupoonb #yupooshoes #yupoo #newbalance ", 
    price: PriceInfo, 
    categories: ["shoes", "nb"], 
    images: generateImagePaths("shoes", "Nb","14", 9) 
  },
  { 
    id: "659", 
    name: "Yupoo Shoes: New Balance Made in USA MR993 - Premium Heritage Runners", 
    description: "The iconic American-made MR993 combines Taiwanese suede with breathable mesh, featuring a 6-layer cushioned midsole and carbon rubber outsole for durability. Classic dad shoe styling meets modern comfort. Sizes 36-45 (MR993TB). #yupoonb #yupooshoes #yupoo #newbalance ", 
    price: PriceInfo, 
    categories: ["shoes", "nb"], 
    images: generateImagePaths("shoes", "Nb","15", 9) 
  },
  { 
    id: "660", 
    name: "Yupoo Shoes: New Balance 327 - Low-Top Cushioned Runners (MS327WE)",
    description: "The NB327 redefines retro running with its layered midsole construction, combining premium materials for lightweight cushioning and a fresh take on classic low-top design. Available in sizes 36-45. #yupoonb #yupooshoes #yupoo #newbalance ", 
    price: PriceInfo, 
    categories: ["shoes", "nb"], 
    images: generateImagePaths("shoes", "Nb","16", 9) 
  },
  {
    id: "nbma07b",
    name: "New Balance Mr740 - Silver Swamp Retro Runners 👟",
    description: "These unisex MR740 sneakers blend Y2K nostalgia with modern tech, featuring split leather/mesh uppers, 3-layer cushioning, and grippy rubber soles in a sleek \"Silver Swamp\" colorway. True-to-size fit, sizes 36-45.",
    price: PriceInfo,
    categories: ["shoes","nb"],
    images: ["/productimgs/shoes/Nb/New Balance MR740 - Silver Swamp Retro Runners/nbma07b_4.jpg","/productimgs/shoes/Nb/New Balance MR740 - Silver Swamp Retro Runners/nbma07b_5.jpg","/productimgs/shoes/Nb/New Balance MR740 - Silver Swamp Retro Runners/nbma07b_6.jpg","/productimgs/shoes/Nb/New Balance MR740 - Silver Swamp Retro Runners/nbma07b_7.jpg","/productimgs/shoes/Nb/New Balance MR740 - Silver Swamp Retro Runners/nbma07b_8.jpg","/productimgs/shoes/Nb/New Balance MR740 - Silver Swamp Retro Runners/nbma07b_9.jpg","/productimgs/shoes/Nb/New Balance MR740 - Silver Swamp Retro Runners/nbma07b_10.jpg","/productimgs/shoes/Nb/New Balance MR740 - Silver Swamp Retro Runners/nbma07b_11.jpg","/productimgs/shoes/Nb/New Balance MR740 - Silver Swamp Retro Runners/nbma07b_12.jpg"]
  },
  {
    id: "nb1dbfc",
    name: "New Balance 1906 - \"Team Away\/Grey\" Retro Runners 👟",
    description: "This updated M1906U blends Y2K nostalgia with modern eco-tech, featuring space-age synthetic leather, breathable mesh, T-Beam arch support, and exposed heel cushioning for stable strides in a versatile grey colorway. Unisex sizes 36-46. #yupooshoes #yupoo #yupoonb #nb #newbalance #nb1906 #1906",
    price: PriceInfo,
    categories: ["shoes","nb"],
    images: ["/productimgs/shoes/nbshoes/New Balance 1906-Team AwayGrey Retro Runners/nb1dbfc_4.jpg","/productimgs/shoes/nbshoes/New Balance 1906-Team AwayGrey Retro Runners/nb1dbfc_5.jpg","/productimgs/shoes/nbshoes/New Balance 1906-Team AwayGrey Retro Runners/nb1dbfc_6.jpg","/productimgs/shoes/nbshoes/New Balance 1906-Team AwayGrey Retro Runners/nb1dbfc_7.jpg","/productimgs/shoes/nbshoes/New Balance 1906-Team AwayGrey Retro Runners/nb1dbfc_8.jpg","/productimgs/shoes/nbshoes/New Balance 1906-Team AwayGrey Retro Runners/nb1dbfc_9.jpg","/productimgs/shoes/nbshoes/New Balance 1906-Team AwayGrey Retro Runners/nb1dbfc_10.jpg","/productimgs/shoes/nbshoes/New Balance 1906-Team AwayGrey Retro Runners/nb1dbfc_11.jpg","/productimgs/shoes/nbshoes/New Balance 1906-Team AwayGrey Retro Runners/nb1dbfc_12.jpg"]
  },
  {
    id: "imn8e81",
    name: "Issey Miyake × Nb Mt10O-\"Sea Salt\" Hiking Sneakers 👟",
    description: "This designer collab MT10O features minimalist leather/mesh construction with barefoot-inspired EVA midsole and Vibram outsole, blending ISSEY MIYAKE's aesthetics with outdoor-ready functionality in a versatile \"Sea Salt\" hue. Women's sizes 36-41. #yupooshoes #yupoonb #newbalance #nb #mt10o",
    price: PriceInfo,
    categories: ["shoes","nb"],
    images: ["/productimgs/shoes/nbshoes/ISSEY MIYAKE NB MT10O-Sea Salt Hiking Sneakers/imn8e81_4.jpg","/productimgs/shoes/nbshoes/ISSEY MIYAKE NB MT10O-Sea Salt Hiking Sneakers/imn8e81_5.jpg","/productimgs/shoes/nbshoes/ISSEY MIYAKE NB MT10O-Sea Salt Hiking Sneakers/imn8e81_6.jpg","/productimgs/shoes/nbshoes/ISSEY MIYAKE NB MT10O-Sea Salt Hiking Sneakers/imn8e81_7.jpg","/productimgs/shoes/nbshoes/ISSEY MIYAKE NB MT10O-Sea Salt Hiking Sneakers/imn8e81_8.jpg","/productimgs/shoes/nbshoes/ISSEY MIYAKE NB MT10O-Sea Salt Hiking Sneakers/imn8e81_9.jpg","/productimgs/shoes/nbshoes/ISSEY MIYAKE NB MT10O-Sea Salt Hiking Sneakers/imn8e81_10.jpg","/productimgs/shoes/nbshoes/ISSEY MIYAKE NB MT10O-Sea Salt Hiking Sneakers/imn8e81_11.jpg","/productimgs/shoes/nbshoes/ISSEY MIYAKE NB MT10O-Sea Salt Hiking Sneakers/imn8e81_12.jpg"]
  },
  {
    id: "nb947fc",
    name: "New Balance 9060 - \"Silver Metallic\" Dad Shoes 👟",
    description: "The 9060 sneaker combines premium split leather with sandwich mesh, featuring 4-layer ABZORB cushioning and heel TPU for stability in a bold \"Silver Metallic\" colorway. Unisex sizes 36-46. #yupooshoes #yupoo #yupoonb #nb #newbalance #nb1906 #1906",
    price: PriceInfo,
    categories: ["shoes","nb"],
    images: ["/productimgs/shoes/nbshoes/New Balance 9060-Silver Metallic Dad Shoes/nb947fc_4.jpg","/productimgs/shoes/nbshoes/New Balance 9060-Silver Metallic Dad Shoes/nb947fc_5.jpg","/productimgs/shoes/nbshoes/New Balance 9060-Silver Metallic Dad Shoes/nb947fc_6.jpg","/productimgs/shoes/nbshoes/New Balance 9060-Silver Metallic Dad Shoes/nb947fc_7.jpg","/productimgs/shoes/nbshoes/New Balance 9060-Silver Metallic Dad Shoes/nb947fc_8.jpg","/productimgs/shoes/nbshoes/New Balance 9060-Silver Metallic Dad Shoes/nb947fc_9.jpg","/productimgs/shoes/nbshoes/New Balance 9060-Silver Metallic Dad Shoes/nb947fc_10.jpg","/productimgs/shoes/nbshoes/New Balance 9060-Silver Metallic Dad Shoes/nb947fc_11.jpg","/productimgs/shoes/nbshoes/New Balance 9060-Silver Metallic Dad Shoes/nb947fc_12.jpg"]
  },
  {
    id: "ysn8e63",
    name: "Yupoo Shoes:New Balance 2002 - Premium Retro Runners 👟",
    description: "The upgraded 2002 sneaker blends soft suede with breathable nylon mesh, featuring enhanced N-ERGY cushioning for all-day comfort in a timeless retro design that pairs perfectly with jeans or workwear. Available in sizes 36-46.5. #yupooshoes #yupoo #yupoonb #nb #newbalance #nb1906 #1906",
    price: PriceInfo,
    categories: ["shoes","nb"],
    images: ["/productimgs/shoes/nbshoes/New Balance 2002 - Premium Retro Runners/ysn8e63_4.jpg","/productimgs/shoes/nbshoes/New Balance 2002 - Premium Retro Runners/ysn8e63_5.jpg","/productimgs/shoes/nbshoes/New Balance 2002 - Premium Retro Runners/ysn8e63_6.jpg","/productimgs/shoes/nbshoes/New Balance 2002 - Premium Retro Runners/ysn8e63_7.jpg","/productimgs/shoes/nbshoes/New Balance 2002 - Premium Retro Runners/ysn8e63_8.jpg","/productimgs/shoes/nbshoes/New Balance 2002 - Premium Retro Runners/ysn8e63_9.jpg","/productimgs/shoes/nbshoes/New Balance 2002 - Premium Retro Runners/ysn8e63_10.jpg","/productimgs/shoes/nbshoes/New Balance 2002 - Premium Retro Runners/ysn8e63_11.jpg","/productimgs/shoes/nbshoes/New Balance 2002 - Premium Retro Runners/ysn8e63_12.jpg"]
  },
   {
    id: "nb9917a",
    name: "New Balance 9060 - Summer Retro Runners (U9060Jbe) 👟",
    description: "Inspired by nostalgic summer memories, these 9060 sneakers blend mesh and suede with space-grid detailing, featuring ABZORB cushioning to absorb impact while channeling vintage vibes. Sizes 36-45. #yupooshoes #yupoo #yupoonb #nb #newbalance #nb9060 #1906",
    price: PriceInfo,
    categories: ["shoes","nb"],
    images: ["/productimgs/shoes/nbshoes/New Balance 9060 - Summer Retro Runners U9060JBE/nb9917a_4.jpg","/productimgs/shoes/nbshoes/New Balance 9060 - Summer Retro Runners U9060JBE/nb9917a_5.jpg","/productimgs/shoes/nbshoes/New Balance 9060 - Summer Retro Runners U9060JBE/nb9917a_6.jpg","/productimgs/shoes/nbshoes/New Balance 9060 - Summer Retro Runners U9060JBE/nb9917a_7.jpg","/productimgs/shoes/nbshoes/New Balance 9060 - Summer Retro Runners U9060JBE/nb9917a_8.jpg","/productimgs/shoes/nbshoes/New Balance 9060 - Summer Retro Runners U9060JBE/nb9917a_9.jpg","/productimgs/shoes/nbshoes/New Balance 9060 - Summer Retro Runners U9060JBE/nb9917a_10.jpg","/productimgs/shoes/nbshoes/New Balance 9060 - Summer Retro Runners U9060JBE/nb9917a_11.jpg","/productimgs/shoes/nbshoes/New Balance 9060 - Summer Retro Runners U9060JBE/nb9917a_12.jpg"]
  },
  {
    id: "nbm4d4b",
    name: "New Balance Mr530 - Classic Dad Shoes \"Abzorb Cushioned\" 👟",
    description: "The MR530 sneaker combines premium fiber leather with breathable mesh, featuring a 3-layer sole with ABZORB cushioning for all-day comfort in a timeless dad shoe design trending on Xiaohongshu. Unisex sizes 36-45. #yupooshoes #yupoo #nb #nbmr530 #530 #ABZORB",
    price: PriceInfo,
    categories: ["shoes","nb"],
    images: ["/productimgs/shoes/nbshoes/New Balance MR530/nbm4d4b_4.jpg","/productimgs/shoes/nbshoes/New Balance MR530/nbm4d4b_5.jpg","/productimgs/shoes/nbshoes/New Balance MR530/nbm4d4b_6.jpg","/productimgs/shoes/nbshoes/New Balance MR530/nbm4d4b_7.jpg","/productimgs/shoes/nbshoes/New Balance MR530/nbm4d4b_8.jpg","/productimgs/shoes/nbshoes/New Balance MR530/nbm4d4b_9.jpg","/productimgs/shoes/nbshoes/New Balance MR530/nbm4d4b_10.jpg","/productimgs/shoes/nbshoes/New Balance MR530/nbm4d4b_11.jpg","/productimgs/shoes/nbshoes/New Balance MR530/nbm4d4b_12.jpg"]
  }, 
  {
    id: "g2s23f3",
    name: "Gucci 2025Ss - Silk Polo Shirt 👔",
    description: "Crafted from premium mulberry silk, this official Spring/Summer 2025 collection polo features a refined three-button placket and mini spread collar, delivering effortless Italian elegance with breathable luxury. Available in sizes M-3XL. #yupooclothing #yupoo #gucci #1965ss #clothing #Polo #shirt",
    price: PriceInfo,
    categories: ["clothing","gucci"],
    images: ["/productimgs/clothing/gucci/Gucci 2025SS - Silk Polo Shirt/g2s23f3_4.jpg","/productimgs/clothing/gucci/Gucci 2025SS - Silk Polo Shirt/g2s23f3_5.jpg","/productimgs/clothing/gucci/Gucci 2025SS - Silk Polo Shirt/g2s23f3_6.jpg","/productimgs/clothing/gucci/Gucci 2025SS - Silk Polo Shirt/g2s23f3_7.jpg","/productimgs/clothing/gucci/Gucci 2025SS - Silk Polo Shirt/g2s23f3_8.jpg","/productimgs/clothing/gucci/Gucci 2025SS - Silk Polo Shirt/g2s23f3_9.jpg","/productimgs/clothing/gucci/Gucci 2025SS - Silk Polo Shirt/g2s23f3_10.jpg","/productimgs/clothing/gucci/Gucci 2025SS - Silk Polo Shirt/g2s23f3_11.jpg","/productimgs/clothing/gucci/Gucci 2025SS - Silk Polo Shirt/g2s23f3_12.jpg"]
  },
  {
    id: "gpma14d",
    name: "Gucci P230 M945 - Heart Print Silk Shirt 👔",
    description: "Crafted from custom silk fabric, this Spring/Summer 2025 shirt features all-over brand heart prints with a chest pocket and spread collar for versatile styling. Unisex cut with original tags, sizes XS-XL. #yupoo #gucci #clothing #shirt",
    price: PriceInfo,
    categories: ["clothing","gucci"],
    images: ["/productimgs/clothing/gucci/Gucci P230 M945 - Heart Print Silk Shirt/gpma14d_4.jpg","/productimgs/clothing/gucci/Gucci P230 M945 - Heart Print Silk Shirt/gpma14d_5.jpg","/productimgs/clothing/gucci/Gucci P230 M945 - Heart Print Silk Shirt/gpma14d_6.jpg","/productimgs/clothing/gucci/Gucci P230 M945 - Heart Print Silk Shirt/gpma14d_7.jpg","/productimgs/clothing/gucci/Gucci P230 M945 - Heart Print Silk Shirt/gpma14d_8.jpg","/productimgs/clothing/gucci/Gucci P230 M945 - Heart Print Silk Shirt/gpma14d_9.jpg","/productimgs/clothing/gucci/Gucci P230 M945 - Heart Print Silk Shirt/gpma14d_10.jpg","/productimgs/clothing/gucci/Gucci P230 M945 - Heart Print Silk Shirt/gpma14d_11.jpg","/productimgs/clothing/gucci/Gucci P230 M945 - Heart Print Silk Shirt/gpma14d_12.jpg"]
  },
  {
    id: "gpmee93",
    name: "Gucci P230 M944 - 2024Ss Gg Print Shirt 👔",
    description: "This playful Spring/Summer 2024 shirt features head-to-toe interlocking GG prints with cartoon-inspired appliqué pockets and a relaxed unisex cut. Includes all original tags, sizes XS-XL. #yupooclothing #yupoo #gucci #clothing #2024SS #shirt",
    price: PriceInfo,
    categories: ["clothing","gucci"],
    images: ["/productimgs/clothing/gucci/Gucci P230 M944 - 2024SS GG Print Shirt/gpmee93_4.jpg","/productimgs/clothing/gucci/Gucci P230 M944 - 2024SS GG Print Shirt/gpmee93_5.jpg","/productimgs/clothing/gucci/Gucci P230 M944 - 2024SS GG Print Shirt/gpmee93_6.jpg","/productimgs/clothing/gucci/Gucci P230 M944 - 2024SS GG Print Shirt/gpmee93_7.jpg","/productimgs/clothing/gucci/Gucci P230 M944 - 2024SS GG Print Shirt/gpmee93_8.jpg","/productimgs/clothing/gucci/Gucci P230 M944 - 2024SS GG Print Shirt/gpmee93_9.jpg","/productimgs/clothing/gucci/Gucci P230 M944 - 2024SS GG Print Shirt/gpmee93_10.jpg","/productimgs/clothing/gucci/Gucci P230 M944 - 2024SS GG Print Shirt/gpmee93_11.jpg","/productimgs/clothing/gucci/Gucci P230 M944 - 2024SS GG Print Shirt/gpmee93_12.jpg"]
  },
  {
    id: "g1l8033",
    name: "Gucci 1965Ss - Luxury Silk Crewneck Tee 👕",
    description: "This premium silk-blend crewneck features Gucci's signature collar design with meticulous tailoring, crafted from imported lustrous fabric for breathable elegance. Original tags included, sizes M-4XL (model wears L at 176cm/70kg). #yupooclothing #yupoo #gucci #1965ss #clothing",
    price: PriceInfo,
    categories: ["clothing","gucci"],
    images: ["/productimgs/clothing/gucci/GUCCI 1965SS - Luxury Silk Crewneck Tee/g1l8033_4.jpg","/productimgs/clothing/gucci/GUCCI 1965SS - Luxury Silk Crewneck Tee/g1l8033_5.jpg","/productimgs/clothing/gucci/GUCCI 1965SS - Luxury Silk Crewneck Tee/g1l8033_6.jpg","/productimgs/clothing/gucci/GUCCI 1965SS - Luxury Silk Crewneck Tee/g1l8033_7.jpg","/productimgs/clothing/gucci/GUCCI 1965SS - Luxury Silk Crewneck Tee/g1l8033_8.jpg","/productimgs/clothing/gucci/GUCCI 1965SS - Luxury Silk Crewneck Tee/g1l8033_9.jpg","/productimgs/clothing/gucci/GUCCI 1965SS - Luxury Silk Crewneck Tee/g1l8033_10.jpg","/productimgs/clothing/gucci/GUCCI 1965SS - Luxury Silk Crewneck Tee/g1l8033_11.jpg","/productimgs/clothing/gucci/GUCCI 1965SS - Luxury Silk Crewneck Tee/g1l8033_12.jpg"]
  },
  {
    id: "g2s0503",
    name: "Gucci 2025 - Silk Short Sleeve Shirt 👕",
    description: "Crafted from premium imported mulberry silk, this 2025 short sleeve shirt delivers ultra-soft comfort with luxurious drape, featuring contemporary design details matching the official boutique collection. Available in sizes M-3XL.  #yupooclothing #yupoo #gucci #clothing #Polo #shirt",
    price: PriceInfo,
    categories: ["clothing","gucci"],
    images: ["/productimgs/clothing/gucci/Gucci 2025 - Silk Short Sleeve Shirt/g2s0503_4.jpg","/productimgs/clothing/gucci/Gucci 2025 - Silk Short Sleeve Shirt/g2s0503_5.jpg","/productimgs/clothing/gucci/Gucci 2025 - Silk Short Sleeve Shirt/g2s0503_6.jpg","/productimgs/clothing/gucci/Gucci 2025 - Silk Short Sleeve Shirt/g2s0503_7.jpg","/productimgs/clothing/gucci/Gucci 2025 - Silk Short Sleeve Shirt/g2s0503_8.jpg","/productimgs/clothing/gucci/Gucci 2025 - Silk Short Sleeve Shirt/g2s0503_9.jpg","/productimgs/clothing/gucci/Gucci 2025 - Silk Short Sleeve Shirt/g2s0503_10.jpg","/productimgs/clothing/gucci/Gucci 2025 - Silk Short Sleeve Shirt/g2s0503_11.jpg","/productimgs/clothing/gucci/Gucci 2025 - Silk Short Sleeve Shirt/g2s0503_12.jpg"]
  },
  {
    id: "gpmb5f1",
    name: "Gucci P180 M950 - Premium Shorts 🩳",
    description: "Crafted from exclusive custom fabric, these high-end shorts feature impeccable tailoring with subtle brand detailing for superior comfort and a flawless fit. Original tags included, sizes M-3XL. #yupoo #gucci #clothing #Shorts",
    price: PriceInfo,
    categories: ["clothing","gucci"],
    images: ["/productimgs/clothing/gucci/Gucci P180 M950 - Premium Shorts/gpmb5f1_4.jpg","/productimgs/clothing/gucci/Gucci P180 M950 - Premium Shorts/gpmb5f1_5.jpg","/productimgs/clothing/gucci/Gucci P180 M950 - Premium Shorts/gpmb5f1_6.jpg","/productimgs/clothing/gucci/Gucci P180 M950 - Premium Shorts/gpmb5f1_7.jpg","/productimgs/clothing/gucci/Gucci P180 M950 - Premium Shorts/gpmb5f1_8.jpg","/productimgs/clothing/gucci/Gucci P180 M950 - Premium Shorts/gpmb5f1_9.jpg","/productimgs/clothing/gucci/Gucci P180 M950 - Premium Shorts/gpmb5f1_10.jpg","/productimgs/clothing/gucci/Gucci P180 M950 - Premium Shorts/gpmb5f1_11.jpg","/productimgs/clothing/gucci/Gucci P180 M950 - Premium Shorts/gpmb5f1_12.jpg"]
  },
  {
    id: "ysl3df0",
    name: "Yupoo  Saint Laurent Solferino Large Box Leather Bag Red Cassandre Lock",
    description: "This elegant and spacious Saint Laurent bag boasts luxurious box leather, full leather lining, and a distinctive LE CASSANDRE lock closure with smooth rounded lines for a unique vintage look—perfect as a chic, statement accessory that elevates any outfit effortlessly.",
    price: PriceInfo,
    categories: ["bags","ysl"],
    images: ["/productimgs/20250607/Yupoo  Saint Laurent SOLFERINO Large Box Leather Bag Red CASSANDRE Lock/ysl3df0_3.jpg","/productimgs/20250607/Yupoo  Saint Laurent SOLFERINO Large Box Leather Bag Red CASSANDRE Lock/ysl3df0_4.jpg","/productimgs/20250607/Yupoo  Saint Laurent SOLFERINO Large Box Leather Bag Red CASSANDRE Lock/ysl3df0_5.jpg","/productimgs/20250607/Yupoo  Saint Laurent SOLFERINO Large Box Leather Bag Red CASSANDRE Lock/ysl3df0_6.jpg","/productimgs/20250607/Yupoo  Saint Laurent SOLFERINO Large Box Leather Bag Red CASSANDRE Lock/ysl3df0_7.jpg","/productimgs/20250607/Yupoo  Saint Laurent SOLFERINO Large Box Leather Bag Red CASSANDRE Lock/ysl3df0_8.jpg","/productimgs/20250607/Yupoo  Saint Laurent SOLFERINO Large Box Leather Bag Red CASSANDRE Lock/ysl3df0_9.jpg","/productimgs/20250607/Yupoo  Saint Laurent SOLFERINO Large Box Leather Bag Red CASSANDRE Lock/ysl3df0_10.jpg","/productimgs/20250607/Yupoo  Saint Laurent SOLFERINO Large Box Leather Bag Red CASSANDRE Lock/ysl3df0_12.jpg"]
  },
  {
    id: "yybf72b",
    name: "Yupoo Ysl Bags Saint Laurent Handbag",
    description: "NIKI shopping bag pleated retro oil wax leather Saint Laurent tote bag decorated with leather covered YSL initials shoulder and back shoulder bag, item number 577999. Size: 33x27x11.5 cm, 100% calfskin",
    price: PriceInfo,
    categories: ["bags","ysl"],
    images: ["/productimgs/20250607/Yupoo YSL bags Saint Laurent handbag black-577999/yybf72b_2.jpg","/productimgs/20250607/Yupoo YSL bags Saint Laurent handbag black-577999/yybf72b_3.jpg","/productimgs/20250607/Yupoo YSL bags Saint Laurent handbag black-577999/yybf72b_4.jpg","/productimgs/20250607/Yupoo YSL bags Saint Laurent handbag black-577999/yybf72b_5.jpg","/productimgs/20250607/Yupoo YSL bags Saint Laurent handbag black-577999/yybf72b_6.jpg","/productimgs/20250607/Yupoo YSL bags Saint Laurent handbag black-577999/yybf72b_7.jpg","/productimgs/20250607/Yupoo YSL bags Saint Laurent handbag black-577999/yybf72b_8.jpg","/productimgs/20250607/Yupoo YSL bags Saint Laurent handbag black-577999/yybf72b_9.jpg","/productimgs/20250607/Yupoo YSL bags Saint Laurent handbag black-577999/yybf72b_10.jpg"]
  },
  {
    id: "ysld1fe",
    name: "Yupoo  Saint Laurent Solferino Large Box Leather Bag Black Cassandre Lock",
    description: "This elegant and spacious Saint Laurent bag boasts luxurious box leather, full leather lining, and a distinctive LE CASSANDRE lock closure with smooth rounded lines for a unique vintage look—perfect as a chic, statement accessory that elevates any outfit effortlessly.",
    price: PriceInfo,
    categories: ["bags","ysl"],
    images: ["/productimgs/20250607/Yupoo  Saint Laurent SOLFERINO Large Box Leather Bag Black CASSANDRE Lock/ysld1fe_3.jpg","/productimgs/20250607/Yupoo  Saint Laurent SOLFERINO Large Box Leather Bag Black CASSANDRE Lock/ysld1fe_4.jpg","/productimgs/20250607/Yupoo  Saint Laurent SOLFERINO Large Box Leather Bag Black CASSANDRE Lock/ysld1fe_5.jpg","/productimgs/20250607/Yupoo  Saint Laurent SOLFERINO Large Box Leather Bag Black CASSANDRE Lock/ysld1fe_6.jpg","/productimgs/20250607/Yupoo  Saint Laurent SOLFERINO Large Box Leather Bag Black CASSANDRE Lock/ysld1fe_7.jpg","/productimgs/20250607/Yupoo  Saint Laurent SOLFERINO Large Box Leather Bag Black CASSANDRE Lock/ysld1fe_8.jpg","/productimgs/20250607/Yupoo  Saint Laurent SOLFERINO Large Box Leather Bag Black CASSANDRE Lock/ysld1fe_9.jpg","/productimgs/20250607/Yupoo  Saint Laurent SOLFERINO Large Box Leather Bag Black CASSANDRE Lock/ysld1fe_11.jpg"]
  },
  {
    id: "ysldbfd",
    name: "Yupoo  Saint Laurent Solferino Large Box Leather Black",
    description: "This elegant and spacious Saint Laurent bag boasts luxurious box leather, full leather lining, and a distinctive LE CASSANDRE lock closure with smooth rounded lines for a unique vintage look—perfect as a chic, statement accessory that elevates any outfit effortlessly.",
    price: PriceInfo,
    categories: ["bags","ysl"],
    images: ["/productimgs/20250607/Yupoo  Saint Laurent SOLFERINO Large Box Leather black/ysldbfd_3.jpg","/productimgs/20250607/Yupoo  Saint Laurent SOLFERINO Large Box Leather black/ysldbfd_4.jpg","/productimgs/20250607/Yupoo  Saint Laurent SOLFERINO Large Box Leather black/ysldbfd_5.jpg","/productimgs/20250607/Yupoo  Saint Laurent SOLFERINO Large Box Leather black/ysldbfd_6.jpg","/productimgs/20250607/Yupoo  Saint Laurent SOLFERINO Large Box Leather black/ysldbfd_7.jpg","/productimgs/20250607/Yupoo  Saint Laurent SOLFERINO Large Box Leather black/ysldbfd_8.jpg","/productimgs/20250607/Yupoo  Saint Laurent SOLFERINO Large Box Leather black/ysldbfd_9.jpg","/productimgs/20250607/Yupoo  Saint Laurent SOLFERINO Large Box Leather black/ysldbfd_10.jpg","/productimgs/20250607/Yupoo  Saint Laurent SOLFERINO Large Box Leather black/ysldbfd_11.jpg"]
  },
  {
    id: "yyv743c",
    name: "Yupoo Ysl Vintage Cloud Mini Leather Shoulder Black",
    description: "This stylish mini bag boasts a unique cloud shape with a soft chain strap, featuring ultra-comfortable original leather that smells divine and is lined with lambskin for a vintage elegant look—perfect for hand-carrying or shoulder-wearing as a must-have fashion statement that turns heads",
    price: PriceInfo,
    categories: ["bags","ysl"],
    images: ["/productimgs/20250607/Yupoo YSL Vintage Cloud Mini Leather Shoulder Black/yyv743c_3.jpg","/productimgs/20250607/Yupoo YSL Vintage Cloud Mini Leather Shoulder Black/yyv743c_4.jpg","/productimgs/20250607/Yupoo YSL Vintage Cloud Mini Leather Shoulder Black/yyv743c_5.jpg","/productimgs/20250607/Yupoo YSL Vintage Cloud Mini Leather Shoulder Black/yyv743c_6.jpg","/productimgs/20250607/Yupoo YSL Vintage Cloud Mini Leather Shoulder Black/yyv743c_7.jpg","/productimgs/20250607/Yupoo YSL Vintage Cloud Mini Leather Shoulder Black/yyv743c_8.jpg","/productimgs/20250607/Yupoo YSL Vintage Cloud Mini Leather Shoulder Black/yyv743c_9.jpg","/productimgs/20250607/Yupoo YSL Vintage Cloud Mini Leather Shoulder Black/yyv743c_10.jpg","/productimgs/20250607/Yupoo YSL Vintage Cloud Mini Leather Shoulder Black/yyv743c_11.jpg"]
  },
  {
    id: "yyv15bd",
    name: "Yupoo Ysl Vintage Cloud Mini Leather Shoulder",
    description: "This stylish mini bag boasts a unique cloud shape with a soft chain strap, featuring ultra-comfortable original leather that smells divine and is lined with lambskin for a vintage elegant look—perfect for hand-carrying or shoulder-wearing as a must-have fashion statement that turns heads. #yupoobags #yupooysl #yupoobag #yupooHandbag #yupooshoulderbag #SaintLaurent #shoulderbag #Handbag #Cardbag",
    price: PriceInfo,
    categories: ["bags","ysl"],
    images: ["/productimgs/20250607/Yupoo YSL Vintage Cloud Mini Leather Shoulder White/yyv15bd_3.jpg","/productimgs/20250607/Yupoo YSL Vintage Cloud Mini Leather Shoulder White/yyv15bd_4.jpg","/productimgs/20250607/Yupoo YSL Vintage Cloud Mini Leather Shoulder White/yyv15bd_5.jpg","/productimgs/20250607/Yupoo YSL Vintage Cloud Mini Leather Shoulder White/yyv15bd_6.jpg","/productimgs/20250607/Yupoo YSL Vintage Cloud Mini Leather Shoulder White/yyv15bd_7.jpg","/productimgs/20250607/Yupoo YSL Vintage Cloud Mini Leather Shoulder White/yyv15bd_8.jpg","/productimgs/20250607/Yupoo YSL Vintage Cloud Mini Leather Shoulder White/yyv15bd_9.jpg","/productimgs/20250607/Yupoo YSL Vintage Cloud Mini Leather Shoulder White/yyv15bd_10.jpg","/productimgs/20250607/Yupoo YSL Vintage Cloud Mini Leather Shoulder White/yyv15bd_11.jpg"]
  },
  {
    id: "ybh0207",
    name: "Yupoo Bags - Hermes Rafia Straw Tote - Summer Beach Essential 🧺",
    description: "This authentic Hermes raffia tote is handwoven using traditional techniques, featuring a trapezoidal shape (40cm top width/23cm base/30cm height) perfect for beach escapes and city strolls. Each piece requires 18 hours of artisan craftsmanship. #yupoobags #hermes #bag #yupoo",
    price: PriceInfo,
    categories: ["bags","hermes"],
    images: ["/productimgs/bags/Hermes/Yupoo Bags - Hermes Rafia Straw Tote - Summer Beach Essential/ybh0207_4.jpg","/productimgs/bags/Hermes/Yupoo Bags - Hermes Rafia Straw Tote - Summer Beach Essential/ybh0207_5.jpg","/productimgs/bags/Hermes/Yupoo Bags - Hermes Rafia Straw Tote - Summer Beach Essential/ybh0207_6.jpg","/productimgs/bags/Hermes/Yupoo Bags - Hermes Rafia Straw Tote - Summer Beach Essential/ybh0207_7.jpg","/productimgs/bags/Hermes/Yupoo Bags - Hermes Rafia Straw Tote - Summer Beach Essential/ybh0207_8.jpg","/productimgs/bags/Hermes/Yupoo Bags - Hermes Rafia Straw Tote - Summer Beach Essential/ybh0207_9.jpg","/productimgs/bags/Hermes/Yupoo Bags - Hermes Rafia Straw Tote - Summer Beach Essential/ybh0207_10.jpg","/productimgs/bags/Hermes/Yupoo Bags - Hermes Rafia Straw Tote - Summer Beach Essential/ybh0207_11.jpg","/productimgs/bags/Hermes/Yupoo Bags - Hermes Rafia Straw Tote - Summer Beach Essential/ybh0207_12.jpg"]
  },
  {
    id: "ybhe576",
    name: "Yupoo Bags - Hermes Rafia Straw Tote - Summer Essential 🧺",
    description: "This official Hermes woven raffia tote features artisanal hand-weaving techniques in a trapezoidal silhouette (40cm top width/23cm base/30cm height), perfect for beach getaways and urban styling. Each piece requires 18 hours of craftsmanship. #yupoobags #hermes #bag #yupoo",
    price: PriceInfo,
    categories: ["bags","hermes"],
    images: ["/productimgs/bags/Hermes/Yupoo Bags - Hermes Rafia Straw Tote - Summer Essential/ybhe576_4.jpg","/productimgs/bags/Hermes/Yupoo Bags - Hermes Rafia Straw Tote - Summer Essential/ybhe576_5.jpg","/productimgs/bags/Hermes/Yupoo Bags - Hermes Rafia Straw Tote - Summer Essential/ybhe576_6.jpg","/productimgs/bags/Hermes/Yupoo Bags - Hermes Rafia Straw Tote - Summer Essential/ybhe576_7.jpg","/productimgs/bags/Hermes/Yupoo Bags - Hermes Rafia Straw Tote - Summer Essential/ybhe576_8.jpg","/productimgs/bags/Hermes/Yupoo Bags - Hermes Rafia Straw Tote - Summer Essential/ybhe576_9.jpg","/productimgs/bags/Hermes/Yupoo Bags - Hermes Rafia Straw Tote - Summer Essential/ybhe576_10.jpg","/productimgs/bags/Hermes/Yupoo Bags - Hermes Rafia Straw Tote - Summer Essential/ybhe576_11.jpg","/productimgs/bags/Hermes/Yupoo Bags - Hermes Rafia Straw Tote - Summer Essential/ybhe576_12.jpg"]
  },

  {
    id: "yll2713",
    name: "Yupoo Lv Liv Pochette Pink Monogram Denim Bag M83008",
    description: "This LV Liv Pochette pink handbag features vintage Monogram Denim fabric for a stylish new-season look, with detachable chain and adjustable strap for comfortable underarm carry.",
    price: PriceInfo,
    categories: ["bags","lv"],
    images: ["/productimgs/bags/Lv/Yupoo LV Liv Pochette Pink Monogram Denim Bag M83008/yll2713_3.jpg","/productimgs/bags/Lv/Yupoo LV Liv Pochette Pink Monogram Denim Bag M83008/yll2713_4.jpg","/productimgs/bags/Lv/Yupoo LV Liv Pochette Pink Monogram Denim Bag M83008/yll2713_5.jpg","/productimgs/bags/Lv/Yupoo LV Liv Pochette Pink Monogram Denim Bag M83008/yll2713_6.jpg","/productimgs/bags/Lv/Yupoo LV Liv Pochette Pink Monogram Denim Bag M83008/yll2713_7.jpg","/productimgs/bags/Lv/Yupoo LV Liv Pochette Pink Monogram Denim Bag M83008/yll2713_8.jpg","/productimgs/bags/Lv/Yupoo LV Liv Pochette Pink Monogram Denim Bag M83008/yll2713_9.jpg","/productimgs/bags/Lv/Yupoo LV Liv Pochette Pink Monogram Denim Bag M83008/yll2713_10.jpg","/productimgs/bags/Lv/Yupoo LV Liv Pochette Pink Monogram Denim Bag M83008/yll2713_11.jpg"]
  },
  {
    id: "ylk6b5f",
    name: "Yupoo Lv Keepit Damier Azur Waist Bag M14806",
    description: "This Keepit waist bag debuted at the LV SS25 runway, crafted in Damier Azur canvas with eye-catching metallic hardware and an adjustable strap for versatile wear.",
    price: PriceInfo,
    categories: ["bags","lv"],
    images: ["/productimgs/bags/Lv/Yupoo LV Keepit Damier Azur Waist Bag M14806/ylk6b5f_3.jpg","/productimgs/bags/Lv/Yupoo LV Keepit Damier Azur Waist Bag M14806/ylk6b5f_4.jpg","/productimgs/bags/Lv/Yupoo LV Keepit Damier Azur Waist Bag M14806/ylk6b5f_5.jpg","/productimgs/bags/Lv/Yupoo LV Keepit Damier Azur Waist Bag M14806/ylk6b5f_6.jpg","/productimgs/bags/Lv/Yupoo LV Keepit Damier Azur Waist Bag M14806/ylk6b5f_7.jpg","/productimgs/bags/Lv/Yupoo LV Keepit Damier Azur Waist Bag M14806/ylk6b5f_8.jpg","/productimgs/bags/Lv/Yupoo LV Keepit Damier Azur Waist Bag M14806/ylk6b5f_9.jpg","/productimgs/bags/Lv/Yupoo LV Keepit Damier Azur Waist Bag M14806/ylk6b5f_10.jpg","/productimgs/bags/Lv/Yupoo LV Keepit Damier Azur Waist Bag M14806/ylk6b5f_11.jpg"]
  },
  {
    id: "lxm675a",
    name: "Lv X Murakami Speedy Yupoo 2025 Bag M13233",
    description: "This supple lambskin LV Coussin BB bag features embossed Monogram and a detachable chain for versatile styling.",
    price: PriceInfo,
    categories: ["bags","lv"],
    images: ["/productimgs/bags/Lv/LV x Murakami Speedy Yupoo 2025 Bag M13233/lxm675a_3.jpg","/productimgs/bags/Lv/LV x Murakami Speedy Yupoo 2025 Bag M13233/lxm675a_4.jpg","/productimgs/bags/Lv/LV x Murakami Speedy Yupoo 2025 Bag M13233/lxm675a_5.jpg","/productimgs/bags/Lv/LV x Murakami Speedy Yupoo 2025 Bag M13233/lxm675a_6.jpg","/productimgs/bags/Lv/LV x Murakami Speedy Yupoo 2025 Bag M13233/lxm675a_7.jpg","/productimgs/bags/Lv/LV x Murakami Speedy Yupoo 2025 Bag M13233/lxm675a_8.jpg","/productimgs/bags/Lv/LV x Murakami Speedy Yupoo 2025 Bag M13233/lxm675a_9.jpg","/productimgs/bags/Lv/LV x Murakami Speedy Yupoo 2025 Bag M13233/lxm675a_10.jpg","/productimgs/bags/Lv/LV x Murakami Speedy Yupoo 2025 Bag M13233/lxm675a_11.jpg"]
  },
  {
    id: "yll22a4",
    name: "Yupoo Lv Liv Pochette Pink Monogram Denim Bag M14159",
    description: "This LV Liv Pochette pink handbag features vintage Monogram Denim fabric for a stylish new-season look, with detachable chain and adjustable strap for comfortable underarm carry.",
    price: PriceInfo,
    categories: ["bags","lv"],
    images: ["/productimgs/bags/Lv/Yupoo LV Liv Pochette Pink Monogram Denim Bag M14159/yll22a4_3.jpg","/productimgs/bags/Lv/Yupoo LV Liv Pochette Pink Monogram Denim Bag M14159/yll22a4_4.jpg","/productimgs/bags/Lv/Yupoo LV Liv Pochette Pink Monogram Denim Bag M14159/yll22a4_5.jpg","/productimgs/bags/Lv/Yupoo LV Liv Pochette Pink Monogram Denim Bag M14159/yll22a4_6.jpg","/productimgs/bags/Lv/Yupoo LV Liv Pochette Pink Monogram Denim Bag M14159/yll22a4_7.jpg","/productimgs/bags/Lv/Yupoo LV Liv Pochette Pink Monogram Denim Bag M14159/yll22a4_8.jpg","/productimgs/bags/Lv/Yupoo LV Liv Pochette Pink Monogram Denim Bag M14159/yll22a4_9.jpg","/productimgs/bags/Lv/Yupoo LV Liv Pochette Pink Monogram Denim Bag M14159/yll22a4_10.jpg","/productimgs/bags/Lv/Yupoo LV Liv Pochette Pink Monogram Denim Bag M14159/yll22a4_11.jpg"]
  },
  {
    id: "yls3d09",
    name: "Yupoo Lv Speedy Soft 30 Monogram Denim Yupoo Bags M13344",
    description: "This supple lambskin LV Coussin BB bag features embossed Monogram and a detachable chain for versatile styling.",
    price: PriceInfo,
    categories: ["bags","lv"],
    images: ["/productimgs/bags/Lv/Yupoo LV Speedy Soft 30 Monogram Denim Yupoo Bags M13344/yls3d09_3.jpg","/productimgs/bags/Lv/Yupoo LV Speedy Soft 30 Monogram Denim Yupoo Bags M13344/yls3d09_4.jpg","/productimgs/bags/Lv/Yupoo LV Speedy Soft 30 Monogram Denim Yupoo Bags M13344/yls3d09_5.jpg","/productimgs/bags/Lv/Yupoo LV Speedy Soft 30 Monogram Denim Yupoo Bags M13344/yls3d09_6.jpg","/productimgs/bags/Lv/Yupoo LV Speedy Soft 30 Monogram Denim Yupoo Bags M13344/yls3d09_7.jpg","/productimgs/bags/Lv/Yupoo LV Speedy Soft 30 Monogram Denim Yupoo Bags M13344/yls3d09_8.jpg","/productimgs/bags/Lv/Yupoo LV Speedy Soft 30 Monogram Denim Yupoo Bags M13344/yls3d09_9.jpg","/productimgs/bags/Lv/Yupoo LV Speedy Soft 30 Monogram Denim Yupoo Bags M13344/yls3d09_10.jpg","/productimgs/bags/Lv/Yupoo LV Speedy Soft 30 Monogram Denim Yupoo Bags M13344/yls3d09_11.jpg"]
  },
  {
    id: "ylhfef9",
    name: "Yupoo Lv Handbag Lv Capucines Malletage Bag",
    description: "This Capucines MM bag reimagines LV trunk-inspired heritage with signature Malletage geometric hardware for sophisticated style.",
    price: PriceInfo,
    categories: ["bags","lv"],
    images: ["/productimgs/bags/Lv/Yupoo LV Handbag LV Capucines Malletage Bag/ylhfef9_3.jpg","/productimgs/bags/Lv/Yupoo LV Handbag LV Capucines Malletage Bag/ylhfef9_4.jpg","/productimgs/bags/Lv/Yupoo LV Handbag LV Capucines Malletage Bag/ylhfef9_5.jpg","/productimgs/bags/Lv/Yupoo LV Handbag LV Capucines Malletage Bag/ylhfef9_6.jpg","/productimgs/bags/Lv/Yupoo LV Handbag LV Capucines Malletage Bag/ylhfef9_7.jpg","/productimgs/bags/Lv/Yupoo LV Handbag LV Capucines Malletage Bag/ylhfef9_8.jpg","/productimgs/bags/Lv/Yupoo LV Handbag LV Capucines Malletage Bag/ylhfef9_9.jpg","/productimgs/bags/Lv/Yupoo LV Handbag LV Capucines Malletage Bag/ylhfef9_10.jpg","/productimgs/bags/Lv/Yupoo LV Handbag LV Capucines Malletage Bag/ylhfef9_11.jpg"]
  },
  {
    id: "ylh1810",
    name: "Yupoo Lv Handbag Lv Capucines Malletage Bag M12751",
    description: "This Capucines MM bag reimagines LV trunk-inspired heritage with signature Malletage geometric hardware for sophisticated style.",
    price: PriceInfo,
    categories: ["bags","lv"],
    images: ["/productimgs/bags/Lv/Yupoo LV Handbag LV Capucines Malletage Bag M12751/ylh1810_3.jpg","/productimgs/bags/Lv/Yupoo LV Handbag LV Capucines Malletage Bag M12751/ylh1810_4.jpg","/productimgs/bags/Lv/Yupoo LV Handbag LV Capucines Malletage Bag M12751/ylh1810_5.jpg","/productimgs/bags/Lv/Yupoo LV Handbag LV Capucines Malletage Bag M12751/ylh1810_6.jpg","/productimgs/bags/Lv/Yupoo LV Handbag LV Capucines Malletage Bag M12751/ylh1810_7.jpg","/productimgs/bags/Lv/Yupoo LV Handbag LV Capucines Malletage Bag M12751/ylh1810_8.jpg","/productimgs/bags/Lv/Yupoo LV Handbag LV Capucines Malletage Bag M12751/ylh1810_9.jpg","/productimgs/bags/Lv/Yupoo LV Handbag LV Capucines Malletage Bag M12751/ylh1810_10.jpg","/productimgs/bags/Lv/Yupoo LV Handbag LV Capucines Malletage Bag M12751/ylh1810_11.jpg"]
  },
  {
    id: "lxmf1ad",
    name: "Lv X Murakami Speedy Yupoo 2025 Bag M25218",
    description: "This supple lambskin LV Coussin BB bag features embossed Monogram and a detachable chain for versatile styling.",
    price: PriceInfo,
    categories: ["bags","lv"],
    images: ["/productimgs/bags/Lv/LV x Murakami Speedy Yupoo 2025 Bag M25218/lxmf1ad_3.jpg","/productimgs/bags/Lv/LV x Murakami Speedy Yupoo 2025 Bag M25218/lxmf1ad_4.jpg","/productimgs/bags/Lv/LV x Murakami Speedy Yupoo 2025 Bag M25218/lxmf1ad_5.jpg","/productimgs/bags/Lv/LV x Murakami Speedy Yupoo 2025 Bag M25218/lxmf1ad_6.jpg","/productimgs/bags/Lv/LV x Murakami Speedy Yupoo 2025 Bag M25218/lxmf1ad_7.jpg","/productimgs/bags/Lv/LV x Murakami Speedy Yupoo 2025 Bag M25218/lxmf1ad_8.jpg","/productimgs/bags/Lv/LV x Murakami Speedy Yupoo 2025 Bag M25218/lxmf1ad_9.jpg","/productimgs/bags/Lv/LV x Murakami Speedy Yupoo 2025 Bag M25218/lxmf1ad_10.jpg","/productimgs/bags/Lv/LV x Murakami Speedy Yupoo 2025 Bag M25218/lxmf1ad_11.jpg"]
  },
  {
    id: "ylka83a",
    name: "Yupoo Lv Keepit Damier Azur Waist Bag M43644-2",
    description: "This Keepit waist bag debuted at the LV SS25 runway, crafted in Damier Azur canvas with eye-catching metallic hardware and an adjustable strap for versatile wear.",
    price: PriceInfo,
    categories: ["bags","lv"],
    images: ["/productimgs/bags/Lv/Yupoo LV Keepit Damier Azur Waist Bag M43644-2/ylka83a_3.jpg","/productimgs/bags/Lv/Yupoo LV Keepit Damier Azur Waist Bag M43644-2/ylka83a_4.jpg","/productimgs/bags/Lv/Yupoo LV Keepit Damier Azur Waist Bag M43644-2/ylka83a_5.jpg","/productimgs/bags/Lv/Yupoo LV Keepit Damier Azur Waist Bag M43644-2/ylka83a_6.jpg","/productimgs/bags/Lv/Yupoo LV Keepit Damier Azur Waist Bag M43644-2/ylka83a_7.jpg","/productimgs/bags/Lv/Yupoo LV Keepit Damier Azur Waist Bag M43644-2/ylka83a_8.jpg","/productimgs/bags/Lv/Yupoo LV Keepit Damier Azur Waist Bag M43644-2/ylka83a_9.jpg","/productimgs/bags/Lv/Yupoo LV Keepit Damier Azur Waist Bag M43644-2/ylka83a_10.jpg","/productimgs/bags/Lv/Yupoo LV Keepit Damier Azur Waist Bag M43644-2/ylka83a_11.jpg"]
  },
  {
    id: "ylk6652",
    name: "Yupoo Lv Keepit Damier Azur Waist Bag N00230",
    description: "This Keepit waist bag debuted at the LV SS25 runway, crafted in Damier Azur canvas with eye-catching metallic hardware and an adjustable strap for versatile wear.",
    price: PriceInfo,
    categories: ["bags","lv"],
    images: ["/productimgs/bags/Lv/Yupoo LV Keepit Damier Azur Waist Bag N00230/ylk6652_3.jpg","/productimgs/bags/Lv/Yupoo LV Keepit Damier Azur Waist Bag N00230/ylk6652_4.jpg","/productimgs/bags/Lv/Yupoo LV Keepit Damier Azur Waist Bag N00230/ylk6652_5.jpg","/productimgs/bags/Lv/Yupoo LV Keepit Damier Azur Waist Bag N00230/ylk6652_6.jpg","/productimgs/bags/Lv/Yupoo LV Keepit Damier Azur Waist Bag N00230/ylk6652_7.jpg","/productimgs/bags/Lv/Yupoo LV Keepit Damier Azur Waist Bag N00230/ylk6652_8.jpg","/productimgs/bags/Lv/Yupoo LV Keepit Damier Azur Waist Bag N00230/ylk6652_9.jpg","/productimgs/bags/Lv/Yupoo LV Keepit Damier Azur Waist Bag N00230/ylk6652_10.jpg","/productimgs/bags/Lv/Yupoo LV Keepit Damier Azur Waist Bag N00230/ylk6652_11.jpg"]
  },
  {
    id: "ylsf786",
    name: "Yupoo Lv Speedy Soft 30 Monogram Denim Yupoo Bags N87627",
    description: "This supple lambskin LV Coussin BB bag features embossed Monogram and a detachable chain for versatile styling.",
    price: PriceInfo,
    categories: ["bags","lv"],
    images: ["/productimgs/bags/Lv/Yupoo LV Speedy Soft 30 Monogram Denim Yupoo Bags N87627/ylsf786_3.jpg","/productimgs/bags/Lv/Yupoo LV Speedy Soft 30 Monogram Denim Yupoo Bags N87627/ylsf786_4.jpg","/productimgs/bags/Lv/Yupoo LV Speedy Soft 30 Monogram Denim Yupoo Bags N87627/ylsf786_5.jpg","/productimgs/bags/Lv/Yupoo LV Speedy Soft 30 Monogram Denim Yupoo Bags N87627/ylsf786_6.jpg","/productimgs/bags/Lv/Yupoo LV Speedy Soft 30 Monogram Denim Yupoo Bags N87627/ylsf786_7.jpg","/productimgs/bags/Lv/Yupoo LV Speedy Soft 30 Monogram Denim Yupoo Bags N87627/ylsf786_8.jpg","/productimgs/bags/Lv/Yupoo LV Speedy Soft 30 Monogram Denim Yupoo Bags N87627/ylsf786_9.jpg","/productimgs/bags/Lv/Yupoo LV Speedy Soft 30 Monogram Denim Yupoo Bags N87627/ylsf786_10.jpg","/productimgs/bags/Lv/Yupoo LV Speedy Soft 30 Monogram Denim Yupoo Bags N87627/ylsf786_11.jpg"]
  },
  {
    id: "ylk5a0b",
    name: "Yupoo Lv Keepit Damier Azur Waist Bag M43644",
    description: "This Keepit waist bag debuted at the LV SS25 runway, crafted in Damier Azur canvas with eye-catching metallic hardware and an adjustable strap for versatile wear.",
    price: PriceInfo,
    categories: ["bags","lv"],
    images: ["/productimgs/bags/Lv/Yupoo LV Keepit Damier Azur Waist Bag M43644/ylk5a0b_3.jpg","/productimgs/bags/Lv/Yupoo LV Keepit Damier Azur Waist Bag M43644/ylk5a0b_4.jpg","/productimgs/bags/Lv/Yupoo LV Keepit Damier Azur Waist Bag M43644/ylk5a0b_5.jpg","/productimgs/bags/Lv/Yupoo LV Keepit Damier Azur Waist Bag M43644/ylk5a0b_6.jpg","/productimgs/bags/Lv/Yupoo LV Keepit Damier Azur Waist Bag M43644/ylk5a0b_7.jpg","/productimgs/bags/Lv/Yupoo LV Keepit Damier Azur Waist Bag M43644/ylk5a0b_8.jpg","/productimgs/bags/Lv/Yupoo LV Keepit Damier Azur Waist Bag M43644/ylk5a0b_9.jpg","/productimgs/bags/Lv/Yupoo LV Keepit Damier Azur Waist Bag M43644/ylk5a0b_10.jpg","/productimgs/bags/Lv/Yupoo LV Keepit Damier Azur Waist Bag M43644/ylk5a0b_11.jpg"]
  },
  {
    id: "ylsd8ea",
    name: "Yupoo Lv Speedy Soft 30 Monogram Denim Yupoo Bags M25670",
    description: "This supple lambskin LV Coussin BB bag features embossed Monogram and a detachable chain for versatile styling.",
    price: PriceInfo,
    categories: ["bags","lv"],
    images: ["/productimgs/bags/Lv/Yupoo LV Speedy Soft 30 Monogram Denim Yupoo Bags M25670 /ylsd8ea_3.jpg","/productimgs/bags/Lv/Yupoo LV Speedy Soft 30 Monogram Denim Yupoo Bags M25670 /ylsd8ea_4.jpg","/productimgs/bags/Lv/Yupoo LV Speedy Soft 30 Monogram Denim Yupoo Bags M25670 /ylsd8ea_5.jpg","/productimgs/bags/Lv/Yupoo LV Speedy Soft 30 Monogram Denim Yupoo Bags M25670 /ylsd8ea_6.jpg","/productimgs/bags/Lv/Yupoo LV Speedy Soft 30 Monogram Denim Yupoo Bags M25670 /ylsd8ea_7.jpg","/productimgs/bags/Lv/Yupoo LV Speedy Soft 30 Monogram Denim Yupoo Bags M25670 /ylsd8ea_8.jpg","/productimgs/bags/Lv/Yupoo LV Speedy Soft 30 Monogram Denim Yupoo Bags M25670 /ylsd8ea_9.jpg","/productimgs/bags/Lv/Yupoo LV Speedy Soft 30 Monogram Denim Yupoo Bags M25670 /ylsd8ea_10.jpg","/productimgs/bags/Lv/Yupoo LV Speedy Soft 30 Monogram Denim Yupoo Bags M25670 /ylsd8ea_11.jpg"]
  },
  {
    id: "lxmc132",
    name: "Lv X Murakami Speedy Yupoo 2025 Bag M59396",
    description: "This supple lambskin LV Coussin BB bag features embossed Monogram and a detachable chain for versatile styling.",
    price: PriceInfo,
    categories: ["bags","lv"],
    images: ["/productimgs/bags/Lv/LV x Murakami Speedy Yupoo 2025 Bag M59396/lxmc132_3.jpg","/productimgs/bags/Lv/LV x Murakami Speedy Yupoo 2025 Bag M59396/lxmc132_4.jpg","/productimgs/bags/Lv/LV x Murakami Speedy Yupoo 2025 Bag M59396/lxmc132_5.jpg","/productimgs/bags/Lv/LV x Murakami Speedy Yupoo 2025 Bag M59396/lxmc132_6.jpg","/productimgs/bags/Lv/LV x Murakami Speedy Yupoo 2025 Bag M59396/lxmc132_7.jpg","/productimgs/bags/Lv/LV x Murakami Speedy Yupoo 2025 Bag M59396/lxmc132_8.jpg","/productimgs/bags/Lv/LV x Murakami Speedy Yupoo 2025 Bag M59396/lxmc132_9.jpg","/productimgs/bags/Lv/LV x Murakami Speedy Yupoo 2025 Bag M59396/lxmc132_10.jpg","/productimgs/bags/Lv/LV x Murakami Speedy Yupoo 2025 Bag M59396/lxmc132_11.jpg"]
  },
  {
    id: "lpc8c37",
    name: "Lv Pochette Camille Monogram Reimagined Yupoo Bags M13566",
    description: "This LV Pochette Camille bag revives the original Spring-Summer 2000 runway design in Monogram canvas, boasting an S-Lock clasp, detachable chain with LV Circle tag, and contrast accents.",
    price: PriceInfo,
    categories: ["bags","lv"],
    images: ["/productimgs/bags/Lv/LV Pochette Camille Monogram Reimagined Yupoo Bags M13566 /lpc8c37_3.jpg","/productimgs/bags/Lv/LV Pochette Camille Monogram Reimagined Yupoo Bags M13566 /lpc8c37_4.jpg","/productimgs/bags/Lv/LV Pochette Camille Monogram Reimagined Yupoo Bags M13566 /lpc8c37_5.jpg","/productimgs/bags/Lv/LV Pochette Camille Monogram Reimagined Yupoo Bags M13566 /lpc8c37_6.jpg","/productimgs/bags/Lv/LV Pochette Camille Monogram Reimagined Yupoo Bags M13566 /lpc8c37_7.jpg","/productimgs/bags/Lv/LV Pochette Camille Monogram Reimagined Yupoo Bags M13566 /lpc8c37_8.jpg","/productimgs/bags/Lv/LV Pochette Camille Monogram Reimagined Yupoo Bags M13566 /lpc8c37_9.jpg","/productimgs/bags/Lv/LV Pochette Camille Monogram Reimagined Yupoo Bags M13566 /lpc8c37_10.jpg","/productimgs/bags/Lv/LV Pochette Camille Monogram Reimagined Yupoo Bags M13566 /lpc8c37_11.jpg"]
  },
  {
    id: "lxm9a5b",
    name: "Lv X Murakami Speedy Yupoo 2025 Bag M20770",
    description: "This supple lambskin LV Coussin BB bag features embossed Monogram and a detachable chain for versatile styling.",
    price: PriceInfo,
    categories: ["bags","lv"],
    images: ["/productimgs/bags/Lv/LV x Murakami Speedy Yupoo 2025 Bag M20770/lxm9a5b_3.jpg","/productimgs/bags/Lv/LV x Murakami Speedy Yupoo 2025 Bag M20770/lxm9a5b_4.jpg","/productimgs/bags/Lv/LV x Murakami Speedy Yupoo 2025 Bag M20770/lxm9a5b_5.jpg","/productimgs/bags/Lv/LV x Murakami Speedy Yupoo 2025 Bag M20770/lxm9a5b_6.jpg","/productimgs/bags/Lv/LV x Murakami Speedy Yupoo 2025 Bag M20770/lxm9a5b_7.jpg","/productimgs/bags/Lv/LV x Murakami Speedy Yupoo 2025 Bag M20770/lxm9a5b_8.jpg","/productimgs/bags/Lv/LV x Murakami Speedy Yupoo 2025 Bag M20770/lxm9a5b_9.jpg","/productimgs/bags/Lv/LV x Murakami Speedy Yupoo 2025 Bag M20770/lxm9a5b_10.jpg","/productimgs/bags/Lv/LV x Murakami Speedy Yupoo 2025 Bag M20770/lxm9a5b_11.jpg"]
  },
  {
    id: "lxm1889",
    name: "Lv X Murakami Speedy Yupoo 2025 Bag M14174",
    description: "This reissued Speedy Bandoulière 25 from Louis Vuitton x Murakami features Monogram canvas with animated motifs and a detachable strap.",
    price: PriceInfo,
    categories: ["bags","lv"],
    images: ["/productimgs/bags/Lv/LV x Murakami Speedy Yupoo 2025 Bag M14174/lxm1889_3.jpg","/productimgs/bags/Lv/LV x Murakami Speedy Yupoo 2025 Bag M14174/lxm1889_4.jpg","/productimgs/bags/Lv/LV x Murakami Speedy Yupoo 2025 Bag M14174/lxm1889_5.jpg","/productimgs/bags/Lv/LV x Murakami Speedy Yupoo 2025 Bag M14174/lxm1889_6.jpg","/productimgs/bags/Lv/LV x Murakami Speedy Yupoo 2025 Bag M14174/lxm1889_7.jpg","/productimgs/bags/Lv/LV x Murakami Speedy Yupoo 2025 Bag M14174/lxm1889_8.jpg","/productimgs/bags/Lv/LV x Murakami Speedy Yupoo 2025 Bag M14174/lxm1889_9.jpg","/productimgs/bags/Lv/LV x Murakami Speedy Yupoo 2025 Bag M14174/lxm1889_10.jpg","/productimgs/bags/Lv/LV x Murakami Speedy Yupoo 2025 Bag M14174/lxm1889_11.jpg"]
  },
  {
    id: "ylh4cd7",
    name: "Yupoo Lv Handbag Lv Capucines Malletage Bag M11964",
    description: "This Capucines MM bag reimagines LV trunk-inspired heritage with signature Malletage geometric hardware for sophisticated style.",
    price: PriceInfo,
    categories: ["bags","lv"],
    images: ["/productimgs/bags/Lv/Yupoo LV Handbag LV Capucines Malletage Bag M11964/ylh4cd7_3.jpg","/productimgs/bags/Lv/Yupoo LV Handbag LV Capucines Malletage Bag M11964/ylh4cd7_4.jpg","/productimgs/bags/Lv/Yupoo LV Handbag LV Capucines Malletage Bag M11964/ylh4cd7_5.jpg","/productimgs/bags/Lv/Yupoo LV Handbag LV Capucines Malletage Bag M11964/ylh4cd7_6.jpg","/productimgs/bags/Lv/Yupoo LV Handbag LV Capucines Malletage Bag M11964/ylh4cd7_7.jpg","/productimgs/bags/Lv/Yupoo LV Handbag LV Capucines Malletage Bag M11964/ylh4cd7_8.jpg","/productimgs/bags/Lv/Yupoo LV Handbag LV Capucines Malletage Bag M11964/ylh4cd7_9.jpg","/productimgs/bags/Lv/Yupoo LV Handbag LV Capucines Malletage Bag M11964/ylh4cd7_10.jpg","/productimgs/bags/Lv/Yupoo LV Handbag LV Capucines Malletage Bag M11964/ylh4cd7_11.jpg"]
  },
  {
    id: "lxm5fd3",
    name: "Lv X Murakami Speedy Yupoo 2025 Bag M59598",
    description: "This supple lambskin LV Coussin BB bag features embossed Monogram and a detachable chain for versatile styling.",
    price: PriceInfo,
    categories: ["bags","lv"],
    images: ["/productimgs/bags/Lv/LV x Murakami Speedy Yupoo 2025 Bag M59598/lxm5fd3_3.jpg","/productimgs/bags/Lv/LV x Murakami Speedy Yupoo 2025 Bag M59598/lxm5fd3_4.jpg","/productimgs/bags/Lv/LV x Murakami Speedy Yupoo 2025 Bag M59598/lxm5fd3_5.jpg","/productimgs/bags/Lv/LV x Murakami Speedy Yupoo 2025 Bag M59598/lxm5fd3_6.jpg","/productimgs/bags/Lv/LV x Murakami Speedy Yupoo 2025 Bag M59598/lxm5fd3_7.jpg","/productimgs/bags/Lv/LV x Murakami Speedy Yupoo 2025 Bag M59598/lxm5fd3_8.jpg","/productimgs/bags/Lv/LV x Murakami Speedy Yupoo 2025 Bag M59598/lxm5fd3_9.jpg","/productimgs/bags/Lv/LV x Murakami Speedy Yupoo 2025 Bag M59598/lxm5fd3_10.jpg","/productimgs/bags/Lv/LV x Murakami Speedy Yupoo 2025 Bag M59598/lxm5fd3_11.jpg"]
  },
  {
    id: "ylh9e03",
    name: "Yupoo Lv Handbag Lv Capucines Malletage Bag Pink",
    description: "This Capucines MM bag reimagines LV trunk-inspired heritage with signature Malletage geometric hardware for sophisticated style.",
    price: PriceInfo,
    categories: ["bags","lv"],
    images: ["/productimgs/bags/Lv/Yupoo LV Handbag LV Capucines Malletage Bag Pink/ylh9e03_3.jpg","/productimgs/bags/Lv/Yupoo LV Handbag LV Capucines Malletage Bag Pink/ylh9e03_4.jpg","/productimgs/bags/Lv/Yupoo LV Handbag LV Capucines Malletage Bag Pink/ylh9e03_5.jpg","/productimgs/bags/Lv/Yupoo LV Handbag LV Capucines Malletage Bag Pink/ylh9e03_6.jpg","/productimgs/bags/Lv/Yupoo LV Handbag LV Capucines Malletage Bag Pink/ylh9e03_7.jpg","/productimgs/bags/Lv/Yupoo LV Handbag LV Capucines Malletage Bag Pink/ylh9e03_8.jpg","/productimgs/bags/Lv/Yupoo LV Handbag LV Capucines Malletage Bag Pink/ylh9e03_9.jpg","/productimgs/bags/Lv/Yupoo LV Handbag LV Capucines Malletage Bag Pink/ylh9e03_10.jpg","/productimgs/bags/Lv/Yupoo LV Handbag LV Capucines Malletage Bag Pink/ylh9e03_11.jpg"]
  },
  {
    id: "lxmef94",
    name: "Lv X Murakami Speedy Yupoo 2025 Bag M59389",
    description: "This supple lambskin LV Coussin BB bag features embossed Monogram and a detachable chain for versatile styling.",
    price: PriceInfo,
    categories: ["bags","lv"],
    images: ["/productimgs/bags/Lv/LV x Murakami Speedy Yupoo 2025 Bag M59389/lxmef94_3.jpg","/productimgs/bags/Lv/LV x Murakami Speedy Yupoo 2025 Bag M59389/lxmef94_4.jpg","/productimgs/bags/Lv/LV x Murakami Speedy Yupoo 2025 Bag M59389/lxmef94_5.jpg","/productimgs/bags/Lv/LV x Murakami Speedy Yupoo 2025 Bag M59389/lxmef94_6.jpg","/productimgs/bags/Lv/LV x Murakami Speedy Yupoo 2025 Bag M59389/lxmef94_7.jpg","/productimgs/bags/Lv/LV x Murakami Speedy Yupoo 2025 Bag M59389/lxmef94_8.jpg","/productimgs/bags/Lv/LV x Murakami Speedy Yupoo 2025 Bag M59389/lxmef94_9.jpg","/productimgs/bags/Lv/LV x Murakami Speedy Yupoo 2025 Bag M59389/lxmef94_10.jpg","/productimgs/bags/Lv/LV x Murakami Speedy Yupoo 2025 Bag M59389/lxmef94_11.jpg"]
  },
  {
    id: "lxmc7be",
    name: "Lv X Murakami Speedy Yupoo 2025 Bag M11401",
    description: "This supple lambskin LV Coussin BB bag features embossed Monogram and a detachable chain for versatile styling.",
    price: PriceInfo,
    categories: ["bags","lv"],
    images: ["/productimgs/bags/Lv/LV x Murakami Speedy Yupoo 2025 Bag M11401/lxmc7be_3.jpg","/productimgs/bags/Lv/LV x Murakami Speedy Yupoo 2025 Bag M11401/lxmc7be_4.jpg","/productimgs/bags/Lv/LV x Murakami Speedy Yupoo 2025 Bag M11401/lxmc7be_5.jpg","/productimgs/bags/Lv/LV x Murakami Speedy Yupoo 2025 Bag M11401/lxmc7be_6.jpg","/productimgs/bags/Lv/LV x Murakami Speedy Yupoo 2025 Bag M11401/lxmc7be_7.jpg","/productimgs/bags/Lv/LV x Murakami Speedy Yupoo 2025 Bag M11401/lxmc7be_8.jpg","/productimgs/bags/Lv/LV x Murakami Speedy Yupoo 2025 Bag M11401/lxmc7be_9.jpg","/productimgs/bags/Lv/LV x Murakami Speedy Yupoo 2025 Bag M11401/lxmc7be_10.jpg","/productimgs/bags/Lv/LV x Murakami Speedy Yupoo 2025 Bag M11401/lxmc7be_11.jpg"]
  },
  {
    id: "lxm597f",
    name: "Lv X Murakami Speedy Yupoo 2025 Bag M21259",
    description: "This supple lambskin LV Coussin BB bag features embossed Monogram and a detachable chain for versatile styling.",
    price: PriceInfo,
    categories: ["bags","lv"],
    images: ["/productimgs/bags/Lv/LV x Murakami Speedy Yupoo 2025 Bag M21259/lxm597f_3.jpg","/productimgs/bags/Lv/LV x Murakami Speedy Yupoo 2025 Bag M21259/lxm597f_4.jpg","/productimgs/bags/Lv/LV x Murakami Speedy Yupoo 2025 Bag M21259/lxm597f_5.jpg","/productimgs/bags/Lv/LV x Murakami Speedy Yupoo 2025 Bag M21259/lxm597f_6.jpg","/productimgs/bags/Lv/LV x Murakami Speedy Yupoo 2025 Bag M21259/lxm597f_7.jpg","/productimgs/bags/Lv/LV x Murakami Speedy Yupoo 2025 Bag M21259/lxm597f_8.jpg","/productimgs/bags/Lv/LV x Murakami Speedy Yupoo 2025 Bag M21259/lxm597f_9.jpg","/productimgs/bags/Lv/LV x Murakami Speedy Yupoo 2025 Bag M21259/lxm597f_10.jpg","/productimgs/bags/Lv/LV x Murakami Speedy Yupoo 2025 Bag M21259/lxm597f_11.jpg"]
  },
  {
    id: "ylh219d",
    name: "Yupoo Lv Handbag Lv Capucines Malletage Bag M12135",
    description: "This Capucines MM bag reimagines LV trunk-inspired heritage with signature Malletage geometric hardware for sophisticated style.",
    price: PriceInfo,
    categories: ["bags","lv"],
    images: ["/productimgs/bags/Lv/Yupoo LV Handbag LV Capucines Malletage Bag M12135/ylh219d_3.jpg","/productimgs/bags/Lv/Yupoo LV Handbag LV Capucines Malletage Bag M12135/ylh219d_4.jpg","/productimgs/bags/Lv/Yupoo LV Handbag LV Capucines Malletage Bag M12135/ylh219d_5.jpg","/productimgs/bags/Lv/Yupoo LV Handbag LV Capucines Malletage Bag M12135/ylh219d_6.jpg","/productimgs/bags/Lv/Yupoo LV Handbag LV Capucines Malletage Bag M12135/ylh219d_7.jpg","/productimgs/bags/Lv/Yupoo LV Handbag LV Capucines Malletage Bag M12135/ylh219d_8.jpg","/productimgs/bags/Lv/Yupoo LV Handbag LV Capucines Malletage Bag M12135/ylh219d_9.jpg","/productimgs/bags/Lv/Yupoo LV Handbag LV Capucines Malletage Bag M12135/ylh219d_10.jpg","/productimgs/bags/Lv/Yupoo LV Handbag LV Capucines Malletage Bag M12135/ylh219d_11.jpg"]
  },
  {
    id: "yls7c92",
    name: "Yupoo Lv Speedy Soft 30 Monogram Denim Yupoo Bags M40391",
    description: "This supple lambskin LV Coussin BB bag features embossed Monogram and a detachable chain for versatile styling.",
    price: PriceInfo,
    categories: ["bags","lv"],
    images: ["/productimgs/bags/Lv/Yupoo LV Speedy Soft 30 Monogram Denim Yupoo Bags M40391/yls7c92_3.jpg","/productimgs/bags/Lv/Yupoo LV Speedy Soft 30 Monogram Denim Yupoo Bags M40391/yls7c92_4.jpg","/productimgs/bags/Lv/Yupoo LV Speedy Soft 30 Monogram Denim Yupoo Bags M40391/yls7c92_5.jpg","/productimgs/bags/Lv/Yupoo LV Speedy Soft 30 Monogram Denim Yupoo Bags M40391/yls7c92_6.jpg","/productimgs/bags/Lv/Yupoo LV Speedy Soft 30 Monogram Denim Yupoo Bags M40391/yls7c92_7.jpg","/productimgs/bags/Lv/Yupoo LV Speedy Soft 30 Monogram Denim Yupoo Bags M40391/yls7c92_8.jpg","/productimgs/bags/Lv/Yupoo LV Speedy Soft 30 Monogram Denim Yupoo Bags M40391/yls7c92_9.jpg","/productimgs/bags/Lv/Yupoo LV Speedy Soft 30 Monogram Denim Yupoo Bags M40391/yls7c92_10.jpg","/productimgs/bags/Lv/Yupoo LV Speedy Soft 30 Monogram Denim Yupoo Bags M40391/yls7c92_11.jpg"]
  },
  {
    id: "ylb4ef0",
    name: "Yupoo Lv Bags Vintage Lv Monogram Denim Crossbody 44464M",
    description: "This rare M95050 crossbody bag features vintage denim with patina leather trim, embodying enduring style as a discontinued collector's piece.",
    price: PriceInfo,
    categories: ["bags","lv"],
    images: ["/productimgs/bags/Lv/Yupoo LV Bags Vintage LV Monogram Denim Crossbody 44464M/ylb4ef0_3.jpg","/productimgs/bags/Lv/Yupoo LV Bags Vintage LV Monogram Denim Crossbody 44464M/ylb4ef0_4.jpg","/productimgs/bags/Lv/Yupoo LV Bags Vintage LV Monogram Denim Crossbody 44464M/ylb4ef0_5.jpg","/productimgs/bags/Lv/Yupoo LV Bags Vintage LV Monogram Denim Crossbody 44464M/ylb4ef0_6.jpg","/productimgs/bags/Lv/Yupoo LV Bags Vintage LV Monogram Denim Crossbody 44464M/ylb4ef0_7.jpg","/productimgs/bags/Lv/Yupoo LV Bags Vintage LV Monogram Denim Crossbody 44464M/ylb4ef0_8.jpg","/productimgs/bags/Lv/Yupoo LV Bags Vintage LV Monogram Denim Crossbody 44464M/ylb4ef0_9.jpg","/productimgs/bags/Lv/Yupoo LV Bags Vintage LV Monogram Denim Crossbody 44464M/ylb4ef0_10.jpg","/productimgs/bags/Lv/Yupoo LV Bags Vintage LV Monogram Denim Crossbody 44464M/ylb4ef0_11.jpg"]
  },
  {
    id: "nbm82ae",
    name: "New Balance Mt10 Barefoot Shoes For Urban Comfort 👟🌆",
    description: "Discover the New Balance MT10 series, featuring lightweight barefoot shoes designed for urban commuting and casual wear. With a thin sole for natural ground feel, these shoes offer excellent traction and durability, making them perfect for running or everyday activities. Experience the perfect blend of style and functionality with the MT10OAD1124! #newbalance #districtveision #nb #yupoo #yupooshoes",
    price: PriceInfo,
    categories: ["shoes","nb"],
    images: ["/productimgs/shoes/nbshoes/New Balance MT10 Barefoot Shoes for Urban Comfort/nbm82ae_4.jpg","/productimgs/shoes/nbshoes/New Balance MT10 Barefoot Shoes for Urban Comfort/nbm82ae_5.jpg","/productimgs/shoes/nbshoes/New Balance MT10 Barefoot Shoes for Urban Comfort/nbm82ae_6.jpg","/productimgs/shoes/nbshoes/New Balance MT10 Barefoot Shoes for Urban Comfort/nbm82ae_7.jpg","/productimgs/shoes/nbshoes/New Balance MT10 Barefoot Shoes for Urban Comfort/nbm82ae_8.jpg","/productimgs/shoes/nbshoes/New Balance MT10 Barefoot Shoes for Urban Comfort/nbm82ae_9.jpg","/productimgs/shoes/nbshoes/New Balance MT10 Barefoot Shoes for Urban Comfort/nbm82ae_10.jpg","/productimgs/shoes/nbshoes/New Balance MT10 Barefoot Shoes for Urban Comfort/nbm82ae_11.jpg","/productimgs/shoes/nbshoes/New Balance MT10 Barefoot Shoes for Urban Comfort/nbm82ae_12.jpg"]
  },
  {
    id: "nbx9e6b",
    name: "New Balance X District Vision Sc Elite V4 🏃‍♂️ Ultra-Light Running Shoes",
    description: "Discover the New Balance x District Vision SC Elite v4, a cutting-edge collaboration blending urban style with advanced running technology—featuring ultra-light 3D knit mesh, FuelCell cushioning, and a full-length TPU plate for exceptional energy return, these sleek black sneakers are designed for all-day comfort and peak marathon performance, making them perfect for athletes and city explorers alike. #newbalance #districtveision #nb #",
    price: PriceInfo,
    categories: ["shoes","nb"],
    images: ["/productimgs/shoes/nbshoes/New Balance x District Vision SC Elite v4 Ultra-Light Running Shoes/nbx9e6b_4.jpg","/productimgs/shoes/nbshoes/New Balance x District Vision SC Elite v4 Ultra-Light Running Shoes/nbx9e6b_5.jpg","/productimgs/shoes/nbshoes/New Balance x District Vision SC Elite v4 Ultra-Light Running Shoes/nbx9e6b_6.jpg","/productimgs/shoes/nbshoes/New Balance x District Vision SC Elite v4 Ultra-Light Running Shoes/nbx9e6b_7.jpg","/productimgs/shoes/nbshoes/New Balance x District Vision SC Elite v4 Ultra-Light Running Shoes/nbx9e6b_8.jpg","/productimgs/shoes/nbshoes/New Balance x District Vision SC Elite v4 Ultra-Light Running Shoes/nbx9e6b_9.jpg"]
  },
  {
    id: "imx9d93",
    name: "Issey Miyake X New Balance Mt10O Stylish Comfort Shoes 👟🌿",
    description: "Introducing the New Balance MT10O, a collaboration with ISSEY MIYAKE that combines style and comfort. Inspired by the concept of barefoot movement, these shoes mimic the foot's natural shape while retaining trail running elements. The lightweight mesh and soft leather upper ensure breathability and quality, while the Vibram outsole provides exceptional grip on various terrains. With a snug fit and a 4mm drop for a natural feel, experience the ground beneath you in ultimate comfort! #newbalance #districtveision #nb #yupoo #yupooshoes",
    price: PriceInfo,
    categories: ["shoes","nb"],
    images: ["/productimgs/shoes/nbshoes/ISSEY MIYAKE x New Balance MT10O Stylish Comfort Shoes/imx9d93_4.jpg","/productimgs/shoes/nbshoes/ISSEY MIYAKE x New Balance MT10O Stylish Comfort Shoes/imx9d93_5.jpg","/productimgs/shoes/nbshoes/ISSEY MIYAKE x New Balance MT10O Stylish Comfort Shoes/imx9d93_6.jpg","/productimgs/shoes/nbshoes/ISSEY MIYAKE x New Balance MT10O Stylish Comfort Shoes/imx9d93_7.jpg","/productimgs/shoes/nbshoes/ISSEY MIYAKE x New Balance MT10O Stylish Comfort Shoes/imx9d93_8.jpg","/productimgs/shoes/nbshoes/ISSEY MIYAKE x New Balance MT10O Stylish Comfort Shoes/imx9d93_9.jpg","/productimgs/shoes/nbshoes/ISSEY MIYAKE x New Balance MT10O Stylish Comfort Shoes/imx9d93_10.jpg","/productimgs/shoes/nbshoes/ISSEY MIYAKE x New Balance MT10O Stylish Comfort Shoes/imx9d93_11.jpg","/productimgs/shoes/nbshoes/ISSEY MIYAKE x New Balance MT10O Stylish Comfort Shoes/imx9d93_12.jpg"]
  },
  {
    id: "ldv26a7",
    name: "Lightweight District Vision X New Balance Rc Elite V2 Shoes 👟✨",
    description: "Discover the upgraded District Vision x New Balance FuelCell RC Elite V2, featuring ultra-lightweight 3D knitted mesh and carbon fiber technology for ultimate comfort. Designed for both style and performance, these shoes showcase unique hand-drawn patterns and embody the \"Center for Inner Peace\" philosophy. Perfect for casual wear or running, they blend innovation with artistic flair! #newbalance #districtveision #nb #",
    price: PriceInfo,
    categories: ["shoes","nb"],
    images: ["/productimgs/shoes/nbshoes/Lightweight District Vision x New Balance RC Elite V2 Shoes/ldv26a7_4.jpg","/productimgs/shoes/nbshoes/Lightweight District Vision x New Balance RC Elite V2 Shoes/ldv26a7_5.jpg","/productimgs/shoes/nbshoes/Lightweight District Vision x New Balance RC Elite V2 Shoes/ldv26a7_6.jpg","/productimgs/shoes/nbshoes/Lightweight District Vision x New Balance RC Elite V2 Shoes/ldv26a7_7.jpg","/productimgs/shoes/nbshoes/Lightweight District Vision x New Balance RC Elite V2 Shoes/ldv26a7_8.jpg","/productimgs/shoes/nbshoes/Lightweight District Vision x New Balance RC Elite V2 Shoes/ldv26a7_9.jpg","/productimgs/shoes/nbshoes/Lightweight District Vision x New Balance RC Elite V2 Shoes/ldv26a7_10.jpg","/productimgs/shoes/nbshoes/Lightweight District Vision x New Balance RC Elite V2 Shoes/ldv26a7_11.jpg","/productimgs/shoes/nbshoes/Lightweight District Vision x New Balance RC Elite V2 Shoes/ldv26a7_12.jpg"]
  },
  {
    id: "yfe9124",
    name: "Yupoo Fog Essentials Pullover Hoodie Beige",
    description: "Authentic Yupoo - Expertly Verified and Platform Certified.",
    price: PriceInfo,
    categories: ["clothing","foge"],
    images: ["/productimgs/clothing/fogessentials/Yupoo FOG ESSENTIALS Pullover Hoodie Beige/yfe9124_3.jpg","/productimgs/clothing/fogessentials/Yupoo FOG ESSENTIALS Pullover Hoodie Beige/yfe9124_4.jpg","/productimgs/clothing/fogessentials/Yupoo FOG ESSENTIALS Pullover Hoodie Beige/yfe9124_5.jpg","/productimgs/clothing/fogessentials/Yupoo FOG ESSENTIALS Pullover Hoodie Beige/yfe9124_6.jpg","/productimgs/clothing/fogessentials/Yupoo FOG ESSENTIALS Pullover Hoodie Beige/yfe9124_7.jpg","/productimgs/clothing/fogessentials/Yupoo FOG ESSENTIALS Pullover Hoodie Beige/yfe9124_8.jpg","/productimgs/clothing/fogessentials/Yupoo FOG ESSENTIALS Pullover Hoodie Beige/yfe9124_9.jpg","/productimgs/clothing/fogessentials/Yupoo FOG ESSENTIALS Pullover Hoodie Beige/yfe9124_10.jpg","/productimgs/clothing/fogessentials/Yupoo FOG ESSENTIALS Pullover Hoodie Beige/yfe9124_11.jpg"]
  },
  {
    id: "yfea151",
    name: "Yupoo Fog Essentials Shorts 160Sp244135F",
    description: "Authentic Yupoo - Expertly Verified and Platform Certified.\nSKU:160SP244135F\nMaterial:\nPolyester Colour: Light green",
    price: PriceInfo,
    categories: ["clothing","foge"],
    images: ["/productimgs/clothing/fogessentials/Yupoo FOG ESSENTIALS Shorts 160SP244135F/yfea151_3.jpg","/productimgs/clothing/fogessentials/Yupoo FOG ESSENTIALS Shorts 160SP244135F/yfea151_4.jpg","/productimgs/clothing/fogessentials/Yupoo FOG ESSENTIALS Shorts 160SP244135F/yfea151_5.jpg","/productimgs/clothing/fogessentials/Yupoo FOG ESSENTIALS Shorts 160SP244135F/yfea151_6.jpg","/productimgs/clothing/fogessentials/Yupoo FOG ESSENTIALS Shorts 160SP244135F/yfea151_7.jpg","/productimgs/clothing/fogessentials/Yupoo FOG ESSENTIALS Shorts 160SP244135F/yfea151_8.jpg","/productimgs/clothing/fogessentials/Yupoo FOG ESSENTIALS Shorts 160SP244135F/yfea151_9.jpg","/productimgs/clothing/fogessentials/Yupoo FOG ESSENTIALS Shorts 160SP244135F/yfea151_10.jpg","/productimgs/clothing/fogessentials/Yupoo FOG ESSENTIALS Shorts 160SP244135F/yfea151_11.jpg"]
  },
  {
    id: "yfecc60",
    name: "Yupoo Fog Essentials Pullover Hoodie Black",
    description: "Authentic Yupoo - Expertly Verified and Platform Certified.\nFOG-FW18-84",
    price: PriceInfo,
    categories: ["clothing","foge"],
    images: ["/productimgs/clothing/fogessentials/Yupoo FOG ESSENTIALS Pullover Hoodie Black/yfecc60_3.jpg","/productimgs/clothing/fogessentials/Yupoo FOG ESSENTIALS Pullover Hoodie Black/yfecc60_4.jpg","/productimgs/clothing/fogessentials/Yupoo FOG ESSENTIALS Pullover Hoodie Black/yfecc60_5.jpg","/productimgs/clothing/fogessentials/Yupoo FOG ESSENTIALS Pullover Hoodie Black/yfecc60_6.jpg","/productimgs/clothing/fogessentials/Yupoo FOG ESSENTIALS Pullover Hoodie Black/yfecc60_7.jpg","/productimgs/clothing/fogessentials/Yupoo FOG ESSENTIALS Pullover Hoodie Black/yfecc60_8.jpg","/productimgs/clothing/fogessentials/Yupoo FOG ESSENTIALS Pullover Hoodie Black/yfecc60_9.jpg","/productimgs/clothing/fogessentials/Yupoo FOG ESSENTIALS Pullover Hoodie Black/yfecc60_10.jpg","/productimgs/clothing/fogessentials/Yupoo FOG ESSENTIALS Pullover Hoodie Black/yfecc60_11.jpg"]
  },
  {
    id: "yfe58dd",
    name: "Yupoo Fog Essentials Short Sleeve Special Edition Obsidian Black",
    description: "Authentic Yupoo - Expertly Verified and Platform Certified.\nColor：Obsidian Black\nSKU:125BT242007F",
    price: PriceInfo,
    categories: ["clothing","foge"],
    images: ["/productimgs/clothing/fogessentials/Yupoo FOG ESSENTIALS Short Sleeve Special Edition Obsidian Black/yfe58dd_3.jpg","/productimgs/clothing/fogessentials/Yupoo FOG ESSENTIALS Short Sleeve Special Edition Obsidian Black/yfe58dd_4.jpg","/productimgs/clothing/fogessentials/Yupoo FOG ESSENTIALS Short Sleeve Special Edition Obsidian Black/yfe58dd_5.jpg","/productimgs/clothing/fogessentials/Yupoo FOG ESSENTIALS Short Sleeve Special Edition Obsidian Black/yfe58dd_6.jpg","/productimgs/clothing/fogessentials/Yupoo FOG ESSENTIALS Short Sleeve Special Edition Obsidian Black/yfe58dd_7.jpg","/productimgs/clothing/fogessentials/Yupoo FOG ESSENTIALS Short Sleeve Special Edition Obsidian Black/yfe58dd_8.jpg","/productimgs/clothing/fogessentials/Yupoo FOG ESSENTIALS Short Sleeve Special Edition Obsidian Black/yfe58dd_9.jpg","/productimgs/clothing/fogessentials/Yupoo FOG ESSENTIALS Short Sleeve Special Edition Obsidian Black/yfe58dd_10.jpg","/productimgs/clothing/fogessentials/Yupoo FOG ESSENTIALS Short Sleeve Special Edition Obsidian Black/yfe58dd_11.jpg"]
  },
  {
    id: "yfe2cb3",
    name: "Yupoo Fog Essentials Short Sleeve Special Edition Amber Gold",
    description: "Authentic Yupoo - Expertly Verified and Platform Certified. \nColor：Amber Gold \nSKU:125BT242000F",
    price: PriceInfo,
    categories: ["clothing","foge"],
    images: ["/productimgs/clothing/fogessentials/Yupoo FOG ESSENTIALS Short Sleeve Special Edition Amber Gold/yfe2cb3_3.jpg","/productimgs/clothing/fogessentials/Yupoo FOG ESSENTIALS Short Sleeve Special Edition Amber Gold/yfe2cb3_4.jpg","/productimgs/clothing/fogessentials/Yupoo FOG ESSENTIALS Short Sleeve Special Edition Amber Gold/yfe2cb3_5.jpg","/productimgs/clothing/fogessentials/Yupoo FOG ESSENTIALS Short Sleeve Special Edition Amber Gold/yfe2cb3_6.jpg","/productimgs/clothing/fogessentials/Yupoo FOG ESSENTIALS Short Sleeve Special Edition Amber Gold/yfe2cb3_7.jpg","/productimgs/clothing/fogessentials/Yupoo FOG ESSENTIALS Short Sleeve Special Edition Amber Gold/yfe2cb3_8.jpg","/productimgs/clothing/fogessentials/Yupoo FOG ESSENTIALS Short Sleeve Special Edition Amber Gold/yfe2cb3_9.jpg","/productimgs/clothing/fogessentials/Yupoo FOG ESSENTIALS Short Sleeve Special Edition Amber Gold/yfe2cb3_10.jpg","/productimgs/clothing/fogessentials/Yupoo FOG ESSENTIALS Short Sleeve Special Edition Amber Gold/yfe2cb3_11.jpg"]
  },
  {
    id: "yfebadc",
    name: "Yupoo Fog Essentials Short Sleeve Special Edition Orchid Purple",
    description: "Authentic Yupoo - Expertly Verified and Platform Certified.\nColor：Orchid Purple\nSKU:125BT242006F",
    price: PriceInfo,
    categories: ["clothing","foge"],
    images: ["/productimgs/clothing/fogessentials/Yupoo FOG ESSENTIALS Short Sleeve Special Edition Orchid Purple/yfebadc_3.jpg","/productimgs/clothing/fogessentials/Yupoo FOG ESSENTIALS Short Sleeve Special Edition Orchid Purple/yfebadc_4.jpg","/productimgs/clothing/fogessentials/Yupoo FOG ESSENTIALS Short Sleeve Special Edition Orchid Purple/yfebadc_5.jpg","/productimgs/clothing/fogessentials/Yupoo FOG ESSENTIALS Short Sleeve Special Edition Orchid Purple/yfebadc_6.jpg","/productimgs/clothing/fogessentials/Yupoo FOG ESSENTIALS Short Sleeve Special Edition Orchid Purple/yfebadc_7.jpg","/productimgs/clothing/fogessentials/Yupoo FOG ESSENTIALS Short Sleeve Special Edition Orchid Purple/yfebadc_8.jpg","/productimgs/clothing/fogessentials/Yupoo FOG ESSENTIALS Short Sleeve Special Edition Orchid Purple/yfebadc_9.jpg","/productimgs/clothing/fogessentials/Yupoo FOG ESSENTIALS Short Sleeve Special Edition Orchid Purple/yfebadc_10.jpg","/productimgs/clothing/fogessentials/Yupoo FOG ESSENTIALS Short Sleeve Special Edition Orchid Purple/yfebadc_11.jpg"]
  },
  {
    id: "yfe3c37",
    name: "Yupoo Fog Essentials Short Sleeve Special Edition Crimson Light Red",
    description: "Authentic Yupoo - Expertly Verified and Platform Certified.\nColor：Crimson light Red\nSKU:125BT242003F",
    price: PriceInfo,
    categories: ["clothing","foge"],
    images: ["/productimgs/clothing/fogessentials/Yupoo FOG ESSENTIALS Short Sleeve Special Edition Crimson light Red/yfe3c37_3.jpg","/productimgs/clothing/fogessentials/Yupoo FOG ESSENTIALS Short Sleeve Special Edition Crimson light Red/yfe3c37_4.jpg","/productimgs/clothing/fogessentials/Yupoo FOG ESSENTIALS Short Sleeve Special Edition Crimson light Red/yfe3c37_5.jpg","/productimgs/clothing/fogessentials/Yupoo FOG ESSENTIALS Short Sleeve Special Edition Crimson light Red/yfe3c37_6.jpg","/productimgs/clothing/fogessentials/Yupoo FOG ESSENTIALS Short Sleeve Special Edition Crimson light Red/yfe3c37_7.jpg","/productimgs/clothing/fogessentials/Yupoo FOG ESSENTIALS Short Sleeve Special Edition Crimson light Red/yfe3c37_8.jpg","/productimgs/clothing/fogessentials/Yupoo FOG ESSENTIALS Short Sleeve Special Edition Crimson light Red/yfe3c37_9.jpg","/productimgs/clothing/fogessentials/Yupoo FOG ESSENTIALS Short Sleeve Special Edition Crimson light Red/yfe3c37_10.jpg","/productimgs/clothing/fogessentials/Yupoo FOG ESSENTIALS Short Sleeve Special Edition Crimson light Red/yfe3c37_11.jpg"]
  },
  {
    id: "yfe3a9c",
    name: "Yupoo Fog Essentials Pullover Hoodie White",
    description: "Authentic Yupoo - Expertly Verified and Platform Certified.\nFOG-FW18-84",
    price: PriceInfo,
    categories: ["clothing","foge"],
    images: ["/productimgs/clothing/fogessentials/Yupoo FOG ESSENTIALS Pullover Hoodie White/yfe3a9c_3.jpg","/productimgs/clothing/fogessentials/Yupoo FOG ESSENTIALS Pullover Hoodie White/yfe3a9c_4.jpg","/productimgs/clothing/fogessentials/Yupoo FOG ESSENTIALS Pullover Hoodie White/yfe3a9c_5.jpg","/productimgs/clothing/fogessentials/Yupoo FOG ESSENTIALS Pullover Hoodie White/yfe3a9c_6.jpg","/productimgs/clothing/fogessentials/Yupoo FOG ESSENTIALS Pullover Hoodie White/yfe3a9c_7.jpg","/productimgs/clothing/fogessentials/Yupoo FOG ESSENTIALS Pullover Hoodie White/yfe3a9c_8.jpg","/productimgs/clothing/fogessentials/Yupoo FOG ESSENTIALS Pullover Hoodie White/yfe3a9c_9.jpg","/productimgs/clothing/fogessentials/Yupoo FOG ESSENTIALS Pullover Hoodie White/yfe3a9c_10.jpg","/productimgs/clothing/fogessentials/Yupoo FOG ESSENTIALS Pullover Hoodie White/yfe3a9c_11.jpg"]
  },
  {
    id: "yfe01a3",
    name: "Yupoo Fog Essentials Short Sleeve Special Edition  Black",
    description: "Authentic Yupoo - Expertly Verified and Platform Certified.\nColor：Obsidian Black\nSKU:125BT242007F",
    price: PriceInfo,
    categories: ["clothing","foge"],
    images: ["/productimgs/clothing/fogessentials/Yupoo FOG ESSENTIALS Short Sleeve Special Edition  Black/yfe01a3_3.jpg","/productimgs/clothing/fogessentials/Yupoo FOG ESSENTIALS Short Sleeve Special Edition  Black/yfe01a3_4.jpg","/productimgs/clothing/fogessentials/Yupoo FOG ESSENTIALS Short Sleeve Special Edition  Black/yfe01a3_5.jpg","/productimgs/clothing/fogessentials/Yupoo FOG ESSENTIALS Short Sleeve Special Edition  Black/yfe01a3_6.jpg","/productimgs/clothing/fogessentials/Yupoo FOG ESSENTIALS Short Sleeve Special Edition  Black/yfe01a3_7.jpg","/productimgs/clothing/fogessentials/Yupoo FOG ESSENTIALS Short Sleeve Special Edition  Black/yfe01a3_8.jpg","/productimgs/clothing/fogessentials/Yupoo FOG ESSENTIALS Short Sleeve Special Edition  Black/yfe01a3_9.jpg","/productimgs/clothing/fogessentials/Yupoo FOG ESSENTIALS Short Sleeve Special Edition  Black/yfe01a3_10.jpg","/productimgs/clothing/fogessentials/Yupoo FOG ESSENTIALS Short Sleeve Special Edition  Black/yfe01a3_11.jpg"]
  },
  {
    id: "fog53b2",
    name: "Fear Of God Essentials Heavy Short-Sleeve Tee - Heather Grey Yupoo Fog",
    description: "The Spring/Summer 2024 collection continues the brand's DNA, emphasizing comfort and daily practicality. The letter print design enhances the brand's identity while maintaining a low-key urban feel-125SU242001F",
    price: PriceInfo,
    categories: ["clothing","foge"],
    images: ["/productimgs/clothing/fogessentials/Fear Of God Essentials Heavy Short-Sleeve Tee - Heather Grey Yupoo fog/fog53b2_4.png","/productimgs/clothing/fogessentials/Fear Of God Essentials Heavy Short-Sleeve Tee - Heather Grey Yupoo fog/fog53b2_5.png","/productimgs/clothing/fogessentials/Fear Of God Essentials Heavy Short-Sleeve Tee - Heather Grey Yupoo fog/fog53b2_6.png","/productimgs/clothing/fogessentials/Fear Of God Essentials Heavy Short-Sleeve Tee - Heather Grey Yupoo fog/fog53b2_7.png","/productimgs/clothing/fogessentials/Fear Of God Essentials Heavy Short-Sleeve Tee - Heather Grey Yupoo fog/fog53b2_8.png","/productimgs/clothing/fogessentials/Fear Of God Essentials Heavy Short-Sleeve Tee - Heather Grey Yupoo fog/fog53b2_9.png","/productimgs/clothing/fogessentials/Fear Of God Essentials Heavy Short-Sleeve Tee - Heather Grey Yupoo fog/fog53b2_10.png","/productimgs/clothing/fogessentials/Fear Of God Essentials Heavy Short-Sleeve Tee - Heather Grey Yupoo fog/fog53b2_11.png","/productimgs/clothing/fogessentials/Fear Of God Essentials Heavy Short-Sleeve Tee - Heather Grey Yupoo fog/fog53b2_12.png"]
  },
  {
    id: "fog5e5c",
    name: "Fear Of God Essentials Heavy Short-Sleeve Tee - Heather Wood Yupoo Fog",
    description: "The Spring/Summer 2024 collection continues the brand's DNA, emphasizing comfort and daily practicality. The letter print design enhances the brand's identity while maintaining a low-key urban feel-125SU242002F",
    price: PriceInfo,
    categories: ["clothing","foge"],
    images: ["/productimgs/clothing/fogessentials/Fear Of God Essentials Heavy Short-Sleeve Tee - Heather Wood Yupoo fog/fog5e5c_4.png","/productimgs/clothing/fogessentials/Fear Of God Essentials Heavy Short-Sleeve Tee - Heather Wood Yupoo fog/fog5e5c_5.png","/productimgs/clothing/fogessentials/Fear Of God Essentials Heavy Short-Sleeve Tee - Heather Wood Yupoo fog/fog5e5c_6.png","/productimgs/clothing/fogessentials/Fear Of God Essentials Heavy Short-Sleeve Tee - Heather Wood Yupoo fog/fog5e5c_7.png","/productimgs/clothing/fogessentials/Fear Of God Essentials Heavy Short-Sleeve Tee - Heather Wood Yupoo fog/fog5e5c_8.png","/productimgs/clothing/fogessentials/Fear Of God Essentials Heavy Short-Sleeve Tee - Heather Wood Yupoo fog/fog5e5c_9.png","/productimgs/clothing/fogessentials/Fear Of God Essentials Heavy Short-Sleeve Tee - Heather Wood Yupoo fog/fog5e5c_10.png","/productimgs/clothing/fogessentials/Fear Of God Essentials Heavy Short-Sleeve Tee - Heather Wood Yupoo fog/fog5e5c_11.png"]
  },
  {
    id: "fog955e",
    name: "Fear Of God Essentials Heavy Short-Sleeve Tee - Black Yupoo Fog",
    description: "The Spring/Summer 2024 collection continues the brand's DNA, emphasizing comfort and daily practicality. The letter print design enhances the brand's identity while maintaining a low-key urban feel-125SU242000F",
    price: PriceInfo,
    categories: ["clothing","foge"],
    images: ["/productimgs/clothing/fogessentials/Fear Of God Essentials Heavy Short-Sleeve Tee - Black Yupoo fog/fog955e_4.png","/productimgs/clothing/fogessentials/Fear Of God Essentials Heavy Short-Sleeve Tee - Black Yupoo fog/fog955e_5.png","/productimgs/clothing/fogessentials/Fear Of God Essentials Heavy Short-Sleeve Tee - Black Yupoo fog/fog955e_6.png","/productimgs/clothing/fogessentials/Fear Of God Essentials Heavy Short-Sleeve Tee - Black Yupoo fog/fog955e_7.png","/productimgs/clothing/fogessentials/Fear Of God Essentials Heavy Short-Sleeve Tee - Black Yupoo fog/fog955e_8.png","/productimgs/clothing/fogessentials/Fear Of God Essentials Heavy Short-Sleeve Tee - Black Yupoo fog/fog955e_9.png","/productimgs/clothing/fogessentials/Fear Of God Essentials Heavy Short-Sleeve Tee - Black Yupoo fog/fog955e_10.png","/productimgs/clothing/fogessentials/Fear Of God Essentials Heavy Short-Sleeve Tee - Black Yupoo fog/fog955e_11.png"]
  },
  {
    id: "nppe306",
    name: "Nike Pegasus Premium - React Air Zoom Cushioning 🏃‍♂️🔥",
    description: "Engineered for elite performance, these Pegasus Premium running shoes combine React foam and Air Zoom cushioning in a sleek \"Football Grey/Orange\" design, featuring Flywire support and a durable waffle outsole for versatile terrain. #yupoonike #yupooshoes #nike #yupoocatalogue #yupooalbum",
    price: PriceInfo,
    categories: ["shoes","nike"],
    images: ["/productimgs/shoes/Nike_Shoes/Nike Pegasus Premium - React Air Zoom Cushioning/nppe306_4.jpg","/productimgs/shoes/Nike_Shoes/Nike Pegasus Premium - React Air Zoom Cushioning/nppe306_5.jpg","/productimgs/shoes/Nike_Shoes/Nike Pegasus Premium - React Air Zoom Cushioning/nppe306_6.jpg","/productimgs/shoes/Nike_Shoes/Nike Pegasus Premium - React Air Zoom Cushioning/nppe306_7.jpg","/productimgs/shoes/Nike_Shoes/Nike Pegasus Premium - React Air Zoom Cushioning/nppe306_8.jpg","/productimgs/shoes/Nike_Shoes/Nike Pegasus Premium - React Air Zoom Cushioning/nppe306_9.jpg","/productimgs/shoes/Nike_Shoes/Nike Pegasus Premium - React Air Zoom Cushioning/nppe306_10.jpg","/productimgs/shoes/Nike_Shoes/Nike Pegasus Premium - React Air Zoom Cushioning/nppe306_11.jpg","/productimgs/shoes/Nike_Shoes/Nike Pegasus Premium - React Air Zoom Cushioning/nppe306_12.jpg"]
  },
  {
    id: "ysn19b9",
    name: "Yupoo Shoes - Nike Pegasus Premium \"Atmosphere Pink\"",
    description: "Design & Tech: Gradient pink/purple \"Atmosphere\" theme with 3M reflective details; Dual-density ZoomX foam + 25PSI Air Zoom unit #yupoonike #yupooshoes #nike #yupoocatalogue #yupooalbum",
    price: PriceInfo,
    categories: ["shoes","nike"],
    images: ["/productimgs/shoes/Nike_Shoes/Yupoo shoes - Nike Pegasus Premium Atmosphere Pink/ysn19b9_4.jpg","/productimgs/shoes/Nike_Shoes/Yupoo shoes - Nike Pegasus Premium Atmosphere Pink/ysn19b9_5.jpg","/productimgs/shoes/Nike_Shoes/Yupoo shoes - Nike Pegasus Premium Atmosphere Pink/ysn19b9_6.jpg","/productimgs/shoes/Nike_Shoes/Yupoo shoes - Nike Pegasus Premium Atmosphere Pink/ysn19b9_7.jpg","/productimgs/shoes/Nike_Shoes/Yupoo shoes - Nike Pegasus Premium Atmosphere Pink/ysn19b9_8.jpg","/productimgs/shoes/Nike_Shoes/Yupoo shoes - Nike Pegasus Premium Atmosphere Pink/ysn19b9_9.jpg","/productimgs/shoes/Nike_Shoes/Yupoo shoes - Nike Pegasus Premium Atmosphere Pink/ysn19b9_10.jpg","/productimgs/shoes/Nike_Shoes/Yupoo shoes - Nike Pegasus Premium Atmosphere Pink/ysn19b9_11.jpg","/productimgs/shoes/Nike_Shoes/Yupoo shoes - Nike Pegasus Premium Atmosphere Pink/ysn19b9_12.jpg"]
  },
  {
    id: "ysn182b",
    name: "Yupoo Shoes - Nike Pegasus Premium \"White/Purple\"",
    description: "Nike Pegasus Premium \"White/Purple\"  #yupoonike #yupooshoes #nike #yupoocatalogue #yupooalbum",
    price: PriceInfo,
    categories: ["shoes","nike"],
    images: ["/productimgs/shoes/Nike_Shoes/Yupoo shoes - Nike Pegasus Premium White-Purple /ysn182b_4.jpg","/productimgs/shoes/Nike_Shoes/Yupoo shoes - Nike Pegasus Premium White-Purple /ysn182b_5.jpg","/productimgs/shoes/Nike_Shoes/Yupoo shoes - Nike Pegasus Premium White-Purple /ysn182b_6.jpg","/productimgs/shoes/Nike_Shoes/Yupoo shoes - Nike Pegasus Premium White-Purple /ysn182b_7.jpg","/productimgs/shoes/Nike_Shoes/Yupoo shoes - Nike Pegasus Premium White-Purple /ysn182b_8.jpg","/productimgs/shoes/Nike_Shoes/Yupoo shoes - Nike Pegasus Premium White-Purple /ysn182b_9.jpg","/productimgs/shoes/Nike_Shoes/Yupoo shoes - Nike Pegasus Premium White-Purple /ysn182b_10.jpg","/productimgs/shoes/Nike_Shoes/Yupoo shoes - Nike Pegasus Premium White-Purple /ysn182b_11.jpg"]
  },
  {
    id: "nazb6c4",
    name: "Nike Air Zoom Alphafly Next Proto - Paris Olympics Edition 🏃‍♂️⚡",
    description: "Engineered for marathon dominance, these \"Black Grey\" Alphafly 3 Proto shoes feature Atomknit 3.0 translucent uppers, dual forefoot Zoom Air units, and ZoomX foam with FlyPlate for explosive speed – a Paris 2024 Olympic tribute design. #yupoonike #yupooshoes #nike #yupoocatalogue #yupooalbum",
    price: PriceInfo,
    categories: ["shoes","nike"],
    images: ["/productimgs/shoes/Nike_Shoes/Nike Air Zoom Alphafly Next Proto - Paris Olympics Edition/nazb6c4_4.jpg","/productimgs/shoes/Nike_Shoes/Nike Air Zoom Alphafly Next Proto - Paris Olympics Edition/nazb6c4_5.jpg","/productimgs/shoes/Nike_Shoes/Nike Air Zoom Alphafly Next Proto - Paris Olympics Edition/nazb6c4_6.jpg","/productimgs/shoes/Nike_Shoes/Nike Air Zoom Alphafly Next Proto - Paris Olympics Edition/nazb6c4_7.jpg","/productimgs/shoes/Nike_Shoes/Nike Air Zoom Alphafly Next Proto - Paris Olympics Edition/nazb6c4_8.jpg","/productimgs/shoes/Nike_Shoes/Nike Air Zoom Alphafly Next Proto - Paris Olympics Edition/nazb6c4_9.jpg","/productimgs/shoes/Nike_Shoes/Nike Air Zoom Alphafly Next Proto - Paris Olympics Edition/nazb6c4_10.jpg","/productimgs/shoes/Nike_Shoes/Nike Air Zoom Alphafly Next Proto - Paris Olympics Edition/nazb6c4_11.jpg","/productimgs/shoes/Nike_Shoes/Nike Air Zoom Alphafly Next Proto - Paris Olympics Edition/nazb6c4_12.jpg"]
  },
  {
    id: "npp2db1",
    name: "Nike Pegasus Premium Running Shoes - Air Zoom & React Foam 👟",
    description: "Get ready for premium comfort and performance with these Black/Crimson running shoes featuring a React foam midsole, Air Zoom cushioning, Flywire support, and a grippy waffle outsole for versatile terrain. #yupoonike #yupooshoes #nike #yupoocatalogue #yupooalbum",
    price: PriceInfo,
    categories: ["shoes","nike"],
    images: ["/productimgs/shoes/Nike_Shoes/Nike Pegasus Premium Running Shoes - Air Zoom React Foam/npp2db1_4.jpg","/productimgs/shoes/Nike_Shoes/Nike Pegasus Premium Running Shoes - Air Zoom React Foam/npp2db1_5.jpg","/productimgs/shoes/Nike_Shoes/Nike Pegasus Premium Running Shoes - Air Zoom React Foam/npp2db1_6.jpg","/productimgs/shoes/Nike_Shoes/Nike Pegasus Premium Running Shoes - Air Zoom React Foam/npp2db1_7.jpg","/productimgs/shoes/Nike_Shoes/Nike Pegasus Premium Running Shoes - Air Zoom React Foam/npp2db1_8.jpg","/productimgs/shoes/Nike_Shoes/Nike Pegasus Premium Running Shoes - Air Zoom React Foam/npp2db1_9.jpg","/productimgs/shoes/Nike_Shoes/Nike Pegasus Premium Running Shoes - Air Zoom React Foam/npp2db1_10.jpg","/productimgs/shoes/Nike_Shoes/Nike Pegasus Premium Running Shoes - Air Zoom React Foam/npp2db1_11.jpg","/productimgs/shoes/Nike_Shoes/Nike Pegasus Premium Running Shoes - Air Zoom React Foam/npp2db1_12.jpg"]
  },
  {
    id: "ytr58c4",
    name: "Yupoo Tudor Royal 41Mm - Sapphire Crystal | Sea-Gull Movement ⌚",
    description: "Master-crafted with top quality, this Tudor Royal features a 41mm 316L steel case, anti-scratch sapphire crystal, and precision Sea-Gull 2834 movement with instant day-date – indistinguishable from authentic at first glance.  #yupoowatch #yupoo #Turdor #yupoo",
    price: PriceInfo,
    categories: ["watch"],
    images: ["/productimgs/watch/Tudor/Yupoo Tudor Royal 41mm - Sapphire Crystal - Sea-Gull Movement/ytr58c4_4.jpg","/productimgs/watch/Tudor/Yupoo Tudor Royal 41mm - Sapphire Crystal - Sea-Gull Movement/ytr58c4_5.jpg","/productimgs/watch/Tudor/Yupoo Tudor Royal 41mm - Sapphire Crystal - Sea-Gull Movement/ytr58c4_6.jpg","/productimgs/watch/Tudor/Yupoo Tudor Royal 41mm - Sapphire Crystal - Sea-Gull Movement/ytr58c4_7.jpg","/productimgs/watch/Tudor/Yupoo Tudor Royal 41mm - Sapphire Crystal - Sea-Gull Movement/ytr58c4_8.jpg","/productimgs/watch/Tudor/Yupoo Tudor Royal 41mm - Sapphire Crystal - Sea-Gull Movement/ytr58c4_9.jpg","/productimgs/watch/Tudor/Yupoo Tudor Royal 41mm - Sapphire Crystal - Sea-Gull Movement/ytr58c4_10.jpg","/productimgs/watch/Tudor/Yupoo Tudor Royal 41mm - Sapphire Crystal - Sea-Gull Movement/ytr58c4_11.jpg","/productimgs/watch/Tudor/Yupoo Tudor Royal 41mm - Sapphire Crystal - Sea-Gull Movement/ytr58c4_12.jpg"]
  },
  {
    id: "2chbf08",
    name: "2025 Chopard Happy Diamonds Stardust Yupo Women'S Watch White",
    description: "The 2025 Chopard Happy Diamonds Stardust watch features an original American alligator strap and a 2892 movement.",
    price: PriceInfo,
    categories: ["watch"],
    images: ["/productimgs/watch/20250618/2025 Chopard Happy Diamonds Stardust Yupo Women's watch White/2chbf08_3.jpg","/productimgs/watch/20250618/2025 Chopard Happy Diamonds Stardust Yupo Women's watch White/2chbf08_4.jpg","/productimgs/watch/20250618/2025 Chopard Happy Diamonds Stardust Yupo Women's watch White/2chbf08_5.jpg","/productimgs/watch/20250618/2025 Chopard Happy Diamonds Stardust Yupo Women's watch White/2chbf08_6.jpg","/productimgs/watch/20250618/2025 Chopard Happy Diamonds Stardust Yupo Women's watch White/2chbf08_7.jpg","/productimgs/watch/20250618/2025 Chopard Happy Diamonds Stardust Yupo Women's watch White/2chbf08_8.jpg","/productimgs/watch/20250618/2025 Chopard Happy Diamonds Stardust Yupo Women's watch White/2chbf08_9.jpg","/productimgs/watch/20250618/2025 Chopard Happy Diamonds Stardust Yupo Women's watch White/2chbf08_10.jpg","/productimgs/watch/20250618/2025 Chopard Happy Diamonds Stardust Yupo Women's watch White/2chbf08_11.jpg"]
  },
  {
    id: "ypp18c9",
    name: "Yupoo Patek Philippe Nautilus 5821 Wristwatch Yupoo Watch Silver",
    description: "The Patek Philippe Nautilus Ref. 69 Cubitus 5821 features an ultra-thin 8.3mm oscillating weight movement, redefining elegance with its groundbreaking design and precision craftsmanship in the iconic Nautilus collection.",
    price: PriceInfo,
    categories: ["watch"],
    images: ["/productimgs/watch/20250618/Yupoo Patek Philippe Nautilus 5821 wristwatch Yupoo Watch Silver/ypp18c9_3.jpg","/productimgs/watch/20250618/Yupoo Patek Philippe Nautilus 5821 wristwatch Yupoo Watch Silver/ypp18c9_4.jpg","/productimgs/watch/20250618/Yupoo Patek Philippe Nautilus 5821 wristwatch Yupoo Watch Silver/ypp18c9_5.jpg","/productimgs/watch/20250618/Yupoo Patek Philippe Nautilus 5821 wristwatch Yupoo Watch Silver/ypp18c9_6.jpg","/productimgs/watch/20250618/Yupoo Patek Philippe Nautilus 5821 wristwatch Yupoo Watch Silver/ypp18c9_7.jpg","/productimgs/watch/20250618/Yupoo Patek Philippe Nautilus 5821 wristwatch Yupoo Watch Silver/ypp18c9_8.jpg","/productimgs/watch/20250618/Yupoo Patek Philippe Nautilus 5821 wristwatch Yupoo Watch Silver/ypp18c9_9.jpg","/productimgs/watch/20250618/Yupoo Patek Philippe Nautilus 5821 wristwatch Yupoo Watch Silver/ypp18c9_10.jpg","/productimgs/watch/20250618/Yupoo Patek Philippe Nautilus 5821 wristwatch Yupoo Watch Silver/ypp18c9_11.jpg"]
  },
  {
    id: "rddf647",
    name: "Rolex Daytona Disney Mickey Hidden Edition Yupoo Rolex Watch",
    description: "The exclusive Rolex Daytona Disney Mickey Hidden Edition combines luxury with whimsy, featuring a stable ultra-thin DanDong 7750 movement synchronized with boutique chronograph functions, 316L stainless steel case/bracelet with refined craftsmanship.",
    price: PriceInfo,
    categories: ["watch","rolex"],
    images: ["/productimgs/watch/20250618/Rolex Daytona Disney Mickey Hidden Edition Yupoo Rolex Watch/rddf647_3.jpg","/productimgs/watch/20250618/Rolex Daytona Disney Mickey Hidden Edition Yupoo Rolex Watch/rddf647_4.jpg","/productimgs/watch/20250618/Rolex Daytona Disney Mickey Hidden Edition Yupoo Rolex Watch/rddf647_5.jpg","/productimgs/watch/20250618/Rolex Daytona Disney Mickey Hidden Edition Yupoo Rolex Watch/rddf647_6.jpg","/productimgs/watch/20250618/Rolex Daytona Disney Mickey Hidden Edition Yupoo Rolex Watch/rddf647_7.jpg","/productimgs/watch/20250618/Rolex Daytona Disney Mickey Hidden Edition Yupoo Rolex Watch/rddf647_8.jpg","/productimgs/watch/20250618/Rolex Daytona Disney Mickey Hidden Edition Yupoo Rolex Watch/rddf647_9.jpg","/productimgs/watch/20250618/Rolex Daytona Disney Mickey Hidden Edition Yupoo Rolex Watch/rddf647_10.jpg","/productimgs/watch/20250618/Rolex Daytona Disney Mickey Hidden Edition Yupoo Rolex Watch/rddf647_11.jpg"]
  },
  {
    id: "vhs5c69",
    name: "Vc Historiques Square Grain Dial Yupoo Vc Watch",
    description: "The Vacheron Constantin Historiques watch showcases a lustrous square case with a minimalist grain-textured dial and Italian calfskin strap, epitomizing timeless refinement and heritage craftsmanship.\n\n",
    price: PriceInfo,
    categories: ["watch"],
    images: ["/productimgs/watch/20250618/VC Historiques Square Grain Dial Yupoo VC Watch/vhs5c69_3.jpg","/productimgs/watch/20250618/VC Historiques Square Grain Dial Yupoo VC Watch/vhs5c69_4.jpg","/productimgs/watch/20250618/VC Historiques Square Grain Dial Yupoo VC Watch/vhs5c69_5.jpg","/productimgs/watch/20250618/VC Historiques Square Grain Dial Yupoo VC Watch/vhs5c69_6.jpg","/productimgs/watch/20250618/VC Historiques Square Grain Dial Yupoo VC Watch/vhs5c69_7.jpg","/productimgs/watch/20250618/VC Historiques Square Grain Dial Yupoo VC Watch/vhs5c69_8.jpg","/productimgs/watch/20250618/VC Historiques Square Grain Dial Yupoo VC Watch/vhs5c69_9.jpg","/productimgs/watch/20250618/VC Historiques Square Grain Dial Yupoo VC Watch/vhs5c69_10.jpg","/productimgs/watch/20250618/VC Historiques Square Grain Dial Yupoo VC Watch/vhs5c69_11.jpg"]
  },
  {
    id: "2chb83f",
    name: "2025 Chopard Happy Diamonds Stardust Yupo Women'S Watch Rose Gold",
    description: "The 2025 Chopard Happy Diamonds Stardust watch features an original American alligator strap and a 2892 movement.",
    price: PriceInfo,
    categories: ["watch"],
    images: ["/productimgs/watch/20250618/2025 Chopard Happy Diamonds Stardust Yupo Women's watch Rose gold/2chb83f_3.jpg","/productimgs/watch/20250618/2025 Chopard Happy Diamonds Stardust Yupo Women's watch Rose gold/2chb83f_4.jpg","/productimgs/watch/20250618/2025 Chopard Happy Diamonds Stardust Yupo Women's watch Rose gold/2chb83f_5.jpg","/productimgs/watch/20250618/2025 Chopard Happy Diamonds Stardust Yupo Women's watch Rose gold/2chb83f_6.jpg","/productimgs/watch/20250618/2025 Chopard Happy Diamonds Stardust Yupo Women's watch Rose gold/2chb83f_7.jpg","/productimgs/watch/20250618/2025 Chopard Happy Diamonds Stardust Yupo Women's watch Rose gold/2chb83f_8.jpg","/productimgs/watch/20250618/2025 Chopard Happy Diamonds Stardust Yupo Women's watch Rose gold/2chb83f_9.jpg","/productimgs/watch/20250618/2025 Chopard Happy Diamonds Stardust Yupo Women's watch Rose gold/2chb83f_10.jpg","/productimgs/watch/20250618/2025 Chopard Happy Diamonds Stardust Yupo Women's watch Rose gold/2chb83f_11.jpg"]
  },
  {
    id: "ppgc06b",
    name: "Patek Philippe Grand Complications 42Mm Engraved Yupoo Watch",
    description: "Description:\nThis Patek Philippe Grand Complications watch features a 42mm case with meticulously hand-engraved patterns.",
    price: PriceInfo,
    categories: ["watch"],
    images: ["/productimgs/watch/20250618/Patek Philippe Grand Complications 42mm Engraved Yupoo Watch/ppgc06b_3.jpg","/productimgs/watch/20250618/Patek Philippe Grand Complications 42mm Engraved Yupoo Watch/ppgc06b_4.jpg","/productimgs/watch/20250618/Patek Philippe Grand Complications 42mm Engraved Yupoo Watch/ppgc06b_5.jpg","/productimgs/watch/20250618/Patek Philippe Grand Complications 42mm Engraved Yupoo Watch/ppgc06b_6.jpg","/productimgs/watch/20250618/Patek Philippe Grand Complications 42mm Engraved Yupoo Watch/ppgc06b_7.jpg","/productimgs/watch/20250618/Patek Philippe Grand Complications 42mm Engraved Yupoo Watch/ppgc06b_8.jpg","/productimgs/watch/20250618/Patek Philippe Grand Complications 42mm Engraved Yupoo Watch/ppgc06b_9.jpg","/productimgs/watch/20250618/Patek Philippe Grand Complications 42mm Engraved Yupoo Watch/ppgc06b_10.jpg","/productimgs/watch/20250618/Patek Philippe Grand Complications 42mm Engraved Yupoo Watch/ppgc06b_11.jpg"]
  },
  {
    id: "ppg75f5",
    name: "Patek Philippe Grand Complications 41Mm Engraved Yupoo Watch",
    description: "Description:\nThis Patek Philippe Grand Complications watch features a 42mm case with meticulously hand-engraved patterns.",
    price: PriceInfo,
    categories: ["watch"],
    images: ["/productimgs/watch/20250618/Patek Philippe Grand Complications 41mm Engraved Yupoo Watch/ppg75f5_3.jpg","/productimgs/watch/20250618/Patek Philippe Grand Complications 41mm Engraved Yupoo Watch/ppg75f5_4.jpg","/productimgs/watch/20250618/Patek Philippe Grand Complications 41mm Engraved Yupoo Watch/ppg75f5_5.jpg","/productimgs/watch/20250618/Patek Philippe Grand Complications 41mm Engraved Yupoo Watch/ppg75f5_6.jpg","/productimgs/watch/20250618/Patek Philippe Grand Complications 41mm Engraved Yupoo Watch/ppg75f5_7.jpg","/productimgs/watch/20250618/Patek Philippe Grand Complications 41mm Engraved Yupoo Watch/ppg75f5_8.jpg","/productimgs/watch/20250618/Patek Philippe Grand Complications 41mm Engraved Yupoo Watch/ppg75f5_9.jpg","/productimgs/watch/20250618/Patek Philippe Grand Complications 41mm Engraved Yupoo Watch/ppg75f5_10.jpg","/productimgs/watch/20250618/Patek Philippe Grand Complications 41mm Engraved Yupoo Watch/ppg75f5_11.jpg"]
  },
  {
    id: "yppaa09",
    name: "Yupoo Patek Philippe Nautilus 5821 Wristwatch Yupoo Watch",
    description: "The Patek Philippe Nautilus Ref. 69 Cubitus 5821 features an ultra-thin 8.3mm oscillating weight movement, redefining elegance with its groundbreaking design and precision craftsmanship in the iconic Nautilus collection.",
    price: PriceInfo,
    categories: ["watch"],
    images: ["/productimgs/watch/20250618/Yupoo Patek Philippe Nautilus 5821 wristwatch Yupoo Watch/yppaa09_3.jpg","/productimgs/watch/20250618/Yupoo Patek Philippe Nautilus 5821 wristwatch Yupoo Watch/yppaa09_4.jpg","/productimgs/watch/20250618/Yupoo Patek Philippe Nautilus 5821 wristwatch Yupoo Watch/yppaa09_5.jpg","/productimgs/watch/20250618/Yupoo Patek Philippe Nautilus 5821 wristwatch Yupoo Watch/yppaa09_6.jpg","/productimgs/watch/20250618/Yupoo Patek Philippe Nautilus 5821 wristwatch Yupoo Watch/yppaa09_7.jpg","/productimgs/watch/20250618/Yupoo Patek Philippe Nautilus 5821 wristwatch Yupoo Watch/yppaa09_8.jpg","/productimgs/watch/20250618/Yupoo Patek Philippe Nautilus 5821 wristwatch Yupoo Watch/yppaa09_9.jpg","/productimgs/watch/20250618/Yupoo Patek Philippe Nautilus 5821 wristwatch Yupoo Watch/yppaa09_10.jpg","/productimgs/watch/20250618/Yupoo Patek Philippe Nautilus 5821 wristwatch Yupoo Watch/yppaa09_11.jpg"]
  },
  {
    id: "ip4f022",
    name: "Iwc Pilot 41Mm Steel Watch Yupoo Watch Rose Gold",
    description: "Crafted in 316L stainless steel with a precise 41mm dial and 20mm strap width, this IWC Pilot watch redefines aviation-inspired durability and timeless elegance for modern explorers.",
    price: PriceInfo,
    categories: ["watch"],
    images: ["/productimgs/watch/20250618/IWC Pilot 41mm Steel Watch Yupoo Watch Rose gold/ip4f022_3.jpg","/productimgs/watch/20250618/IWC Pilot 41mm Steel Watch Yupoo Watch Rose gold/ip4f022_4.jpg","/productimgs/watch/20250618/IWC Pilot 41mm Steel Watch Yupoo Watch Rose gold/ip4f022_5.jpg","/productimgs/watch/20250618/IWC Pilot 41mm Steel Watch Yupoo Watch Rose gold/ip4f022_6.jpg","/productimgs/watch/20250618/IWC Pilot 41mm Steel Watch Yupoo Watch Rose gold/ip4f022_7.jpg","/productimgs/watch/20250618/IWC Pilot 41mm Steel Watch Yupoo Watch Rose gold/ip4f022_8.jpg","/productimgs/watch/20250618/IWC Pilot 41mm Steel Watch Yupoo Watch Rose gold/ip4f022_9.jpg","/productimgs/watch/20250618/IWC Pilot 41mm Steel Watch Yupoo Watch Rose gold/ip4f022_10.jpg","/productimgs/watch/20250618/IWC Pilot 41mm Steel Watch Yupoo Watch Rose gold/ip4f022_11.jpg"]
  },
  {
    id: "2chea48",
    name: "2025 Chopard Happy Diamonds Stardust Yupo Women'S Watch Pink",
    description: "The 2025 Chopard Happy Diamonds Stardust watch features an original American alligator strap and a 2892 movement.",
    price: PriceInfo,
    categories: ["watch"],
    images: ["/productimgs/watch/20250618/2025 Chopard Happy Diamonds Stardust Yupo Women's watch pink/2chea48_3.jpg","/productimgs/watch/20250618/2025 Chopard Happy Diamonds Stardust Yupo Women's watch pink/2chea48_4.jpg","/productimgs/watch/20250618/2025 Chopard Happy Diamonds Stardust Yupo Women's watch pink/2chea48_5.jpg","/productimgs/watch/20250618/2025 Chopard Happy Diamonds Stardust Yupo Women's watch pink/2chea48_6.jpg","/productimgs/watch/20250618/2025 Chopard Happy Diamonds Stardust Yupo Women's watch pink/2chea48_7.jpg","/productimgs/watch/20250618/2025 Chopard Happy Diamonds Stardust Yupo Women's watch pink/2chea48_8.jpg","/productimgs/watch/20250618/2025 Chopard Happy Diamonds Stardust Yupo Women's watch pink/2chea48_9.jpg","/productimgs/watch/20250618/2025 Chopard Happy Diamonds Stardust Yupo Women's watch pink/2chea48_10.jpg"]
  },
  {
    id: "ip47e0b",
    name: "Iwc Pilot 41Mm Steel Watch Yupoo Watch Black",
    description: "Crafted in 316L stainless steel with a precise 41mm dial and 20mm strap width, this IWC Pilot watch redefines aviation-inspired durability and timeless elegance for modern explorers.",
    price: PriceInfo,
    categories: ["watch"],
    images: ["/productimgs/watch/20250618/IWC Pilot 41mm Steel Watch Yupoo Watch Black/ip47e0b_3.jpg","/productimgs/watch/20250618/IWC Pilot 41mm Steel Watch Yupoo Watch Black/ip47e0b_4.jpg","/productimgs/watch/20250618/IWC Pilot 41mm Steel Watch Yupoo Watch Black/ip47e0b_5.jpg","/productimgs/watch/20250618/IWC Pilot 41mm Steel Watch Yupoo Watch Black/ip47e0b_6.jpg","/productimgs/watch/20250618/IWC Pilot 41mm Steel Watch Yupoo Watch Black/ip47e0b_7.jpg","/productimgs/watch/20250618/IWC Pilot 41mm Steel Watch Yupoo Watch Black/ip47e0b_8.jpg","/productimgs/watch/20250618/IWC Pilot 41mm Steel Watch Yupoo Watch Black/ip47e0b_9.jpg","/productimgs/watch/20250618/IWC Pilot 41mm Steel Watch Yupoo Watch Black/ip47e0b_10.jpg","/productimgs/watch/20250618/IWC Pilot 41mm Steel Watch Yupoo Watch Black/ip47e0b_11.jpg"]
  },
  {
    id: "rdb5acc",
    name: "Rolex Daytona Black Steel & Titanium Yupoo Rolex Watch",
    description: "The 2025 Rolex Daytona Black Steel & Titanium redefines luxury with its unconventional fusion of dark steel and titanium, housing the ultra-thin DanDong 7750 movement for precise chronograph functionality, while the Oysterlock clasp ensures secure wear and refined comfort.",
    price: PriceInfo,
    categories: ["watch"],
    images: ["/productimgs/watch/20250618/Rolex Daytona Black Steel & Titanium Yupoo Rolex Watch/rdb5acc_3.jpg","/productimgs/watch/20250618/Rolex Daytona Black Steel & Titanium Yupoo Rolex Watch/rdb5acc_4.jpg","/productimgs/watch/20250618/Rolex Daytona Black Steel & Titanium Yupoo Rolex Watch/rdb5acc_5.jpg","/productimgs/watch/20250618/Rolex Daytona Black Steel & Titanium Yupoo Rolex Watch/rdb5acc_6.jpg","/productimgs/watch/20250618/Rolex Daytona Black Steel & Titanium Yupoo Rolex Watch/rdb5acc_7.jpg","/productimgs/watch/20250618/Rolex Daytona Black Steel & Titanium Yupoo Rolex Watch/rdb5acc_8.jpg","/productimgs/watch/20250618/Rolex Daytona Black Steel & Titanium Yupoo Rolex Watch/rdb5acc_9.jpg","/productimgs/watch/20250618/Rolex Daytona Black Steel & Titanium Yupoo Rolex Watch/rdb5acc_10.jpg","/productimgs/watch/20250618/Rolex Daytona Black Steel & Titanium Yupoo Rolex Watch/rdb5acc_11.jpg"]
  },
  {
    id: "yhbada3",
    name: "Yupoo Hermes Belt  Kelly 1.8Cm Reversible Red Bright Red",
    description: "Crafted from imported premium leather with meticulous hand-finishing, this dual-sided HERMES Kelly belt features a polished steel buckle for versatile styling, embodying timeless elegance and artisanal quality.",
    price: PriceInfo,
    categories: ["belt","hermes"],
    images: ["/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Red Bright red/yhbada3_3.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Red Bright red/yhbada3_4.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Red Bright red/yhbada3_5.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Red Bright red/yhbada3_6.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Red Bright red/yhbada3_7.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Red Bright red/yhbada3_8.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Red Bright red/yhbada3_9.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Red Bright red/yhbada3_10.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Red Bright red/yhbada3_11.jpg"]
  },
  {
    id: "yhb20dc",
    name: "Yupoo Hermes Belt  Kelly 1.8Cm Reversible Brown",
    description: "Crafted from imported premium leather with meticulous hand-finishing, this dual-sided HERMES Kelly belt features a polished steel buckle for versatile styling, embodying timeless elegance and artisanal quality.",
    price: PriceInfo,
    categories: ["belt","hermes"],
    images: ["/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Brown/yhb20dc_3.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Brown/yhb20dc_4.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Brown/yhb20dc_5.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Brown/yhb20dc_6.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Brown/yhb20dc_7.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Brown/yhb20dc_8.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Brown/yhb20dc_9.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Brown/yhb20dc_10.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Brown/yhb20dc_11.jpg"]
  },
  {
    id: "yhbc18a",
    name: "Yupoo Hermes Belt  Kelly 1.8Cm Reversible Gold",
    description: "Crafted from imported premium leather with meticulous hand-finishing, this dual-sided HERMES Kelly belt features a polished steel buckle for versatile styling, embodying timeless elegance and artisanal quality.",
    price: PriceInfo,
    categories: ["belt","hermes"],
    images: ["/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Gold/yhbc18a_3.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Gold/yhbc18a_4.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Gold/yhbc18a_5.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Gold/yhbc18a_6.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Gold/yhbc18a_7.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Gold/yhbc18a_8.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Gold/yhbc18a_9.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Gold/yhbc18a_10.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Gold/yhbc18a_11.jpg"]
  },
  {
    id: "yhbc988",
    name: "Yupoo Hermes Belt  Kelly 1.8Cm Reversible Blue",
    description: "Crafted from imported premium leather with meticulous hand-finishing, this dual-sided HERMES Kelly belt features a polished steel buckle for versatile styling, embodying timeless elegance and artisanal quality.",
    price: PriceInfo,
    categories: ["belt","hermes"],
    images: ["/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Blue/yhbc988_3.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Blue/yhbc988_4.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Blue/yhbc988_5.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Blue/yhbc988_6.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Blue/yhbc988_7.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Blue/yhbc988_8.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Blue/yhbc988_9.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Blue/yhbc988_10.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Blue/yhbc988_11.jpg"]
  },
  {
    id: "yhbea27",
    name: "Yupoo Hermes Belt  Kelly 1.8Cm Reversible Camel Color",
    description: "Crafted from imported premium leather with meticulous hand-finishing, this dual-sided HERMES Kelly belt features a polished steel buckle for versatile styling, embodying timeless elegance and artisanal quality.",
    price: PriceInfo,
    categories: ["belt","hermes"],
    images: ["/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Camel color/yhbea27_3.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Camel color/yhbea27_4.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Camel color/yhbea27_5.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Camel color/yhbea27_6.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Camel color/yhbea27_7.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Camel color/yhbea27_8.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Camel color/yhbea27_9.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Camel color/yhbea27_10.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Camel color/yhbea27_11.jpg"]
  },
  {
    id: "yhb1539",
    name: "Yupoo Hermes Belt  Kelly 1.8Cm Reversible Black",
    description: "Crafted from imported premium leather with meticulous hand-finishing, this dual-sided HERMES Kelly belt features a polished steel buckle for versatile styling, embodying timeless elegance and artisanal quality.",
    price: PriceInfo,
    categories: ["belt","hermes"],
    images: ["/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Black/yhb1539_3.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Black/yhb1539_4.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Black/yhb1539_5.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Black/yhb1539_6.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Black/yhb1539_7.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Black/yhb1539_8.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Black/yhb1539_9.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Black/yhb1539_10.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Black/yhb1539_11.jpg"]
  },
  {
    id: "yhbf744",
    name: "Yupoo Hermes Belt  Kelly 1.8Cm Reversible White",
    description: "Crafted from imported premium leather with meticulous hand-finishing, this dual-sided HERMES Kelly belt features a polished steel buckle for versatile styling, embodying timeless elegance and artisanal quality.",
    price: PriceInfo,
    categories: ["belt","hermes"],
    images: ["/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible White/yhbf744_3.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible White/yhbf744_4.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible White/yhbf744_5.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible White/yhbf744_6.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible White/yhbf744_7.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible White/yhbf744_8.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible White/yhbf744_9.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible White/yhbf744_10.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible White/yhbf744_11.jpg"]
  },
  {
    id: "yhb3d17",
    name: "Yupoo Hermes Belt  Kelly 1.8Cm Reversible Red",
    description: "Crafted from imported premium leather with meticulous hand-finishing, this dual-sided HERMES Kelly belt features a polished steel buckle for versatile styling, embodying timeless elegance and artisanal quality.",
    price: PriceInfo,
    categories: ["belt","hermes"],
    images: ["/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Red/yhb3d17_3.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Red/yhb3d17_4.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Red/yhb3d17_5.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Red/yhb3d17_6.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Red/yhb3d17_7.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Red/yhb3d17_8.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Red/yhb3d17_9.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Red/yhb3d17_10.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Red/yhb3d17_11.jpg"]
  },
  {
    id: "yhb91ec",
    name: "Yupoo Hermes Belt  Kelly 1.8Cm Reversible Belt",
    description: "Crafted from imported premium leather with meticulous hand-finishing, this dual-sided HERMES Kelly belt features a polished steel buckle for versatile styling, embodying timeless elegance and artisanal quality.",
    price: PriceInfo,
    categories: ["belt","hermes"],
    images: ["/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Belt/yhb91ec_3.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Belt/yhb91ec_4.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Belt/yhb91ec_5.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Belt/yhb91ec_6.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Belt/yhb91ec_7.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Belt/yhb91ec_8.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Belt/yhb91ec_9.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Belt/yhb91ec_10.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Belt/yhb91ec_11.jpg"]
  },
  {
    id: "yhb63b8",
    name: "Yupoo Hermes Belt  Kelly 1.8Cm Reversible Pink Green",
    description: "Crafted from imported premium leather with meticulous hand-finishing, this dual-sided HERMES Kelly belt features a polished steel buckle for versatile styling, embodying timeless elegance and artisanal quality.",
    price: PriceInfo,
    categories: ["belt","hermes"],
    images: ["/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Pink Green/yhb63b8_3.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Pink Green/yhb63b8_4.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Pink Green/yhb63b8_5.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Pink Green/yhb63b8_6.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Pink Green/yhb63b8_7.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Pink Green/yhb63b8_8.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Pink Green/yhb63b8_9.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Pink Green/yhb63b8_10.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Pink Green/yhb63b8_11.jpg"]
  },
  {
    id: "yhb856b",
    name: "Yupoo HERMES Belt 1.8cm Width Women thin waist belt",
    description: "Crafted with imported premium Togo leather and a Polished steel buckle, this 1.8cm HERMES belt features meticulous hand-finishing for versatile waist or hip wear, embodying signature sophistication through expert craftsmanship.",
    price: PriceInfo,
    categories: ["belt","hermes"],
    images: ["/productimgs/Belt/Hermes/Yupoo HERMES Belt 1.8cm Width Women thin waist belt/yhb856b_3.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt 1.8cm Width Women thin waist belt/yhb856b_4.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt 1.8cm Width Women thin waist belt/yhb856b_5.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt 1.8cm Width Women thin waist belt/yhb856b_6.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt 1.8cm Width Women thin waist belt/yhb856b_7.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt 1.8cm Width Women thin waist belt/yhb856b_8.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt 1.8cm Width Women thin waist belt/yhb856b_9.jpg"]
  },
  {
    id: "yhbd325",
    name: "Yupoo Hermes Belt  Kelly 1.8Cm Reversible Purple",
    description: "Crafted from imported premium leather with meticulous hand-finishing, this dual-sided HERMES Kelly belt features a polished steel buckle for versatile styling, embodying timeless elegance and artisanal quality.",
    price: PriceInfo,
    categories: ["belt","hermes"],
    images: ["/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Purple/yhbd325_3.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Purple/yhbd325_4.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Purple/yhbd325_5.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Purple/yhbd325_6.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Purple/yhbd325_7.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Purple/yhbd325_8.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Purple/yhbd325_9.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Purple/yhbd325_10.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Purple/yhbd325_11.jpg"]
  },
  {
    id: "yhb00c2",
    name: "Yupoo Hermes Belt  Kelly 1.8Cm Reversible Orange",
    description: "Crafted from imported premium leather with meticulous hand-finishing, this dual-sided HERMES Kelly belt features a polished steel buckle for versatile styling, embodying timeless elegance and artisanal quality.",
    price: PriceInfo,
    categories: ["belt","hermes"],
    images: ["/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Orange/yhb00c2_3.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Orange/yhb00c2_4.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Orange/yhb00c2_5.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Orange/yhb00c2_6.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Orange/yhb00c2_7.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Orange/yhb00c2_8.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Orange/yhb00c2_9.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Orange/yhb00c2_10.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Orange/yhb00c2_11.jpg"]
  },
  {
    id: "yhb6791",
    name: "Yupoo Hermes Belt  Kelly 1.8Cm Reversible Grey",
    description: "Crafted from imported premium leather with meticulous hand-finishing, this dual-sided HERMES Kelly belt features a polished steel buckle for versatile styling, embodying timeless elegance and artisanal quality.",
    price: PriceInfo,
    categories: ["belt","hermes"],
    images: ["/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Grey/yhb6791_3.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Grey/yhb6791_4.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Grey/yhb6791_5.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Grey/yhb6791_6.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Grey/yhb6791_7.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Grey/yhb6791_8.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Grey/yhb6791_9.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Grey/yhb6791_10.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Grey/yhb6791_11.jpg"]
  },
  {
    id: "yhbd0b5",
    name: "Yupoo Hermes Belt  Kelly 1.8Cm Reversible Pink Belt",
    description: "Crafted from imported premium leather with meticulous hand-finishing, this dual-sided HERMES Kelly belt features a polished steel buckle for versatile styling, embodying timeless elegance and artisanal quality.",
    price: PriceInfo,
    categories: ["belt","hermes"],
    images: ["/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Pink Belt/yhbd0b5_3.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Pink Belt/yhbd0b5_4.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Pink Belt/yhbd0b5_5.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Pink Belt/yhbd0b5_6.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Pink Belt/yhbd0b5_7.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Pink Belt/yhbd0b5_8.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Pink Belt/yhbd0b5_9.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Pink Belt/yhbd0b5_10.jpg","/productimgs/Belt/Hermes/Yupoo HERMES Belt  Kelly 1.8cm Reversible Pink Belt/yhbd0b5_11.jpg"]
  },
  {
    id: "lis28b3",
    name: "Lv Initiales Studs Reversible Belt 40Mm Yupoo Belt",
    description: "This 4.0cm LV Initiales Studs reversible belt masterfully merges House DNA with bold sophistication, featuring full-coverage signature print on both sides and instantly elevating everyday style with its defining studded buckle.",
    price: PriceInfo,
    categories: ["belt","lv"],
    images: ["/productimgs/Belt/Lv/LV Initiales Studs Reversible Belt 40mm Yupoo Belt/lis28b3_3.jpg","/productimgs/Belt/Lv/LV Initiales Studs Reversible Belt 40mm Yupoo Belt/lis28b3_4.jpg","/productimgs/Belt/Lv/LV Initiales Studs Reversible Belt 40mm Yupoo Belt/lis28b3_5.jpg","/productimgs/Belt/Lv/LV Initiales Studs Reversible Belt 40mm Yupoo Belt/lis28b3_6.jpg","/productimgs/Belt/Lv/LV Initiales Studs Reversible Belt 40mm Yupoo Belt/lis28b3_7.jpg","/productimgs/Belt/Lv/LV Initiales Studs Reversible Belt 40mm Yupoo Belt/lis28b3_8.jpg","/productimgs/Belt/Lv/LV Initiales Studs Reversible Belt 40mm Yupoo Belt/lis28b3_9.jpg","/productimgs/Belt/Lv/LV Initiales Studs Reversible Belt 40mm Yupoo Belt/lis28b3_10.jpg","/productimgs/Belt/Lv/LV Initiales Studs Reversible Belt 40mm Yupoo Belt/lis28b3_11.jpg"]
  },
  {
    id: "lrb0a6d",
    name: "Lv Reversible Belt 40Mm Dual-Sided  Yupoo Lv Belt Black",
    description: "The LV Flower 40mm reversible belt seamlessly blends heritage and modernity, featuring dual-sided design with coated canvas displaying House initials on one side and embossed leather showcasing the iconic LV Flower insignia on the other.",
    price: PriceInfo,
    categories: ["belt","lv"],
    images: ["/productimgs/Belt/Lv/LV Reversible Belt 40mm Dual-Sided  Yupoo LV Belt Black/lrb0a6d_3.jpg","/productimgs/Belt/Lv/LV Reversible Belt 40mm Dual-Sided  Yupoo LV Belt Black/lrb0a6d_4.jpg","/productimgs/Belt/Lv/LV Reversible Belt 40mm Dual-Sided  Yupoo LV Belt Black/lrb0a6d_5.jpg","/productimgs/Belt/Lv/LV Reversible Belt 40mm Dual-Sided  Yupoo LV Belt Black/lrb0a6d_6.jpg","/productimgs/Belt/Lv/LV Reversible Belt 40mm Dual-Sided  Yupoo LV Belt Black/lrb0a6d_7.jpg","/productimgs/Belt/Lv/LV Reversible Belt 40mm Dual-Sided  Yupoo LV Belt Black/lrb0a6d_8.jpg","/productimgs/Belt/Lv/LV Reversible Belt 40mm Dual-Sided  Yupoo LV Belt Black/lrb0a6d_9.jpg"]
  },
  {
    id: "lrb4791",
    name: "Lv Reversible Belt 40Mm Dual-Sided  Yupoo Lv Belt Brown",
    description: "The LV Flower 40mm reversible belt seamlessly blends heritage and modernity, featuring dual-sided design with coated canvas displaying House initials on one side and embossed leather showcasing the iconic LV Flower insignia on the other.",
    price: PriceInfo,
    categories: ["belt","lv"],
    images: ["/productimgs/Belt/Lv/LV Reversible Belt 40mm Dual-Sided  Yupoo LV Belt Brown/lrb4791_3.jpg","/productimgs/Belt/Lv/LV Reversible Belt 40mm Dual-Sided  Yupoo LV Belt Brown/lrb4791_4.jpg","/productimgs/Belt/Lv/LV Reversible Belt 40mm Dual-Sided  Yupoo LV Belt Brown/lrb4791_5.jpg","/productimgs/Belt/Lv/LV Reversible Belt 40mm Dual-Sided  Yupoo LV Belt Brown/lrb4791_6.jpg","/productimgs/Belt/Lv/LV Reversible Belt 40mm Dual-Sided  Yupoo LV Belt Brown/lrb4791_7.jpg","/productimgs/Belt/Lv/LV Reversible Belt 40mm Dual-Sided  Yupoo LV Belt Brown/lrb4791_8.jpg","/productimgs/Belt/Lv/LV Reversible Belt 40mm Dual-Sided  Yupoo LV Belt Brown/lrb4791_9.jpg"]
  },
  {
    id: "lisa3b4",
    name: "Lv Initiales Studs Reversible Belt 4.0Cm Yupoo Belt",
    description: "This 4.0cm LV Initiales Studs reversible belt masterfully merges House DNA with bold sophistication, featuring full-coverage signature print on both sides and instantly elevating everyday style with its defining studded buckle.",
    price: PriceInfo,
    categories: ["belt","lv"],
    images: ["/productimgs/Belt/Lv/LV Initiales Studs Reversible Belt 4.0cm Yupoo Belt/lisa3b4_3.jpg","/productimgs/Belt/Lv/LV Initiales Studs Reversible Belt 4.0cm Yupoo Belt/lisa3b4_4.jpg","/productimgs/Belt/Lv/LV Initiales Studs Reversible Belt 4.0cm Yupoo Belt/lisa3b4_5.jpg","/productimgs/Belt/Lv/LV Initiales Studs Reversible Belt 4.0cm Yupoo Belt/lisa3b4_6.jpg","/productimgs/Belt/Lv/LV Initiales Studs Reversible Belt 4.0cm Yupoo Belt/lisa3b4_7.jpg","/productimgs/Belt/Lv/LV Initiales Studs Reversible Belt 4.0cm Yupoo Belt/lisa3b4_8.jpg","/productimgs/Belt/Lv/LV Initiales Studs Reversible Belt 4.0cm Yupoo Belt/lisa3b4_9.jpg","/productimgs/Belt/Lv/LV Initiales Studs Reversible Belt 4.0cm Yupoo Belt/lisa3b4_10.jpg","/productimgs/Belt/Lv/LV Initiales Studs Reversible Belt 4.0cm Yupoo Belt/lisa3b4_11.jpg"]
  },
  {
    id: "lib8855",
    name: "Lv Initiales Blason 40Mm Belt Yupoo Lv Belt Brown",
    description: "The LV Initiales Blason 40mm reversible belt fuses heritage and modernity with dual-sided LV-embossed leather, embodying Pharrell Williams' vision for refined versatility and tactile sophistication.",
    price: PriceInfo,
    categories: ["belt","lv"],
    images: ["/productimgs/Belt/Lv/LV Initiales Blason 40mm Belt Yupoo LV Belt Brown/lib8855_3.jpg","/productimgs/Belt/Lv/LV Initiales Blason 40mm Belt Yupoo LV Belt Brown/lib8855_4.jpg","/productimgs/Belt/Lv/LV Initiales Blason 40mm Belt Yupoo LV Belt Brown/lib8855_5.jpg","/productimgs/Belt/Lv/LV Initiales Blason 40mm Belt Yupoo LV Belt Brown/lib8855_6.jpg","/productimgs/Belt/Lv/LV Initiales Blason 40mm Belt Yupoo LV Belt Brown/lib8855_7.jpg","/productimgs/Belt/Lv/LV Initiales Blason 40mm Belt Yupoo LV Belt Brown/lib8855_8.jpg","/productimgs/Belt/Lv/LV Initiales Blason 40mm Belt Yupoo LV Belt Brown/lib8855_9.jpg","/productimgs/Belt/Lv/LV Initiales Blason 40mm Belt Yupoo LV Belt Brown/lib8855_10.jpg","/productimgs/Belt/Lv/LV Initiales Blason 40mm Belt Yupoo LV Belt Brown/lib8855_11.jpg"]
  },
  {
    id: "lisec75",
    name: "Lv Initiales Studs Reversible Belt 4.0Cm Yupoo Belt Black",
    description: "This 4.0cm LV Initiales Studs reversible belt masterfully merges House DNA with bold sophistication, featuring full-coverage signature print on both sides and instantly elevating everyday style with its defining studded buckle.",
    price: PriceInfo,
    categories: ["belt","lv"],
    images: ["/productimgs/Belt/Lv/LV Initiales Studs Reversible Belt 4.0cm Yupoo Belt Black/lisec75_3.jpg","/productimgs/Belt/Lv/LV Initiales Studs Reversible Belt 4.0cm Yupoo Belt Black/lisec75_4.jpg","/productimgs/Belt/Lv/LV Initiales Studs Reversible Belt 4.0cm Yupoo Belt Black/lisec75_5.jpg","/productimgs/Belt/Lv/LV Initiales Studs Reversible Belt 4.0cm Yupoo Belt Black/lisec75_6.jpg","/productimgs/Belt/Lv/LV Initiales Studs Reversible Belt 4.0cm Yupoo Belt Black/lisec75_7.jpg","/productimgs/Belt/Lv/LV Initiales Studs Reversible Belt 4.0cm Yupoo Belt Black/lisec75_8.jpg","/productimgs/Belt/Lv/LV Initiales Studs Reversible Belt 4.0cm Yupoo Belt Black/lisec75_9.jpg","/productimgs/Belt/Lv/LV Initiales Studs Reversible Belt 4.0cm Yupoo Belt Black/lisec75_10.jpg","/productimgs/Belt/Lv/LV Initiales Studs Reversible Belt 4.0cm Yupoo Belt Black/lisec75_11.jpg"]
  },
  {
    id: "lib7b30",
    name: "Lv Initiales Blason 40Mm Belt Yupoo Lv Brown Belt Black Logo",
    description: "The LV Initiales Blason 40mm reversible belt fuses heritage and modernity with dual-sided LV-embossed leather, embodying Pharrell Williams' vision for refined versatility and tactile sophistication.",
    price: PriceInfo,
    categories: ["belt","lv"],
    images: ["/productimgs/Belt/Lv/LV Initiales Blason 40mm Belt Yupoo LV Brown Belt Black LOGO/lib7b30_3.jpg","/productimgs/Belt/Lv/LV Initiales Blason 40mm Belt Yupoo LV Brown Belt Black LOGO/lib7b30_4.jpg","/productimgs/Belt/Lv/LV Initiales Blason 40mm Belt Yupoo LV Brown Belt Black LOGO/lib7b30_5.jpg","/productimgs/Belt/Lv/LV Initiales Blason 40mm Belt Yupoo LV Brown Belt Black LOGO/lib7b30_6.jpg","/productimgs/Belt/Lv/LV Initiales Blason 40mm Belt Yupoo LV Brown Belt Black LOGO/lib7b30_7.jpg","/productimgs/Belt/Lv/LV Initiales Blason 40mm Belt Yupoo LV Brown Belt Black LOGO/lib7b30_8.jpg"]
  },
  {
    id: "liscde3",
    name: "Lv Initiales Studs Reversible Belt 4.0Cm Yupoo Belt Brown",
    description: "This 4.0cm LV Initiales Studs reversible belt masterfully merges House DNA with bold sophistication, featuring full-coverage signature print on both sides and instantly elevating everyday style with its defining studded buckle.",
    price: PriceInfo,
    categories: ["belt","lv"],
    images: ["/productimgs/Belt/Lv/LV Initiales Studs Reversible Belt 4.0cm Yupoo Belt Brown/liscde3_3.jpg","/productimgs/Belt/Lv/LV Initiales Studs Reversible Belt 4.0cm Yupoo Belt Brown/liscde3_4.jpg","/productimgs/Belt/Lv/LV Initiales Studs Reversible Belt 4.0cm Yupoo Belt Brown/liscde3_5.jpg","/productimgs/Belt/Lv/LV Initiales Studs Reversible Belt 4.0cm Yupoo Belt Brown/liscde3_6.jpg","/productimgs/Belt/Lv/LV Initiales Studs Reversible Belt 4.0cm Yupoo Belt Brown/liscde3_7.jpg","/productimgs/Belt/Lv/LV Initiales Studs Reversible Belt 4.0cm Yupoo Belt Brown/liscde3_8.jpg","/productimgs/Belt/Lv/LV Initiales Studs Reversible Belt 4.0cm Yupoo Belt Brown/liscde3_9.jpg","/productimgs/Belt/Lv/LV Initiales Studs Reversible Belt 4.0cm Yupoo Belt Brown/liscde3_10.jpg","/productimgs/Belt/Lv/LV Initiales Studs Reversible Belt 4.0cm Yupoo Belt Brown/liscde3_11.jpg"]
  },
  {
    id: "lib8555",
    name: "Lv Initiales Blason 40Mm Belt Yupoo Lv Belt Black Logo",
    description: "The LV Initiales Blason 40mm reversible belt fuses heritage and modernity with dual-sided LV-embossed leather, embodying Pharrell Williams' vision for refined versatility and tactile sophistication.",
    price: PriceInfo,
    categories: ["belt","lv"],
    images: ["/productimgs/Belt/Lv/LV Initiales Blason 40mm Belt Yupoo LV Belt Black LOGO/lib8555_3.jpg","/productimgs/Belt/Lv/LV Initiales Blason 40mm Belt Yupoo LV Belt Black LOGO/lib8555_4.jpg","/productimgs/Belt/Lv/LV Initiales Blason 40mm Belt Yupoo LV Belt Black LOGO/lib8555_5.jpg","/productimgs/Belt/Lv/LV Initiales Blason 40mm Belt Yupoo LV Belt Black LOGO/lib8555_6.jpg","/productimgs/Belt/Lv/LV Initiales Blason 40mm Belt Yupoo LV Belt Black LOGO/lib8555_7.jpg","/productimgs/Belt/Lv/LV Initiales Blason 40mm Belt Yupoo LV Belt Black LOGO/lib8555_8.jpg"]
  },
  {
    id: "lis674d",
    name: "Lv Initiales Studs Reversible Belt 40Mm Yupoo Belt Black",
    description: "This 4.0cm LV Initiales Studs reversible belt masterfully merges House DNA with bold sophistication, featuring full-coverage signature print on both sides and instantly elevating everyday style with its defining studded buckle.",
    price: PriceInfo,
    categories: ["belt","lv"],
    images: ["/productimgs/Belt/Lv/LV Initiales Studs Reversible Belt 40mm Yupoo Belt Black/lis674d_3.jpg","/productimgs/Belt/Lv/LV Initiales Studs Reversible Belt 40mm Yupoo Belt Black/lis674d_4.jpg","/productimgs/Belt/Lv/LV Initiales Studs Reversible Belt 40mm Yupoo Belt Black/lis674d_5.jpg","/productimgs/Belt/Lv/LV Initiales Studs Reversible Belt 40mm Yupoo Belt Black/lis674d_6.jpg","/productimgs/Belt/Lv/LV Initiales Studs Reversible Belt 40mm Yupoo Belt Black/lis674d_7.jpg","/productimgs/Belt/Lv/LV Initiales Studs Reversible Belt 40mm Yupoo Belt Black/lis674d_8.jpg","/productimgs/Belt/Lv/LV Initiales Studs Reversible Belt 40mm Yupoo Belt Black/lis674d_9.jpg","/productimgs/Belt/Lv/LV Initiales Studs Reversible Belt 40mm Yupoo Belt Black/lis674d_10.jpg","/productimgs/Belt/Lv/LV Initiales Studs Reversible Belt 40mm Yupoo Belt Black/lis674d_11.jpg"]
  },
  {
    id: "lib58ad",
    name: "Lv Initiales Blason 40Mm Belt Yupoo Lv Belt",
    description: "The LV Initiales Blason 40mm reversible belt fuses heritage and modernity with dual-sided LV-embossed leather, embodying Pharrell Williams' vision for refined versatility and tactile sophistication.",
    price: PriceInfo,
    categories: ["belt","lv"],
    images: ["/productimgs/Belt/Lv/LV Initiales Blason 40mm Belt Yupoo LV Belt/lib58ad_3.jpg","/productimgs/Belt/Lv/LV Initiales Blason 40mm Belt Yupoo LV Belt/lib58ad_4.jpg","/productimgs/Belt/Lv/LV Initiales Blason 40mm Belt Yupoo LV Belt/lib58ad_5.jpg","/productimgs/Belt/Lv/LV Initiales Blason 40mm Belt Yupoo LV Belt/lib58ad_6.jpg","/productimgs/Belt/Lv/LV Initiales Blason 40mm Belt Yupoo LV Belt/lib58ad_7.jpg","/productimgs/Belt/Lv/LV Initiales Blason 40mm Belt Yupoo LV Belt/lib58ad_8.jpg","/productimgs/Belt/Lv/LV Initiales Blason 40mm Belt Yupoo LV Belt/lib58ad_9.jpg","/productimgs/Belt/Lv/LV Initiales Blason 40mm Belt Yupoo LV Belt/lib58ad_10.jpg","/productimgs/Belt/Lv/LV Initiales Blason 40mm Belt Yupoo LV Belt/lib58ad_11.jpg"]
  },
  {
    id: "lis70b0",
    name: "Lv Initiales Studs Reversible Belt 4.0Cm Yupoo Belt Gold Silver Logo",
    description: "This 4.0cm LV Initiales Studs reversible belt masterfully merges House DNA with bold sophistication, featuring full-coverage signature print on both sides and instantly elevating everyday style with its defining studded buckle.",
    price: PriceInfo,
    categories: ["belt","lv"],
    images: ["/productimgs/Belt/Lv/LV Initiales Studs Reversible Belt 4.0cm Yupoo Belt Gold Silver LOGO/lis70b0_3.jpg","/productimgs/Belt/Lv/LV Initiales Studs Reversible Belt 4.0cm Yupoo Belt Gold Silver LOGO/lis70b0_4.jpg","/productimgs/Belt/Lv/LV Initiales Studs Reversible Belt 4.0cm Yupoo Belt Gold Silver LOGO/lis70b0_5.jpg","/productimgs/Belt/Lv/LV Initiales Studs Reversible Belt 4.0cm Yupoo Belt Gold Silver LOGO/lis70b0_6.jpg","/productimgs/Belt/Lv/LV Initiales Studs Reversible Belt 4.0cm Yupoo Belt Gold Silver LOGO/lis70b0_7.jpg","/productimgs/Belt/Lv/LV Initiales Studs Reversible Belt 4.0cm Yupoo Belt Gold Silver LOGO/lis70b0_8.jpg","/productimgs/Belt/Lv/LV Initiales Studs Reversible Belt 4.0cm Yupoo Belt Gold Silver LOGO/lis70b0_9.jpg","/productimgs/Belt/Lv/LV Initiales Studs Reversible Belt 4.0cm Yupoo Belt Gold Silver LOGO/lis70b0_10.jpg","/productimgs/Belt/Lv/LV Initiales Studs Reversible Belt 4.0cm Yupoo Belt Gold Silver LOGO/lis70b0_11.jpg"]
  },
];

